const es = {
wholesaleQtyLabel: "Cantidad mínima de mayoreo",
priceLabels: "Etiquetas de precio",
bankLedgerMenu: "Cuentas y Bancos",
save: "Guardar", cancel: "Cancelar", delete: "Eliminar", edit: "Editar", add: "Agregar",
    search: "Buscar", loading: "Cargando...", confirm: "Confirmar", close: "Cerrar",
    clear: "Limpiar", print: "Imprimir", export: "Exportar", all: "Todos",
    actions: "Acciones", noData: "Sin datos", noResults: "Sin resultados", noSearchResult: "No se encontraron productos",
    operationFailed: "Error", addSuccess: "Agregado", updateSuccess: "Actualizado",
    deleteSuccess: "Eliminado", deleteFailed: "Error al eliminar", loadFailed: "Error al cargar",
    deleteConfirm: "Confirmar eliminar?", fillCompleteInfo: "Complete todos los campos",
    username: "Usuario", password: "Contrasena", login: "Iniciar Sesion", logout: "Cerrar Sesion",
    deviceVerifyTitle: "Equipo nuevo: enviamos un código a tu correo", deviceVerifyResent: "Código reenviado", deviceVerifyResend: "Reenviar código", deviceVerifyHelp: "Válido 10 minutos. ¿No llega? El dueño puede autorizar este equipo en «Equipos de confianza», o contacta a soporte Sellox.", trustedDevicesMenu: "🔐 Equipos de confianza", adminTabMerchantHint: "¿Eres comerciante? Usa la pestaña «Comercio Login» (ID de comercio + usuario + contraseña)", adminLogin: "Admin Login", tenantLogin: "Comercio Login", posLogin: "POS Caja", posLoginHint: "Cajero - ingreso directo a la caja", enterPos: "Entrar a Caja",
    fillAllFields: "Complete todos los campos", tenantIdLabel: "ID Comercio", providedByAdmin: "Proporcionado por admin",
    pointsLookup: "Consulta de Puntos", loyaltyTierBenefits: "Beneficios", pointsHistory: "Historial de Puntos",
    memberCode: "Codigo de Miembro", cancelled: "Cancelado",
    unitPcs: "und",
    plan_basic: "Basico", plan_pro: "Pro", plan_enterprise: "Empresa",
    plan_lifetime_1: "Básico · 1 tienda (vitalicio)", plan_lifetime_2: "Negocio · 2 tiendas (vitalicio)", plan_lifetime_4: "Empresa · 4 tiendas (vitalicio)", plan_lifetime_6: "Insignia · ilimitadas (vitalicio)", plan_lifetime_5: "Empresa · 11 tiendas (vitalicio, legado)",
    plan_trial: "Prueba",
    upgradePlan: "Actualizar Plan",
    upgradePlanCurrent: "Plan Actual",
    upgradePlanTo: "Actualizar a",
    upgradePlanConfirm: "Confirmar Actualizacion",
    upgradePlanSuccess: "Plan actualizado exitosamente",
    upgradePlanCurrentLimits: "Limites actuales",
    upgradePlanUsers: "usuarios",
    upgradePlanStores: "tiendas",
    upgradePlanUnlimited: "Ilimitado",
    deleteTenant: "Eliminar Inquilino",
    deleteTenantWarning: "Todos los datos del inquilino se eliminaran permanentemente y no se podran recuperar!",
    deleteEnterPassword: "Ingrese la contrasena de administrador para confirmar",
    deletePasswordWrong: "Contrasena incorrecta, eliminacion cancelada",
    deleteTenantConfirm: "Confirmar Eliminacion",
    shopUrl: "URL Tienda",
    dashboard: "Panel", storeManagement: "Tiendas", warehouseManagement: "Almacenes",
    productManagement: "Productos", transferManagement: "Transferencias",
    customerManagement: "Clientes", supplierManagement: "Proveedores",
    purchaseManagement: "Compras", salesManagement: "Ventas",
    onlineOrders: "Pedidos Online", reports: "Reportes", exchangeRates: "Tipo de Cambio",
    paymentSettings: "Config. Pagos", salesReport: "Reporte de Ventas",
    saasManagement: "SaaS Comercios", adminManual: "Manual Admin", videoTutorials: "Video Tutoriales", userManual: "Manual de Usuario",
    todaySales: "Ventas Hoy", onlineOrderTotal: "Pedidos Online", totalProducts: "Productos",
    pendingOrders: "Pendientes", recentSales: "Ventas Recientes", quickActions: "Acciones Rapidas",
    productCode: "Codigo", productName: "Nombre", category: "Categoria",
    unit: "Unidad", costPrice: "Costo", margin: "Margen",
    price1: "Precio 1", price2: "Precio 2", price3Box: "Precio 3 (Caja)",
    boxQuantity: "Cant/Caja", status: "Estado", active: "Activo", inactive: "Inactivo",
    addProduct: "Agregar Producto", editProduct: "Editar Producto", priceSettings: "Precios",
    marginFormula: "Costo x (1 + Margen%)",
    searchProduct: "Buscar producto...",
    importProducts: "Importar Productos", selectFile: "Seleccionar Archivo",
    supportedFormats: "Formatos Soportados", importSuccess: "Importacion Exitosa",
    importFailed: "Error de Importacion", downloadTemplate: "Descargar Plantilla",
    importCount: "Cantidad", skipDuplicate: "Omitir Duplicados", overwriteDuplicate: "Sobrescribir",
    duplicateHandling: "Manejo de Duplicados", startImport: "Iniciar Importacion",
    importing: "Importando...", importResult: "Resultado",
    created: "Creados", updated: "Actualizados", skipped: "Omitidos", failed: "Fallidos",
    posTitle: "POS", currency: "Moneda", shift: "Turno",
    openShift: "Abrir turno", openingCashFloat: "Fondo de caja inicial", openingCashHint: "¿Cuánto efectivo hay en la caja ahora para dar cambio? Se descontará al cerrar turno.",
    startShift: "Iniciar Turno", endShift: "Cerrar Turno", noShift: "Sin Turno",
    shiftSince: "Turno desde", salesOrder: "Orden de Venta", items: "articulos",
    products: "Productos", quantity: "Cant.", priceType: "Tipo Precio",
    unitPrice: "P. Unit.", amount: "Monto", total: "Total",
    sendToCashier: "📨 Enviar a caja", checkout: "Cobrar", scanOrSearch: "Escanear codigo / Buscar producto...",
    box: "Caja", boxes: "cajas", pieces: "pzas",
    paymentMethod: "Metodo de Pago", cash: "Efectivo", card: "Tarjeta", giftCard: "🎫 Vale de compra",
    received: "Recibido", change: "Cambio", confirmPayment: "Confirmar Pago", orderComplete: "Pedido Completado", skip: "Omitir",
    storeCode: "Codigo Tienda", storeName: "Nombre Tienda", addStore: "Agregar Tienda",
    editStore: "Editar Tienda", headquarters: "Casa Matriz", associatedWarehouse: "Almacen",
    physicalStore: "Tienda Fisica", onlineStore: "Tienda Online",
    selectWarehouse: "Seleccione Almacen",
    warehouseCode: "Codigo Almacen", warehouseName: "Nombre Almacen", addWarehouse: "Agregar Almacen",
    setMainWarehouse: "Almacen Principal", inventoryQty: "Cant. Stock",
    reservedQty: "Cant. Reservada", availableQty: "Cant. Disponible",
    noInventoryData: "Sin datos de inventario", inventoryList: "Lista de Inventario",
    customerCode: "Codigo Cliente", customerName: "Nombre Cliente", addCustomer: "Agregar Cliente",
    searchCustomerPlaceholder: "Buscar cliente...",
    memberLevel: "Nivel Membresia", points: "Puntos", balance: "Saldo",
    normal: "Normal", vip: "VIP",
    supplierCode: "Codigo Proveedor", supplierName: "Nombre Proveedor", addSupplier: "Agregar Proveedor",
    contact: "Contacto",
    createPurchaseOrder: "Nueva Orden de Compra", orderNo: "No. Orden", itemCount: "Articulos",
    purchaseNoProducts: "No hay productos. Agregue productos en Gestion de Productos primero",
    purchaseBatchSelect: "Seleccionar productos (multi-seleccion)",
    purchaseBatchAdd: "Agregar lote a la orden",
    purchaseAddedItems: "Articulos agregados",
    purchaseItemsAdded: "articulos agregados",
    purchaseSelectAtLeastOne: "Seleccione al menos un producto",
    purchaseNotesPlaceholder: "Notas (opcional)",
    transferBatchSelect: "Seleccionar productos para transferir (multi-seleccion)",
    transferBatchConfirm: "Transferencia por lote",
    transferSelectAtLeastOne: "Seleccione al menos un producto",
    transferNoStock: "No hay productos con stock en este almacen",
    transferSelectWarehouseFirst: "Seleccione un almacen de origen primero",
    transferQty: "Cantidad",
    reportCurrency: "Moneda",
    reportBoth: "Ambas",
    reportExchangeRate: "Tasa de cambio actual",
    reportUsdSales: "Ventas en USD",
    reportBsSales: "Ventas en Bolivares",
    dbBusinessOverview: "Resumen de Negocio",
    dbPurchaseIn: "Compras",
    dbTotalPO: "Total OCs",
    dbReceived: "Recibidas",
    dbPendingReceive: "Pendientes",
    dbTotalPurchaseItems: "Total articulos",
    dbTotalPurchaseAmount: "Monto total",
    dbDamageLoss: "Danos / Perdidas",
    dbLossRecords: "Registros",
    dbLossQty: "Cantidad perdida",
    dbLossValue: "Valor perdido",
    dbRetailSales: "Ventas Minoristas",
    dbTotalOrders: "Total pedidos",
    dbTotalItems: "Total articulos",
    dbTotalRevenue: "Ingresos totales",
    dbWholesale: "Mayoreo",
    dbCompleted: "Completados",
    dbPending: "Pendientes",
    dbTotalPaid: "Pagado",
    dbUnpaid: "Sin pagar",
    dbPaidToSupplier: "Pagado a Proveedores",
    dbSupplierDebt: "Deuda con Proveedores",
    poRecordPay: "Registrar Pago",
    poPayAmount: "Monto del pago",
    poPayAll: "Pagar total",
    poPaySuccess: "Pago registrado",
    posStockLookup: "Consulta de Stock",
    posReserved: "Reservado",
    posAvailable: "Disponible",
    posMinStock: "Stock Minimo",
    posOutOfStock: "Agotado",
    posLowStock: "Bajo Stock",
    allWarehouses: "Todos los Almacenes",
    posCartEmpty: "Haga clic en productos a la izquierda",
    posNeedShift: "Inicie un turno antes de cobrar",
    totalAmount: "Total", createTime: "Creado",
    receiveGoods: "Recibir", receivedStatus: "Recibido", pendingReceive: "Pendiente",
    selectSupplier: "Seleccione Proveedor", selectProduct: "Seleccione Producto",
    receiveWarehouse: "Almacen de Recepcion", createSuccess: "Creado",
    addItems: "Agregar Articulos",
    otherPayment: "Otro", completedStatus: "Completado", pendingStatus: "Pendiente",
    newTransfer: "Nueva Transferencia", sourceWarehouse: "Origen",
    targetWarehouse: "Destino", product: "Producto", transferConfirm: "Confirmar",
    inventoryOverview: "Inventario por Almacen", transferHistory: "Historial",
    stock: "Stock", time: "Fecha", source: "Origen", target: "Destino",
    sameWarehouseError: "Origen y destino no pueden ser iguales",
    transferSuccess: "Transferencia Exitosa", transferFailed: "Error de Transferencia",
    salesReportTitle: "Reporte de Ventas", storeFilter: "Filtrar Tienda",
    dateFrom: "Desde", dateTo: "Hasta", generateReport: "Generar",
    printReport: "Imprimir Reporte", totalSales: "Ventas Totales", totalOrders: "Total Ordenes", avgPerOrder: "Promedio", byCurrency: "Por Moneda", byPaymentMethod: "Por Metodo de Pago",
    totalItems: "Total Articulos", storeSalesDetail: "Detalle por Tienda",
    productSalesDetail: "Detalle por Producto", soldQuantity: "Vendidos",
    salesAmount: "Monto", topProducts: "Más Vendidos",
    shopTitle: "Tienda Online", myOrders: "Mis Pedidos", addToCart: "Agregar al Carrito",
    cart: "Carrito", checkoutTitle: "Pagar", orderSuccess: "Pedido Exitoso",
    orderLookup: "Buscar Pedido", orderNumber: "No. Pedido", phone: "Telefono",
    shippingInfo: "Envio", paymentInfo: "Pago",
    online: "En Linea", offline: "Sin Conexion", offlineMode: "Modo Sin Conexion",
    cachedData: "Cache", offlineCacheMode: "Modo offline - usando datos en cache, ordenes se sincronizan al reconectar",
    offlineNoCache: "Sin conexion y sin cache - conecte e inicie sesion primero",
    pendingSync: "Pendiente", syncNow: "Sincronizar", syncSuccess: "Sincronizado",
    offlineWarning: "Modo sin conexion - los datos se sincronizaran al reconectar",
    location: "Ubicacion", type: "Tipo",
    retail: "Tienda", warehouse: "Almacen", mainWarehouse: "Almacen Principal",
    name: "Nombre", contactPhone: "Telefono", email: "Correo", address: "Direccion",
    purchaseOrder: "Orden de Compra", supplier: "Proveedor",
    received_status: "Recibido", pending: "Pendiente",
    language: "Idioma", chinese: "中文", english: "English", spanish: "Espanol",
    discount: "Descuento", orderDetail: "Detalle del Pedido", shipping: "Envio",
    paid: "Pagado", processing: "Procesando", shipped: "Enviado", completed: "Completado",
    customer: "Cliente", date: "Fecha",
    systemSettings: "Config. Sistema", employees: "Empleados", stockAlerts: "Alertas Stock", stockTaking: "Inventario Fisico",
    stockLoss: "Merma", stockLossManagement: "Gestion de Mermas", newStockLoss: "Nueva Merma", stockLossSuccess: "Merma registrada",
    stockLossSearchProduct: "Buscar producto...", stockLossQty: "Cantidad", stockLossReason: "Razon",
    stockLossNotePlaceholder: "Notas adicionales (opcional)", stockLossCostEstimate: "Perdida Estimada", confirmStockLoss: "Confirmar Merma",
    stockLossOnlyManagers: "Solo gerentes/admins pueden registrar mermas", totalLossRecords: "Registros", totalLossQty: "Cantidad Total",
    totalCostLoss: "Perdida Total", costLoss: "Perdida", operator: "Operador", allReasons: "Todas las Razones",
    companyName: "Nombre Empresa", taxId: "RIF", companyAddress: "Direccion", companyPhone: "Telefono",
    invoiceHeader: "Encabezado Factura", invoiceFooter: "Pie Factura", printFormat: "Formato Impresion",
    shopTheme: "Tema de la Tienda Online", businessType: "Tipo de Negocio", shopDescription: "Descripcion de la tienda (en portada)", shopDescPlaceholder: "Ej: Productos frescos cada dia", shopPreview: "Vista previa del enlace",
    themeSupermarket: "Supermercado", themeRestaurant: "Restaurante", themeDepartment: "Tienda por Departamentos", themePharmacy: "Farmacia", themeBakery: "Panaderia", themeClothing: "Ropa", themeElectronics: "Electronica", themeButcher: "Carniceria", themeGeneral: "General", themeCustom: "Imagen Personalizada",
    uploadBackground: "Subir fondo (recomendado 1920x800, max 5MB)", selectImage: "Seleccionar Imagen", uploadSuccess: "Subido exitosamente",
    autoPrint: "Auto Imprimir", printSuccess: "Enviado a impresora", receiptCopies: "Copias", scannerEnabled: "Escaner",
    printerConfig: "Opciones de Impresora", posReceiptPrinter: "Impresora de Recibos (POS)", reportPrinter: "Impresora de Reportes", fiscalPrinter: "Impresora Fiscal",
    printerName: "Nombre de Impresora", printerModel: "Modelo", connectionPort: "Puerto de Conexion", paperSize: "Tamano de Papel",
    thermal: "Termica", enableCashDrawer: "Habilitar Cajon de Dinero", printItemCode: "Imprimir Codigo (solo fiscal)",
    silentPrintTip: "Config. Impresion Silenciosa (sin dialogo)", setDefaultPrinter: "Establecer impresora POS como predeterminada en Windows", downloadShortcut: "Descargar acceso directo, colocar en escritorio y doble clic", closeAllBrowserFirst: "Usa proceso independiente, no necesita cerrar otras ventanas del navegador",
    chromeKioskTip: "Agregar --kiosk-printing al acceso directo de Chrome, ej.:", autoPrintTip: "El sistema imprime automaticamente despues del pago",
    reportPrinterDesc: "Para imprimir reportes de ventas, inventario y otros documentos A4", testPrint: "Imprimir Prueba",
    qzNotConnected: "Impresion silenciosa no conectada - Instale QZ Tray", download: "Descargar",
    wholesaleEnabled: "Mayoreo", wholesaleMinQty: "Cantidad Min.", wholesaleDiscount: "Desc. Mayoreo",
    refund: "Devolucion", refundReason: "Motivo", holdOrder: "Apartar", recallOrder: "Recuperar",
    dailySettlement: "Cierre Diario", grossProfit: "Ganancia Bruta", netSales: "Ventas Netas",
    permission: "Permiso", canDiscount: "Puede Descontar", canRefund: "Puede Devolver", maxDiscount: "Desc. Maximo",
    wholesale: "Mayoreo", retailMode: "Detalle", wholesaleMode: "Mayoreo",
    receipt80mm: "Ticket 80mm", receiptA4: "Factura A4", printReceipt: "Imprimir", reprintReceipt: "Reimprimir", receiptDetail: "Detalle Recibo",
    bestSellers: "Mas Vendidos", slowSellers: "Menos Vendidos", actualQty: "Cant. Real", systemQty: "Cant. Sistema",
    difference: "Diferencia", enterQty: "Ingrese Cant.",
    systemRates: "Tasas del Sistema", categoryRates: "Tasas por Categoria",
    categoryRateDesc: "Configurar tasa de cambio por categoria",
    usdPricingMode: "Modo Precio USD",
    originalUsd: "Precio $ tal como se ingresó (por defecto)",
    bsToUsd: "Precio Bs de estante ÷ tasa (tiendas que marcan en Bs)",
    originalUsdDesc: "POS cobra en USD al precio original del producto",
    bsToUsdDesc: "POS cobra en USD usando precio Bs ÷ tasa BCV",
    productRate: "Tasa de Producto", productRateDesc: "Tasa para convertir precios $ a Bs",
    salesExchangeRate: "Tasa de Venta", salesExchangeRateDesc: "Tasa POS/factura (sincronización BCV)",
    salesRate: "Tasa de Venta", salesRateDesc: "Al facturar en $, calcula el monto en USD a cobrar (Formula: Precio × Tasa Venta ÷ Tasa Producto)",
    noSalesRates: "No hay tasas de venta. Haga clic en Agregar.",
    localSymbol: "Simbolo Local", saveRates: "Guardar Tasas", ratesUpdated: "Tasas Actualizadas",
    quickConverter: "Convertidor Rapido", example: "Ejemplo",
    bankTransfer: "Transferencia Bancaria", mobilePay: "Pago Movil",
    bankName: "Banco", accountNumber: "Numero de Cuenta",
    accountHolder: "Titular de la Cuenta", idNumber: "Cedula",
    selectBank: "Seleccione Banco", saveSettings: "Guardar Config.", settingsSaved: "Config. Guardada",
    saveFailed: "Error al Guardar", preview: "Vista Previa",
    transferData: "Datos Transferencia", mobilePayData: "Datos Pago Movil",
    bank: "Banco", account: "Cuenta", holder: "Titular",
    whatsappContact: "Contacto WhatsApp",
    whatsappNumber: "Numero WhatsApp",
    whatsappHint: "Ingrese numero con codigo de pais, sin + ni espacios",
    whatsappEnabled: "Los clientes podran contactarte por WhatsApp despues de hacer un pedido",
    casheaBNPL: "Compra ahora, paga despues", casheaDesc: "El cliente paga en cuotas sin intereses a traves de Cashea",
    casheaCedula: "Cedula del cliente", casheaAmount: "Monto Cashea",
    casheaProcessing: "Procesando con Cashea...", casheaSettingsDesc: "Compra ahora, paga despues - cuotas sin intereses",
    casheaKeyHint: "Sin API Key funciona en modo demo. Solicite en soporte@cashea.com",
    casheaDemoMode: "Modo demo activo - pagos se aprueban automaticamente", casheaLiveMode: "Modo real activo - conectado con Cashea",
    saving: "Guardando...",
    notes: "Notas",
    printReceipt80mm: "Imprimir Ticket", printInvoiceA4: "Imprimir Factura",
    printPriceLabels: "Etiquetas de Precio", printPreview: "Vista Previa",
    labelDisplayMode: "Mostrar etiqueta", labelModeP1: "Precio 1 (Detal)", labelModeP3: "Precio 3 (Mayor)", labelModeWholesale: "Precio Caja (Mayor)", labelModeP1P3: "Precio 1 + Precio 3", labelModeP1W: "Precio 1 + Precio Caja", labelModeUsdP1: "Precio USD 1 (Detal)", labelShowForeign: "Mostrar USD ($)", labelNoDecimals: "Sin decimales", labelShowBarcode: "Mostrar codigo", labelPaperSize: "Papel", labelSize80mm: "80mm Térmico", labelSize50x30: "50x30mm Etiqueta", labelBilingual: "Bilingüe (ES+CN)",
    selectProducts: "Seleccionar Productos", selectAll: "Seleccionar Todo",
    deselectAll: "Deseleccionar Todo", selectedCount: "Seleccionados",
    printSelected: "Imprimir Seleccionados", time: "Hora",
    connectPrinter: "Conectar Impresora", printerReady: "Conectada", printerConnected: "Impresora conectada", printerConnectFailed: "Error de conexion", directPrintFailed: "Impresion directa fallida", printing: "Imprimiendo...",
    pricingMode: "Modo de Precio en Divisa",
    pricingLocalBased: "Calcular desde precio local",
    pricingLocalDesc: "Bs.=Costo×Tasa Dpto., USD=Bs.÷Tasa Venta (tasa paralela)",
    pricingForeignDirect: "Usar precio directo en divisa",
    pricingForeignDesc: "Usar precios USD almacenados directamente (tasa BCV)",
    dailySettlement: "Cierre Diario", grossProfit: "Ganancia Bruta",
    refundHistory: "Historial de Devoluciones", refundReason: "Motivo", expenseManagement: "Gastos", addExpense: "Agregar Gasto", totalExpenses: "Total Gastos", expenseCount: "Registros", expenseByStore: "Por Tienda", avgOrder: "Ticket Promedio", expenseDesc: "Descripcion", expense_rent: "Alquiler", expense_utilities: "Servicios", expense_salary: "Salario", expense_supplies: "Insumos", expense_maintenance: "Mantenimiento", expense_transport: "Transporte", expense_food: "Comida", expense_tax: "Impuestos", expense_other: "Otros", selectStore: "Seleccionar Tienda", categoryManagement: "Categorias",
    profitAnalysis: "Analisis de Ganancias", revenue: "Ingresos", cost: "Costo", profit: "Ganancia",
    profitMargin: "Margen", overallMargin: "Margen Global", totalRevenue: "Ingresos Totales",
    totalCost: "Costo Total", totalProfit: "Ganancia Total",
    categoryAnalysis: "Analisis Categoria/Tasa", categoryBreakdown: "Por Categoria", dailyBreakdown: "Desglose Diario",
    govtGoods: "Productos Tasa Oficial", blackMarketGoods: "Productos Mercado Negro", rateLabel: "Tasa:", blackMarket: "Mercado Negro",
    salesUsd: "Ventas ($)", salesBs: "Ventas (Bs)", costUsd: "Costo ($)", profitUsd: "Ganancia ($)",
    pricingMode: "Modo Precio", margin: "Margen", totalSales: "Ventas Totales",
    thisWeek: "Esta Semana", thisMonth: "Este Mes", lastMonth: "Mes Pasado",
    today: "Hoy", allStores: "Todas", categoryName: "Categoria", exchangeRate: "Tasa",
    orders: "Pedidos", sales: "Ventas", items: "Articulos",
    grossProfit: "Ganancia Bruta", netProfit: "Ganancia Neta", expenses: "Gastos", stockLoss: "Daños/Perdida",
    expenseBreakdown: "Desglose Gastos", lossBreakdown: "Desglose Daños",
    damage: "Daño", expired: "Vencido", personalUse: "Uso Personal", sample: "Muestra", other: "Otro",
    rateType: "Tasa", selectedRate: "Tasa Seleccionada", usdEquivalent: "Equivalente USD",
    expenseRent: "Alquiler", expenseUtilities: "Servicios", expenseSalary: "Salario", expenseSupplies: "Insumos",
    expenseMaintenance: "Mantenimiento", expenseTransport: "Transporte", expenseFood: "Comida", expenseTax: "Impuesto",
    exchangeProfit: "Ganancia Cambio", buyUsdCash: "Compra USD Efectivo", cardToCash: "Tarjeta a Efectivo",
    usdAmount: "Monto USD", buyRate: "Tasa Compra", sellRate: "Tasa Venta",
    cardAmount: "Monto Tarjeta(Bs)", cashGiven: "Efectivo Dado(Bs)", bsCost: "Costo Bs", bsValue: "Valor Bs",
    profitBs: "Ganancia(Bs)", profitUsd: "Ganancia($)", commissionPct: "Comision",
    todayProfitBs: "Ganancia Hoy(Bs)", todayProfitUsd: "Ganancia Hoy($)",
    exchangeProfitDetail: "Detalle Ganancia Cambio", cashMustBeLess: "Efectivo debe ser menor al monto de tarjeta",
    note: "Nota", details: "Detalles", type: "Tipo",
    purchaseHistory: "Historial de Compras", totalSpent: "Total Gastado", orderCount: "Pedidos",
    addPoints: "Agregar Puntos", redeemPoints: "Canjear Puntos", topupBalance: "Recargar", pointsLog: "Historial Puntos",
    balanceLog: "Historial Saldo", earn: "Ganar", redeem: "Canjear", topup: "Recarga",
    auditLog: "Registro de Auditoria", action: "Accion", targetType: "Tipo", targetId: "ID Objetivo",
    detail: "Detalle", operator: "Operador",
    promotions: "Promociones", promoName: "Nombre", promoType: "Tipo",
    discount_promo: "Descuento", fullReduction: "Ahorro", buyGet: "Compra y Lleva", flashSale: "Oferta Flash",
    startDate: "Fecha Inicio", endDate: "Fecha Fin", minAmount: "Monto Minimo",
    discountValue: "Valor Descuento", addPromotion: "Agregar Promocion",
    accountsReceivable: "Cuentas por Cobrar", accountsPayable: "Cuentas por Pagar",
    receivable: "Por Cobrar", payable: "Por Pagar", creditor: "Deudor",
    dueDate: "Fecha Vencimiento", paidAmount: "Pagado", remainingAmount: "Restante",
    markPaid: "Marcar Pagado", addReceivable: "Agregar Cobro", addPayable: "Agregar Pago",
    partialPaid: "Parcial",
    dataBackup: "Respaldo de Datos", exportBackup: "Exportar Respaldo", backupDesc: "Exportar datos como JSON",
    salesTrend: "Tendencia Ventas", last7Days: "Ultimos 7 Dias", last30Days: "Ultimos 30 Dias",
    rolePermissions: "Permisos", admin: "Admin", manager: "Gerente", store_manager: "Jefe de Tienda", cashier: "Cajero", order_taker: "Tomapedidos (solo pedidos, no cobra)", staff: "Personal", warehouse: "Almacen", finance: "Finanzas", price_checker: "Verificador de Precios", stock_viewer: "Consulta de Inventario", wholesale_clerk: "Facturador Mayorista",
    discountAboveCostOnly: "No menor al costo", discountAboveCostDesc: "El descuento no puede estar por debajo del precio de costo",
    marketing: "Marketing",
    mktDesc: "Campanas de email, SMS y notificaciones a clientes",
    mktNewCampaign: "Nueva Campana",
    mktCreateCampaign: "Crear Campana",
    mktCampaigns: "Campanas",
    mktNoCampaigns: "No hay campanas creadas",
    mktNameRequired: "Nombre y mensaje son obligatorios",
    mktCampaignCreated: "Campana creada",
    mktSentTo: "Enviado a {count} clientes",
    mktSendError: "Error al enviar",
    mktDeleted: "Eliminada",
    mktName: "Nombre",
    mktType: "Tipo",
    mktSegment: "Segmento",
    mktSubject: "Asunto",
    mktMessage: "Mensaje",
    mktVariablesHint: "Variables: {nombre}, {telefono}, {puntos}",
    mktSend: "Enviar",
    mktRecipients: "destinatarios",
    mktAllCustomers: "Todos los clientes",
    mktVipCustomers: "Clientes VIP",
    mktInactiveCustomers: "Clientes inactivos (30+ dias)",
    mktBirthdayToday: "Cumpleanos hoy",
    mktNamePlaceholder: "Promo Fin de Semana",
    mktSubjectPlaceholder: "Oferta especial para ti",
    mktMessagePlaceholder: "Hola {nombre}, tenemos una oferta especial...",
    mktEmail: "Email",
    mktSms: "SMS",
    mktWhatsapp: "WhatsApp",
    mpLoginRequired: "Inicia sesion",
    mpSearchPlaceholder: "Buscar...",
    mpAllCategories: "Todos",
    mpLoading: "Cargando...",
    mpNoResults: "Sin resultados",
    mpItems: "items",
    mpTotal: "Total",
    mpEmpty: "Vacio",
    mpCharge: "Cobrar",
    mpPaymentTitle: "Pago",
    mpCash: "Efectivo",
    mpCard: "Tarjeta",
    mpTransfer: "Transferencia",
    mpZelle: "Zelle",
    mpPagoMovil: "Pago Movil",
    mpConfirm: "Confirmar",
    mpSaleComplete: "Venta completada",
    exportSalesReport: "Exportar Ventas", exportInventoryReport: "Exportar Inventario",
    exporting: "Exportando...",
    usePoints: "Usar Puntos", pointsAvailable: "Disponibles", pointsEarned: "Puntos Ganados",
    pointsDiscount: "Descuento Puntos", pointsIssued: "Puntos Otorgados", pointsRecon: "Conciliación de Puntos", pointsMonthly: "Informe Mensual de Puntos", pointsVoidClaw: "Retiro por Anulación", pointsRefundClaw: "Retiro por Devolución", pointsRestoreUsed: "Puntos Usados Devueltos", pointsManualAdjust: "Ajuste Manual", last6Months: "Últimos 6 Meses", pointsRate: "Tasa Puntos", noCustomerNoPoints: "Seleccione cliente para usar puntos",
    clerkLimitTitle: "Límite Diario del Clerk AI de la Tienda", clerkLimitDesc: "Evita que visitantes agoten sus créditos; al superar el límite se dirige al cliente a WhatsApp (0 = sin límite)", featBgRemove: "Quitar Fondo", featBeautify: "Mejorar Foto Pro", featRetouch: "Retocar Foto Pro", featPoster: "Poster AI", featBanner: "Banner AI", featLegalChat: "Asesor Legal", featPayroll: "Nómina AI",
    vipRules: "Reglas VIP", autoUpgrade: "Auto Upgrade", minSpent: "Gasto Minimo", pointsMultiplier: "Multiplicador",
    silver: "Plata", gold: "Oro", vip: "VIP", normal: "Normal",
    wholesale: "Mayorista", wholesaleOrder: "Pedido Mayorista", createWholesaleOrder: "Crear Pedido Mayorista",
    wholesaleStats: "Estadisticas Mayoreo", pendingOrders: "Pendientes", totalRevenue: "Ingresos Totales",
    totalPaid: "Total Cobrado", totalItems: "Total Articulos", orderDetail: "Detalle Pedido",
    deliveryAddress: "Direccion Entrega", deliveryDate: "Fecha Entrega", orderNotes: "Notas",
    markCompleted: "Completar", markDelivered: "Entregado", cancelOrder: "Cancelar Pedido",
    wholesalePrice: "Precio Mayoreo", retailPrice: "Precio Detalle", paidAmount: "Pagado",
    unpaidAmount: "Pendiente", recordPayment: "Registrar Pago", paymentAmount: "Monto Pago",
    orderCancelled: "Pedido Cancelado", statusPending: "Pendiente", statusCompleted: "Completado",
    statusDelivered: "Entregado", statusCancelled: "Cancelado", printOrder: "Imprimir Pedido",
    wholesaleCustomer: "Cliente Mayorista", itemCount: "Articulos",
    attendance: "Asistencia", clockIn: "Entrada", clockOut: "Salida", hours: "Horas", present: "Presente",
    salesTarget: "Meta Ventas", targetAmount: "Meta", actual: "Real", progress: "Progreso",
    setTarget: "Fijar Meta", monthly: "Mensual", quarterly: "Trimestral",
    purchaseReturn: "Devolucion Compra", returnReason: "Razon", approve: "Aprobar",
    bundles: "Combos", bundleName: "Nombre Combo", bundlePrice: "Precio Combo", originalPrice: "Precio Original",
    fixedItems: "Items Fijos", optionalGroups: "Opciones", addGroup: "Agregar Grupo",
    addOptionalGroup: "Agregar Grupo Opcional", groupName: "Nombre del Grupo", defaultOption: "Opcion Predeterminada",
    optGroupHint: "Agrega al menos 2 opciones. El cliente elige una por grupo.",
    optGroupNeedTwoOptions: "Necesita al menos 2 opciones",
    addBundleHint: "Crea combos para aumentar el ticket promedio",
    comboAnalytics: "Analisis de Ventas de Combos", comboOrders: "Ordenes de Combo", comboRevenue: "Ingresos de Combos",
    comboOrderRatio: "del total de ordenes", activeCombos: "Combos Activos", avgComboValue: "Valor Promedio",
    comboRanking: "Ranking de Ventas de Combos", comboSalesDistribution: "Distribucion de Ventas",
    comboTrend: "Tendencia de Ventas de Combos", optionStats: "Estadisticas de Opciones",
    comboRankingTable: "Detalle de Ventas de Combos", noComboSalesYet: "Sin datos de ventas de combos",
    createComboHint: "Los datos aparecen al crear combos y vender",
    addToCart: "Agregar al Carrito", saving: "Ahorro", options: " opciones",
    noItems: "Sin items fijos", noOptGroups: "Sin grupos opcionales",
    costHistory: "Historial Costos", notifications: "Notificaciones", stockLow: "Stock Bajo",
    overdueAccount: "Cuenta Vencida", pendingOrdersNotif: "Pedidos Pendientes",
    uploadImage: "Subir Imagen", deleteImage: "Eliminar Imagen", restoreBackup: "Restaurar Respaldo",
    restoreDesc: "Restaurar datos desde archivo JSON", restoreWarning: "Restaurar sobreescribira datos actuales",
    commission: "Comision", commissionRules: "Reglas Comision", commissionReport: "Reporte Comision",
    baseTier: "Base", standardTier: "Estandar", excellentTier: "Excelente",
    commissionRate: "Tasa", estimatedCommission: "Comision Est.",
    totalCommission: "Comision Total", tier: "Nivel", selectMonth: "Seleccionar Mes",
    addEmployee: "Agregar Empleado", editEmployee: "Editar Empleado",
    role: "Rol", deleteEmployeeConfirm: "Eliminar este empleado?",
    rolePresetHint: "Rol (clic para aplicar permisos)",
    permPOS: "POS", permDiscount: "Descuento", permSwitchPrice: "Cambiar precio 1/2/caja", permRefund: "Devolucion", permVoid: "Anular",
    permProducts: "Productos", permInventory: "Inventario", permPurchases: "Compras",
    permCustomers: "Clientes", permReports: "Reportes", permExport: "Exportar",
    permCostPrice: "Precio Costo", permEmployees: "Empleados", permSettings: "Configuracion",
    permPromotions: "Promociones",
    permEditOrders: "Editar Pedidos", permDescEditOrders: "Modificar productos de pedidos completados (auditado)",
    permTakeOnline: "Atender Pedidos Online", permDescTakeOnline: "Aceptar pedidos online/mayoristas, confirmar, imprimir documentos y despachar desde el POS",
    permDescPOS: "Usar caja POS", permDescDiscount: "Aplicar descuentos", permDescSwitchPrice: "Cambiar precio 1/2/caja en POS", permDescRefund: "Procesar devoluciones",
    permDescVoid: "Anular transacciones", permDescProducts: "Agregar/editar productos, sumar stock", permDeleteProducts: "Eliminar / bajar stock", permDescDeleteProducts: "Eliminar o desactivar productos, bajar stock, mermas — sin esto solo puede agregar",
    permDescInventory: "Gestionar stock", permDescPurchases: "Crear ordenes de compra",
    permDescCustomers: "Gestionar clientes", permDescReports: "Ver reportes de ventas",
    permDescExport: "Exportar datos a Excel", permDescCostPrice: "Ver precios de costo",
    permDescEmployees: "Gestionar empleados", permDescSettings: "Configuracion del sistema", permDescPromotions: "Gestionar promociones",
    permGroupWholesale: "🏭 Mayorista", permWsEditPrice: "Cambiar precio mayorista", permWsCredit: "Vender a crédito", permWsCreditLimit: "Cambiar límite de crédito", permWsEditOrders: "Editar/anular pedidos mayoristas", permWsReturns: "Devoluciones mayoristas", wsMaxDiscountPercent: "Descuento máx. mayorista",
    permDescWsEditPrice: "Puede subir el precio sobre la lista; apagado = solo precio de lista", permDescWsCredit: "Puede vender a crédito (fiado)", permDescWsCreditLimit: "Puede cambiar límite de crédito y plazo del cliente", permDescWsEditOrders: "Edita/anula pedidos sin QR del gerente", permDescWsReturns: "Puede procesar devoluciones mayoristas",
    permGroupPOS: "POS", permGroupCatalog: "Catalogo", permGroupCRM: "CRM",
    permGroupReports: "Reportes", permGroupSystem: "Sistema",
    passwordKeepHint: "dejar vacio para mantener",
    enabledCount: "habilitados",
    maxDiscountPercent: "Descuento Maximo",
    superAdmin: "Super Admin",
    shops: "Tiendas",
    shop: "Tienda",
    changePassword: "Cambiar Contraseña",
    oldPassword: "Contraseña Actual",
    newPassword: "Nueva Contraseña",
    confirmNewPassword: "Confirmar Contraseña",
    passwordChanged: "Contraseña cambiada",
    passwordMismatch: "Las contraseñas no coinciden",
    taxReport: "Reporte Fiscal",
    // Analytics Center
    analyticsCenter: "Centro de Analisis",
    acOverview: "Resumen",
    acCustomerAnalysis: "Analisis de Clientes",
    acCategoryAnalysis: "Analisis por Categoria",
    acTrendAnalysis: "Analisis de Tendencias",
    acRevenue: "Ingresos",
    acOrders: "Pedidos",
    acAvgOrder: "Pedido Prom.",
    acCustomers: "Clientes",
    acRevenueTrend: "Tendencia de Ingresos",
    acTotalCustomers: "Total Clientes",
    acActiveCustomers: "Clientes Activos",
    acActivityRate: "Tasa Actividad",
    acTopCustomersChart: "Top 10 Clientes por Gasto",
    acCustomerRanking: "Ranking de Clientes",
    acTotalRevenue: "Ingresos Totales",
    acCategoryCount: "Categorias",
    acTopCategory: "Mejor Categoria",
    acCategoryShare: "Participacion por Categoria",
    acCategoryRevenue: "Ingresos por Categoria",
    acCategoryDetail: "Detalle por Categoria",
    acProductCount: "Productos",
    acShare: "Participacion",
    acPeakHour: "Hora Pico",
    acPeakDay: "Mejor Dia",
    acHourlySales: "Ventas por Hora",
    acWeekdaySales: "Ventas por Dia de Semana",
    acExportProfit: "Exportar Ganancias",
    ac_week: "Esta Semana",
    ac_month: "Este Mes",
    ac_year: "Este Ano",
    acDayUnit: "d",
    acDays: "dias",
    acLast: "Ultimos",
    // Shift Reports
    shiftReports: "Turnos",
    shiftReport: "Reporte de Turno",
    shiftStart: "Hora Inicio",
    shiftEnd: "Hora Fin",
    shiftDuration: "Duracion",
    shiftCount: "Turnos",
    shiftActive: "Activo",
    shiftEnded: "Finalizado",
    shiftTxCount: "Transacciones",
    shiftTxCount2: "transacciones",
    shiftSalesDetail: "Detalle de Ventas",
    shiftReconciliationPrint: "Conciliación punto/caja",
    printA4: "Imprimir A4",
    printTicket: "Imprimir ticket",
    exportExcel: "Exportar Excel",
    poInvoiceNo: "Nº factura / albarán del proveedor (opcional)",
    shiftNetTotal: "Total Neto",
    shiftEndConfirmMsg: "Se generara un reporte detallado de conciliacion",
    shiftGenerateReport: "Generar Reporte",
    // Stock Alerts
    saTotal: "Total Alertas",
    saCritical: "Critico",
    saWarning: "Alerta",
    saOutOfStock: "Sin Stock",
    saLowStock: "Stock Bajo",
    saValueAtRisk: "Valor en Riesgo",
    saCurrentStock: "Stock Actual",
    saMinStock: "Stock Min.",
    saShortage: "Faltante",
    saSuggestedOrder: "Pedido Sugerido",
    saOrderCost: "Costo Pedido",
    saLevel: "Nivel",
    saItemsAffected: "productos necesitan atencion",
    saTotalSuggestedCost: "Costo Total Sugerido",
    saBatchThreshold: "Umbrales en Lote",
    saBatchThresholdDesc: "Ajustar umbrales minimos de stock",
    saUpdated: "Actualizado",
    saAllGood: "Todo Bien",
    saAllGoodDesc: "Todos los productos tienen stock suficiente",
    saAlertBanner: "Alerta de Stock",
    saAutoReorder: "Pedido Automatico",
    saAutoReorderDesc: "Seleccione proveedor y almacen para generar orden de compra automaticamente.",
    saSelectSupplier: "Seleccionar Proveedor",
    saSelectWarehouse: "Seleccionar Almacen",
    saSelectSupplierWarehouse: "Seleccione proveedor y almacen",
    saGeneratePO: "Generar OC",
    saPoGenerated: "Orden de compra generada:",
    supplier: "Proveedor",
    // Dashboard customization
    dbCustomize: "Personalizar",
    dbEditing: "Editando",
    dbResetLayout: "Restablecer",
    dbDragHint: "Arrastre para mover, esquinas para redimensionar",
    // Email Reports
    emailReports: "Reportes Email",
    erSmtpConfig: "Config. Email",
    erSmtpHost: "Servidor SMTP",
    erSmtpPort: "Puerto",
    erSmtpUser: "Usuario",
    erSmtpPassword: "Contrasena",
    erSenderEmail: "Email Remitente",
    erSenderName: "Nombre Remitente",
    erTestEmail: "Enviar Prueba",
    erTestSent: "Email de prueba enviado",
    erConfigSaved: "Config. guardada",
    erConfigured: "Email Configurado",
    erNotConfigured: "Email No Configurado",
    erConfigHint: "Configure SMTP para habilitar reportes por email",
    erAddSchedule: "Agregar Programacion",
    erReportType: "Tipo de Reporte",
    erFrequency: "Frecuencia",
    erRecipients: "Destinatarios",
    erAddRecipient: "Agregar Destinatario",
    erDaily: "Diario",
    erWeekly: "Semanal",
    erMonthly: "Mensual",
    erDailySales: "Resumen Ventas Diario",
    erProfitSummary: "Resumen Ganancias",
    erSendNow: "Enviar Ahora",
    erSentTo: "Enviado a",
    erLastSent: "Ultimo Envio",
    erDisabled: "Deshabilitado",
    erNoSchedules: "Sin Programaciones",
    erNoSchedulesDesc: "Agregue programaciones para envio automatico de reportes",
    // Mobile POS
    mobilePOS: "POS Movil",
    mpSelectStore: "Seleccione tienda para comenzar",
    mpViewCart: "Ver Carrito",
    mpCart: "Carrito",
    mpEmptyCart: "Carrito vacio",
    mpCheckout: "Pagar",
    mpPayment: "Pago",
    mpConfirmPay: "Confirmar Pago",
    backToAdmin: "Volver a Admin",
    transfer: "Transferencia",
    clearCart: "Vaciar",
    // Store Comparison
    acStoreComparison: "Comparacion de Tiendas",
    acStoreCount: "Tiendas",
    acTopStore: "Mejor Tienda",
    acStoreRevenue: "Comparacion de Ingresos",
    acStoreDetail: "Detalle de Tiendas",
    // POS Shortcuts
    editQty: "Editar Cant.",
    editPrice: "Editar Precio",
    uiThemeTitle: "Tema de interfaz",
    uiThemeHint: "Se aplica a toda la tienda: cajas y panel",
    accentColorLabel: "Color de acento (botones / resaltados)",
    defaultColor: "Verde por defecto",
    customColor: "Color personalizado",
    uiThemeSaveHint: "👆 Vista previa al hacer clic. No olvides Guardar para aplicar a toda la tienda",
    aiLegalAdvisor: "Asesor Legal IA",
    editPriceNeedAuth: "Autorización para cambiar precio (QR o contraseña)",
    usdPriceHint: "Precio USD (Bs ÷ tasa)",
    bsPriceLabel: "Precio Bs.",
    usdPriceLabel: "Precio $ USD",
    priceBelowCostConfirm: "¡Precio por debajo del costo! ¿Continuar?",
    shortcutHint: "Flechas para seleccionar, F5 editar cant., F6 editar precio",
    splitPayment: "Pago Dividido", addNote: "Nota", itemNote: "Nota del Producto", orderNote: "Nota del Pedido",
    enterNote: "Ingrese nota...", enterOrderNote: "Ingrese nota del pedido...", clearNote: "Limpiar",
    noSugar: "Sin Azucar", lessIce: "Poco Hielo", extraHot: "Extra Picante", noOnion: "Sin Cebolla", takeaway: "Para Llevar", urgent: "Urgente",
    exact: "Exacto", addPaymentMethod: "Agregar Metodo de Pago",
    // Loyalty Program
    loyaltyProgram: "Programa de Lealtad",
    loyaltyDesc: "Gestionar niveles, reglas de puntos y recompensas",
    loyaltyTiers: "Niveles de Membresia",
    loyaltyMembers: "Total Miembros",
    loyaltyTotalPoints: "Total Puntos",
    loyaltyIssued30d: "Puntos Emitidos (30d)",
    loyaltyRedeemed30d: "Puntos Canjeados (30d)",
    loyaltyLevelDist: "Distribucion por Nivel",
    loyaltyTopMembers: "Ranking de Puntos",
    loyaltyRecentActivity: "Actividad Reciente",
    loyaltyAddTier: "Agregar Nivel",
    loyaltyTierColor: "Color del Nivel",
    loyaltyPointsConfig: "Reglas de Puntos",
    loyaltyEarnRate: "Tasa de Ganancia",
    loyaltyPtsPerDollar: "pts/$",
    loyaltyRedeemRate: "Tasa de Canje",
    loyaltyPtsEqDollar: "pts = $1",
    loyaltyBonusConfig: "Config. de Bonos",
    loyaltyWelcomeBonus: "Bono de Bienvenida",
    loyaltyWelcomeBonusDesc: "Otorgar puntos al registrar nuevo cliente",
    loyaltyBirthdayBonus: "Bono de Cumpleanos",
    loyaltyBirthdayBonusDesc: "Otorgar puntos en el cumpleanos del cliente",
    loyaltyReferralBonus: "Bono de Referido",
    loyaltyReferralBonusDesc: "Otorgar puntos por referir nuevos clientes",
    // Sales Channels
    salesChannels: "Canales de Venta",
    salesChannelsDesc: "Ver rendimiento y tendencias por canal de venta",
    channel_pos: "POS Detalle",
    channel_online: "Tienda Online",
    channel_wholesale: "Mayoreo",
    channelGrandTotal: "Total General",
    channelShare: "Participacion por Canal",
    channelRevenue: "Ingresos por Canal",
    channelTrend: "Tendencia por Canal",
    channelDetails: "Detalle de Canales",
    channelName: "Canal",
    // Member Lookup QR
    loyaltyQrCode: "Codigo QR de Consulta",
    loyaltyQrCodeDesc: "Imprima este QR para que los clientes consulten sus puntos",
    loyaltyQrLink: "Enlace de Consulta",
    loyaltyQrPrint: "Capture pantalla e imprima para mostrador",
    loyaltyNoTenant: "Primero cree un negocio",
    selectTenant: "Seleccionar Negocio",
    copied: "Copiado",
    // Points Mall
    pointsMall: "Tienda de Puntos",
    pointsMallDesc: "Gestionar productos canjeables y ordenes de canje",
    mallItems: "Productos",
    mallOrders: "Ordenes",
    mallAddItem: "Agregar Producto",
    mallEditItem: "Editar Producto",
    mallNoItems: "Sin productos, haga clic para agregar",
    mallType_coupon: "Cupon",
    mallType_gift: "Regalo",
    mallType_balance: "Recarga de Saldo",
    mallStock: "Inventario",
    mallUnlimited: "Ilimitado",
    mallRedeemed: "Canjeado",
    mallFillRequired: "Complete el nombre y los puntos requeridos",
    mallPerLimit: "Limite por cliente",
    mallCouponSettings: "Config. de Cupon",
    mallCouponType: "Tipo de Cupon",
    mallDiscountAmount: "Monto de Descuento",
    mallDiscountPercent: "Porcentaje de Descuento",
    mallMinOrder: "Pedido Minimo",
    mallValidDays: "Dias de Validez",
    mallBalanceSettings: "Config. de Recarga",
    mallBalanceAmount: "Monto de Recarga",
    mallGiftSettings: "Config. de Regalo",
    mallGiftInfo: "Descripcion del Regalo",
    mallGiftInfoPlaceholder: "Ej: Recoger regalo en tienda",
    mallItemName: "Nombre del Producto",
    mallComplete: "Completar",
    mallStatus_pending: "Pendiente",
    mallStatus_completed: "Completado",
    mallStatus_cancelled: "Cancelado",
    active: "Activo",
    inactive: "Inactivo",
    mallTimed: "Limitado",
    mallTimedSale: "Venta Flash",
    mallStartTime: "Hora de Inicio",
    mallEndTime: "Hora de Fin",
    mallUploadImage: "Subir Imagen",
    mallPendingUpload: "Subir al guardar",
    mallImageHint: "JPG/PNG/WebP, cuadrado recomendado",
    // Member Lookup Page
    memberNormal: "Miembro", memberSilver: "Plata", memberGold: "Oro", memberVip: "VIP",
    memberPhonePlaceholder: "Ingrese telefono", memberCodePlaceholder: "Ingrese codigo",
    memberInvalidLink: "Enlace invalido", memberNotFound: "Miembro no encontrado", memberSearchFailed: "Busqueda fallida",
    memberRedeemSuccess: "Canjeado!", memberRedeemFail: "Canje fallido",
    memberInsufficient: "Puntos insuficientes", memberSoldOut: "Agotado", memberLimitReached: "Limite alcanzado",
    memberMyProfile: "Perfil", memberMallTab: "Tienda Puntos", memberOrdersTab: "Historial",
    memberPointsEarn: "Puntos ganados", memberPointsRedeem: "Puntos canjeados",
    memberTimedEnded: "Terminado", memberTimedNotStarted: "No iniciado", memberRedeemBtn: "Canjear",
    memberTrialExpired: "Vencido", memberTrialDays: "Prueba {days}d",
    memberTrialRemaining: "{days} dias restantes",
    memberUpgradeProgress: "Progreso", memberNeedSpend: "Falta gastar", memberMaxLevel: "Nivel maximo",
    mallFlashSale: "Venta Flash", couponCode: "Codigo Cupon",
    memberUpgradeProgress: "Progreso", memberNeedSpend: "Falta gastar", memberMaxLevel: "Nivel maximo",
    mallFlashSale: "Venta Flash", couponCode: "Codigo Cupon",
    // Video Tutorials Page
    vidCatPos: "POS", vidCatProducts: "Productos", vidCatInventory: "Inventario",
    vidCatSales: "Ventas", vidCatCustomers: "Clientes", vidCatReports: "Reportes",
    vidCatSettings: "Configuracion", vidCatGeneral: "Otros",
    vidRecStart: "Grabacion iniciada!", vidRecFail: "No se puede grabar",
    vidUploadSuccess: "Video subido!", vidUploadFail: "Error al subir",
    vidDeleteConfirm: "Eliminar video?", vidDeleted: "Eliminado", vidDeleteFail: "Error al eliminar",
    vidUpdated: "Actualizado", vidUpdateFail: "Error al actualizar",
    vidUploadBtn: "Subir Video", vidUploading: "Subiendo...",
    vidRecHint: "Realice las acciones y haga clic en Detener",
    vidNoData: "Haga clic en Grabar para crear un tutorial o Subir Video",
    vidTitleLabel: "Titulo", vidDefaultTitle: "Tutorial", vidVideoTitle: "Titulo del Video",
    vidSaveUpload: "Guardar y Subir",
    startRecording: "Iniciar Grabacion", stopRecording: "Detener Grabacion", recording: "Grabando",
    vidPreviewTitle: "Vista Previa",
    vidGenerating: "Generando videos tutoriales...",
    vidGenerateBtn: "Generar Tutoriales",
    vidGeneratingBtn: "Generando...",
    vidGenerateSuccess: "Tutoriales generados!",
    vidGenerateFail: "Error al generar",
    vidGenerateDesc: "Grabando operaciones automaticamente y generando videos tutoriales con narracion.",
    vidProgress: "Progreso",
    vidGenerateComplete: "Grabacion completa!",
    done: "Listo", close: "Cerrar",
    // Tenant Management & Subscription
    tenantManagement: "Gestion de Inquilinos",
    addTenant: "Agregar Inquilino",
    totalTenants: "Total Inquilinos",
    activeTenants: "Inquilinos Activos",
    inactiveTenants: "Inquilinos Inactivos",
    tenantName: "Nombre del Inquilino",
    tenantBusinessName: "Nombre del Negocio",
    contactPerson: "Persona de Contacto",
    details: "Detalles",
    plan: "Plan",
    subSubscription: "Suscripcion",
    subAlerts: "Alertas de Suscripcion",
    subExpired: "Expirado",
    subExpiringSoon: "Por Vencer",
    subActive: "Activo",
    subNone: "No Configurado",
    subExpiringSoonList: "Por Vencer Pronto",
    subExpiredList: "Inquilinos Expirados",
    subDaysLeft: " restantes",
    subExpiryDate: "Fecha de Vencimiento",
    subRenew: "Renovar",
    subSuspend: "Suspender",
    subActivate: "Activar",
    subAnnualRevenue: "Ingresos Anuales",
    subStartDate: "Fecha de Inicio",
    subYears: "Anos de Suscripcion",
    subYear: "ano",
    subAnnualFee: "Cuota Anual",
    subNote: "Nota",
    subNotePlaceholder: "Notas de suscripcion...",
    subTrialAccount: "Cuenta de Prueba",
    subTrialDays: "Dias de Prueba",
    subAdminAccount: "Cuenta de Admin",
    subStatus: "Estado de Suscripcion",
    subCurrentExpiry: "Vencimiento Actual",
    subRenewYears: "Anos de Renovacion",
    subConfirmRenew: "Confirmar Renovacion",
    subTrial: "Prueba",
    subDashExpiring: "Alerta de Vencimiento",
    subDashDesc: "Los siguientes inquilinos estan por vencer o han vencido",
    subCopyReminder: "Copiar Recordatorio",
    subReminderCopied: "Mensaje de recordatorio copiado",
    subRenewReminder: "Recordatorio de Renovacion",
    subLastReminded: "Ultimo Recordatorio",
    superAdmin: "Super Admin",
    // Trial Conversion
    trialTitle: "Periodo de Prueba Terminando",
    trialSubTitle: "Suscripcion por Vencer",
    trialExpiredBadge: "Vencido",
    trialRemaining: " restantes",
    trialOverdue: " vencido",
    trialExpiredMsg: "Su acceso ha vencido. Contacte al administrador para renovar y continuar usando todas las funciones.",
    trialExpiringMsg: "Renueve a tiempo para asegurar el servicio continuo. Todos sus datos seran preservados.",
    trialProducts: "Productos",
    trialCustomers: "Clientes",
    trialSales: "Pedidos",
    trialRevenue: "Ingresos",
    trialStores: "Tiendas",
    trialSeeValue: "Ver sus logros de negocio",
    trialValueTitle: "Sus Logros",
    trialValueMsg: "Tiene {products} productos, atendio {customers} clientes, completo {sales} transacciones con ingresos totales de ${revenue}. Todos estos datos valiosos seguiran sirviendole despues de la renovacion.",
    trialAnnualFee: "Cuota Anual",
    trialContactAdmin: "Contacte a su administrador para renovar. Todas las funciones estaran disponibles inmediatamente. Sus datos estan seguros!",
    // Self-Registration
    regTitle: "Prueba Sellox Gratis",
    regSubtitle: "7 dias de prueba gratis, sin tarjeta de credito",
    regCompanyName: "Nombre de Empresa / Tienda",
    regCompanyPlaceholder: "Ingrese el nombre de su empresa o tienda",
    regContactPerson: "Persona de Contacto",
    regContactPlaceholder: "Su nombre",
    regContactPhone: "Telefono",
    regPhonePlaceholder: "Numero de telefono",
    regAccountSection: "Configure su cuenta de administrador",
    regAdminUsername: "Usuario Administrador",
    regUsernamePlaceholder: "Al menos 3 caracteres",
    regPassword: "Contrasena",
    regConfirmPassword: "Confirmar Contrasena",
    regPasswordMismatch: "Las contrasenas no coinciden",
    regPasswordTooShort: "La contrasena debe tener al menos 6 caracteres",
    regTrialNote: "Registrese para una prueba gratuita de 7 dias con acceso completo. Contactenos para actualizar al finalizar la prueba.",
    regSubmit: "Registrarse Ahora",
    regBackToLogin: "Ya tiene cuenta? Volver al inicio de sesion",
    regFreeTrialLink: "No tiene cuenta? Prueba gratis 7 dias",
    regSuccess: "Registro exitoso!",
    regSuccessTitle: "Registro Completado",
    regSuccessDesc: "Su cuenta de prueba esta lista. Guarde la siguiente informacion",
    regTrialPeriod: "Periodo de Prueba",
    regDays: "dias",
    regSaveCredentials: "Recuerde su ID de Comercio y usuario - los necesitara para iniciar sesion. Recomendamos tomar una captura de pantalla.",
    regGoLogin: "Ir a Iniciar Sesion",
    regCopied: "Copiado al portapapeles",
    creditManagement: "Gestion de Credito",
    referralRewards: "Recompensas por Referidos",
    categoryImportSuccess: "Departamentos importados exitosamente",
    enterCategoryName: "Ingrese nombre de categoria",
    addCategory: "Agregar Categoria",
    catCode: "Codigo",
    catNameRequired: "Nombre",
    catRateLabel: "Tasa de Cambio",
    catNote: "Notas",
    systemRate: "Tasa del Sistema",
    usdByRate: "USD (Tasa",
    receiptSentEmail: "Recibo enviado al correo",
    sendFailed: "Error al enviar",
    changeFailed: "Error al cambiar",
    confirmChange: "Confirmar Cambio",
    importDepartments: "Importar Categorias",
    downloadDeptTemplate: "Descargar Plantilla Categoria",
    editWarehouse: "Editar Almacen",
    deleteWarehouseConfirm: "Confirmar eliminar este almacen?",
    cannotDeleteMainWarehouse: "No se puede eliminar el almacen principal",
    warehouseHasStock: "El almacen tiene inventario, no se puede eliminar",
    credit: "Credito",
    creditPayment: "Credito",
    selectCustomerForCredit: "Debe seleccionar un cliente para pago a credito",
    creditRecorded: "Credito registrado",
    paymentCurrencyLabel: "Moneda de Pago",
    bsPayment: "Pagar en Bs",
    usdPayment: "Pagar en $",
    selectPrinter: "Seleccionar impresora:",
    scanQrReceipt: "El cliente escanea QR para recibo digital",
    emailSendReceipt: "Enviar recibo por correo",
    bsPaid: "Pago en Bs",
    usdPaid: "Pago en $",
    invalidLink: "Enlace invalido",
    receiptNotFound: "Recibo no encontrado o expirado",
    paymentSuccess: "Pago exitoso",
    orderNoLabel: "Pedido #",
    customerLabel: "Cliente",
    discountLabel: "Descuento",
    subtotalLabel: "Total",
    bsReference: "Bs. ref.",
    paymentMethodLabel: "Metodo de pago",
    thankYou: "Gracias por su compra",
    pmCash: "Efectivo",
    pmCard: "Tarjeta",
    pmTransfer: "Transferencia",
    pmMixed: "Mixto",
    creditManage: "Gestion de Credito",
    newCredit: "Nuevo Credito",
    totalCreditAmount: "Total Credito",
    creditRecovered: "Recuperado",
    creditOutstanding: "Pendiente",
    creditPendingCount: "Pendientes",
    debtRanking: "Ranking de Deudas",
    creditCount: "registros",
    searchCustomerName: "Buscar cliente...",
    creditStatusPending: "Impago",
    creditStatusPartial: "Parcial",
    creditStatusPaid: "Pagado",
    creditCustomer: "Cliente",
    creditAmount: "Monto Credito",
    creditPaid: "Pagado",
    creditBalance: "Saldo",
    creditDate: "Fecha",
    creditStatus: "Estado",
    creditAction: "Acciones",
    repayment: "Pago",
    repaymentRecord: "Historial de pagos:",
    noCreditRecord: "Sin registros de credito",
    selectCustomerRequired: "Seleccione un cliente",
    enterAmount: "Ingrese el monto",
    creditAdded: "Credito registrado",
    enterRepayAmount: "Ingrese monto de pago",
    repaySuccess: "Pago exitoso",
    repayAmount: "Monto de Pago",
    repayMethod: "Metodo de Pago",
    remarkLabel: "Notas",
    remarkPlaceholder: "Opcional...",
    monthlyGoods: "ej. Mercancia de marzo...",
    selectedLabel: "Seleccionado",
    importDemoData: "Importar Datos Demo",
    demoDataImported: "Datos demo importados",
    copyCatalogLink: "Copiar Link Catalogo",
    catalogLinkCopied: "Link del catalogo copiado",
    extraBarcodes: "Codigos de Barra Extra",
    importProductsLabel: "Importar Productos",
    deptIdAsRate: "ID Categoria como Tasa",
    deptIdAsRateDesc: "Usar columna ID categoria como tasa de cambio, convertir precio Bs a $ ($ = Bs / tasa)",
    deptImportFormat: "Formato categoria: codigo, nombre, tasa, orden",
    deptImportExample: "ej. C001, Funda, 600, 1",
    allOrders: "Todos los Pedidos",
    normalView: "Vista Normal",
    adminVerify: "Verificacion de Admin",
    enterPinToView: "Ingrese PIN de admin para ver todos los pedidos",
    showAllOrders: "Mostrar todos los pedidos",
    pinError: "PIN incorrecto",
    refundAmountLabel: "Monto de Devolucion",
    refundReasonPlaceholder: "Razon de devolucion (opcional)",
    enterOrderNumber: "Ingrese numero de pedido",
    refundOnlyManagers: "Solo gerentes/admins pueden procesar devoluciones",
    refundSearchHint: "O busque en el historial de pedidos",
    refundKeywordPlaceholder: "Pedido #, producto, cliente...",
    refundSearchOrders: "Buscar Pedidos",
    refundResultsFound: "pedidos encontrados",
    refundClickToSelect: "haga clic para seleccionar",
    refundSearchTip: "Ingrese numero de pedido directamente, o busque por nombre de producto, fecha, etc.",
    back: "Volver",
    promoDiscount: "Descuento",
    promoFullReduction: "Compra & Ahorra",
    promoBuyGet: "Compra & Lleva",
    promoFlashSale: "Oferta Relampago",
    promoStatusInactive: "Inactivo",
    promoStatusEnded: "Finalizado",
    promoStatusPending: "Proximo",
    promoStatusActive: "Activo",
    promoEnabled: "Activado",
    promoDisabled: "Desactivado",
    promoAllActivities: "Todas las Promociones",
    promoActiveCount: "Activas",
    promoUpcomingCount: "Proximas",
    promoName: "Nombre Promocion",
    promoType: "Tipo",
    promoContent: "Detalle Oferta",
    promoScope: "Aplica A",
    promoTime: "Duracion",
    promoDiscountTitle: "Promocion de Descuento",
    promoDiscountDesc: "Descuento porcentual en productos. ej: 20% descuento",
    promoDiscountFieldVal: "Descuento (%)",
    promoDiscountFieldValHint: "Porcentaje de descuento. ej: 20 = 20% off",
    promoDiscountFieldMin: "Monto Min. ($)",
    promoDiscountFieldMinHint: "Compra minima requerida. 0 = sin minimo",
    promoDiscountExample: "Ejemplo: 20% off -> Desc=20, Min=0",
    promoFullRedTitle: "Compra & Ahorra",
    promoFullRedDesc: "Gasta monto minimo, recibe reduccion fija. ej: Gasta $100 ahorra $10",
    promoFullRedFieldAmt: "Ahorro ($)",
    promoFullRedFieldAmtHint: "Monto a reducir en dolares",
    promoFullRedFieldMin: "Gasto Min. ($)",
    promoFullRedFieldMinHint: "Gasto minimo requerido",
    promoFullRedExample: "Ejemplo: Gasta $50 ahorra $5 -> Ahorro=5, Min=50",
    promoBuyGetTitle: "Compra & Lleva Gratis",
    promoBuyGetDesc: "Compra cantidad especifica, lleva gratis. ej: Compra 2 Lleva 1",
    promoBuyQty: "Cant. Compra",
    promoBuyQtyHint: "Cantidad que debe comprar",
    promoGetQty: "Cant. Gratis",
    promoGetQtyHint: "Cantidad gratuita",
    promoBuyGetExample: "Ejemplo: Compra 3 Lleva 1 -> Compra=3, Gratis=1",
    promoFlashTitle: "Oferta Relampago",
    promoFlashDesc: "Precio especial durante el periodo. Debe establecer fechas",
    promoFlashPrice: "Precio Oferta ($)",
    promoFlashPriceHint: "Precio durante la promocion",
    promoFlashMinHint: "N/A, dejar 0",
    promoFlashExample: "Ejemplo: Audifonos $65 -> Oferta=39.9",
    promoNamePlaceholder: "ej: 20% Desc, Gasta $100 Ahorra $10...",
    promoDiscountValLabel: "Descuento (%)",
    promoPayPercent: "Paga",
    promoMinSpendLabel: "Gasto Min. ($)",
    promoMinAmtLabel: "Monto Min. ($)",
    promoReductionAmtLabel: "Ahorro ($)",
    promoOrigPriceRef: "Precio Original ($)",
    promoOptionalDisplay: "Opcional, solo para mostrar",
    promoStartDate: "Fecha Inicio",
    promoEndDate: "Fecha Fin",
    promoApplyScope: "Aplica A",
    promoAllProducts: "Todos los Productos",
    promoByCategory: "Por Categoria",
    promoByProduct: "Por Producto",
    promoSelectCategories: "Seleccionar categorias:",
    promoMinOneCategory: "Seleccione al menos una categoria",
    promoSelectProducts: "Seleccionar productos:",
    promoSearchProduct: "Buscar por nombre o codigo",
    promoSelectedProducts: "Seleccionados",
    promoProducts: "productos",
    promoMinOneProduct: "Seleccione al menos un producto",
    promoDescription: "Descripcion (opcional)",
    promoDescPlaceholder: "Notas adicionales...",
    promoPreview: "Vista previa:",
    promoFullDiscountLabel: "Toda la tienda",
    promoLimitedOffer: "Oferta Relampago",
    promoCategories: "categorias",
    enterPromoName: "Ingrese nombre de promocion",
    setPromoDate: "Establezca fechas de inicio y fin",
    endBeforeStart: "Fecha fin no puede ser antes que inicio",
    discountRange: "Descuento debe ser entre 1-100",
    fullRedMinRequired: "Compra & Ahorra requiere monto minimo",
    enterReductionAmt: "Ingrese monto de ahorro",
    setFlashPrice: "Establezca precio de oferta",
    editPromotion: "Editar Promocion",
    addPromotionDialog: "Agregar Promocion",
    fullRedLabel: "Gasta $",
    fullRedOff: "Ahorra $",
    buyLabel: "Compra",
    getLabel: "Lleva",
    specifiedCats: "Por Categoria",
    merchantId: "ID Comerciante",
    barcode: "Codigo de Barras",
    specification: "Especificacion / Peso",
    specPlaceholder: "ej: 500g, 1L, XL...",
    currentId: "ID Actual",
    merchantIdDesc: "Usado para links del catalogo, tienda online, etc. Debe re-iniciar sesion despues de cambiar.",
    changeMerchantId: "Cambiar ID Comerciante",
    newId: "Nuevo ID",
    merchantIdRule: "4-20 caracteres, solo minusculas, numeros, guiones y guion bajo",
    changeIdWarning: "Debe re-iniciar sesion despues del cambio. Tienda online y links tambien cambiaran.",
    merchantIdPlaceholder: "ej: mi-tienda-001",
    // B2B / Franchise HQ
    b2bPortal: "B2B Mayorista", franchiseHQ: "Central Franquicia", franchiseOverview: "Vista General",
    crossStoreInventory: "Inventario Cruzado", pushPrices: "Actualizar Precios", topProducts: "Mas Vendidos",
    b2bCustomers: "Clientes B2B", creditLimit: "Limite Credito", paymentTerms: "Plazo Pago",
    outstanding: "Pendiente", customerType: "Tipo Cliente", discountRate: "Tasa Descuento",
    retailCustomer: "Minorista", wholesaleCustomer: "Mayorista", vipCustomer: "VIP",
    totalStores: "Total Tiendas", todaySalesAll: "Ventas Hoy", weekSalesAll: "Ventas Semana",
    monthSalesAll: "Ventas Mes", storePerformance: "Rendimiento Tiendas", storeName: "Tienda",
    storeAddress: "Direccion", noStoresYet: "Sin tiendas aun",
    pushPriceSuccess: "Precios actualizados", selectProductsFirst: "Seleccione productos",
    batchPriceUpdate: "Precios en Lote", retailPrice: "Precio Venta", wholesalePrice: "Precio Mayoreo",
    applyPriceChanges: "Aplicar Cambios", priceUpdated: "Precios actualizados",
    allWarehouses: "Todos Almacenes", totalQuantity: "Cant. Total", headquarters: "Central",
    // Smart Restock
    smartRestock: "Reabastecimiento", restockSuggestions: "Sugerencias", salesVelocity: "Velocidad Venta",
    dailyAvgSales: "Prom. Diario", weeklyAvgSales: "Prom. Semanal", daysUntilStockout: "Dias para Agotarse",
    suggestedQty: "Cant. Sugerida", suggestedCost: "Costo Sugerido", urgencyLevel: "Urgencia",
    urgencyCritical: "Agotado", urgencyUrgent: "Urgente", urgencyWarning: "Alerta", urgencyLow: "Bajo", urgencyIncoming: "En camino",
    urgencyOk: "Normal", analysisPeriod: "Periodo", days30: "30 Dias", days60: "60 Dias", days90: "90 Dias",
    totalRestockCost: "Costo Total", restockItems: "Productos a Reabastecer",
    salesTrend: "Tendencia", trendUp: "Sube", trendDown: "Baja", trendFlat: "Estable",
    speedFast: "Rapido", speedMedium: "Medio", speedSlow: "Lento", speedDead: "Sin Movimiento",
    generatePO: "Generar Orden Compra", exportRestockList: "Exportar Lista",
    currentStock: "Stock Actual", minStockLevel: "Stock Minimo",
    periodSold: "Vendido en Periodo",
    importToCategory: "Importar a Categoria", importSelectCategory: "Seleccionar Categoria", importCategoryHint: "Todos los productos se asignaran a esta categoria", noCategoryAssign: "Sin asignar (usar del archivo)",
    importFieldSelect: "Campos a Importar", importFieldHint: "Info basica (codigo, nombre, especificacion) siempre se importa", allCategories: "Todas Categorias",
    storeManagerPanel: "Panel Gerente", dailySummary: "Resumen Diario", viewInventory: "Inventario",
    printDailySummary: "Imprimir Resumen", viewOrderDetail: "Ver Detalle de Ordenes",
    transferManagement: "Transferencias", newTransferOrder: "Nueva Transferencia", transferOrderNo: "No. Transferencia",
    fromWarehouse: "Almacen Origen", toWarehouse: "Almacen Destino", totalQuantity: "Cantidad Total",
    pendingReceive: "Pendiente", transferReceived: "Recibido", receiveTransfer: "Recibir Transferencia",
    sentQuantity: "Cant. Enviada", receivedQuantity: "Cant. Recibida", confirmReceive: "Confirmar Recepcion",
    receiveSuccess: "Recibido", createAndPrint: "Crear e Imprimir", selectWarehouse: "Seleccionar Almacen",
    addProducts: "Agregar Productos", searchProduct: "Buscar producto...",

    accountNumber: "Número de Cuenta",
    accountsPayable: "Cuentas por Pagar",
    action: "Acción",
    activeCombos: "Combos Activos",
    actual: "Real",
    actualQty: "Cant. Real",
    add: "Agregar",
    addCustomer: "Agregar Cliente",
    addExpense: "Agregar Gasto",
    addGroup: "Agregar Grupo",
    addNote: "Agregar Nota",
    addPayable: "Agregar por Pagar",
    addPaymentMethod: "Agregar Método de Pago",
    addPromotion: "Agregar Promoción",
    addReceivable: "Agregar por Cobrar",
    addStore: "Agregar Tienda",
    addSuccess: "Agregado exitosamente",
    addSupplier: "Agregar Proveedor",
    addWarehouse: "Agregar Almacén",
    address: "Dirección",
    adminManual: "Manual de Administrador",
    all: "Todos",
    allCategories: "Todas las Categorías",
    allReasons: "Todas las Razones",
    amount: "Monto",
    amountRequired: "Monto requerido",
    analysisPeriod: "Período de Análisis",
    approve: "Aprobar",
    associatedWarehouse: "Almacén Asociado",
    availableQty: "Cant. Disponible",
    avgComboValue: "Valor Promedio Combo",
    avgOrder: "Pedido Promedio",
    backupDesc: "Descripción de Respaldo",
    balance: "Saldo",
    batchDelete: "Eliminar en Lote",
    bundleName: "Nombre del Combo",
    bundlePrice: "Precio del Combo",
    businessType: "Tipo de Negocio",
    cancel: "Cancelar",
    cancelOrder: "Cancelar Pedido",
    cancelled: "Cancelado",
    card: "Tarjeta",
    cash: "Efectivo",
    casheaAmount: "Monto Cashea",
    casheaDesc: "Cuotas Cashea",
    casheaLiveMode: "Modo Real Cashea - Conectado",
    casheaSettingsDesc: "Compra ahora, paga después - cuotas sin intereses",
    category: "Categoría",
    categoryManagement: "Gestión de Categorías",
    categoryRates: "Tasas por Categoría",
    change: "Cambio",
    checkoutTitle: "Pagar",
    clearNote: "Borrar Nota",
    cleared: "Liquidado",
    clockIn: "Entrada",
    clockOut: "Salida",
    close: "Cerrar",
    closeAllBrowserFirst: "Cierre todas las ventanas del navegador primero",
    code: "Código",
    comboOrders: "Pedidos Combo",
    comboRevenue: "Ingresos Combo",
    comboSalesDistribution: "Distribución Ventas Combo",
    commissionReport: "Reporte de Comisiones",
    commissionRules: "Reglas de Comisiones",
    companyAddress: "Dirección de la Empresa",
    companyPhone: "Teléfono de la Empresa",
    completed: "Completado",
    completedStatus: "Completado",
    confirm: "Confirmar",
    confirmClearPending: "¿Confirmar limpiar pedidos pendientes?",
    confirmDelete: "Confirmar Eliminación",
    confirmPayment: "Confirmar Pago",
    confirmReceive: "Confirmar Recepción",
    confirmStockLoss: "Confirmar Pérdida",
    connectionPort: "Puerto de Conexión",
    cost: "Costo",
    costLoss: "Costo de Pérdida",
    costPrice: "Precio de Costo",
    couponCode: "Código de Cupón",
    createAndPrint: "Crear e Imprimir",
    createSuccess: "Creado exitosamente",
    createTime: "Fecha de Creación",
    createWholesaleOrder: "Crear Pedido Mayorista",
    creditLimit: "Límite de Crédito",
    creditor: "Acreedor",
    currency: "Moneda",
    customerName: "Nombre del Cliente",
    customerType: "Tipo de Cliente",
    dailySummary: "Resumen Diario",
    date: "Fecha",
    dateTo: "Hasta",
    days30: "30 Días",
    days60: "60 Días",
    days90: "90 Días",
    daysUntilStockout: "Días hasta Agotamiento",
    defaultOption: "Opción Predeterminada",
    defaultWarehouse: "Almacén Predeterminado",
    delete: "Eliminar",
    deleteEmployeeConfirm: "¿Confirmar eliminar este empleado?",
    deleteFailed: "Error al eliminar",
    deleteImage: "Eliminar Imagen",
    deleteSelected: "Eliminar Seleccionados",
    description: "Descripción",
    directPrintFailed: "Impresión directa fallida",
    discountAboveCostDesc: "Precio con descuento por debajo del costo",
    downloadShortcut: "Descargar Acceso Directo",
    downloadTemplate: "Descargar Plantilla",
    edit: "Editar",
    editEmployee: "Editar Empleado",
    editProduct: "Editar Producto",
    email: "Correo",
    employees: "Empleados",
    enableCashDrawer: "Habilitar Caja Registradora",
    endShift: "Finalizar Turno",
    enterOrderNote: "Ingrese nota del pedido",
    enterPos: "Entrar al POS",
    estimatedCommission: "Comisión Estimada",
    example: "Ejemplo",
    excellentTier: "Nivel Excelente",
    exchangeRates: "Tasas de Cambio",
    expenseByStore: "Gastos por Tienda",
    expenseCount: "Cantidad de Gastos",
    expenseDesc: "Descripción del Gasto",
    expenseDescPlaceholder: "Ingrese descripción del gasto",
    expenseManagement: "Gestión de Gastos",
    export: "Exportar",
    exportBackup: "Exportar Respaldo",
    exportInventoryReport: "Exportar Reporte de Inventario",
    exportRestockList: "Exportar Lista de Reposición",
    extraHot: "Extra Picante",
    failed: "Fallido",
    fillCompleteInfo: "Por favor complete la información",
    fiscalPrinter: "Impresora Fiscal",
    franchiseHQ: "Sede Central",
    franchiseOverview: "Vista General Franquicia",
    generateReport: "Generar Reporte",
    gold: "Oro",
    grossProfit: "Ganancia Bruta",
    groupName: "Nombre del Grupo",
    headquarters: "Sede Central",
    holdOrder: "Retener Pedido",
    hours: "Horas",
    html2canvas: "html2canvas",
    idNumber: "Número de Cédula",
    iframe: "iframe",
    importCategoryHint: "Importar a categoría",
    importFieldHint: "Seleccionar campos a importar",
    importResult: "Resultado de Importación",
    importSelectCategory: "Seleccionar categoría",
    importSuccess: "Importación exitosa",
    inventoryList: "Lista de Inventario",
    inventoryQty: "Cant. Inventario",
    invoiceFooter: "Pie de Factura",
    itemCount: "Cantidad de Artículos",
    itemNote: "Nota del Artículo",
    items: "artículos",
    jspdf: "jspdf",
    labelModeP1: "Precio 1 (Detalle)",
    labelModeP1P3: "Precio 1 + Precio 3",
    labelModeP1W: "Precio 1 + Mayoreo",
    labelModeP3: "Precio 3 (Mayoreo)",
    labelModeUsdP1: "Precio USD 1 (Detalle)",
    labelModeWholesale: "Precio Caja (Mayoreo)",
    labelNoDecimals: "Sin Decimales",
    labelShowBarcode: "Mostrar Código de Barras",
    labelShowForeign: "Mostrar Moneda Extranjera ($)",
    labelShowBs: "Mostrar Bs.",
    labelPaperSize: "Papel",
    labelSize80mm: "80mm Térmico",
    labelSize50x30: "50x30mm Etiqueta",
    labelBilingual: "Bilingüe (ES+CN)",
    last30Days: "Últimos 30 Días",
    last7Days: "Últimos 7 Días",
    lessIce: "Menos Hielo",
    loadFailed: "Error al cargar",
    loading: "Cargando...",
    loginExpired: "Sesión expirada, inicie sesión nuevamente",
    login: "Iniciar Sesión",
    logout: "Cerrar Sesión",
    loyaltyTierBenefits: "Beneficios por Nivel",
    mainWarehouse: "Almacén Principal",
    margin: "Margen",
    markDelivered: "Marcar Entregado",
    maxDiscount: "Descuento Máximo",
    memberCodePlaceholder: "Ingrese código de miembro",
    memberGold: "Miembro Oro",
    memberLimitReached: "Límite de miembros alcanzado",
    memberMallTab: "Tienda de Puntos",
    memberMaxLevel: "Nivel Máximo",
    memberNeedSpend: "Necesita gastar",
    memberNotFound: "Miembro no encontrado",
    memberOrdersTab: "Historial de Pedidos",
    memberPointsRedeem: "Canjear Puntos",
    memberRedeemBtn: "Canjear",
    memberRedeemFail: "Error al canjear",
    memberSearchFailed: "Error en búsqueda",
    memberSilver: "Miembro Plata",
    memberSoldOut: "Agotado",
    memberTimedNotStarted: "Evento no iniciado",
    memberTrialDays: "Días de Prueba",
    memberVip: "Miembro VIP",
    minSpent: "Gasto Mínimo",
    minStockLevel: "Stock Mínimo",
    mixed: "Mixto",
    mobilePay: "Pago Móvil",
    monthly: "Mensual",
    newStockLoss: "Nueva Pérdida",
    newTransferOrder: "Nueva Orden de Transferencia",
    noCategoryAssign: "Sin categoría asignada",
    noComboSalesYet: "Sin ventas de combo aún",
    noCustomerNoPoints: "Sin cliente, sin puntos",
    noData: "Sin datos",
    noOnion: "Sin Cebolla",
    noOptGroups: "Sin grupos de opciones",
    noShift: "Sin turno",
    noStoresYet: "Sin tiendas aún",
    note: "Nota",
    notifications: "Notificaciones",
    offline: "Sin Conexión",
    offlineCacheMode: "Modo Caché Sin Conexión",
    offlineMode: "Modo Sin Conexión",
    onlineOrderTotal: "Total Pedidos en Línea",
    onlineStore: "Tienda en Línea",
    operator: "Operador",
    optionStats: "Estadísticas de Opciones",
    optionalGroups: "Grupos Opcionales",
    options: "Opciones",
    orderComplete: "Pedido Completado",
    orderCount: "Cantidad de Pedidos",
    orderDetail: "Detalle del Pedido",
    orderNo: "N° de Pedido",
    orderNote: "Nota del Pedido",
    orderNotes: "Notas del Pedido",
    originalPrice: "Precio Original",
    overallMargin: "Margen General",
    overwriteDuplicate: "Sobrescribir Duplicados",
    paidAmount: "Monto Pagado",
    paperSize: "Tamaño de Papel",
    password: "Contraseña",
    payable: "Por Pagar",
    paymentAmount: "Monto del Pago",
    paymentInfo: "Información de Pago",
    pending: "Pendiente",
    pendingOrdersNotif: "Notificación de Pedidos Pendientes",
    pendingStatus: "Pendiente",
    phone: "Teléfono",
    pieces: "pzas",
    plan_enterprise: "Empresarial",
    plan_pro: "Profesional",
    points: "Puntos",
    pointsAvailable: "Puntos Disponibles",
    pointsEarned: "Puntos Ganados",
    pointsHistory: "Historial de Puntos",
    pointsMultiplier: "Multiplicador de Puntos",
    pointsRate: "Tasa de Puntos",
    posLogin: "Acceso POS",
    posLoginHint: "Acceso de cajero",
    posMode: "Modo POS",
    posReceiptPrinter: "Impresora de Recibos POS",
    present: "Actual",
    price: "Precio",
    price2: "Precio 2",
    price3Box: "Precio 3/Caja",
    priceSettings: "Config. de Precios",
    priceType: "Tipo de Precio",
    pricing: "Precio",
    printFormat: "Formato de Impresión",
    printInvoiceA4: "Imprimir Factura A4",
    printItemCode: "Imprimir Código",
    printMethod: "Método de Impresión",
    printOrder: "Imprimir Pedido",
    printReceipt: "Imprimir Recibo",
    printSuccess: "Impresión exitosa",
    printTime: "Hora de Impresión",
    printerConnectFailed: "Conexión de impresora fallida",
    printerConnected: "Impresora conectada",
    printerGuide: "Guía de Impresora",
    printerModel: "Modelo de Impresora",
    printerReady: "Impresora Lista",
    printing: "Imprimiendo...",
    processing: "Procesando...",
    product: "Producto",
    productName: "Nombre del Producto",
    profit: "Ganancia",
    progress: "Progreso",
    providedByAdmin: "Proporcionado por admin",
    pushPrices: "Enviar Precios",
    qty: "Cant.",
    quantity: "Cantidad",
    quarterly: "Trimestral",
    quickActions: "Acciones Rápidas",
    ratesUpdated: "Tasas actualizadas",
    recallOrder: "Recuperar Pedido",
    receiptCopies: "Copias del Recibo",
    receiptDetail: "Detalle del Recibo",
    receiveTransfer: "Recibir Transferencia",
    receivedQuantity: "Cant. Recibida",
    receivedStatus: "Recibido",
    recordPayment: "Registrar Pago",
    recording: "Grabando",
    records: "Registros",
    redeemPoints: "Canjear Puntos",
    ref: "Ref",
    refundReason: "Razón de Devolución",
    remaining: "Restante",
    remainingAmount: "Monto Restante",
    reportPrinter: "Impresora de Reportes",
    reports: "Reportes",
    reprintReceipt: "Reimprimir Recibo",
    restockItems: "Artículos para Reponer",
    restockSuggestions: "Sugerencias de Reposición",
    restoreBackup: "Restaurar Respaldo",
    restoreWarning: "La restauración sobrescribirá los datos actuales",
    retailPrice: "Precio de Venta",
    returnReason: "Razón de Devolución",
    revenue: "Ingresos",
    rightClickClear: "Clic derecho para borrar",
    salesExchangeRateDesc: "Descripción Tasa de Venta",
    salesManagement: "Gestión de Ventas",
    salesOrder: "Pedido de Venta",
    salesRateDesc: "Descripción Tasa de Venta",
    salesVelocity: "Velocidad de Ventas",
    save: "Guardar",
    saveRates: "Guardar Tasas",
    saveSettings: "Guardar Configuración",
    scale: "Balanza",
    scanOrSearch: "Escanear o buscar",
    scannerEnabled: "Escáner habilitado",
    searchProducts: "Buscar productos",
    selectAll: "Seleccionar Todo",
    selectCustomer: "Seleccionar Cliente",
    selectImage: "Seleccionar Imagen",
    selectProduct: "Seleccionar Producto",
    selectProductsFirst: "Seleccione productos primero",
    selectStore: "Seleccionar Tienda",
    selectedCount: "seleccionados",
    setDefaultPrinter: "Establecer como impresora predeterminada",
    settingsSaved: "Configuración guardada",
    shipped: "Enviado",
    shopDescPlaceholder: "Ej: Productos frescos, entrega diaria",
    shopDescription: "Descripción de Tienda",
    shopPreview: "Vista Previa Tienda",
    skip: "Omitir",
    skipDuplicate: "Omitir Duplicados",
    skipped: "Omitidos",
    soldQuantity: "Cant. Vendida",
    staleDataInfo: "Los datos pueden estar desactualizados",
    staleDataWarning: "Advertencia de datos antiguos",
    standardTier: "Nivel Estándar",
    startImport: "Iniciar Importación",
    status: "Estado",
    statusCancelled: "Cancelado",
    statusCompleted: "Completado",
    statusPending: "Pendiente",
    stockAlerts: "Alertas de Stock",
    stockLossCostEstimate: "Estimación Costo Pérdida",
    stockLossManagement: "Gestión de Pérdidas",
    stockLossQty: "Cant. Pérdida",
    stockLossReason: "Razón de Pérdida",
    stockLossSuccess: "Pérdida registrada",
    stockLow: "Stock Bajo",
    stockTaking: "Inventario",
    stopRecording: "Detener Grabación",
    storeFilter: "Filtro de Tienda",
    storeManagement: "Gestión de Tiendas",
    storeName: "Nombre de Tienda",
    storePerformance: "Rendimiento de Tienda",
    stores: "Tiendas",
    suggestedCost: "Costo Sugerido",
    supplierManagement: "Gestión de Proveedores",
    supplierName: "Nombre del Proveedor",
    syncPending: "Sincronización Pendiente",
    systemQty: "Cant. Sistema",
    takeaway: "Para Llevar",
    targetAmount: "Monto Objetivo",
    targetType: "Tipo de Objetivo",
    taxId: "RIF",
    tenantIdLabel: "ID de Inquilino",
    tenantLogin: "Acceso Comerciante",
    testPrint: "Imprimir Prueba",
    themeBakery: "Panadería",
    themeButcher: "Carnicería",
    themeClothing: "Ropa",
    themeCustom: "Personalizado",
    themeDepartment: "Tienda por Departamentos",
    themeElectronics: "Electrónica",
    themeGeneral: "General",
    themePharmacy: "Farmacia",
    themeRestaurant: "Restaurante",
    tier: "Nivel",
    time: "Hora",
    toWarehouse: "Al Almacén",
    todaySalesAll: "Ventas Totales Hoy",
    topProducts: "Productos Más Vendidos",
    topupBalance: "Recargar Saldo",
    total: "Total",
    totalExpenses: "Gastos Totales",
    totalLossQty: "Cant. Total Pérdida",
    totalLossRecords: "Total Registros Pérdida",
    totalOrders: "Pedidos Totales",
    totalProducts: "Total Productos",
    totalProfit: "Ganancia Total",
    totalQuantity: "Cantidad Total",
    totalRevenue: "Ingresos Totales",
    totalSales: "Ventas Totales",
    totalSpent: "Total Gastado",
    transferOrderNo: "N° Orden Transferencia",
    trendFlat: "Estable",
    type: "Tipo",
    updateSuccess: "Actualizado exitosamente",
    updated: "Actualizado",
    uploadSuccess: "Carga exitosa",
    urgencyLevel: "Nivel de Urgencia",
    urgencyLow: "Bajo",
    urgencyUrgent: "Urgente",
    urgencyWarning: "Advertencia",
    urgent: "Urgente",
    userManual: "Manual de Usuario",
    vidDefaultTitle: "Video Tutorial",
    vidDeleteFail: "Error al eliminar video",
    vidDeleted: "Video eliminado",
    vidRecFail: "Error en grabación",
    vidUpdateFail: "Error al actualizar video",
    vidUploadFail: "Error al subir video",
    vidUploading: "Subiendo...",
    vidVideoTitle: "Título del Video",
    videoTutorials: "Tutoriales en Video",
    viewInventory: "Ver Inventario",
    viewOrderDetail: "Ver Detalle del Pedido",
    vip: "VIP",
    vipCustomer: "Cliente VIP",
    warehouse: "Almacén",
    warehouseManagement: "Gestión de Almacenes",
    warehouseName: "Nombre del Almacén",
    weekSalesAll: "Ventas Totales Semana",
    weeklyAvgSales: "Ventas Promedio Semanal",
    wholesaleDiscount: "Descuento Mayorista",
    wholesaleMinQty: "Cant. Mín. Mayoreo",
    wholesaleOrder: "Pedido Mayorista",
    cashBalance: "Saldo en Efectivo",
    cashUsd: "Efectivo USD",
    cashVes: "Efectivo Bs",
    cashTransaction: "Operación de Efectivo",
    cashDeposit: "Depósito",
    cashWithdraw: "Retiro",
    cashHandover: "Entrega",
    cashAdjustment: "Ajuste",
    recentRecords: "Registros Recientes",
    employeeAccounts: "Cuentas de Empleados",
    employee: "Empleado",
    newEmpTransaction: "Nueva Transacción de Empleado",
    selectEmployee: "Seleccionar Empleado",
    loanToEmployee: "Préstamo al Empleado",
    goodsCreditToEmployee: "Crédito de Mercancía",
    employeeRepayment: "Reembolso del Empleado",
    salaryDeduction: "Deducción de Salario",
    transactionHistory: "Historial de Transacciones",
    productInfo: "Info del Producto",
    productInfoPlaceholder: "Detalles de crédito...",
    noEmployeeDebt: "Sin registros de deuda",
    notePlaceholder: "Nota...",
    owes: "Debe",
    loans: "Préstamos",
    goodsCredit: "Crédito",
    repaid: "Pagado",
    sale: "Venta",
    exchange: "Cambio",
    addEmployee: "Agregar Empleado",
    idCard: "Cedula",
    employeeStatement: "Estado de Cuenta",
    currentBalance: "Saldo Actual",
    orderNoLookup: "Ingrese numero de orden",
    date: "Fecha",
    staff: "Personal",
    cashier: "Cajero",
    byCashier: "Por Cajero",
    filterByCashier: "Filtrar por Cajero",
    storeManager: "Gerente",
    employeeCredit: "Credito de Empleados",
    printTime: "Hora de Impresion",
    paySalary: "Pagar Salario",
    grossSalary: "Salario Bruto",
    deductFromSalary: "Deducir del salario",
    netPay: "Pago Neto",
    deductMax: "Deducir máximo",
    noDeduct: "Sin deducir (todo en efectivo)",
    repayByBs: "Pagar en Bs →",
    repayByBsHint: "Empleado paga en Bs → convertir auto a USD y deducir",
    rateManagerCustom: "Gerente: tasa propia",
    rateStaffBcv: "Empleado: tasa BCV",
    balance: "Saldo",
    employeeReceivables: "Cuentas por Cobrar Empleados",
    employeeReceivablesNote: "Pendiente",
    totalOwed: "Total Deuda",
    absencePenalty: "Multa por Ausencia",
    creditLimit: "Limite de Credito",
    creditLimitWarning: "Limite de credito excedido!",
    currentOwed: "Deuda Actual",
    afterTxn: "Despues",
    overBy: "Excede por",
    todayAttendance: "Asistencia de Hoy",
    clockIn: "Entrada",
    clockOut: "Salida",
    onDuty: "Trabajando",
    offDuty: "Salio",
    notClockedIn: "Sin Marcar",
    fullDay: "Dia Completo",
    halfDay: "Medio Dia",
    absent: "Ausente",
    dailyRate: "Tarifa Diaria",
    fullDays: "Dias Completos",
    halfDays: "Medios Dias",
    absentDays: "Ausencias",
    currentDebt: "Deuda",
    salaryCalcMode: "Modo Calculo",
    autoCalc: "Auto",
    manualInput: "Manual",
    autoAdjustable: "Auto+Ajuste",
    salaryAmount: "Monto Salario",
    payCycle: "Ciclo de Pago",
    weekly: "Semanal",
    biweekly: "Quincenal",
    monthly: "Mensual",
    siteMonitor: "Monitor del Sitio",
    monitorCheckNow: "Verificar Ahora",
    monitorCurrentStatus: "Estado Actual",
    monitorUptime24h: "Disponibilidad (24h)",
    monitorTotalChecks: "Total Verificaciones",
    monitorAlertConfig: "Configuracion de Alertas",
    monitorAlertEmail: "Email de Alerta",
    monitorEmailRequired: "Ingrese el email de alerta",
    monitorKeyRequired: "Ingrese la API Key de Resend",
    monitorSettingsSaved: "Configuracion guardada",
    monitorConfigured: "Configurado",
    monitorResendHelp: "Obtenga su API Key gratis en",
    monitorResendHelp2: "para recibir alertas de caida.",
    monitorSendTest: "Enviar Alerta de Prueba",
    monitorRecentLogs: "Verificaciones Recientes",
    monitorNoLogs: "Sin registros. El sistema verifica cada 5 minutos.",
    storeReceiptInfo: "Info Factura/Recibo",
    storeReceiptInfoHint: "Si se configura, los recibos de esta tienda usaran esta info en lugar de la empresa.",
    storeReceiptName: "Razon Social (Factura)",
    storeReceiptNamePlaceholder: "Ej: ALFONZO SHOP C.A.",
    storeReceiptAddress: "Direccion Factura 1",
    storeReceiptAddress2: "Direccion Factura 2",
    storeReceiptPhone: "Telefono Factura",
    inventoryDownloadTemplate: "Descargar Plantilla",
    inventoryImport: "Importar Inventario",
    inventoryTemplateDownloaded: "Plantilla descargada",
    inventoryImportSuccess: "Importacion completada",
    importing: "Importando...",
    created: "nuevos",
    updated: "actualizados",
    skipped: "omitidos",
    allStores: "Todas las Tiendas",
    allowedHours: "Horario Permitido (vacio=sin limite)",
    allowedHoursHint: "Hora Venezuela (UTC-4). Ej: 07:00 ~ 22:00",
    allowedIPs: "IPs Permitidas (vacio=sin limite)",
    allowedIPsHint: "Separar IPs con comas. Admin/Gerente exentos.",
    attendanceHistory: "Historial de Asistencia",
    avgPerOrder: "Promedio por Orden",
    bsCashGiven: "Efectivo en USD ($)",
    bsCost: "Costo Bs",
    bsValue: "Valor Bs",
    buyRate: "Tasa de Compra",
    byCurrency: "Por Moneda",
    byPaymentMethod: "Por Metodo de Pago",
    cashGiven: "Efectivo Recibido",
    categoryBreakdown: "Desglose por Categoria",
    categoryName: "Nombre de Categoria",
    clockedIn: "Fichado",
    costUsd: "Costo (USD)",
    dailyBreakdown: "Desglose Diario",
    days: "dias",
    downloadFailed: "Descarga fallida",
    exchangeRate: "Tasa de Cambio",
    expenses: "Gastos",
    expenseFood: "Comida",
    expenseSalary: "Salario",
    expenseSupplies: "Suministros",
    expenseTax: "Impuesto",
    expenseTransport: "Transporte",
    expenseUtilities: "Servicios",
    expired: "Expirado",
    lastDays: "Ultimos Dias",
    lastMonth: "Mes Pasado",
    loadingData: "Conectando al servidor y cargando datos",
    lossBreakdown: "Desglose de Perdidas",
    mixedPayment: "Pago Mixto",
    netProfit: "Ganancia Neta",
    nextPage: "Siguiente",
    noSearchResult: "Sin resultados",
    prevPage: "Anterior",
    print: "Imprimir",
    profitUsd: "Ganancia (USD)",
    rateLabel: "Tasa",
    sales: "Ventas",
    salesBs: "Ventas (Bs)",
    schedule: "Horario",
    sellRate: "Tasa de Venta",
    showing: "Mostrando",
    split: "Dividir",
    store: "Tienda",
    subtotal: "Subtotal",
    thisMonth: "Este Mes",
    todayProfitUsd: "Ganancia Hoy (USD)",
    totalDue: "Total a Pagar",
    totalEmployees: "Total Empleados",
    unassignedStore: "Sin Asignar",
    usdCashGiven: "Efectivo en USD ($)",
    usdEquivalent: "Equivalente USD",
    selectedRate: "Tasa Seleccionada",
    sample: "Ejemplo",
    other: "Otro",
    personalUse: "Uso Personal",
    blackMarket: "Mercado Negro",
    blackMarketGoods: "Productos Mercado Negro",
    buyUsdCash: "Compra USD Efectivo",
    cardToCash: "Tarjeta a Efectivo",
    cashMustBeLess: "Efectivo debe ser menor al total",
    commissionPct: "% Comision",
    installApp: "Instalar Aplicacion",
    installAppHint: "Abre en Chrome para instalar como App",
    // AI Feature
    aiFeatures: "Funciones IA",
    aiEnabled: "IA Activada",
    aiDisabled: "IA Desactivada",
    aiToggle: "Interruptor IA",
    aiSubscriptionFee: "Tarifa Mensual IA",
    aiFeatureNote: "Las funciones de IA requieren un cargo adicional",
    aiRegDisclaimer: "Las funciones de IA (asistente inteligente, verificacion de comprobantes de pago, etc.) requieren una suscripcion adicional y no estan incluidas en el plan base.",
    aiCostPerMsg: "por mensaje",
    aiCostPerImg: "por verificacion de imagen",
    aiMonthlyFee: "Tarifa Mensual IA ($)",
    aiToggleOn: "Activar IA",
    aiToggleOff: "Desactivar IA",
    // Auth Scan
    authRequired: "Autorizacion Requerida",
    authAction: "Accion",
    authScanHint: "Pida al gerente que escanee su codigo QR",
    authScanPlaceholder: "Escanear o ingresar codigo...",
    verify: "Verificar",
    verifying: "Verificando...",
    authSuccess: "Autorizado",
    authFailed: "Autorizacion Fallida",
    authorizer: "Autorizado por",
    authCodeGenerate: "Generar Codigo",
    authCodeRegenerate: "Regenerar",
    authCodePrint: "Imprimir QR",
    noAuthCode: "Sin codigo de autorizacion",
    authCodeGenerated: "Codigo generado",
    priceSwitchNeedAuth: "Cambiar precio requiere autorizacion",
    refundNeedAuth: "Devolucion requiere autorizacion",
    onlyManagerCanSwitch: "Solo gerente/admin puede cambiar precio",
    boxModeNoStock: "Stock insuficiente para una caja completa",
    // Payment methods
    totalDue: "Total a Pagar",
    totalPaid: "Total Pagado",
    remaining: "Restante",
    // Credit overdue
    creditOverdue: "Vencido",
    creditDueSoon: "Por Vencer",
    creditDueDate: "Fecha de Vencimiento",
    creditAlerts: "Alertas de Credito",
    creditOverdaysDays: "Vencido",
    creditDueSoonDays: "Restante",
    days: "dias",
    noOverdueCredits: "Sin creditos vencidos",
    // Price check
    priceCheck: "Consulta de Precios",
    priceCheckSearch: "Ingrese nombre/codigo de barras...",
    canViewPrices: "Ver Precios",
    // Wholesale order
    wholesaleOrder: "Pedido Mayorista",
    selectCustomer: "Seleccionar Cliente",
    addCustomer: "Agregar Cliente",
    addProductsFirst: "Busque y agregue productos al pedido",
    orderSummary: "Resumen del Pedido",
    confirmOrder: "Confirmar Pedido",
    orderCreated: "Pedido Creado",
    orderNotes: "Notas",
    creditLimit: "Limite de Credito",
    creditLimitExceeded: "Limite de credito excedido",
    amountWarning: "Monto inusual",
    largeAmountHint: "El monto recibido es mucho mayor que el total. Verifique si es correcto.",
    correctAmount: "Corregir",
    confirmCorrect: "Si, es correcto",
    salesContacts: "Vendedores",
    addContact: "Agregar",
    noContacts: "Sin vendedores",
    contactName: "Nombre",
    contactPhone: "Telefono",
    editSupplier: "Editar proveedor",
    printReceipt: "Imprimir",
    refundSuccess: "Devolucion exitosa",
    salesperson: "Vendedor",
    selectSalesperson: "Seleccionar vendedor",
    salespersonName: "Nombre del vendedor (opcional)",
    noSalesperson: "Sin vendedor",
    filterBy: "Filtrado por",
    clearFilter: "Quitar filtro",
    voidOrder: "Anular Pedido",
    voided: "Anulado",
    voidReason: "Motivo de anulacion",
    voidReasonPlaceholder: "Ej: Error en monto, pedido duplicado...",
    voidWarning: "Anular restaurara inventario. No se puede deshacer.",
    confirmVoid: "Confirmar Anular",
    voidSuccess: "anulado",
    // === HQ Monitor Center (StoreOverviewPage) ===
    hqTitle: "Centro de Monitoreo",
    hqAutoRefresh: "Actualiza cada 60s",
    hqRefresh: "Actualizar",
    hqLoading: "Cargando...",
    hqNoData: "Sin datos",
    hqLoadFailed: "Error al cargar",
    hqAiAnalysisFailed: "Error en analisis AI",
    hqTotalSales: "Ventas Totales",
    hqToday: "Hoy",
    hqEmployeeDebt: "Deuda Empleados",
    hqOnDutyCount: "En Turno",
    hqActiveShifts: "turnos activos",
    hqStockWarning: "Alerta Stock",
    hqLowStockItems: "Productos bajo stock",
    hqAiAssistant: "Asistente AI",
    hqStoreMonitor: "Tiendas",
    hqEmployeeStatus: "Empleados",
    hqShiftHandover: "Turnos",
    hqSalesDetail: "Ventas",
    hqAlerts: "Alertas",
    hqCashFlow: "Flujo de Caja",
    hqAiHqAssistant: "Asistente AI Central",
    hqAnalyzing: "Analizando...",
    hqReAnalyze: "Re-analizar",
    hqStartAnalysis: "Iniciar Analisis",
    hqAiClickToAnalyze: "Haga clic en \"Iniciar Analisis\" para que AI analice los datos de todas las tiendas",
    hqAiWillCheck: "AI verificara tendencias de ventas, inventario, problemas de empleados y dara sugerencias",
    hqAiAnalyzingData: "AI esta analizando datos de todas las tiendas...",
    hqAiAnalyzingIncludes: "Incluye comparacion de ventas, verificacion de stock, deudas, diferencias de turno, etc.",
    hqViewRawData: "Ver resumen de datos",
    hqOperating: "Abierto",
    hqOrders: "ordenes",
    hqCurrentOnDuty: "En turno actualmente",
    hqSince: "Desde ",
    hqCashBalanceUsd: "Saldo Efectivo USD",
    hqCashBalanceBs: "Saldo Efectivo Bs",
    hqTransactionCount: "Transacciones",
    hqProductLowStock: "productos bajo stock",
    hqCollapseDetails: "Ocultar",
    hqExpandDetails: "Ver Detalles",
    hqUsdIn: "USD Entrada",
    hqUsdOut: "USD Salida",
    hqBsIn: "Bs Entrada",
    hqBsOut: "Bs Salida",
    hqTodayPayments: "Pagos de hoy",
    hqStoreStaff: "Personal",
    hqOnDuty: "En turno",
    hqOwes: "Debe ",
    hqOffline: "Desconectado",
    hqBranch: "Sucursal",
    hqClockIn: "Entrada",
    hqIdCard: "Cedula",
    hqPhone: "Telefono",
    hqLoans: "Prestamos",
    hqGoodsCredit: "Credito",
    hqRepaid: "Pagado",
    hqDebt: "Deuda",
    hqSalaryPaid: "Salario Pagado",
    hqCurrentActiveShifts: "Turnos Activos",
    hqRecentShiftRecords: "Registros de Turnos Recientes",
    hqNoShiftRecords: "Sin registros de turnos",
    hqManager: "Gerente",
    hqDiscrepancy: "Diferencia",
    hqAllStoresSalesSummary: "Resumen de Ventas Todas las Tiendas",
    hqRefund: "Reembolsos",
    hqTodayDetails: "Detalles de Hoy",
    hqLowStockWarning: "Alerta de Stock Bajo",
    hqAllStockOk: "Todos los productos con stock suficiente",
    hqStock: "Stock",
    hqOutOfStock: "Agotado",
    hqHeadquarters: "Central",
    hqBorrow: "Prest.",
    hqCreditShort: "Cred.",
    hqRepaidShort: "Pag.",
    hqShiftDiscrepancyWarning: "Alerta Diferencia de Turno",
    hqCrossStoreTransfer: "Sugerencias de Transferencia",
    hqTransferSuggestionDesc: "Estos productos estan agotados en una tienda pero disponibles en otra",
    hqStockIsZero: "stock es 0",
    hqTransfer: "Transferencia",
    hqTime: "Hora",
    hqType: "Tipo",
    hqDirection: "Direccion",
    hqIn: "Entrada",
    hqOut: "Salida",
    hqHas: "Tiene",
    hqUnits: "unidades",
    hqPaymentWay: "Forma de pago",
    hqTransferNoCash: "Transferencia no afecta el saldo en efectivo",
    hqHolidayCalendar: "Calendario de Feriados",
    hqHolidayTip: "Haga clic en una fecha para marcar/desmarcar como feriado. Trabajar en feriado = 1.5x pago (LOTTT)",
    hqHolidaysThisMonth: "Feriados este mes",
    hqHolidaySet: "Feriado configurado (1.5x pago)",
    hqHolidayRemoved: "Feriado eliminado",
    hqPrefillHolidays: "Pre-llenar feriados oficiales 2026",
    hqHolidaysPrefilled: "Feriados oficiales pre-llenados",
    hqNew: "nuevos",
    price3: "Precio 3",
    boxPrice: "Caja",
    shopQRPoster: "Poster QR de Tienda",
    shopQRPosterDesc: "Generar un poster promocional con codigo QR para tu tienda en linea",
    shopQRUrl: "Enlace de Tienda",
    managerAuth: "Autorizar Gerente",
    managerApproved: "Gerente Autorizado",
    managerAuthRequired: "Se requiere autorizacion del gerente para cerrar turno",
    actualCashCount: "Conteo Real de Efectivo",
    cashReconciliation: "Conciliacion de Caja",
    shiftNotes: "Notas (explique diferencias)",
    expected: "Esperado",
    actual: "Real",
    pendingShiftFound: "Turno sin cerrar encontrado, cierre primero",
    shiftEndAuthHint: "El cierre de turno requiere escaneo o contrasena del gerente",
    passwordAuth: "Contrasena",
    scanCode: "Escanear Codigo",
    authorize: "Autorizar",
    clearInventory: "Vaciar Inventario",
    copyFromMain: "Copiar del Principal",
    editQty: "Editar Cantidad",
    saveQty: "Guardar",
    onlyWithStock: "Solo con stock",
    noStock: "Sin Stock",
    action: "Accion",
    legacyDebt: "Importar Deuda Anterior",
    legacyDebtHint: "Solo registra la deuda, sin descontar efectivo",
    netCash: "Efectivo Neto",
    currentShift: "Turno Actual",
    dailySummary: "Resumen del Dia",
    noActiveShift: "Sin turno activo",
    addProductHint: "El producto se agrega a todas las tiendas, solo esta tienda tendra inventario",
    initStock: "Cantidad Inicial",
    overdue: "Vencido",
    partial: "Parcial",
    paymentVerify: "Verificar Pago",
    priceRequired: "Ingrese el precio",
    productNameRequired: "Ingrese el nombre del producto",
    quickExchange: "Cambio Rapido",
    quickExchangeDesc: "Convertir moneda rapidamente",
    reconciliation: "Conciliacion",
    scanBarcode: "Escanear o escribir codigo de barras",
    scanOrType: "Escanear o escribir",
    selectCategory: "Seleccionar categoria",
    totalChange: "Cambio Total",
    totalReceived: "Total Recibido",
    goExchange: "Ir a Cambio",
    cashReconciliationNote: "Nota de conciliacion",
    rptTitle: "Reporte de Turno",
    rptCashier: "Cajero",
    rptStore: "Tienda",
    rptStart: "Inicio",
    rptClose: "Cierre",
    rptManager: "Gerente",
    rptRate: "Tasa",
    rptSalesByMethod: "Ventas por Metodo",
    rptCashRecon: "Conciliacion de Caja",
    rptSummary: "Resumen Total",
    rptCashUsd: "Efectivo USD",
    rptCashBs: "Efectivo Bs",
    rptCard: "Tarjeta",
    rptTransfer: "Transferencia",
    rptTotalOrders: "Total Ordenes",
    rptTotalBs: "Total Bs",
    rptGrandTotal: "Venta Total",
    rptNet: "Neto",
    rptRefunds: "Devoluciones",
    rptExpected: "Esperado",
    rptActual: "Real",
    rptDiff: "Dif.",
    rptNote: "Nota",
    rptMethod: "Metodo",
    rptUsdReceived: "USD Recibido",
    rptBsReceived: "Bs Recibido",
    chkFillShipping: "Por favor complete los datos de envío",
    chkRefOrProof: "Por favor ingrese referencia o suba comprobante",
    chkSelectBank: "Por favor seleccione el banco",
    chkOrderPlaced: "¡Pedido realizado!",
    chkTransferencia: "Transferencia",
    chkPagoMovil: "Pago Móvil",
    chkCashea: "Cashea",
    chkCasheaSub: "Compra ahora, paga después",
    chkCredit: "Crédito",
    chkCredit7or15: "7 ó 15 días",
    chkWhatsappPay: "Contactar al vendedor para pagar",
    chkConfirmPedido: "Confirmar Pedido",
    chkSending: "Enviando...",
    chkCancel: "Cancelar",
    chkReference: "Referencia",
    chkProof: "Comprobante de Pago (foto)",
    chkUploadProof: "Subir comprobante",

    // ===== Super Admin · Multi-Country & Industry Switch =====
    scTitle: "🌍 Control Global de Tenants",
    scTitleSub: "Multi-País / Super Admin",
    scTotalTenants: "Tenants Totales",
    scCountries: "Países Cubiertos",
    scMonthRevenue: "Ingresos Globales del Mes (USD)",
    scPluginsLive: "{total} plugins · {live} activos",
    scMapTitle: "🗺 Mapa Global de Tenants",
    scMapHint: "Tamaño del círculo = Ingresos del mes (equiv. USD)",
    scTenantsUnit: "tenants",
    scOrdersUnit: "pedidos",
    scThisMonth: "este mes",
    scCurrency: "Moneda",
    scTimezone: "Zona horaria",
    scPluginsTitle: "💳 Registro de Plugins de Pago",
    scCountriesLabel: "Países",
    scByCountryTitle: "Tenants por País",
    scRefresh: "Actualizar",
    scThTenant: "Tenant",
    scThStatus: "Estado",
    scIndustryPlaceholder: "⚡ Cambiar rubro…",
    scIndustryTitle: "Cambiar plantilla de rubro",
    scIndustryConfirm: "¿Cambiar este tenant a \"{industry}\"?\nSe sembrarán categorías + funciones del rubro (restaurante también crea 10 mesas). Los datos existentes se preservan.",
    scIndustryOk: "✅ {tenant} → {industry} (categorías +{cats}, mesas +{tables})",
    scIndustryFail: "Error al cambiar de rubro",
    scCountryConfirm: "¿Cambiar país del tenant a \"{country}\"?\nSe sincroniza moneda / zona horaria / impuesto / FX",
    scCountryOk: "Cambiado · Nuevo FX: {fx}",
    scCountryFail: "Error al cambiar de país",
    scFxRefreshed: "Tipo de cambio actualizado",
    scFxRefreshFail: "Error al actualizar",
    scLoadFail: "Error al cargar",

    // ===== Industry templates =====
    tplProductsRestaurant: "🍽️ Menú / Platos",
    tplProductsFastFood: "🥡 Menú",
    tplProductsClothing: "👕 Estilos",
    tplProductsPharmacy: "💊 Medicamentos",
    tplProductsBeauty: "💅 Servicios",
    tplCategoriesRestaurant: "📋 Categorías del menú",
    tplCategoriesClothing: "🏷️ Temporadas",
    tplCategoriesBeauty: "🏷️ Categorías de servicios",
    tplSalesRestaurant: "🧾 Cuentas de mesas",
    tplSalesBeauty: "🧾 Cuentas de servicios",
    tplMenuTables: "🍽️ Mesas",
    tplMenuKds: "👨‍🍳 Pantalla de cocina",
    tplMenuAppointments: "💅 Citas",
    tplMenuGiftCards: "🎫 Vales de compra",

    dashRestoTitle: "Mesas de hoy",
    dashRestoRevenue: "Ingresos comer aquí",
    dashRestoAvgTicket: "ticket prom.",
    dashRestoScanRate: "📱 Pedidos por QR",
    dashRestoOnlineCount: "en línea",
    dashRestoWalkinCount: "POS en mesa",
    dashRestoTopTables: "🏆 Top 5 mesas",
    dashRestoNoData: "Sin datos hoy",
    dashRestoPeak: "⏰ Horas pico",
    dashRestoUnit: "pedidos",
    dashRestoLoading: "Cargando datos...",

    dashExpiryTitle: "💊 Próximos a vencer / Vencidos",
    dashExpiryLoading: "Cargando vencimientos...",
    dashExpiryAllGood: "✅ Todos los productos vigentes",
    dashExpiryAllGoodSub: "Ningún producto vence en 30 días",
    dashExpiryExpired: "Vencidos",
    dashExpiryCritical: "≤ 7 días",
    dashExpiryWarning: "≤ 30 días",
    dashExpiryStock: "stock",
    dashExpiryDays: "días",
    dashExpiryExpiredDays: "Vencido hace {n}d",
    dashExpiryMore: "+ {n} más... atender en /admin/products",

    dashApptsTitle: "💅 Citas de hoy",
    dashApptsLoading: "Cargando citas...",
    dashApptsNone: "No hay citas hoy",
    dashApptsGoto: "Agregar →",
    dashApptsScheduled: "Pendiente",
    dashApptsDone: "Atendido",
    dashApptsNoShow: "No vino",
    dashApptsCancelled: "Cancelada",

    dashLoyalTitle: "🔄 Clientes leales · ≥2 visitas en 30d",
    dashLoyalLoading: "Cargando...",
    dashLoyalEmpty: "Sin clientes leales aún — ¡pide el teléfono al cobrar!",
    dashLoyalReturning: "recurrentes · total",
    dashLoyalVisits: "visitas",
    dashLoyalAvg: "prom.",

    dashLeaderTitle: "🏆 Vales canjeados · 30d",
    dashLeaderLoading: "Cargando...",
    dashLeaderEmpty: "Sin vales canjeados en 30 días",
    dashLeaderTotal: "vales · total aplicado",
    dashLeaderIssue: "canjeados",
    dashLeaderTopup: "recarga",

    apptPageTitle: "💅 Citas",
    apptPrevWeek: "← Semana anterior",
    apptThisWeek: "Esta semana",
    apptNextWeek: "Siguiente semana →",
    apptNew: "Nueva cita",
    apptTotal: "{n} citas",
    apptToday: "Hoy",
    apptAddSlot: "+ Agregar cita",
    apptCustomer: "Nombre del cliente",
    apptCustomerPhone: "Teléfono",
    apptService: "Servicio",
    apptStaff: "Personal (opcional)",
    apptStart: "Hora de inicio",
    apptDuration: "Duración (min)",
    apptPrice: "Precio ($)",
    apptNote: "Nota",
    apptCreate: "Crear",
    apptCancel: "Cancelar",
    apptStatusScheduled: "Pendiente",
    apptStatusDone: "Atendido",
    apptStatusNoShow: "No vino",
    apptStatusCancelled: "Cancelada",
    apptCommissions: "Comisiones",
    apptServicesDone: "Servicios",
    apptRevenue: "Ingresos",
    apptCommission: "Comisión",
    apptToPay: "A pagar",
    apptNoCommissionData: "Sin citas completadas este mes",
    apptCommissionHint: "Cambia el % y se guarda automáticamente. Solo cuentan citas completadas.",
    apptMarkDone: "Atender",
    apptMarkNoShow: "No vino",
    apptMarkCancelled: "Cancelar",
    apptDelete: "Eliminar",
    apptUnassigned: "Sin asignar",
    apptMin: "min",
    apptCurrentStatus: "Estado actual:",
    apptErrFill: "Ingrese nombre del cliente y servicio",
    apptOk: "✅ Cita creada",
    apptDelConfirm: "¿Eliminar esta cita?",

    // ===== Online shop =====
    shopErrPickTable: "Seleccione su mesa",
    shopErrNamePhone: "Ingrese nombre y teléfono",
    shopBannerDineIn: "Comer aquí · {table}",
    shopBannerDineInUnset: "Comer aquí · sin mesa",
    shopBannerTakeout: "Para llevar / Recoger",
    shopBannerDelivery: "Delivery",
    shopPickTable: "elija mesa",
    shopTablePrefix: "Mesa {n}",
    shopChange: "cambiar",
    shopChkDineInTitle: "{table} · Datos",
    shopChkTakeoutTitle: "Recoger en restaurante",
    shopOrderTypeTitle: "¿Cómo desea su pedido?",
    shopOrderTypeDineIn: "🍽️ Comer aquí (Dine-in)",
    shopOrderTypeDineInSub: "Comer en el restaurante en una mesa",
    shopOrderTypeTakeout: "🥡 Para llevar (Takeout)",
    shopOrderTypeTakeoutSub: "Recoger en el restaurante",
    shopOrderTypeDelivery: "🛵 Delivery (a domicilio)",
    shopOrderTypeDeliverySub: "Le llevamos a su dirección",
    shopRetailModeTitle: "¿Cómo quieres recibir tu compra?",
    shopRetailPickup: "🏪 Retiro en tienda",
    shopRetailPickupSub: "Pides y pasas a buscar, sin costo de envío",
    shopRetailDeliverySub: "Te lo llevamos a tu dirección",

    // 📦 Lotes / Trazabilidad FIFO
    lotsMenuLabel: "📦 Lotes (FIFO)",
    lotsPageTitle: "📦 Trazabilidad de Lotes (FIFO)",
    lotAdd: "Agregar lote",
    lotEdit: "Editar lote",
    lotNo: "N° Lote",
    lotNoAutoGen: "Dejar vacío = auto",
    lotQtyRemaining: "Restante",
    lotQtyUsed: "Usado",
    lotActive: "Lotes activos",
    lotExpired: "Vencidos",
    lotCritical: "≤ 7 días",
    lotWarning: "≤ 30 días",
    lotOk: "OK",
    lotExpiringSoon: "Vencen pronto (30d)",
    lotProductsTracked: "Productos con lote",
    lotRecalled: "Retirado",
    lotRecallConfirm: "¿Retirar este lote? La cantidad se pondrá en 0.",
    lotTraceability: "Trazabilidad / Retirada",
    lotNoSales: "Este lote aún no se vendió.",
    lotSearchPlaceholder: "Buscar producto / lote...",
    lotEmpty: "Sin lotes. Agréguelos manualmente o reciba una compra con lote/vencimiento.",
    lotFieldsRequired: "Producto, almacén y cantidad obligatorios",
    lotCreated: "Lote creado",
    warehouseAll: "Todos los almacenes",
    expiry: "Vencimiento",

    // 🎯 RFM + WhatsApp masivo
    rfmMenuLabel: "🎯 RFM + Envío masivo",
    rfmTitle: "🎯 Segmentación RFM + Envío masivo WhatsApp",
    rfmSegment: "Segmento",
    rfmRecency: "Recencia",
    rfmFrequency: "Visitas",
    rfmMonetary: "Gastado",
    rfmAllSegments: "Todos los segmentos",
    rfmSegmentHint: "Clic en un segmento para seleccionar todos sus clientes y precargar plantilla promocional.",
    rfmSearchPlaceholder: "Buscar nombre / teléfono...",
    rfmEmpty: "No hay clientes con ventas en este período.",
    rfmShowingFirst: "Mostrando primeros 500 — afine el filtro para ver más.",
    rfmBroadcast: "Envío masivo WhatsApp",
    rfmSelectFirst: "Primero seleccione clientes",
    rfmWaNotReady: "WhatsApp Web no conectado — vaya a ajustes.",
    rfmWaWarning: "WhatsApp Web no conectado. Escanee el QR en [📱 WhatsApp Auto-conexión] antes de enviar.",
    rfmComposeMessage: "Redactar envío masivo",
    rfmRecipientCount: "Destinatarios",
    rfmTemplateHint: "Tip: use {name} para insertar el primer nombre del cliente.",
    rfmPlaceholder: "¡Hola {name}! 20% OFF este fin de semana 🎉",
    rfmPreview: "Previa (con María):",
    rfmSendNow: "Enviar ahora",
    rfmJobRunning: "Envío en progreso...",
    rfmBroadcastStarted: "🚀 Envío iniciado",
    rfmBroadcastDone: "✅ Envío completado",
    rfmMessageRequired: "Mensaje vacío",
    rfmWindow30: "Últimos 30 días",
    rfmWindow60: "Últimos 60 días",
    rfmWindow90: "Últimos 90 días",
    rfmWindow180: "Últimos 180 días",
    rfmWindow365: "Último año",
    rfmAiTitle: "✨ Generador IA de Mensajes (GPT-5.2)",
    rfmAiSubtitle: "Genera 3 mensajes WhatsApp según tu rubro + segmento + comportamiento de compra",
    rfmAiHintPlaceholder: "Opcional: Día de las Madres / Nuevos productos / Fin de semana...",
    rfmAiGenerate: "Generar",
    rfmAiInsightsLabel: "IA detectó",
    rfmAvgSpend: "gasto promedio",
    rfmAvgVisits: "visitas promedio",
    rfmAiNoVariants: "IA no devolvió variantes — intente otra vez",
    rfmAiError: "IA falló — verifique saldo de Universal Key",
    rfmSegChampions: "👑 Campeones",
    rfmSegLoyal: "❤️ Leales",
    rfmSegPotentialLoyalists: "📈 Potenciales Leales",
    rfmSegNewCustomers: "🆕 Nuevos",
    rfmSegPromising: "✨ Prometedores",
    rfmSegNeedAttention: "⚠️ Necesitan Atención",
    rfmSegAtRisk: "🚨 En Riesgo",
    rfmSegHibernating: "🌙 Hibernando",
    rfmSegOthers: "👥 Otros",
    rfmAiVariantPicked: "Seleccionada",
    grossSales: "Venta bruta",
    shiftReconcile: "🔧 Reconciliar (desde órdenes)",
    shiftReconcileConfirm: "¿Recalcular los totales de este turno desde el registro de órdenes?",
    shiftReconcileForceClose: "¿También forzar cierre del turno?",
    shiftReconcileDone: "✅ Reconciliado",
    orphanCreditsMenu: "🔧 Créditos huérfanos",
    orphanCreditsTitle: "🔧 Reparación de créditos huérfanos",
    orphanCreditsFound: "Créditos huérfanos encontrados",
    orphanCreditsHint: "El cajero presionó Crédito pero no seleccionó cliente/empleado — haga clic en «Asignar».",
    orphanCreditsNone: "✅ Sin créditos huérfanos — todos están bien asignados.",
    orphanCreditsEmpty: "Sin créditos huérfanos coincidentes",
    orphanAssign: "Asignar",
    orphanAssigned: "✅ Asignado",
    orphanPickTitle: "Asignar a...",
    orphanPickEmployee: "👤 Empleado",
    orphanPickCustomer: "🧑‍🤝‍🧑 Cliente",
    orphanSearchPlaceholder: "Buscar pedido / artículo / cajero...",
    orphanSearchEmp: "Buscar empleado...",
    orphanSearchCust: "Buscar cliente / teléfono...",
    cashier: "Cajero",
    outOfStock: "Producto AGOTADO",
    currentStock: "Stock actual",
    agotadoHint: "Reabastezca primero o pida al gerente activar «permitir stock negativo» para continuar",
    understood: "✓ Entendido",

    // 🏆 Desempeño del personal (detallado)
    staffPerfMenu: "🏆 Desempeño del personal",
    staffPerfTitle: "🏆 Desempeño del personal — Detalle",
    staffPerfEmployees: "Empleados",
    staffPerfOrders: "Pedidos",
    staffPerfGross: "Ventas brutas",
    staffPerfRefunds: "Devoluciones",
    staffPerfNet: "Ventas netas",
    staffPerfAvg: "Ticket promedio",
    staffPerfRate: "Tasa %",
    staffPerfEarnings: "Comisión $",
    staffPerfCommission: "Comisión total",
    staffPerfTopProducts: "Top 3 productos",
    staffPerfEmpty: "Sin ventas en este período.",
    allStores: "Todas las tiendas",
    from: "Desde",
    to: "Hasta",
  pleaseConnectPrinter: "Conecte la impresora",
  connectPrinterHint: "Haga clic en ⚡ para conectar la impresora USB",
  printError: "Error de impresión",
  labelPrinted: "Etiqueta impresa",
  labelsPrinted: "Etiquetas impresas",
  popupBlocked: "Popup bloqueado",
  printerCheckConnection: "Verifique que la impresora esté encendida y conectada",
  selectProducts: "Seleccione productos",

  // E1_POS_I18N_V1
  pmVerifyTitle: 'Verificar pago',
  pmRefPlaceholder: 'Nº de referencia (mín 4 dígitos)',
  pmRefMin4: 'Mínimo 4 dígitos',
  pmVerifyBtn: 'Verificar',
  pmMustVerify: '🔒 Verificación obligatoria: el pago debe estar confirmado y cubrir el total',
  pmReused: 'Referencia YA USADA',
  pmVerdictOk: 'PAGO CONFIRMADO',
  pmInfoBank: 'Banco',
  pmInfoTime: 'Hora',
  pmInfoFrom: 'De',
  pmInfoRef: 'Referencia',
  pmAmountShort: 'Monto menor al total:',
  pmNotFoundTitle: 'NO ENCONTRADO',
  pmNotFound: 'El pago aún no llega. Si el cliente acaba de transferir, espera unos segundos y verifica otra vez.',
  pmMarkPendingBtn: '⚠️ Sin SMS del banco — cobrar como PENDIENTE de verificar',
  pmMarkPendingConfirm: '¿El SMS del banco no llegó? La venta quedará marcada ⚠️ PENDIENTE y el encargado debe verificarla al cerrar el turno.',
  pmPendingToast: '⚠️ Venta marcada PENDIENTE de verificar',
  pmPendingBanner: 'Puedes cobrar; el encargado debe verificar este pago al cerrar el turno.',
  pmBlockToast: 'Verifica el pago o márcalo PENDIENTE primero',
  pvTitle: 'pago(s) PENDIENTE(S) de verificar',
  pvHint: 'El SMS del banco no llegó al cobrar. Verifica si el dinero realmente entró antes de cerrar el turno.',
  pvOk: 'Llegó',
  pvBad: 'No llegó',
  pvBadConfirm: '¿Confirmar que el pago NO llegó? Quedará marcado para reclamar.',
  pvStillNo: '❌ Aún NO aparece',
  reconciliationMenu: 'Conciliación Diaria',
  apartadosMenu: 'Apartados',
  cameraBossMenu: 'Cámara Jefe',
  pointsQrMenu: 'QR de Puntos',
  deliveryMenu: 'Repartidores',
  marketingBlastMenu: 'Difusión Masiva',
  clothingVariantsMenu: 'Variantes Talla/Color',
  aiCreditsMenu: 'Créditos AI',
  waOutboxMenu: 'WhatsApp Pendientes',
  waConnectMenu: 'WhatsApp Conexión + Festivos',
  syncQueueMenu: 'Cola de Sincronización',
  fxAlertsMenu: 'Alertas de Tasa',
  bossPinMenu: 'PIN WhatsApp del Jefe',
  reportsHubMenu: 'Centro de Análisis',
  taxReportHint: 'Seleccione un rango de fechas y genere el reporte',
  autoRefresh: 'Auto-actualizar',
  fixedQRTip: 'QR fijo — imprímalo y péguelo en la caja',
  matched: 'Verificado',
  noRef: 'Sin referencia',
  paymentVerification: 'Verificación Pago Móvil',
  printFiscal: 'Imprimir factura',
  recentUploads: 'Subidas recientes',
  saveSchedule: 'Guardar horario',
  searchByOrderNo: 'Buscar N° de orden',
  verifyPayment: 'Verificar pago',
  waitingCustomerUpload: 'Esperando que el cliente escanee y suba...',
  x_7b6a3713: 'Sin permiso',
  x_930e724c: 'Por favor introduce un precio válido',
  x_58abd523: 'Caché borrada, recargando datos...',
  x_567717bd: 'Los datos han sido actualizados.',
  x_13284485: 'Error al actualizar:',
  x_c67c3701: 'La red ha sido restaurada y los datos se están actualizando...',
  x_ec64f9ef: 'Conexión restaurada',
  x_97249636: 'Modo offline',
  x_srv_down: '🔴 El servidor Sellox no responde (tu internet está bien). Modo offline: puedes seguir cobrando, se sincroniza al volver',
  x_de00636b: 'Precio mayorista',
  x_3355b9c9: 'Turno sincronizado',
  x_cdcb5470: 'El token se ha renovado automáticamente',
  x_65deb2f1: 'Error al volver a iniciar sesión automáticamente, inicie sesión manualmente',
  x_066dcc67: 'El inicio de sesión ha caducado. Inicie sesión nuevamente después de que se restablezca la red para sincronizar los pedidos.',
  x_05b73e1e: 'Reenviado a la cola',
  x_4668b3da: 'El reenvío falló:',
  x_cfc81929: '¿Está seguro de que desea borrar todos los pedidos pendientes?',
  x_59462c81: 'despejado',
  x_769d88e4: 'completo',
  x_a3605cd3: 'Se ha detectado un registro de turno no entregado. Por favor entregue su turno primero.',
  x_d3ab821c: 'El inicio de sesión ha caducado, inicie sesión nuevamente',
  x_904b6b66: 'Impresora USB conectada (impresión silenciosa)',
  x_bfff47cd: 'La balanza electrónica está conectada.',
  x_3b0e123b: 'Sólo el administrador/gerente de la tienda puede operar el informe de pérdidas.',
  x_316b388f: '✅ El pedido ha sido realizado (no hay platos nuevos, no impresos)',
  x_1c68b907: 'Actualmente hay artículos en el carrito de compras. ¿Quieres colgar primero y luego cambiar de mesa?',
  x_bd2ec68d: 'No se puede encontrar el orden de la tabla.',
  x_4a61c29a: 'Modo sin conexión',
  x_87dc2a1a: 'No se puede iniciar sesión en modo fuera de línea; primero inicie sesión en línea',
  x_e4bb7fff: 'Modo sin conexión: utiliza datos almacenados en caché',
  x_c8d270fe: '⚠️ ATENCIÓN / ADVERTENCIA\\n\\n',
  x_428684a8: 'El servidor no responde y es posible que la clase no se cargue correctamente. \\n\\n',
  x_990dd915: 'Se ha guardado temporalmente en esta máquina. Si la red aún está desconectada mientras continúa vendiendo productos, se asignará al equipo de ventas a un turno temporal y se notificará al jefe después del trabajo para que lo verifique.',
  x_d04b8716: '⚠️MODO SIN CONEXIÓN\\n\\n',
  x_58f36ff7: 'Actualmente no existe ninguna red. Los turnos sólo se guardarán localmente. \\n\\n',
  x_59875eda: 'Si la red sigue sin estar disponible, las ventas de hoy quedarán relegadas a un turno temporal y la conciliación tras la salida del trabajo llevará más tiempo. \\n\\n',
  x_d1737caf: 'Sugerencia: espere de 1 a 2 minutos para que la red se recupere antes de volver a intentarlo. \\n\\n',
  x_05d979dc: '¿Continuar de todos los modos? / ¿Aún quieres continuar?',
  x_3bddf726: 'Por favor comienza la clase primero.',
  x_bec775e5: 'No se pudieron cargar los datos de conciliación',
  x_d31c6a37: '⚠️ ¡Aún no hay registros de ventas para este turno! \\n',
  x_d8e2e78b: '¿Estás seguro de que quieres terminar la clase? \\n¿ ¿Confirmar tu turno?\\n\\n',
  x_cc49e31b: '(La cancelación puede continuar con el negocio)',
  x_6d35a343: '✅ Todos los pedidos han sido subidos al servidor',
  x_ac03942e: '⚠ La API de turno falló y se agregó a la cola para sincronizarse. Lo intentará automáticamente nuevamente después de que se restablezca la red.',
  x_86c1eb39: 'Cambiar de cuenta',
  x_2767058e: 'Cliente agregado exitosamente',
  x_6452a055: 'Error al agregar',
  x_8b2a8a38: 'Los datos se han sincronizado automáticamente.',
  x_d23f4e73: 'Peso inválido',
  x_b189550a: 'Añadido',
  x_a5366b92: 'No reducible al costo',
  x_c0297a24: 'El turno anterior expiró — abre un turno nuevo / El vuelo anterior ha caducado, inicie el vuelo primero',
  x_da71e1f7: 'Modo sin conexión: la clase comenzó automáticamente',
  x_0bb666b2: '¡El pedido no se puede guardar en esta máquina! Por favor inmediatamente:\\n\\n',
  x_573ee6e2: '1) Foto al recibo / Toma fotos y guarda el recibo\\n',
  x_f474a85a: '3) Avisa al jefe / Notificar al jefe para realizar entradas adicionales manualmente\\n\\n',
  x_5e8eda89: '⚠️ Error al guardar sin conexión: ¡tome una foto del recibo y notifique al jefe!',
  x_fef4f558: '❌ PEDIDO RECHAZADO / Pedido Rechazado\\n\\n',
  x_0eccf7aa: 'Motivo/Razón:',
  x_4187e323: '¡El pedido no fue acreditado! El carrito de la compra ha sido reservado. Resuelva el problema y vuelva a cobrar el pago. \\n',
  x_1bc8b552: '¡El servidor no responde y el pedido no se puede guardar localmente! Inmediatamente:\\n\\n',
  x_48449982: '3) Avisa al jefe / Notificar al jefe para realizar entradas adicionales manualmente',
  x_8c837c19: '⚠️ Totalmente incapaz de guardar: ¡tome un recibo y notifique al jefe!',
  x_081947d7: 'Error de impresión:',
  x_93fdb105: 'Enviado a la impresora',
  x_a63bd9a0: 'ID de comerciante',
  x_b5caf579: 'Por ejemplo: 21da4d91',
  x_ca95bed3: 'Ir al Panel Admin',
  x_bd0271ed: 'Cargando...',
  x_e6e60286: 'Conexión al servidor y carga de datos',
  x_81960a3b: 'Entra en el fondo',
  x_3f685cd2: 'Clear customer',
  x_5e3d6f1e: 'Mesas',
  x_c5b1fdb6: 'Dividir cuenta',
  x_987d1310: 'Urgente enviado',
  x_3e0187a0: 'Apurar cocina',
  x_4f9af33b: 'Actualmente hay artículos en el carrito de compras. ¿Descartar y limpiar la mesa? (Se recomienda presionar F4 para realizar un pedido primero)',
  x_93a34d2b: 'mesa clara',
  x_2e0d8c60: 'Error al exportar:',
  x_4429e2af: 'Ingrese manualmente el tipo de cambio USD→Bs de hoy (por ejemplo, 478)\\nTarifa manual para hoy:',
  x_496630eb: 'Tipo de cambio no válido',
  x_632d6847: 'El tipo de cambio se ha sincronizado con el servidor.',
  x_e1bbd792: '(Subiendo...)',
  x_a66048b8: '(Subir automáticamente después de conectarse a Internet)',
  x_a5596eed: 'No se pueden exportar órdenes a sincronizar',
  x_87bae330: 'La exportación USB falló:',
  x_0d05c12d: 'Empaquete los pedidos que se sincronizarán en archivos JSON (puede llevar una unidad flash USB a una PC con una red para cargar)',
  x_483b3198: 'Los archivos sellox-usb-*.json exportados desde otras PC se fusionan en la cola local para sincronizarse.',
  x_d6c969fc: 'La importación USB falló:',
  x_0257f05e: 'Error de formato',
  x_97072b48: 'Cámara escanear',
  x_4aeb4434: 'Venta rápida: introduzca directamente el precio (cigarrillos/bolsas/productos a granel)',
  x_c017be6f: 'carrito de compras',
  x_9897d884: 'mercancía',
  x_5d7dbac5: 'cargo por servicio',
  x_e92b87e6: 'No hay ventas pendientes, todo subido',
  x_ac05c6e0: 'Selecciona un cliente',
  x_822d3b01: 'Error',
  x_ece89972: 'Reenviar',
  x_47c14729: '¿Eliminar definitivamente?',
  x_c1d0ffe6: 'Venta Rápida',
  x_703ccc54: 'Productos sin códigos de barras: cigarrillos/bolsas/mercancías a granel, etc., ingrese el precio directamente para agregar al carrito de compras',
  x_0e9fd989: 'Precio',
  x_8d70d6cc: 'nombre (opcional)',
  x_2ba4914f: 'Por ejemplo: Cigarrillo/Cigarro/Bolsa',
  x_62d36990: 'añadir al carrito',
  x_c542cafa: 'Este producto está agotado',
  x_cd14d6ac: 'Inventario actual',
  x_f0f7c38e: 'Primero reponga los productos o pídale al gerente que active "Permitir inventario negativo" antes de continuar con la venta.',
  x_b6fc6280: '✓ Lo tengo (Entendido)',
  x_5e3c50d7: 'Cliente:',
  x_79283113: '¡Por favor confirme! Se borrará automáticamente después de realizar el pedido.',
  x_3a4e7b4a: 'dividir el pedido',
  x_1a3e9cc8: 'instar a las verduras',
  x_5a99b099: 'hoy es',
  x_69eccd2b: 'Es tu cumpleaños. ¿Quieres un pequeño obsequio/obsequio/descuento de cumpleaños? 🎁',
  x_d53b49d4: 'cerrar',
  x_71e5e874: '📡 Sin conexión',
  x_bf349b27: '— La facturación del cajero es normal, los documentos se guardaron localmente y se cargarán automáticamente después de conectarse a Internet.',
  x_5326b4f3: '⚠️ Tipo de cambio BCV vencido',
  x_1d5e15a6: 'Vencido/Atrasado:',
  x_02117218: 'Pronto / Expira pronto:',
  x_c4d536c0: '📋Reglas/Reglas:',
  x_7f038370: '📱 Ver en línea / Ver en línea:',
  x_56c29a7f: '¡Gracias! / Gracias por visitar',
  x_f59fbcc6: 'Granel · Introducir peso',
  x_75c7e478: 'Pedidos rechazados',
  x_9b109b95: 'No grabado',
  x_261d3371: '🔁 Volver a enviar',
  x_2300874f: '🗑 Eliminar',
  x_faf1993a: 'Todo procesado ✅',
  x_76ddec31: 'Nota: ¡Eliminar productos afectará a todas las sucursales! ¿Estás seguro de eliminar este producto?',
  x_69b0f684: 'Desactivado',
  x_53ace430: 'Habilitado',
  x_5fa802be: 'Operación fallida',
  x_9424cd13: 'Error de impresión: permita ventanas emergentes',
  x_e80262e7: 'La impresora está conectada',
  x_ce79f0c8: 'No se pudo conectar a la impresora',
  x_7aa71b32: 'Nota: ¡Eliminar productos afectará a todas las sucursales!',
  x_631cd220: 'Confirmar eliminación',
  x_35a7afeb: 'artículos',
  x_0007d170: 'Eliminar exitosamente',
  x_7775d70e: 'Ningún producto con imagen',
  x_d34bd225: 'Créditos AI insuficientes',
  x_54e5de42: 'Error al subir',
  x_7fb62b30: 'Eliminación por lotes',
  x_56b318c4: 'Subir imágenes en lotes',
  x_06a90552: '¿Está seguro de que desea recodificar todos los productos ordenados por nombre? (01, 02, 03...)',
  x_9708fbed: 'Reordenamiento de codificación completado',
  x_d959452f: 'Reordenamiento de codificación',
  x_7bf54e28: 'Seleccionado',
  x_66eeacd9: 'Seleccionar todo',
  x_a04144e4: 'Deseleccionar todo',
  x_cd0b9aca: 'Eliminar seleccionado',
  x_3c237c07: 'Conectar impresora',
  x_c5ea9c6a: 'Conectado',
  x_81ba5ea7: 'Imprimiendo...',
  x_de2bc1d2: 'Visualización de etiquetas',
  x_693b926b: 'Mostrar moneda extranjera ($)',
  x_3b64fbff: 'Mostrar B',
  x_80806771: 'Sin decimales',
  x_ac837e75: 'Mostrar código de barras',
  x_55c475bb: 'papel de etiqueta',
  x_b2a6f7ae: 'térmica de 80 mm',
  x_9e5dde5b: 'etiqueta de 50x30mm',
  x_a7ad78bd: 'Bilingue (ES+CN)',
  x_5423e287: 'Sin fotos',
  x_9460a7d0: 'Tamaño × Variaciones de color',
  x_5b02e434: 'Discontinuado (mantener en stock)',
  x_7b6defeb: 'Volver a habilitar',
  x_2f4aaddd: 'Eliminar',
  x_4d775d4c: 'mostrar',
  x_f4f85316: 'Pagina anterior',
  x_b4e1b508: 'Página siguiente',
  x_8056acb6: 'A granel',
  x_8fe35fdc: 'min',
  x_7d1f14ef: '0 = apagado',
  x_dc90fae8: 'ajuste de inventario',
  x_a59299fc: 'Gestión de transferencia de carga',
  x_01dcb2bb: 'La solicitud de imagen falló, primero configure el número del jefe en /admin/whatsapp-settings',
  x_d5124910: 'Quitar fondo con IA? (3 créditos)',
  x_cfc6745d: 'Procesando... (~15s)',
  x_57553dee: '¡Recorte de IA completado!',
  x_94c6b3ba: 'Falló el corte de IA',
  x_b4168dc5: '¿Usar la imagen original para volver a recortar la imagen con IA? Resta otro 1 punto de IA',
  x_afcaa4ef: 'Reprocesamiento de IA...',
  x_b6cd67bb: '¡El recorte está completo!',
  x_164df077: 'Recorte fallido',
  x_48fde72b: '¿Restaurar la imagen original antes del recorte de AI?',
  x_80145d31: 'La imagen original ha sido restaurada.',
  x_7bd43c80: 'Restauración fallida',
  x_c74e4f1a: 'Seleccione categoría de importación',
  x_5fcb1e4d: 'Seleccionar categoría',
  x_45e49ae9: 'No especificado (use la clasificación del archivo)',
  x_7c60e550: 'Después de la selección, todos los productos importados se clasificarán en esta categoría.',
  x_e111f522: 'Seleccionar campos de importación',
  x_41e49b1c: 'La información básica (número, nombre, especificaciones) siempre se importa',
  x_020f1ecd: 'Empezar a subir',
  x_92cd554e: 'Subiendo...',
  x_794a4ecb: 'Todos los productos',
  x_abaff128: 'Ejemplo: 10 = costo aumentado en un 10%',
  x_2fff577b: 'Por favor complete al menos un elemento',
  x_9fce5962: 'Categoría:',
  x_2fb90b05: 'Procesando...',
  x_2901ac42: 'Confirmar ajuste de precio',
  x_727dc210: 'Recorte de IA por lotes',
  x_7385d670: 'Seleccionar todo con fotos',
  x_625fb26b: 'Cancelar',
  x_a642d255: 'Nombre de la tienda:',
  x_04870124: 'Etiqueta tienda',
  x_d5acfdec: 'Sin etiqueta',
  x_6e41198f: 'HOT',
  x_46a742e3: 'NUEVO',
  x_e1179aa4: 'OFERTA',
  x_47eddf7c: '🥬 A granel / vendido por gramos y kilogramos',
  x_7c88c892: '(La tienda en línea mostrará la etiqueta "A granel" y los clientes podrán comprar decimales como 0,5/1,8)',
  x_28b47633: 'Temporada',
  x_7c8d6872: 'Sin temporada —',
  x_2f1cc7f8: 'Primavera',
  x_e87105bf: 'Verano',
  x_dded849e: 'Otoño',
  x_7c7a55ef: 'Invierno',
  x_6047e490: 'Todo el año',
  x_89f7904f: 'Para descuentos de fin de temporada.',
  x_9966d712: 'Etapa',
  x_61541067: 'Sincronizado —',
  x_efd81299: 'Entrada primero',
  x_864dc4dc: 'Plato principal',
  x_125653fe: 'Acompañamiento',
  x_c64f64c1: 'Bebida',
  x_c63fb6f7: 'Postre al final',
  x_e091ce54: 'La cocina votará según este grupo · Cocina grupo por etapa',
  x_58b439e0: 'Tiempo prep',
  x_210974b9: 'Se utiliza para ordenar e instar pedidos.',
  x_4a2ac468: 'Imprimir en cocina',
  x_88ca75d5: 'Los pedidos realizados después del cierre no se enviarán a cocina (apto para bebidas/compras al aire libre)',
  x_ee4e4b38: 'Lote',
  x_e7100153: 'Vencimiento',
  x_1ac5191c: 'Producto recetado',
  x_52af7df5: 'La identidad del cliente será registrada obligatoriamente durante las ventas.',
  x_ae0b0527: 'Serial',
  x_89d8ab7a: 'Garantía (meses)',
  x_b5e44315: 'Variantes / variaciones de sabor',
  x_5adfcd10: '(separado por comas)',
  x_72ee7c09: 'Cant. mayorista auto',
  x_378c05db: '(Almacén principal de ALFONZO SHOP)',
  x_c852c3dc: 'Otros almacenes (solo lectura, utilice "Ajuste de inventario" o "Gestión de transferencias" para modificar)',
  x_5c0c578b: '📱Foto de WhatsApp por favor',
  x_a1773715: '✨Recorte de IA',
  x_90f7259e: '🔄 Recorte',
  x_e955fcb2: '↩️Restaurar imagen original',
  x_ae5ad52a: 'Cargar imágenes de productos en lotes',
  x_7c5dc935: 'Cómo utilizar:',
  x_eabafd4b: '1. Haga clic en el archivo de imagen',
  x_f9d8b163: 'Código de producto',
  x_25c971d2: 'Nombre',
  x_c2654942: 'Por ejemplo: código de producto',
  x_d13c1bb8: '→La imagen se llama',
  x_1aeffd84: '2. Seleccione todos los archivos de imagen y cárguelos a la vez.',
  x_3be0aaea: '3. El sistema coincide automáticamente con el código y actualiza la imagen del producto.',
  x_b226d05e: 'Formatos soportados: JPG, JPEG, PNG, WEBP',
  x_f08afd1f: 'Seleccionado',
  x_6d03439d: 'archivo, haga clic en "Iniciar carga" para que coincida con la codificación del servidor',
  x_7b9de9b7: 'No se encontró ningún producto correspondiente:',
  x_c4390da8: 'Error:',
  x_b15d9127: 'Cerrar',
  x_ec74c566: 'Ajuste Masivo',
  x_85f16ef9: 'Categorías / Categoría (dejar en blanco = todos)',
  x_7f1fd8fd: 'Todos',
  x_ef7e66eb: 'Aumento de costo (%)',
  x_ebb263a8: 'Nuevo margen / Nuevo margen (%) — Déjelo en blanco y no cambie',
  x_e93880f5: 'Beneficio 1 (P1)',
  x_e105c7e7: 'Beneficio 2 (P2)',
  x_af32ce55: 'Beneficio 3 (P3)',
  x_3621e3c6: 'Fórmula: nuevo precio de venta = nuevo costo × (1 + margen de beneficio%)',
  x_0d2f0cb5: 'Ejemplo: Costo $1 + Ganancia 30% = Precio de venta $1,30',
  x_fc51faec: 'Tema de fondo de la tienda en línea',
  x_1dbb0d24: 'Tipo de tienda',
  x_faeff5ef: 'supermercado',
  x_2580b405: 'restaurante',
  x_2ac97357: 'grandes almacenes',
  x_3972c872: 'farmacia',
  x_94f1c5f0: 'panadería',
  x_d2fe24af: 'ropa',
  x_cdce861f: 'productos electronicos',
  x_4c745eb9: 'carnicería',
  x_aa05fd09: 'Universales',
  x_b42f3d0b: 'imagen personalizada',
  x_470c8cb6: 'Sube una imagen de fondo (recomendado 1920x800, máximo 5 MB)',
  x_ba9fc45d: 'Seleccionar imagen',
  x_a7699ba7: 'Subida exitosa',
  x_97e448c5: 'Descripción de la tienda (que se muestra en la página de inicio de la tienda en línea)',
  x_e90f3dd4: 'marcador de posición={t(\'shopDescPlaceholder\') || \'Por ejemplo: frutas y verduras frescas entregadas diariamente\'} data-testid=',
  x_e4de2708: 'Vista previa del enlace de la tienda en línea',
  x_146c214c: '⚡ Cobro rápido',
  x_847d3492: 'red de invitados',
  x_0d9614ed: 'Opciones de impresora',
  x_a305b265: 'Impresora de recibos ordinaria (POS)',
  x_9d2ae79f: 'Nombre de la impresora',
  x_37ba4d4d: 'Método de impresión',
  x_e3127cc1: 'Formato',
  x_dc7ac037: 'Termosensible',
  x_8419e5a2: 'Impresión automática',
  x_b815bd61: 'Modo compacto (font -40%)',
  x_0a50b98b: 'Número de copias a imprimir',
  x_95a11756: 'Impresión de prueba',
  x_08d73983: 'Impresora de informes',
  x_1822051b: 'tamaño del papel',
  x_086f6c26: 'Se utiliza para imprimir documentos A4, como informes de ventas e informes de inventario.',
  x_f6c5bb79: 'Impresora de Impuestos (Fiscal)',
  x_85fc7de8: 'Modelo de impresora',
  x_923f0558: 'puerto de conexión',
  x_9ec10f88: 'Habilitar el control del cajón de dinero',
  x_46886d25: 'Imprimir número de artículo (solo documentos fiscales)',
  x_0d1eb73c: 'Configuración de impresión silenciosa (no aparece ningún cuadro de diálogo de impresión)',
  x_c530a752: 'Configure XP-80C como impresora predeterminada de Windows',
  x_f5dcc91d: 'Descargue el archivo de acceso directo a continuación, colóquelo en el escritorio y haga doble clic para abrirlo.',
  x_34c425af: 'Utilice el modo de proceso independiente sin cerrar otras ventanas del navegador',
  x_1f439178: 'Permitir inventario 0/pedido cuando sea negativo (Permitir sobreventa)',
  x_d28ccc95: 'Ejemplo: 5 = menos 5%',
  x_89b146df: 'Ejemplo: 3 = menos 3%',
  x_3b108349: 'Guardado exitosamente',
  x_6de920b4: 'Error al guardar',
  x_667519a7: 'Limpiando caché...',
  x_715e78ba: '¡Caché limpio, recargando...',
  x_3d58a3f4: 'Error al limpiar',
  x_635d85ed: 'Método de costeo',
  x_9f3cdb13: 'Último costo',
  x_cdf4510f: 'Promedio ponderado',
  x_a2361773: '✓ Al recibir mercancías en lotes mixtos con dos tipos de cambio, la ganancia se calculará con mayor precisión en función del costo promedio.',
  x_8c332c85: 'Salario Mínimo Legal (Bs/mes) Salario mínimo',
  x_1f1cb126: 'Cuando el gobierno ajuste el salario mínimo, modifíquelo aquí. Valor predeterminado actual: Bs. 130.00',
  x_fcf71823: 'Los clientes WiFi escanean el código QR para conectarse a Internet',
  x_a4162fc6: 'WiFi SSID (nombre de red)',
  x_93952fec: 'Contraseña WiFi',
  x_aea862e7: 'Cuando los clientes paguen con PagoMovil, se mostrará un código QR WiFi en la ventana de verificación para que los clientes escaneen el código para conectarse a Internet.',
  x_764327eb: 'Se recomienda utilizar la "red de invitados" del router (Red Invitado) para configurar la desconexión automática en 2 minutos.',
  x_d38fdd96: 'Quiosco (silencioso - recomendado)',
  x_64ae72e7: 'Conexión directa USB (puerto serie COM)',
  x_3ac81273: 'Quiosco (silencioso - compartido con boletos regulares)',
  x_a27aa9d2: 'Conexión directa USB (puerto serie COM - impresora Fiscal independiente)',
  x_1fdcab60: '📦 Reglas de inventario',
  x_8c0b62d0: '⚠️ Se ha activado "Permitir sobreventa"',
  x_0b98802c: '🛡 Modo estricto (recomendado)',
  x_3469dcde: '🏭 Umbral de identificación automática al por mayor (piezas)',
  x_abe9d5a5: 'Cualquier pedido único ≥ esta cantidad → automáticamente juzgado como un pedido al por mayor',
  x_66b516be: '🏭 Pedidos al por mayor: puntos / $1',
  x_44cdb632: 'Utilice esta proporción para pedidos mayoristas (generalmente más bajos que los minoristas para proteger las ganancias)',
  x_cad2cdb3: '📊 Cálculo del reembolso:',
  x_e9b42d03: 'Descuento Tienda Online',
  x_c8ebef70: 'Descuento al contado',
  x_b315c033: 'Descuento crédito 7 días',
  x_92f50a16: 'Crédito de 15 días sin descuento. Los descuentos se calculan automáticamente durante el pago en la tienda online.',
  x_6a46e901: 'Guardar configuración de descuento',
  x_aecb318e: 'Versión actual:',
  x_fd044b72: 'Limpieza: Service Worker + Cache API + LocalStorage PWA flags',
  x_c3c63335: 'Verifica la tarjeta primero',
  x_258b5e0a: 'Saldo insuficiente',
  x_6074ad12: 'Error al cobrar la tarjeta / Error en la deducción de la tarjeta de valor almacenado',
  x_4091e27c: 'Descuento',
  x_952fe994: 'pago dividido',
  x_d9b8f7dc: 'Código (GC-XXXX...)',
  x_df635901: 'Ingresa código y PIN',
  x_44efeacf: 'Tarjeta inválida',
  x_cd8992b6: 'verificar',
  x_fbb9242b: 'Justo',
  x_ac770469: 'Falta',
  x_855bfd60: 'hacer frente a',
  x_a1b49020: 'No es lo suficientemente bueno',
  x_c993e001: 'cambiar',
  x_450efd2f: 'total',
  x_23d0eed8: 'siguiente',
  x_aaf7077a: 'dias',
  x_249aba76: 'dia',
  x_1ceaeb7c: 'Buscar empleado / Buscar empleados...',
  x_0c9d2b45: 'Método de pago',
  x_e83a256e: 'Confirmar',
  x_bf15f831: 'Subtotal',
  x_954a5f2c: 'Total a pagar',
  x_a2e76886: '% porcentaje',
  x_4ca7ca2e: '$ menos cantidad',
  x_62409e5c: '$ precio final',
  x_4ea4474d: 'Elija cualquiera: Complete 3 → 97% de descuento · o $1.57 de descuento · o pierda los $50 finales',
  x_f761deae: 'Seleccione un cliente / Por favor seleccione el cliente primero',
  x_719a6f48: 'Plazo de pago / Número de días a crédito',
  x_a2c1dba8: 'Seleccione un empleado / Por favor seleccione un empleado',
  x_203546f6: 'Precio cambiado',
  x_2432b575: 'Observaciones',
  x_a8b0c204: 'Todos',
  x_4c37b31d: 'Actualmente no hay productos en esta categoría.',
  x_d8318796: 'Por favor ingrese el nombre del producto',
  x_2d5bd318: 'Ingrese costo y margen P1',
  x_3fdaeadf: 'Agregado exitosamente',
  x_26983664: 'Por favor ingrese el monto del reembolso',
  x_b58060b3: 'Pago guardado offline',
  x_ae5a8a24: 'Pago exitoso',
  x_8b649901: 'Reembolso fallido',
  x_d594b77a: 'Por favor ingrese la cantidad',
  x_305091bd: 'Por favor seleccione un empleado',
  x_e2079942: 'Por favor ingrese el monto del salario',
  x_cdef21ee: 'Las deducciones no pueden exceder los salarios.',
  x_43b972b2: 'El pedido no fue encontrado.',
  x_0d66ed02: 'Consulta fallida',
  x_8093e392: 'Por favor ingrese el nombre',
  x_08b1fa13: 'Por favor ingrese el nombre de usuario',
  x_11524166: 'La contraseña debe tener al menos 4 dígitos',
  x_b5e12476: 'Empleado agregado exitosamente',
  x_ea340b7c: 'pedir dinero prestado',
  x_3f01df5b: 'bienes a crédito',
  x_4c95bf44: 'reembolso',
  x_79ef16e5: 'deducciones de nómina',
  x_ded3cdfb: 'pagar salarios',
  x_029d48fa: 'Ausencia del trabajo bien',
  x_5ba2fb47: 'Atrasos históricos',
  x_756048fc: 'Declaración del empleado',
  x_4ff1e74e: 'Fecha',
  x_226b0912: 'Tipo',
  x_4cf24aba: 'Cantidad',
  x_5a4fcfe2: 'Monto actual adeudado',
  x_26068dad: 'tiempo de impresión',
  x_d0de55dc: 'Perforado con éxito',
  x_15ffd5c7: 'Registré y salí del trabajo exitosamente',
  x_20cdb977: 'No se pudo registrar la entrada',
  x_bd4357f9: 'todo el dia',
  x_c31b1b99: 'medio dia',
  x_02efd8b1: 'ausentismo',
  x_95748d60: '✅ La deuda debida por ausencia de ese día ha quedado automáticamente cancelada.',
  x_40862774: 'Error al marcar',
  x_b6838383: 'alquilar',
  x_0ee0c81c: 'Agua y electricidad',
  x_be11fc04: 'salario',
  x_1f4beff9: 'Consumibles',
  x_324712a3: 'Reparación',
  x_0f3a252a: 'transporte',
  x_2a0ad6ff: 'restauración',
  x_638e3280: 'impuestos',
  x_0d98c747: 'Otros',
  x_fdfd5d5f: 'Por favor seleccione un empleado primero',
  x_50bcbd71: 'La nómina falló',
  x_36cb9c59: 'Horario de turnos guardado',
  x_57b08dd4: 'sin personal',
  x_efafd9a3: 'La solicitud falló',
  x_8f21b986: 'Por favor ingrese el nombre de la plantilla',
  x_979b4faf: 'Plantilla eliminada',
  x_acf0664a: 'Error al eliminar',
  x_1603b069: 'lunes',
  x_b5a6a07e: 'martes',
  x_e60725e7: 'miércoles',
  x_170fc8e2: 'jueves',
  x_eb79cea6: 'viernes',
  x_24575130: 'sábado',
  x_562d7476: 'domingo',
  x_f8fbeae1: 'mañana',
  x_e2eb289c: 'tarde',
  x_51147c21: 'hugo',
  x_fbcf05da: 'title>',
  x_e1adc7de: 'h2><p class="sub">',
  x_ae2703cb: 'th><th>',
  x_e3e234b4: '<span><span class="box" style="background:#d4edda"></span> Todo el día</span>',
  x_034dcc79: '<span><span class="box" style="background:#fff3cd"></span> Mañana</span>',
  x_ebdf24a9: '<span><span class="box" style="background:#ffeaa7"></span> Tarde</span>',
  x_13db7d6d: '<span><span class="box" style="background:#f0f0f0"></span> Descanso</span></div></body></html>',
  x_bd626c2f: 'Firmado exitosamente',
  x_2bd5e2ab: 'Error al firmar',
  x_c10a6c00: 'Por favor complete el completo',
  x_1fbd718d: 'El efectivo debe ser menor que la cantidad deslizada con la tarjeta.',
  x_c31eabb4: 'tarjeta magnética',
  x_acaf665f: 'transferir',
  x_b416b575: 'pago movil',
  x_41ce131a: 'mezclar',
  x_3df74976: 'credito',
  x_0319bf13: 'Resumen empresarial del día.',
  x_fbb493d0: 'Número de pedidos',
  x_8bd00685: 'Panel de administrador de tienda',
  x_9c1d16fc: 'Abierto hoy',
  x_cc1987ec: 'Ver inventario',
  x_78d078e8: 'gastos',
  x_29225555: 'Ganancias cambiarias',
  x_e7c0908c: 'efectivo',
  x_2f6805aa: 'cuenta de empleado',
  x_d37a7de1: 'Programación',
  x_fa3aee98: 'Añadir producto',
  x_848704b1: 'Transferir y recibir mercancías.',
  x_94fea5cb: 'Resumen de todo el día',
  x_843e649c: 'Turno actual',
  x_19940592: 'No hay vuelos activos',
  x_b1423de3: 'promedio único',
  x_5bc31fd0: 'Por método de pago',
  x_c2e5a8e2: 'Estadísticas por moneda',
  x_b634ce2e: 'Bs orden abierta',
  x_d0af2c40: '$ Abrir un pedido',
  x_83958d46: ' pedidos',
  x_aded5d5b: 'recibir',
  x_eddd9ee1: 'reconciliación',
  x_d97f0de8: 'colección total',
  x_be77abaa: 'Estadísticas por cajero',
  x_3960424f: 'Conciliación de cambio de efectivo',
  x_2e8e048d: 'recibir efectivo',
  x_043d5f39: 'cambio total',
  x_534097e9: 'efectivo neto',
  x_22b91744: 'Sólo se cuentan los pedidos en efectivo con cantidades registradas recibidas.',
  x_21533faf: 'Imprimir resumen empresarial',
  x_a8e76489: 'Ver detalles del pedido',
  x_dc9b2ec5: 'Cajero de pantalla',
  x_bfdaebfd: 'cajero',
  x_654522d2: 'Moneda',
  x_0bf60b32: 'Cantidad',
  x_da4abd3e: 'precio unitario',
  x_f599fcd3: 'Subtotal',
  x_26922a58: 'recibido',
  x_56ae8659: 'Todos los almacenes',
  x_adcd38b7: 'Buscar + Enter / Buscar nombre/código del producto...',
  x_0aaf10c2: 'No se encontró ningún producto coincidente',
  x_d3bc58b6: 'tipo de cambio',
  x_f155c56c: 'Tipo de cambio seleccionado',
  x_37a3f5ca: 'Convertido a dólares estadounidenses',
  x_ac502247: 'Comprar USD en efectivo',
  x_2feedc17: 'Pase la tarjeta para obtener dinero en efectivo',
  x_2ddd1415: 'Monto en dólares ($)',
  x_735fcb9f: 'tasa de compra',
  x_27cae7b2: 'tasa de venta',
  x_26431425: 'costo de bs',
  x_9aef4e3c: 'valor en bs',
  x_cb340191: 'beneficio',
  x_b58c7549: 'agregar',
  x_f58a32cd: 'Monto de tarjeta de crédito deslizada (Bs)',
  x_d5dd40af: 'Dar Efectivo(Bs)',
  x_171cc7f8: 'Ganancia(Bs)',
  x_f2d612ee: 'Tarifa de manejo',
  x_524d7e11: 'Ganancia de hoy (Bs)',
  x_58add0bd: 'Ganancia de hoy ($)',
  x_19fcb9eb: 'tiempo',
  x_f26225bd: 'Detalles',
  x_e052f520: 'Beneficio ($)',
  x_cbe408cd: 'comprar dolares',
  x_a185dea2: 'Desliza tu tarjeta para canjear efectivo',
  x_b9db8476: 'Aún no hay registro',
  x_c966e6db: 'USD en efectivo',
  x_d96c0531: 'Bs en efectivo',
  x_b7b3fa73: 'Cambio de moneda rápido',
  x_1c927ecc: 'No es necesario ir a la pestaña de cambio de moneda, solo hazlo aquí',
  x_b28432d4: 'Ve y cambia moneda',
  x_661f8852: 'operaciones de efectivo',
  x_4cc6a2f6: 'Depósito',
  x_7be8ae3a: 'sacar',
  x_474a556a: 'dale la vuelta',
  x_1827f06e: 'ajustar',
  x_0367ebd1: 'Observaciones...',
  x_abe2c5d2: 'Enviando...',
  x_b66b2e82: 'registros recientes',
  x_676e5982: 'operador',
  x_7f0dc5e3: 'ventas',
  x_774e1765: 'intercambiar',
  x_742440c4: 'Cuentas de empleados',
  x_2ef46a5f: 'Agregar empleado',
  x_60d0458a: 'nombre',
  x_32ffa250: 'número de identificación',
  x_5a93d3f7: 'telefono',
  x_819767ad: 'Nombre de usuario',
  x_a8105204: 'Contraseña',
  x_464f3d4e: 'papel',
  x_3887bfff: 'Empleados ordinarios',
  x_bbc407c7: 'inspector de precios',
  x_586a52f3: 'límite de crédito',
  x_eeb4d5b7: '0 = sin límite',
  x_25cebe66: 'monto del salario',
  x_b5ca1dd9: 'ciclo de pago',
  x_09b03b6d: 'semanal',
  x_93a158a9: 'cada 15 dias',
  x_aa3d57c0: 'mensual',
  x_5e3640e4: 'Confirmar para agregar',
  x_4c998309: 'Imprimir Tarjeta QR',
  x_8d7eb002: 'Recibo + QR',
  x_2dbf283b: 'Estado de cuenta',
  x_e8da0032: 'Atrasos',
  x_bbdd42a0: 'asentado',
  x_620610c0: 'ha sido devuelto',
  x_8577b01a: 'Retiro de depósito',
  x_44ba3fed: 'No se pudo extraer',
  x_7b1df363: 'Actualmente no hay registro de deudas de empleados.',
  x_7941da94: 'uno',
  x_2d8be272: 'dos',
  x_e662ff59: 'tres',
  x_21716cf3: 'cuatro',
  x_1fcc29d0: 'cinco',
  x_61b45352: 'seis',
  x_3edddd85: 'dia',
  x_93849f29: 'asistencia de hoy',
  x_416b2ef6: 'ya fuera del trabajo',
  x_b767d98a: 'en el trabajo',
  x_6bc72d59: 'No registrado',
  x_b4f0388f: 'ir a trabajar',
  x_96ed60cd: 'salir del trabajo',
  x_7b6e413b: 'Agregar cuentas de empleados',
  x_37c140e9: 'Seleccionar empleados',
  x_99b437e5: 'Préstamos a empleados',
  x_c06881f5: 'Dar bienes a los empleados a crédito.',
  x_fbb40b61: 'Pago de empleados',
  x_783aaf86: 'Importar deudas históricas',
  x_859e83a6: 'Sólo se registra el monto adeudado, no se deduce ningún saldo de efectivo.',
  x_83ba80ef: 'La transferencia no afecta el saldo de caja de la tienda.',
  x_27622285: 'salario total',
  x_a46225b3: 'Ingrese el número de pedido para realizar la consulta automáticamente',
  x_bee912d7: 'Consulta',
  x_b433e6c6: 'Información del producto',
  x_f87737b3: 'Detalles del producto de crédito...',
  x_2edddab1: 'salario diario',
  x_074eca2c: 'Deducción de atrasos de salarios',
  x_20b7f99c: 'pelo real',
  x_39ce9e78: 'Sin deducción (todo en efectivo)',
  x_82a6f2f0: 'Los empleados pagan con Bs → Convierten USD automáticamente para compensar los atrasos',
  x_162fe161: 'Gerente de tienda: complete el tipo de cambio usted mismo',
  x_7e21332c: 'Personal: tipo de cambio BCV',
  x_767b82cb: 'Autocompletar',
  x_9e3eba91: 'Modo de cálculo',
  x_3aed2c11: 'automático',
  x_2a3e7f5c: 'manuales',
  x_b4b4b75b: 'Ajustable automáticamente',
  x_0a61f1ae: '¡Límite de crédito excedido!',
  x_c6403f20: 'Cuota',
  x_28b24262: 'Después de la operación',
  x_2e81e23d: 'más allá',
  x_07b42ee9: 'historial de transacciones',
  x_2ed39222: 'empleados',
  x_e05e6f34: 'equilibrio',
  x_e25b7872: 'Añadir nuevo producto',
  x_1fd1d5c5: 'Nombre del producto',
  x_cc6c35a3: 'codificación',
  x_d0771a42: 'Clasificación',
  x_2e2ce286: 'precio de costo',
  x_7a3da957: 'margen de beneficio',
  x_2acbbffe: 'El sistema calcula automáticamente el precio.',
  x_650f9201: 'caja entera',
  x_3301f812: 'Cantidad por caja',
  x_2a79a737: 'tasa impositiva',
  x_72993534: 'Cantidad entrante',
  x_39f76a9b: 'código de barras',
  x_257a8023: 'Escanee/ingrese el código de barras y presione Enter',
  x_4347fc1c: 'Los productos agregados se sincronizarán con todas las sucursales, pero solo nuestra tienda tiene inventario.',
  x_ae1c4d7f: 'Buscar cliente/número de pedido...',
  x_322ade24: 'no pagado',
  x_fa25eda2: 'Vencido',
  x_13992709: 'Amortización parcial',
  x_480018e8: 'dio sus frutos',
  x_4403fca0: 'Borrar',
  x_c624290a: 'registros',
  x_c75e2f5f: 'En espera de recogida',
  x_ff0b2077: 'Cliente',
  x_1e8dc255: 'Número de pedido',
  x_6ffe81e2: 'cantidad total',
  x_57b642fc: 'Pagado',
  x_499b9a62: 'fecha de vencimiento',
  x_3fea7ca7: 'Estado',
  x_2b6bc0f2: 'Operación',
  x_45274498: 'parte',
  x_1611cbc7: 'Para ser devuelto',
  x_2722964b: 'No hay registros coincidentes',
  x_8e6adfe0: 'Monto del reembolso',
  x_37fa12a4: 'Orden de transferencia de mercancías a recibir',
  x_694fc5ef: 'Actualizar',
  x_bf08ab13: 'No hay ninguna orden de transferencia por recibir',
  x_4933ca41: 'En espera de recibo',
  x_04531587: 'Envío',
  x_91bcfc81: 'Almacén principal',
  x_8690efe6: 'Número de envíos',
  x_a8974abd: 'Recibos reales',
  x_a18a1f0c: 'Confirmar recibo',
  x_29825420: 'El almacén no está cargado, inténtalo de nuevo más tarde.',
  x_38bbc161: 'Almacén no cargado',
  x_1ba301c3: 'Enviado para aprobación del administrador / Enviado para aprobación del administrador',
  x_72520580: 'esta semana',
  x_9c5f8689: 'Pagar salarios a empleados seleccionados.',
  x_ba4c8037: 'Guardar horario',
  x_f8dfedcd: 'salvado',
  x_0963bb54: 'Plantilla de turno',
  x_cb86af8d: '{t(\'nombre de plantilla\') || \'nombre de plantilla\'}',
  x_eb347bdb: '+ Nuevo',
  x_26b5bd49: 'Cargando...',
  x_69a69eb0: 'estimación de salario semanal',
  x_85a77ddc: 'Haga clic en la cuadrícula para recorrerla',
  x_80da96c6: 'Horario',
  x_c59cae5e: 'Horario de empleados',
  x_3a991a4c: 'descansar',
  x_10627c90: 'Cómo calcular el número de entradas y salidas.',
  x_955acdc0: 'Entrada manual de ventas en efectivo.',
  x_cd06c6b3: 'Aumento de depósito/ajuste manual',
  x_a9f5d26a: 'Sacar/entregar/ajustar reducción manual',
  x_a20bbe5d: 'Pago de salario/préstamo a empleado',
  x_d13feaa2: 'Biopago/deslizar/transferir no cuenta para el saldo de efectivo (al banco)',
  x_aaa36041: 'Monto VES = producto precio USD x tipo de cambio BCV',
  x_0e59b159: 'Trabajar en vacaciones = 1,5 veces el salario (calculado automáticamente)',
  x_63686703: 'No hay vacaciones este mes',
  x_362bb8be: 'Recibo de Pago',
  x_79274ddb: 'Inventariar / Inventario',
  x_5d855937: 'Vencido',
  x_dcc961ae: 'anulado',
  x_a0bf20e8: 'Para sincronizar',
  x_c2c0df04: 'Guardado en esta PC',
  x_4650017d: 'Sin red: las cuentas de crédito se guardaron localmente y se muestran en la lista (amarilla para sincronizar) y se cargarán automáticamente después de conectarse a Internet.',
  x_eb3eae91: 'Pago guardado en esta PC',
  x_fa17371a: 'Sin red: el pago se registró localmente (amarillo para sincronizar) y se cargará automáticamente después de conectarse a Internet.',
  x_1c97a7ce: 'Expira pronto',
  x_a44f40d4: 'El número de teléfono móvil del jefe no está configurado, vaya a la configuración de WhatsApp para agregarlo.',
  x_464208d1: 'Error al enviar',
  x_1cf1a230: 'Envía un resumen de cuentas vencidas al WhatsApp de tu jefe',
  x_24cc017a: 'Error al enviar reclamación',
  x_6910a681: 'Envíe automáticamente recordatorios de WhatsApp a cada cliente vencido o vencido',
  x_aab87728: 'Pagado, sin facturas pendientes',
  x_a48948bf: 'Todas las tiendas',
  x_a7da9234: 'tienda',
  x_6b0cbe98: 'Mira la esquina superior derecha☁️',
  x_832af156: 'Subir automáticamente en línea',
  x_d2593e04: 'Solo USD',
  x_8e0be5e5: 'La carga del pago es rechazada, haga clic en ☁️ en la esquina superior derecha para procesar',
  x_10efc391: 'Detalles del producto',
  x_1c40f543: 'Historial de pagos',
  x_d88fb1dd: 'Este crédito debe pagarse en dólares estadounidenses.',
  x_84857e3e: 'Recordatorio de vencimiento de crédito',
  x_43b510ed: 'restante',
  x_bfc2bc5a: 'Aún no hay cuentas de crédito vencidas/vencidas',
  x_f3737dbf: 'Número de pedido',
  x_7c5f7ff6: '💵 USD no recibidos',
  x_139bf01e: '🇻🇪 Bs no recibidos (valor actual en USD)',
  x_23414073: '⚠️ USD y Bs no suman: USD es el dólar estadounidense recibido real; Bs se registra como valor en dólares estadounidenses según el tipo de cambio instantáneo del día y Bs se convierte utilizando el tipo de cambio en tiempo real del día al recibir el pago.',
  x_7b7d5246: '⚠️ Hay un incumplimiento de pago',
  x_b3032ddd: '@ese día',
  x_6845ced0: 'Monto total adeudado',
  x_1302a371: 'Historial de pagos:',
  x_d7e9237c: 'El código de barras no coincide con el producto.',
  x_ef48633e: 'Por favor seleccione un almacén diferente',
  x_dd2124ee: 'Por favor agregue producto',
  x_1fc560de: 'Guardado offline',
  x_b56601bf: 'Verifique luego que aparezca en la lista.',
  x_028e7279: 'Orden de transferencia creada exitosamente',
  x_861505e1: 'La orden de transferencia ha sido cancelada',
  x_8ae6036e: '⚠️ Ha ingresado la cantidad real recibida de todos los productos como 0. \\n\\nEsto significa que no se agregará nada al almacén de MANUEL. \\n\\nSi los productos no han llegado, haga clic en "Aceptar" para continuar. \\nSi es un error, haga clic en "Cancelar" para devolver y recargar.',
  x_d2875199: 'Crear una nueva orden de transferencia',
  x_7c5e97eb: 'Firmado por',
  x_cc1bacb5: 'artículos',
  x_7031d352: 'Número de orden de transferencia',
  x_b683d031: 'Almacén de emisiones',
  x_8dda8a9c: 'Almacén receptor',
  x_8887e33b: 'cantidad total',
  x_2111ccbb: 'Cancelado',
  x_e699aa3c: 'Duplicar',
  x_ef091458: 'Cancelar orden de transferencia',
  x_f89fa9b6: 'Seleccionar almacén',
  x_6b705e8c: 'Buscar productos/escanear código QR...',
  x_14545603: 'Código de escaneo de la cámara',
  x_b26107b6: 'Creando...',
  x_73de67b8: 'Crear e imprimir',
  x_a9aa4fae: 'Firmar para orden de entrega',
  x_bf09ef8b: 'problema',
  x_15e9238b: 'recibir',
  x_6edb92ec: 'Llamar cantidad',
  x_7a6e939a: 'Cantidad real recibida',
  x_7e28d689: 'La cantidad se ha ajustado automáticamente a la cantidad disponible. Por favor confirme y envíe nuevamente.',
  x_3e71abd0: 'orden de transferencia',
  x_ea887bd0: 'Especificaciones',
  x_ebb67faf: 'Firma de envío: _______________',
  x_6afdc8b0: 'Firma del recibo: _______________',
  x_4c271bd8: 'Orden de Transferencia · Orden de Transferencia',
  x_8d4312cd: 'From:',
  x_8a90ed66: 'To:',
  x_cd50b523: 'Fecha de creación:',
  x_b5e8e5c3: 'Operador:',
  x_55bea7c5: 'Observaciones:',
  x_0a64548c: 'Producto',
  x_50b98e79: 'Cantidad de transferencia',
  x_031a18b8: 'Firma emisor · Fecha',
  x_81cb422e: 'Firma receptor · Fecha',
  x_90d971c7: 'Stock insuficiente',
  x_59d31a31: '/requerido',
  x_3cd9e10d: 'El almacén de origen mostrará un inventario negativo; recuerde reponer los productos más tarde.',
  x_866b795e: 'Error al cargar',
  x_acc47889: '✅ Agregado',
  x_acd5cb84: 'falló',
  x_c4ebcdbf: '¿Está seguro de que desea eliminar esta tabla?',
  x_cec8924c: '✅ Eliminado',
  x_fd691fb1: '¿Estás seguro de publicar esta tabla? (Se borrará el enlace de orden pendiente vinculada)',
  x_c77aedd7: '✅ Liberado',
  x_23f7319b: 'Error al cargar QR',
  x_65e200d3: 'Descarga fallida',
  x_28d45b55: '✅ ZIP descargado',
  x_b264a9b6: 'Error en la descarga:',
  x_d3a27772: 'Add tables first',
  x_16fca75d: '✅ ZIP descargado / Descargado',
  x_3317ce8e: 'Número de mesa (dejar en blanco para automático)',
  x_f1e3f7fb: 'nombre (opcional)',
  x_4af1e6c6: 'Número de asientos',
  x_a7bac223: 'chino',
  x_806c4388: 'verde',
  x_d088e652: 'rojo',
  x_b990b42b: 'naranja',
  x_2fc8da52: 'azul',
  x_34e66c72: 'morado',
  x_9cba5857: 'negro',
  x_4207f36f: 'Mesas',
  x_be5fbbe3: 'guardar',
  x_904614f6: 'Aún no hay mesa',
  x_55fdd74d: 'Primero vaya a "⚡ Plantilla de industria" y seleccione "🍽️ Restaurante", el sistema creará automáticamente 10 mesas',
  x_505fcefc: 'O haga clic en el botón "Agregar tabla" arriba para agregarla manualmente',
  x_d07d6cdf: 'Libre',
  x_29880b96: 'Uso:',
  x_45e716f0: 'El cliente se sienta → el camarero selecciona el producto en el TPV → pulsa "F4 para realizar un pedido"',
  x_362857a7: 'Ingrese los comentarios del número de tabla (como "Tabla 3") al realizar un pedido, o visite esta página para asociar',
  x_5abc3304: 'El cliente quiere añadir platos → TPV recupera el pedido → Añade nuevos productos → Reemplaza el pedido',
  x_d01b9612: 'El cliente quiere pagar → POS recupera el pedido → cobra el pago → libera esta tabla',
  x_a889dfa2: 'Escanea el código QR para realizar pedidos en cada mesa. Imprime o descarga el ZIP y pégalo en tu escritorio.',
  x_56ba8da3: 'Sellox · Escanea el código QR para pedir comida',
  x_a6bcd7fd: 'Escanee el código QR para seleccionar automáticamente un número de mesa',
  x_bffc3306: 'Aún no hay ninguna tabla; vaya a "Agregar tabla" a la izquierda',
  x_22342357: 'Language',
  x_664bd4c3: 'Color',
  x_562afa20: 'Seleccione idioma y colores para ver la vista previa',
  x_cdc8aa2a: 'Por favor ingresa una cantidad válida',
  x_a6be14ea: '🎉 Se ha generado la tarjeta prepago',
  x_a889286a: 'La creación falló',
  x_d9217d95: 'Recarga fallida',
  x_73268407: '¿Estás seguro de que quieres desactivar esta tarjeta? (El titular de la tarjeta ya no podrá utilizarla)',
  x_174bdf89: 'Por favor introduce el número de tarjeta + PIN',
  x_6047d376: 'La ventana emergente ha sido bloqueada, permita la ventana emergente y vuelva a intentarlo.',
  x_3671b15c: '4 dígitos',
  x_99c1801d: 'Buscar nombre de cliente/número de teléfono/último número de tarjeta',
  x_ad6b7038: 'Disponible',
  x_9c2b5257: 'Agotado',
  x_5c56a889: 'desactivar',
  x_7779a6ac: 'Compra $50 y recibe $5',
  x_81b5d9ee: 'Número de tarjeta copiado',
  x_a2fd009c: '🎁 Tarjeta de Regalo / tarjeta de valor almacenado',
  x_cac30fb8: 'Código / número de tarjeta',
  x_a93dac50: 'Saldo / Equilibrio',
  x_fa6c3ef4: 'Guarde este cupón en un lugar seguro. Se requiere número de tarjeta + PIN para su consulta y uso.',
  x_d4334477: 'Tarjetas de Regalo',
  x_0e03f74c: 'Consultar saldo',
  x_f9089b58: 'Número de tarjeta (16 dígitos)',
  x_554b5f0d: 'Número de cola de tarjeta',
  x_3577a5ae: 'En venta',
  x_584cd195: 'Caducado',
  x_8a6e6c55: 'Aún no hay tarjeta de valor almacenado',
  x_11344dd6: '🎫 Liberación de tarjetas de valor almacenado',
  x_39a058d6: 'Ingresa el monto y la información del cliente para generar una nueva tarjeta prepago.',
  x_5b90f4f9: 'Monto en la tarjeta ($)',
  x_a10e8516: 'Regalo de la tienda ($)',
  x_8f876263: 'Nombre del cliente (opcional)',
  x_b4a12819: 'Número de teléfono del cliente (opcional)',
  x_7430e2e0: 'Período de validez (días, 0 = para siempre)',
  x_1ffb8483: 'generar tarjeta',
  x_f0ec8be7: '🎉 Se ha generado una tarjeta prepago: anote el número de tarjeta + PIN',
  x_76bd513c: 'Copie el número de tarjeta y el PIN recién generados en la tarjeta física.',
  x_a614e73a: 'Código',
  x_308111f4: 'Importante:',
  x_b3531d90: 'Número de tarjeta y PIN',
  x_f2c00976: 'Mostrar solo esta vez',
  x_bd8ee68a: '🖨️Imprimir',
  x_a6dada89: 'He notado ✓',
  x_c5b6c7ba: '💵 Recarga tarjeta de valor almacenado',
  x_7a8c087d: 'Agregue fondos adicionales a las tarjetas de valor almacenado que se hayan emitido.',
  x_74fbcc56: 'Número de cola de tarjeta:',
  x_204538f5: 'Saldo actual:',
  x_1f143c8d: 'Monto de recarga ($)',
  x_7e410409: 'Activa',
  x_eca18247: 'Completada',
  x_9809e6f2: 'Cancelada',
  x_b7a2291a: 'Forfeit',
  x_5a08deaf: 'Error al cargar',
  x_63b8f2b2: 'Buscar número de pedido / cliente / número de teléfono',
  x_e7784a34: 'Guardado',
  x_712939e0: 'La cantidad debe ser mayor que 0',
  x_051e1c80: 'Cobro registrado',
  x_3d1f2fcc: 'Error',
  x_22bbda1e: 'Permita ventanas emergentes',
  x_d6818f91: '<tr><td colspan="3" style="text-align:center;color:#999">Sin registro</td></tr>',
  x_dd139654: 'Cancelado / Cancelada (El inventario ha sido revertido)',
  x_5cbad596: '🟢Depósito',
  x_b5a103dc: '💵 Pago adicional',
  x_d98fd798: 'Nota/Nota (opcional)',
  x_5769b85a: 'Confirmar abono',
  x_a29d3fab: 'Motivo',
  x_92b67f7b: 'Devolución del depósito al cliente',
  x_094590c4: 'El depósito va al comerciante (sin reembolsos)',
  x_2a33020e: 'Guardando...',
  x_0aa2fd58: 'Activas',
  x_80e42329: 'Completadas',
  x_443483c9: 'Todo el estado',
  x_fb852fc6: 'En progreso',
  x_fad5222c: 'Completado',
  x_d6a3df8d: 'confiscado',
  x_08226a9b: 'Items',
  x_a015434e: 'Productos',
  x_b9224f27: 'Montos',
  x_0b68090c: 'Total',
  x_8ed12dec: 'Pagado',
  x_f085817a: 'Saldo',
  x_7220e4d5: 'camino',
  x_edd98a05: 'Sin registro',
  x_21a22391: 'Cliente',
  x_9f796492: 'Items',
  x_3f1e93a5: 'Agregar abono',
  x_9b7e9298: 'Hoy:',
  x_464ee460: '🔒 Bloqueo de creación:',
  x_15e8601c: 'Efectivo USD',
  x_6aad3987: 'Bs en efectivo',
  x_3ed4a686: 'Transferencia',
  x_25557e0c: 'Tarjeta',
  x_66a35235: '⚠️ Cancelar aparta (el stock se restablecerá automáticamente)',
  x_4253d249: 'reglas aparte',
  x_150978ed: 'Habilitar la funcionalidad Aparta',
  x_db82dff0: 'Mín. anticipo %',
  x_f411a870: 'Plazo (días)',
  x_bfa32868: 'Días de gracia',
  x_89d38266: 'Una vez transcurrido este número de días, el depósito será devuelto al comerciante.',
  x_05e6cff3: 'Recordatorio (días antes)',
  x_780eb764: 'Recibo WhatsApp',
  x_ca0e7ab8: '🏭 Modelo específico de la industria',
  x_40a69a97: 'Seleccione una industria para habilitar las funciones correspondientes + ajustes preestablecidos de categoría con un solo clic',
  x_ce198527: 'modelo de restaurante',
  x_4457ca2a: 'Gestión de mesa · Pantalla de cocina KDS · Tarifa de servicio · Impresión de grupo de platos · Pulsador de urgencia de platos',
  x_f3bede6c: 'tienda de ropa',
  x_31638707: 'Tamaño × variante de color · Etiqueta de temporada · Reducción automática de precios al por mayor y al por menor · El inventario se cuenta independientemente por variante',
  x_4b94f7ca: 'comida rápida/repostería',
  x_e4ec5eb2: 'Pedido de comidas · Ticketing de cocina · 7 categorías preestablecidas (pan/pastel/café)',
  x_f62e3009: 'Supermercado/comestibles',
  x_c6f34300: '10 categorías principales · Granel/pesaje habilitado de forma predeterminada · Ventas de cajas enteras · Distinción de cadena de frío',
  x_629960fd: 'farmacia',
  x_ba330da8: 'Clasificación con/sin receta · Número de lote + aviso de fecha de caducidad · Trazabilidad de la receta',
  x_0f84be62: 'Hardware/Electrónica',
  x_17b68710: 'Herramientas/Pintura/Plomería 7 Categorías · Trazabilidad del Número de Serie (Electrónico) · Gestión de Garantía',
  x_7bcbf628: '🛒 Cajero + Ventas',
  x_79223063: 'Cajero POS inteligente',
  x_e5cbb127: 'Escaneo de códigos de barras · Múltiples niveles de precios · Doble moneda Bs/USD · Teclas de acceso directo · Operación sin conexión',
  x_ed4d7ae6: 'Modo PWA sin conexión',
  x_c8bc72c1: 'La facturación se seguirá emitiendo incluso si la red está desconectada · Después de la restauración, la cola global se cargará automáticamente de forma sincrónica',
  x_2e16c12a: 'Aplicación de escritorio de Windows',
  x_44819336: 'Empaquetado de electrones · Sesión larga JWT de 90 días · Actualizaciones silenciosas · Listo para usar',
  x_a6185298: 'Centro comercial online + código QR',
  x_3ff0e9d1: 'La tienda online se genera automáticamente · Los clientes escanean el código QR para realizar un pedido · Autoservicio de pedidos / entrega puerta a puerta / autorecogida',
  x_c6840e7e: 'CRM para clientes + margen de beneficio mayorista',
  x_c98fb10f: 'Puntos/nivel de membresía · Cuenta de crédito · Reembolso por recomendación · Cambio automático de precio para clientes mayoristas',
  x_3a44d260: 'Impresión térmica',
  x_715e4b5e: 'Recibo de 80 mm · Etiqueta de precio · Conexión directa ESC/POS · Configuración de impresora multitienda',
  x_61ac4d4d: '🛵 Entrega + Comercialización',
  x_c51eca4b: 'Plataforma de repartidores + asignación automática de pedidos',
  x_31439e52: 'Registro de repartidores · Seguimiento GPS en tiempo real · Asignación automática según distancia y disponibilidad · Cuenta regresiva de 60 segundos',
  x_50e8efc4: 'Deseos automáticos de cumpleaños de WhatsApp',
  x_a8701246: 'Escanea los cumpleaños de los clientes a las 09:00 todos los días · Envía automáticamente bendiciones + códigos de descuento · Recompra sin costo',
  x_157c7c85: 'Mensajería masiva navideña + programación',
  x_abe4ae61: 'Mensajería masiva con un solo clic para Navidad/Día de la Madre/Día de San Valentín · Horario programado · Lista de feriados nacionales · Registros históricos',
  x_1eb970e4: 'promociones',
  x_aef63132: 'Descuentos · Descuentos totales · Compra de regalos · Ventas flash por tiempo limitado · Configuración por categoría/producto único',
  x_a1336484: 'Centro comercial de puntos',
  x_193aa1e3: 'Los clientes usan puntos para canjear cupones, regalos o recargar saldo · Canje por tiempo limitado',
  x_9a3ebc32: '💼Gestión de backend',
  x_83d7870e: 'Multialmacen + traspaso',
  x_5ca33875: 'Múltiples almacenes · Asigna y crea almacenes de origen automáticos · Registra automáticamente diferencias en recibos e informa pérdidas · Seguimiento en tránsito',
  x_b3184a0c: 'Reporte de PyG (USD/Bs separados)',
  x_387e4ccd: 'Ganancia bruta · Gastos · Pérdidas · Ingresos cambiarios · Cada moneda se muestra de forma independiente',
  x_41cdb401: 'Gestión de efectivo en sucursales + infalible',
  x_7c6e4907: 'Saldo USD/Bs en tiempo real · Montos grandes (>100.000 Bs / $1k) deben confirmarse dos veces · Evitar ingreso accidental',
  x_4bb41a3f: 'traspaso de turno',
  x_12e3a178: 'Recuento de efectivo · Firma del cliente · Listado de denominaciones · Envío automático de WhatsApp al jefe',
  x_7be86c2c: 'Cuentas de Empleados + Asistencia + Nómina',
  x_50fa2355: 'Préstamo · Crédito · Pago · LOTTT Sección 106 Cumplimiento A4 Nómina',
  x_8ddf6808: 'Registro de auditoría + auditoría de inventario',
  x_4d5169cd: 'Registros completos de operaciones de alto riesgo · Exportación CSV · Comparación automática nocturna de producto.stock vs almacén real',
  x_c97dba40: '🤖 Bendición de IA',
  x_6d06e53e: 'Embellecimiento de imágenes de productos con IA',
  x_8ed5fef6: 'Gemini Nano Banana elimina fondos con un clic + embellece las imágenes de productos · Procesamiento por lotes · Restaura imágenes originales',
  x_b94b644f: 'asistente de chat de IA',
  x_df5fb097: 'Servicio al cliente GPT-5.2 · Responder automáticamente al estado del producto/inventario/pedido · 24 horas al día, 7 días a la semana en línea',
  x_4ec4a23d: 'Verificación AI Pago Móvil',
  x_56c6972a: 'La captura de pantalla AI identifica automáticamente la cantidad/fecha/número de referencia · Revisión con un solo clic por parte del cajero · Antifalsificación',
  x_32a15937: 'El código de barras crea productos automáticamente',
  x_875fae32: 'Escanear o ingresar código de barras · Buscar automáticamente en la base de datos global de productos (Open Food Facts / UPCitemdb) · 0 entradas manuales',
  x_10899d94: '🌍 Adaptación multipaís',
  x_ee7818c0: '8 países configurados automáticamente',
  x_77a6000a: '🇻🇪VE · 🇨🇴CO · 🇧🇷BR · 🇿🇦ZA · 🇩🇴DO · 🇨🇷CR · 🇹🇹TT · 🇵🇦PA · Tipo de cambio automático/idioma/canal de pago',
  x_9dd027aa: 'Cambio de 4 idiomas',
  x_f6cbc1ec: 'Chino/inglés/español/portugués: cambio con un clic',
  x_e3c6859e: 'Liquidación de moneda dual + tipo de cambio en tiempo real',
  x_6cb9867e: 'Cambio de Bs/USD a voluntad · BCV oficial + tipo de cambio del mercado negro · Cambio de moneda del informe con un clic',
  x_863683ad: 'POS inteligente diseñado para el comercio minorista',
  x_e1828ed2: 'Cubriendo 7 industrias principales · 4 idiomas · 8 mercados nacionales',
  x_3665550b: 'Restaurante · Comida Rápida · Ropa · Panadería · Farmacia · Belleza: las plantillas industriales se pueden activar con un clic · Prueba gratuita de 7 días',
  x_cd1ce731: 'Pruébalo ahora gratis',
  x_0d2a321f: '¿Ya tienes una cuenta? Iniciar sesión',
  x_7bf86a2a: 'Todas las características',
  x_e539f895: 'Más de 30 funciones que cubren cajero, inventario, distribución, marketing e inteligencia artificial · Regístrate para disfrutar',
  x_6a4ab7b8: 'Regístrate ahora',
  x_660d93f4: 'Experimente todas las funciones gratis durante 7 días sin pagar · Configuración automática opcional para 7 industrias principales',
  x_5a631c6c: 'nuevo',
  x_402d19e5: 'Iniciar sesión',
  x_9ceb77bb: 'Soporte trilingüe · Liquidación de doble moneda · 7 días gratis',
  x_021782de: 'Soporte de idiomas',
  x_81ea4b71: 'Corre en la nube',
  x_1d3ba50c: 'Seguridad de datos',
  x_2e525185: 'Soporta cualquier dispositivo',
  x_0ec9d3c3: 'Se puede utilizar en ordenadores, tablets y teléfonos móviles.',
  x_1cfc09aa: 'Regístrate para disfrutar de todas las funciones',
  x_8e046e99: 'Creado para diversas empresas',
  x_d48f3735: 'tienda minorista',
  x_926a9ffe: 'Apto para supermercados, tiendas de conveniencia, tiendas de abarrotes, tiendas de ropa, etc.',
  x_cff3dc29: 'negocio mayorista',
  x_5087d5ee: 'Soporte al sistema de precios mayoristas, gestión de cuentas clave, cuentas por cobrar.',
  x_ce98716f: 'Gestión de cadenas de tiendas.',
  x_320fd2de: 'La sede administra múltiples sucursales de manera unificada, con inventarios de productos interconectados y asignados, y cada tienda tiene cajeros e informes independientes.',
  x_605629af: 'tienda ordinaria',
  x_14079459: '✨ Crea automáticamente 7 categorías de menú + 10 mesas + 10% de tarifa de servicio',
  x_02d470b4: '✨ Crea automáticamente 8 categorías de ropa + variantes de tamaño y color',
  x_19c60018: 'Modelo minorista universal: sin categorías preestablecidas, cree las suyas propias (apto para el 90% de las empresas)',
  x_a93d885f: 'Código de referencia (opcional)',
  x_fefc4fec: 'Regístrese usando el código de referencia para obtener 30 días adicionales de prueba',
  x_87417e71: 'Tipo de negocio',
  x_f134be36: 'No se puede iniciar sesión sin conexión; primero inicie sesión en línea',
  x_80745991: 'Cajero en la recepción',
  x_29ee0354: 'Solo cajero: inicie sesión y vaya directamente al cajero',
  x_2443e297: 'Entra al cajero',
  x_de094deb: 'Instalar aplicación / Instalar aplicación',
  x_ea90083b: 'Abre en Chrome para instalar / Abrir con Chrome para instalar',
  x_11afe095: 'Escanear código de barras del producto',
  x_570e1531: 'Alinee el código de barras completamente con el marco verde · Distancia 10-20 cm',
  x_58faba06: 'No se puede acceder a la cámara, verifique los permisos',
  x_bec7e4d6: 'cambiar',
  x_17e423b0: 'destello',
  x_a4c59470: 'Haga clic en la pantalla para enfocar manualmente',
  x_3c43c899: '💡 Deje que el código de barras llene el marco verde y manténgalo estable · Se verá borroso si está demasiado cerca',
  x_5f031153: '📵 Este dispositivo no admite flash',
  x_22867dc5: 'Escanear de nuevo',
  x_lbl_created: 'Creado',
  x_lbl_rejected: 'Rechazado',
  x_lbl_reason: 'Motivo',
  x_lbl_operator: 'Operador',
  x_lbl_total: 'Total (unid.)',
  x_lbl_notes: 'Notas',
  x_80a36145: '✅ Sincronizado automáticamente',
  x_1eec1e2e: 'Finalizar operaciones de cortes de red anteriores',
  x_e85b2d54: 'Los productos sin conexión se han sincronizado.',
  x_8cc59319: 'Sincronización de pedidos exitosa',
  x_fad33691: 'La sincronización del pedido falló:',
  x_1fa61c48: 'El historial de pedidos rechazados de Zhang se ha reenviado automáticamente / pedidos recuperados automáticamente',
  x_73ae77ff: 'Modo sin conexión: utiliza datos almacenados en caché (',
  x_8ae9eaca: 'actualizar)',
  x_57fa0696: '- recordado (',
  x_49ae0e5e: 'artículos)',
  x_4068bc35: '⬆️Subir antes de que termine la clase',
  x_7b697750: 'Orden a sincronizar...',
  x_cdc0393e: '⚠️También',
  x_960c577f: 'El pedido no se pudo cargar (se guardó en esta máquina y se cargará automáticamente después de conectarse a Internet)',
  x_4094833e: ', no más / agotado',
  x_b7b8517c: ', máximo / agotado',
  x_6f630d34: '🥡 Recoger comida #',
  x_edb823f2: '❌ Producto no encontrado:',
  x_45524982: 'El pedido ha sido exportado a la carpeta de descargas.',
  x_498458a5: '✅ El tipo de cambio de hoy se ha fijado en Bs.',
  x_5ec06103: '(solo esta máquina)',
  x_c6615916: 'hace dias',
  x_bb39a0c6: 'hace horas',
  x_9021c675: '📤 Exportado',
  x_1eab1ec2: 'Haga clic para descargar la carpeta (copiable por USB)',
  x_634abe29: '✅ Importación USB completada:',
  x_b359a569: 'Nuevo ·',
  x_3af4ed2f: 'Ya existe ·',
  x_7030ff64: 'error',
  x_c6e4b6a0: 'la clase ha comenzado',
  x_e7a7a7e2: 'Turnos por horas no entregados: entregue los turnos inmediatamente para evitar confusiones en la conciliación entre días.',
  x_73559114: 'horas, se recomienda entregar el turno lo antes posible / Turno abierto hace',
  x_e2efd3fa: '⬇️ Nueva versión v',
  x_2d455ce5: 'Descargando',
  x_51a8f63f: '🔄 Nueva versión v',
  x_c540ce8f: 'Listo · Desactivar la instalación automática de software ·',
  x_4c4d6a98: '📡 Sin internet -',
  x_922a9dca: 'El pedido se ha guardado de forma segura y se cargará automáticamente después de conectarse a Internet / Sin red, se subirán automáticamente',
  x_8d1c5588: '⬆️ Subiendo',
  x_6479a0a7: 'Single... / Subiendo',
  x_a53de3a7: '• Después del vencimiento, el depósito regresará al comerciante',
  x_c0cd0f67: 'Crédito de cambio activado / Crédito de cambio:',
  x_bc4e851c: 'Confirmar para desactivar',
  x_9cd30436: '? \\nDespués de la desactivación, los productos desaparecerán del POS/tienda online, pero el inventario y el historial de pedidos se conservarán y podrán reactivarse en cualquier momento.',
  x_47bf13b6: 'a',
  x_c9729ffc: 'Si los recortes de IA se realizan sobre fondo blanco para cada producto, se deducirá 1 punto de IA por cada producto (un total de',
  x_69db7ae0: 'punto). ¿Continuar?',
  x_c70a3c01: 'Recorte de IA completado: éxito',
  x_114d9700: '/fallar',
  x_8cac6775: 'Imágenes coincidentes exitosamente',
  x_5d459d55: 'Procesamiento',
  x_1e1445b3: 'Empiece a recortar (',
  x_6242f731: ') · Hebilla',
  x_be604f8b: 'punto',
  x_2ecbd077: '📱 Se ha enviado enlace al WhatsApp del jefe...',
  x_3a17aa8e: '¡Enlace enviado!\\n\\n',
  x_fa407236: '\\n\\nPresione Aceptar para copiar el enlace al portapapeles',
  x_cbcbd4e6: '¿Confirmar el ajuste de precio al por mayor?',
  x_1b92092d: 'actualizado',
  batchNoMatch: '⚠️ No hay productos en la categoría seleccionada — elija otra categoría',
  orderShift: 'Turno',
  viewShiftReport: 'Ver cierre de turno',
  shiftOpenBadge: 'Abierto',
  shiftClosedBadge: 'Cerrado',
  batchAllSkipped: '⚠️ 0 actualizados: los productos no tienen precio de costo, regístrelo primero',
  x_8c533c4a: '⚠️ El producto ya existe:',
  x_d8172b79: '✅ Precargado:',
  x_162d92be: '— Complete el precio y guárdelo',
  x_82978490: 'Se ha deducido la tarjeta de valor almacenado',
  x_955e88ca: '· Saldo',
  x_d43bd196: 'Guardar sin conexión:',
  x_eeb31a4e: '(Sincronizado automáticamente después de conectarse)',
  x_41c5ecd6: 'exceder',
  x_ed87d0af: 'Umbral de seguridad. \\n\\nPor favor, confirme nuevamente si el monto es correcto.',
  x_94d22b13: '⚠️ Nota:\\n\\nDinero real:',
  x_741ca864: '(muy pequeña)\\nDeducción de atrasos:',
  x_1a079931: '\\nDespués de las deducciones, todavía debes:',
  x_e93a7373: '\\n\\n¿Estás seguro?\\n• Presione [Confirmar] → pague de acuerdo con la cantidad anterior\\n• Presione [Cancelar] → pague el salario completo',
  x_4f2bb016: 'Se deducirán todos los atrasos (pago real',
  x_6e11eb39: 'Restablecer: Deducción',
  x_9de6f844: ', cabello real',
  x_8800e34b: '- Deducción',
  x_569ff68a: '= cabello real',
  x_48eb726e: 'Pago de salario exitoso: pago real',
  x_4c117f20: 'Orden',
  x_f6348db9: 'Orden encontrada:',
  x_692d69b4: 'artículos,',
  x_3b5e93d8: 'Marcado como [Día completo]\\n\\nEl salario se calcula en función del día completo. \\n¿Estás seguro?',
  x_1f623127: 'Marcado como [Medio día]\\n\\nEl salario se calcula como medio día (50%), y la ausencia se registrará automáticamente atrasada. \\n¿Estás seguro?',
  x_0064a575: 'Marcado como [Ausentismo]\\n\\n¡El sistema registrará automáticamente el salario de 1 día atrasado! \\n¿Estás seguro?',
  x_dc49966b: '💰 Se ha registrado deuda',
  x_e897afe2: '¿Confirma pagar a los siguientes empleados? \\n\\n',
  x_87c3b869: '\\n\\nTotal',
  x_465afe3c: 'gente',
  x_70e23b2c: 'Nómina -',
  x_a657f46f: 'semana',
  x_247b6518: 'Se ha pagado el salario',
  x_d051c48c: 'la gente falla',
  x_59cf15fe: 'Plantilla',
  x_1463e88d: 'Aplicado',
  x_d846c018: 'la empresa debe',
  x_b52d1753: 'Saldo del depósito:',
  x_6a34412a: '\\n\\nIngrese el monto a gastar (deje en blanco = Todo',
  x_5f3fd382: 'La cantidad debe',
  x_f3221016: '0 y ≤',
  x_c66b7456: '✅ Pagado',
  x_37186b95: 'dar',
  x_92ff3137: 'Deducción máxima (= min(salario, atrasos) =',
  x_ff06778b: 'soltero)',
  x_9d074fc7: '📱 Enviado a',
  x_be509224: 'teléfono móvil · vencido',
  x_e6c92b78: '· Expira pronto',
  x_59359c92: '¿Está seguro de que desea enviar recordatorios de WhatsApp a todos los clientes vencidos o vencidos? \\n\\n(El mismo cliente solo será enviado una vez dentro de 7 días y no será molestado repetidamente)',
  x_03e25cc4: '✅ Enviado',
  x_f6614467: 'recordatorios para clientes (saltar',
  x_6eb87074: 'Artículo · Fallido',
  x_feebfd78: 'artículo)',
  x_a80efbb5: 'No enviado (total',
  x_60c5bacd: 'registros, saltar',
  x_fcc7ee2d: ', falló',
  x_7e1fefa7: ')——Compruebe si el cliente tiene un número de teléfono móvil + suscripción',
  x_88fe7ca5: 'Declaración completa A4 ·',
  x_fe78a84f: 'Recibo de 80 mm · Solo resumen de pago ·',
  x_758ec925: 'la mayoría',
  x_cf4a812f: 'Totales / Totales:',
  x_f7edf5ac: 'piezas',
  x_2c117f7f: '✓ Orden copiada',
  x_01d7aa49: 'de',
  x_4e4008f8: 'productos, por favor seleccione la tienda de destino',
  x_53952782: 'Confirmar para cancelar la orden de transferencia',
  x_26671096: '? \\n\\nDespués de la cancelación, el inventario se devolverá al almacén de origen.',
  x_128b1e7c: 'mesa',
  x_2e3a36de: 'hace minutos',
  x_2de0d491: 'horas',
  x_73c826e5: '✅ Recarga exitosa · Nuevo saldo',
  x_7e2720b4: 'Cliente/cliente:',
  x_a423e73c: 'Fecha/Fecha:',
  x_1a608891: 'días para expirar',
  x_182da4c4: '💳 Historial de Pagos / Pagos (',
  x_24d9bec1: '⚠️ El tipo de cambio aumentó hoy',
  x_2e29f312: '% — El pago de Bs se convierte según el tipo de cambio actual (el monto es menor que cuando estaba bloqueado)',
  x_b1848125: '✅ El tipo de cambio bajó hoy',
  x_be793e09: '% — El pago de Bs se convierte según el tipo de cambio actual (el monto es mayor que cuando estaba bloqueado)',
  x_d6420ec0: '— Última actualización',
  x_603f7892: '⬆️Subir ahora (',
  x_d6f5f3c9: '🚫 Manejar pedidos rechazados (',
  x_365c6e84: '🔄 Crédito de cambio / Exchange credit $',
  x_cd600b9e: '), la conversión Bs puede tener una gran desviación',
  x_b61b86ae: 'En espera para sincronización',
  x_4827c1f8: 'El pedido fue rechazado por el servidor (no acreditado)',
  x_ff503ba7: '(Bs. actuales',
  x_7d68b4e3: 'Actual:',
  x_2be10f11: 'La cantidad de este producto en POS es ≥',
  x_41ae38b5: 'Partido exitoso:',
  x_13ddc197: 'Seleccionado · Consultar solo productos con fotos',
  x_bec8b787: 'Cambia automáticamente el precio 2 cuando',
  x_74714605: '🛒 Minorista minorista -',
  x_bb255d74: '🛒 Venta al por menor:',
  x_f84bb79f: '🏭 Venta al por mayor:',
  x_530afc78: '% de reembolso',
  x_30f580f1: 'Descuento / Descuento',
  x_06772a76: 'Deducción de Puntos / Puntos (',
  x_66525fb9: 'Precio original$',
  x_ae89baf7: '🛡️ la mayoría',
  x_f93a3192: '⚠️ Descuento máximo alcanzado (costo $',
  x_98e21b6a: 'Saldo insuficiente para pagar $',
  x_f2c67994: 'Se deducirán $',
  x_b682eb31: 'Vencimiento/Vencimiento:',
  x_dcbed21c: '% (protección de costos)',
  x_9f93459b: ', no se puede bajar o perderás dinero)',
  x_64e6defd: '· Saldo/Saldo:',
  x_2a7a6a6b: '→ Pagadero $',
  x_128029c2: '· $ restantes',
  x_eeedcd26: '💵 Retirar Depósito / Retirar $',
  x_aedc526b: 'hebilla',
  x_41cbd47f: 'Nómina (',
  x_a71e4358: 'Aún no hay plantilla. Después de programar su turno, haga clic en "',
  x_0d2fb245: '"Guardar como plantilla',
  x_4ce4ef96: 'información',
  x_b4ebe3f5: 'No',
  x_25aa5d7d: '/ Por favor agregue primero',
  x_fbd2b1fb: 'total',
  x_2187d87a: 'Pedido · Recibido $',
  x_cc09dc10: 'Especificaciones:',
  x_a0d921b3: '(Escasez',
  x_c37f6a62: 'Código QR de la tabla · Total',
  x_914e2a75: 'Descargar todos los carteles de mesa ZIP (',
  x_6499fc74: 'zhang',
  x_c2c92c19: 'Zhang)',
  x_e93c8f7b: 'Ocupado · Total actual $',
  x_87ba5064: 'Recargar $',
  x_31180e95: 'Error de carga:',
  x_36ea3e81: 'A cobrar $',
  x_fdf80fc9: 'Cobrar $',
  x_b34de51a: 'Pagado $',
  x_0c6c45ae: 'Historial de Pagos / Pagos (',
  x_e3bc8fa5: 'Convertido a USD (Bs.',
  x_7f4bb1d6: 'dias de gracia',
  x_48b0dec0: '·Yu$',
  x_27720067: '✕ Borrar',
  x_8decf585: '💱 Establecer manualmente el tipo de cambio de hoy',
  x_80272374: '📥 Exportar el resumen sin conexión de hoy',
  x_b2abad7a: '📤 Exportación USB todo',
  x_68771e30: '📥 Importación USB',
  x_7ca39c26: 'Cerrar turno',
  x_2ce5a620: 'Estas órdenes fueron rechazadas por el servidor durante la sincronización.',
  x_d8e901bc: 'Cuando sea 0, use el mercado negro; de lo contrario, use BCV.',
  x_f47fc941: '— Haga clic en el botón de la derecha para ver la causa y solucionarla.',
  x_1faae5c2: 'Cambio de precio del lote',
  x_ee2b9ce1: '📷 Escanee el código QR para agregar',
  x_d0c1006c: 'Pago Móvil/Transferencia siguen la mayoría de la verificación. / Imprime automáticamente el recibo después del pago e inicia el siguiente pedido directamente (excepto Pago Móvil/transferencia)',
  x_f3131239: 'Al cobrar en USD (efectivo/Zelle), el POS suma automáticamente el 3% de IGTF y lo imprime en el recibo. / Al recibir dólares estadounidenses, el impuesto IGTF del 3% se agregará automáticamente y se imprimirá en el recibo.',
  x_f09933aa: '¿No ves el nuevo botón? Haga clic aquí → El sistema borrará automáticamente el caché antiguo → Cargue la última versión inmediatamente.',
  x_f40cbd21: 'Recuerde a todos los empleados que después de hacer clic en este botón, todos los empleados se sincronizarán automáticamente con la última versión en 5 segundos.',
  x_3a04c76e: '• El POS aún puede realizar el pago cuando el inventario es 0 o negativo',
  x_8250b510: '• El inventario se convertirá en un número negativo (por ejemplo, -5 significa que 5 piezas están agotadas)',
  x_121b783a: '• Adecuado para: El producto físico está en la tienda pero el inventario del sistema es inexacto, el mayorista a menudo se vende por adelantado y se acaban de lanzar nuevos productos pero el inventario no está registrado.',
  x_4fbdd3a8: '• ⚠️ NOTA: vaya con regularidad',
  x_694ccb6b: '• POS se niega a realizar pedidos cuando el inventario es insuficiente',
  x_959932ab: '• Prevenir la sobreventa y el caos de datos',
  x_f34c6c1f: 'Conteo de páginas, borrado de números negativos',
  x_59637fe6: 'Ajuste el número de páginas o active temporalmente este interruptor',
  x_684ee9b5: 'Forzar actualización',
  x_140d6e9a: 'Actualizar ahora',
  x_32415951: 'Cliente',
  x_85fc0b89: 'Empleado',
  x_vale_label: 'Vale de compra',
  x_vale_placeholder: 'Escanee / escriba el código, Enter',
  x_vale_apply: 'Aplicar',
  x_vale_applied_ok: 'aplicado',
  x_vale_forfeit: 'El vale supera la compra; se pierde:',
  x_vale_earned_title: '¡El cliente ganó un vale!',
  x_vale_earned_rule: 'Compra ≥',
  x_vale_valid_until: 'Válido hasta',
  x_vale_later: 'Luego',
  x_vale_print: 'Imprimir vale',
  x_f676b12b: 'Tarjeta de Saldo',
  x_d5109b1f: '📱 Resumir y enviar al jefe',
  x_f6a5aaac: '🔔 Enviar recordatorios a cada cliente',
  x_e87e3fba: '⏳ Para sincronizar',
  x_c66a65a3: '💵 Debe pagar en dólares estadounidenses / Solo USD — No disponible pago en Bs',
  x_4ef6283c: 'Fallido·Requiere procesamiento',
  x_7ab62e2e: 'Los siguientes productos no tienen suficiente inventario en el almacén de origen. Por favor elija cómo manejar:',
  x_f75eee5f: '✅ Seguir ajustando mercancías / Continuar (se permite inventario negativo)',
  x_58c10a18: 'Ajustar al disponible',
  x_9cc890a7: 'Cancelar',
  x_c16cdc6d: '🎨 Embellecer carteles',
  x_cbdcabad: 'liberar',
  x_1b8de39d: '⚙️ Integre automáticamente la interfaz de usuario "Selección de mesa → Realizar pedido" en la siguiente ronda. Actualmente, utilice las notas de pedidos pendientes para asociar.',
  x_5b3aaade: 'ℹ️ Después de imprimir, corte y pegue el protector en cada tablero; los invitados pueden escanear para ingresar a la página de pedidos de su propia mesa (el número de mesa se selecciona automáticamente)',
  x_7559ce8e: '🎨 Pósteres de mesa · Pósteres de marca',
  x_2601cd44: 'ℹ️ Póster tamaño A5 (1240×1748 @ 200 DPI), que incluye barra superior con el nombre de la tienda + placa con el número de la mesa + QR grande + eslogan en varios idiomas + barra inferior con información de contacto.',
  x_81567a16: 'Simplemente imprímelo en la imprenta, córtalo, protégelo y pégalo sobre la mesa. El huésped escanea el código QR → ingresa automáticamente a la página de pedidos → se ha completado el número de mesa.',
  x_7be49895: '📱 Tabla QR',
  x_727c86c9: 'Agregar una tabla',
  x_fbac2d7f: 'Imprimir directamente',
  x_c12a29c0: 'Descargar ZIP (cada PNG por separado)',
  x_46c8a671: 'Lanzamiento de nuevas tarjetas.',
  x_e50663b2: 'Recargar',
  x_79d3abe9: 'Copiar',
  x_b1fe43e8: '. Escríbalos en la tarjeta física/imprima el recibo y entréguelo al cliente. Si se pierde la tarjeta, el cliente deberá mostrar el número de tarjeta + PIN para comprobarla/utilizarla.',
  x_fd924ff0: '🏷️ Aparta',
  x_f20ccb10: 'Sin apartados',
  x_e8606af7: 'Confirmar cancelación',
  x_45f2c9a0: 'Vence:',
  x_616c68e6: 'Configuración de reglas',
  x_132c5cdc: 'Inténtalo de nuevo',
  x_5c52b0fd: 'Vencen 7d',
  x_12aabd94: 'Vencidas',
  x_ad3cd23a: 'Imprimir',
  x_1cb2b4b8: 'Cancelar',
  x_fix_bulk_hint: '(La tienda online mostrará etiqueta "A granel"; el cliente puede comprar 0.5 / 1.8, etc.)',
  x_fix_otherwh_hint: 'Otros almacenes (solo lectura; use Ajuste de inventario o Transferencias para modificar)',
  x_fix_upload_hint: 'archivos; pulse "Empezar a subir" y el servidor los emparejará por código',
  x_fix_rejected_hint: 'Verifique el motivo: si es duplicado elimínelo; si es un cobro real pulse "Reenviar".',
  x_fix_guestwifi_tip: 'Sugerencia: use la Red de Invitados del router con desconexión automática de 2 minutos.',
  x_cd509648: 'Buscar productos...',
  x_26b5bd49: 'Cargando...',
  x_d5faf486: 'la tienda no existe',
  x_a8b0c204: 'Todos',
  x_e3a7209e: 'Aún no hay productos',
  x_1bd84635: 'Selección diaria de alimentos frescos.',
  x_663af409: 'Orden de comida deliciosa en línea',
  x_c76203b6: 'Selección de grandes almacenes, todo lo que necesitas',
  x_9450139e: 'Vida sana, cuidado esmerado.',
  x_fb289d60: 'Recién horneado y fragante',
  x_13f0b75a: 'La ropa de moda saborea la vida.',
  x_a6ef79b6: 'Todas las novedades tecnológicas están a tu alcance',
  x_a03f1a4b: 'Garantía de calidad de la carne fresca',
  x_21f9dcf0: 'Compras en línea Entrega a domicilio',
  x_54e5de42: 'Error al subir',
  x_18e80613: 'Merchant WhatsApp not configured',
  x_aed1dfbc: 'en',
  x_b71301e1: 'Elegir / Seleccionar',
  x_0288e6a2: 'El navegador no soporta GPS',
  x_12cffd73: '📍Ubicando...',
  x_48b05582: '✅ Su ubicación fue registrada para que el repartidor pueda entregar con mayor precisión',
  x_9ccbd711: 'No se puede obtener la ubicación, complete la dirección manualmente',
  x_2f6911f3: 'Mi ubicación ha sido registrada ✓',
  x_1499f061: 'Usar mi ubicación actual (la entrega es más precisa)',
  x_dc715bb8: 'Confirmar pedido',
  x_0d0bc2bc: 'Copiado / Copiado',
  x_dac8225e: 'Selecciona opción (talla/color/sabor)',
  x_9f9cbc48: '1.8 OK)',
  x_7f6e80a6: 'Click "Confirm"',
  x_27c05b27: 'WhatsApp se abrirá automáticamente con los detalles del pedido ya completados y usted podrá simplemente enviar el método de pago al comerciante.',
  x_3a9be7db: 'Enviar pago a / Favor transferir a:',
  x_f65ce56a: 'Banco emisor / banco',
  x_ed4ea468: 'Telf. número de teléfono del emisor/remitente',
  x_bb58400a: 'Consultar precio',
  x_619fd86c: 'Introduzca el nombre del producto/código de barras...',
  x_1d7a5330: 'Producto no encontrado',
  x_fb852fc6: 'En progreso',
  x_cd8c77d3: 'Completada / Completado ✅',
  x_2111ccbb: 'Cancelado',
  x_6a0abbb7: 'Vencida / Confiscada ⚠️',
  x_1ea78d47: 'factura',
  x_ff0b2077: 'Cliente',
  x_6ffe81e2: 'cantidad total',
  x_57b642fc: 'Pagado',
  x_931f1f80: 'a pagar',
  x_9897d884: 'mercancía',
  x_474cd02d: 'pago',
  x_b0fae043: 'reglas',
  x_499b9a62: 'fecha de vencimiento',
  x_8c1bc4ba: 'término',
  x_98ffc82c: 'Depósito mínimo',
  x_82188307: 'Si no se paga dentro del plazo, el depósito pertenecerá al comerciante.',
  x_e2eb6313: 'Por favor paga en tienda',
  x_6f83193b: 'Firma del cliente',
  x_e9bd1d12: 'Términos aceptados',
  x_c281ff84: 'Términos no aceptados',
  x_affa4d0e: 'Cargando... / Cargando...',
  x_c6dd0ab3: '• Si no se paga dentro del plazo, el depósito pertenecerá al comerciante.',
  x_8deff26f: 'Toma fotografías casualmente',
  x_866b795e: 'Error al cargar',
  x_7683487f: '✅ Completado, continúa con el siguiente.',
  x_82bae6ba: 'Buscar nombre/código/código de barras',
  x_bbd24cc2: '📷 Toma fotos',
  x_2a3114f2: '🔄 Reemplazo',
  x_c0588fd1: 'Has negado el permiso de la cámara. Permita la cámara en la configuración de su navegador.',
  x_efb8ad19: 'Dispositivo de cámara no encontrado',
  x_c9ece2f8: 'El embellecimiento de IA falla, puedes usar la imagen original directamente',
  x_d1f9b309: 'No se pudo guardar, se ha conservado la imagen original',
  x_8705e16b: 'Disponible solo para jefes y gerentes/Administrador/gerente individual',
  x_77dbf376: 'Camera Boss',
  x_42eae5c2: '¡Todos los productos tienen fotos!',
  x_d2a53af5: 'Sin productos',
  x_3fe62d01: 'Primero busque el producto que desea reemplazar',
  x_5fbe1b26: 'Tomando fotografías...',
  x_36152aa9: 'Embellecimiento por IA...',
  x_bfeacb2a: '~15 segundos',
  x_95d9b747: '📸 Imagen original',
  x_3fb7e372: '✨Embellecimiento AI (fondo blanco)',
  x_3f981012: 'Recomendado',
  x_997c7a5d: 'Función',
  x_6adafe27: 'Industria',
  x_a95dd3e1: 'tecnología',
  x_d38a089e: 'Contacto',
  x_402d19e5: 'Iniciar sesión',
  x_248f81e2: 'Prueba gratuita',
  x_3ab22098: 'Sistema POS en la nube',
  x_e06f69f5: 'haz tu negocio',
  x_cc15c20a: 'Ir al siguiente nivel',
  x_2852a028: 'Toma el control total de tu tienda, restaurante o farmacia. USD/VES multidivisa, factura electrónica, disponible sin conexión.',
  x_dd88cfbf: 'Prueba gratuita durante 7 días',
  x_8a81d8ca: 'Ver características',
  x_b52b8c1f: 'Seguro y estable',
  x_d255512b: 'VES',
  x_1d8d47a1: 'Verificación automática Pago Móvil',
  x_84b0b2a1: 'Disponible sin conexión',
  x_6fcc5a76: 'Seguridad en la nube',
  x_0cee3341: 'Comerciante activo',
  x_55131659: 'volumen de operaciones diario',
  x_b67495ee: 'tarifa en línea',
  x_f0fbeece: 'Soporte técnico',
  x_176ca494: 'Un sistema para todas las necesidades',
  x_b4fa6629: 'Desde pagos rápidos hasta informes inteligentes, Sellox tiene todas las herramientas para ayudar a que su negocio crezca.',
  x_f1c5a568: 'Pago extremadamente rápido',
  x_adc03f83: 'La búsqueda inteligente, el escaneo de códigos de barras y los atajos de teclado completan las ventas en segundos. También funciona sin conexión.',
  x_c0c97799: 'inventario en tiempo real',
  x_40483407: 'Inventario en tiempo real, combinaciones de paquetes, advertencias de inventario bajo y transferencias entre almacenes.',
  x_3c1a2842: 'informe inteligente',
  x_1aa9589f: 'Ventas, ganancias, productos más vendidos y análisis de paquetes, visualice con un solo clic.',
  x_ab572bf7: 'Pague en pedidos separados',
  x_c677e641: 'Se aceptan múltiples métodos de pago para una transacción: efectivo, tarjeta bancaria, transferencia.',
  x_42081db9: 'lealtad del cliente',
  x_a1c08c39: 'Programas de puntos, niveles de membresía, precios especiales por tipo de cliente.',
  x_3f70a475: 'Impresión de billetes',
  x_f5fbde12: 'Compatible con impresoras térmicas convencionales (Bixolon, HKA) y admite impresión dual de recibos y facturas.',
  x_47acae77: 'Gestión de sedes de cadena',
  x_ae346bda: 'Descripción general del rendimiento de varias tiendas, visualización de inventario entre tiendas, ajuste de precios unificado y gestión de crédito de clientes B2B.',
  x_9eb1059d: 'Reposición inteligente',
  x_77e17012: 'Analice automáticamente la velocidad de ventas, prediga tiempos de agotamiento de existencias y genere una lista de sugerencias de reabastecimiento.',
  x_c14027b7: 'Adáptate a tu tipo de negocio',
  x_0c5bd351: 'venta al por menor',
  x_e37fda71: 'Tiendas y comercio minorista',
  x_1752dd18: 'Control integral de inventario: advertencia de inventario bajo, escaneo de códigos de barras, precios escalonados para el cliente, impresión de etiquetas de precios y gestión de proveedores.',
  x_9d39de37: 'escaneo de código de barras',
  x_8bc3ace8: 'Precios escalonados',
  x_a297a148: 'Gestión de inventario de varios almacenes.',
  x_9e4e8242: 'Paquetes y Promociones',
  x_37346312: 'Impresión de etiquetas de precio',
  x_faeff5ef: 'supermercado',
  x_87dc671e: 'Supermercados y tiendas de conveniencia.',
  x_312dc180: 'Maneje de manera eficiente grandes volúmenes de transacciones, integrando balanzas electrónicas, escaneo de códigos de barras, paralelización de múltiples cajas y gestión de la vida útil.',
  x_3e6c0601: 'Procesamiento de transacciones de alta frecuencia',
  x_73b2dfdf: 'Múltiples cajeros en paralelo',
  x_b4157847: 'Integración de balanza electrónica',
  x_e9bb592c: 'Gestión de la vida útil',
  x_58936f4b: 'Precios al por mayor y al por menor',
  x_2a0ad6ff: 'restauración',
  x_d2010d15: 'Restaurantes y cafeterías',
  x_26b82bf3: 'Plataforma integral para gestión de mesas, recibos de cocina, notas de platos, propinas y facturación por separado.',
  x_450fec16: 'Gestión de escritorio',
  x_58adcc1a: 'Pantalla/impresión de cocina',
  x_8c1b8588: 'Facturación separada',
  x_6c7083d9: 'Volcado automático',
  x_537efc66: 'pedido para llevar',
  x_53b4b807: 'belleza',
  x_98a53972: 'Salones de belleza y peluquería',
  x_24fbec85: 'Gestión de citas, registros de atención al cliente, comisiones de empleados y programas de fidelización de miembros.',
  x_220e22c6: 'Gestión de citas',
  x_9c4df083: 'Comisión de empleados',
  x_b78043c0: 'Perfil del cliente',
  x_cc98eba1: 'Programa de puntos',
  x_cceccce5: 'Recordatorio automático',
  x_068d9237: 'Se puede utilizar con o sin conexión a Internet.',
  x_495aee53: 'Diseñado para Venezuela. Incluso si se corta la energía y la red, el POS seguirá funcionando.',
  x_f0527d8a: 'Los datos se respaldan automáticamente y se puede acceder a ellos en cualquier momento desde cualquier dispositivo.',
  x_4a61c29a: 'Modo sin conexión',
  x_b5b0394e: 'Las ventas continuarán como de costumbre incluso si la red se desconecta y los datos se sincronizarán automáticamente después de que se conecte la red.',
  x_b0404c0b: 'Sincronización inteligente',
  x_ad79d5c5: 'Los datos se guardan en IndexedDB local y no se perderán incluso si la red se desconecta durante varios días.',
  x_30504e20: 'Soporte para múltiples dispositivos',
  x_6d6042f2: 'Se puede utilizar en ordenadores, tablets y teléfonos móviles, y la interfaz se adapta perfectamente a varias pantallas.',
  x_f3de96c1: 'Computadora como cajero principal',
  x_a123f815: 'Consulta los datos de ventas en cualquier momento desde tu teléfono móvil',
  x_18e45612: 'Múltiples terminales en línea al mismo tiempo',
  x_2ed39222: 'empleados',
  x_9c7d7a67: 'ilimitado',
  x_654522d2: 'Moneda',
  x_97b835a4: 'Disponibilidad',
  x_17927e12: 'Funcionalidad completa',
  x_a8b6d749: 'Más completo que cualquier TPV',
  x_ac84ee55: 'factura electrónica',
  x_bdb58c39: 'Actualizaciones automáticas del tipo de cambio',
  x_8242ec7e: 'Programa de fidelización de miembros',
  x_3e751fda: 'Paquetes y combos',
  x_bb84d6ea: 'Notas de pedido',
  x_b612cf7a: 'Gestión de turnos',
  x_dbc12902: 'impresión térmica silenciosa',
  x_e81ee1fe: 'Gestión de múltiples almacenes',
  x_87821b0d: 'informe de ventas',
  x_46756e70: 'análisis de ganancias',
  x_c791eec3: 'Gestión de proveedores',
  x_f5a29430: 'Control de adquisiciones',
  x_8cca9955: 'Centro comercial en línea',
  x_93befa62: 'pedido en línea',
  x_9f08dc32: 'tienda virtual',
  x_be37ebc5: 'Devoluciones y reembolsos',
  x_baa125c4: 'Inventario entre tiendas',
  x_42b52276: 'Gestión de clientes B2B',
  x_b9ee7355: 'Sugerencias de reabastecimiento inteligentes',
  x_d4d37b95: 'Análisis de velocidad de ventas',
  x_46cf89f9: 'Predicción agotada',
  x_ebff97ec: 'Gestión de préstamos/créditos para empleados',
  x_28d629c1: 'Sistema de tarjeta perforada de asistencia',
  x_67580600: 'Cálculo automático de nómina',
  x_a4e9168d: 'Calendario de vacaciones (1,5 veces el salario)',
  x_cb4588c2: 'Verificación AI Pago Móvil',
  x_f348c3f7: 'Gestión de cambio (comprar dólares estadounidenses/tarjetas magnéticas para cambiarlas por efectivo)',
  x_4e3c5d06: 'Gestión de órdenes de compra',
  x_52f264a7: 'Recuento de efectivo por turnos',
  x_28f364b2: 'Modelo multiprecio (minorista/mayorista/contenedor completo)',
  x_7253b11c: 'Pedido de PWA sin conexión',
  x_df5a934f: 'Prepárate para hacer tu negocio',
  x_47db59fb: '¿Llevándolo al siguiente nivel?',
  x_267335fb: 'Únase a cientos de comerciantes en Venezuela que confían en Sellox.',
  x_2673904b: 'Empieza gratis',
  x_65300d22: 'No se requiere tarjeta de crédito, se configura en 5 minutos.',
  x_1a69cc94: 'Empezar ahora',
  x_4d9b70e1: 'Mejora de la eficiencia',
  x_0e9fd989: 'Precio',
  x_a7bac223: 'chino',
  x_a132c42f: 'Descargar para Windows',
  x_a825a5b0: '¿Tiene alguna pregunta? preguntar',
  x_92248c47: 'servicio al cliente o',
  x_c984d4fd: '✨ Últimas funciones de IA',
  x_01ff215e: 'La IA te ayuda a hacer negocios',
  x_f5299c8e: 'Nano Plátano Bellas Imágenes',
  x_7fa9308c: 'Convierte fotos de productos borrosas tomadas con tu teléfono móvil en fotos profesionales con un solo clic (Gemini Nano Banana)',
  x_e9a8de17: 'Marketing de IA de WhatsApp',
  x_ed2f6b2f: 'Saludos de cumpleaños automáticos + marketing navideño + respuestas en cuatro idiomas (chino, inglés, español y portugués)',
  x_576c046d: 'cajero de voz',
  x_8f395150: 'Di "Agrega 3 Coca-Colas" para realizar tu pedido (Whisper STT)',
  x_99d6e6c1: 'Mayordomo de IA',
  x_627f661f: 'Analice automáticamente las ventas todas las noches y brinde sugerencias de existencias para mañana',
  x_1f7b6ef8: 'Tipo de cambio multinacional',
  x_d1529f52: 'Actualizaciones automáticas BCV + Paralelo + Frankfurter en tiempo real (compatible con 7 países)',
  x_c0373da5: 'La tarifa anual incluye servidores en la nube, copias de seguridad automáticas y actualizaciones del sistema: cuantas más tiendas, mayor será el uso de la nube.',
  x_3a80619c: '¿No estás seguro de qué función es la adecuada para ti? preguntar',
  x_5d6e903d: 'servicio al cliente, o',
  x_423811c2: 'Paquete simple, todas las funciones.',
  x_86cb3a40: 'Sin cargos ocultos, cancela en cualquier momento. Comience con una prueba gratuita de 7 días.',
  x_55b728d1: 'más popular',
  x_890e3707: 'Versión básica',
  x_f9205ad4: 'Versión comercial',
  x_94ac1fb3: 'Edición empresarial',
  x_5ad3f664: 'Año Nube + Cuota de Mantenimiento',
  x_a3e93bd5: '✅ Verificar automáticamente la llegada de la cuenta Pago Móvil',
  x_8242103b: 'Multidivisa USD/VES + tipo de cambio automático',
  x_b7815b8e: 'Disponible sin conexión + copia de seguridad en la nube',
  x_af2ed285: 'Atención al cliente de WhatsApp',
  x_dc65864a: '🛒 Incluye tienda online (centro comercial online)',
  x_01efcb04: 'No incluye tienda online',
  x_7a5eaa76: '¿Necesitas activar o renovar? Contacto',
  x_49707f5f: '¿Tiene preguntas?',
  x_b69517e9: 'servicio al cliente /',
  x_2f312b31: 'original$',
  x_c87b05f9: 'Tienda/tienda:',
  x_d6b71ccb: 'Todas / Todas las tiendas',
  x_91c1ffb2: 'Bs/BCV (Compra de tipo de cambio del Gobierno)',
  x_06510ba7: 'inventario de piezas',
  x_12448e37: 'Costo:',
  x_6c694f7b: 'Venta al por menor:',
  x_b0c1f4e6: 'Original $ (compra en el mercado negro)',
  x_450efd2f: 'total',
  x_f6f1d40b: 'Costo total:',
  x_724210ee: 'Ventas minoristas totales:',
  x_61406e63: 'Margen de beneficio:',
  x_652be256: 'Detalles de clasificación',
  x_d0771a42: 'Clasificación',
  x_f0789e79: 'modo',
  x_040dd10a: 'Número de artículos',
  x_0eac8802: 'inventario',
  x_671e045d: 'Costo$',
  x_4c5d80a5: 'Minorista$',
  x_1fc64a84: 'Ganancia$',
  x_bd4357f9: 'todo el dia',
  x_c31b1b99: 'medio dia',
  x_02efd8b1: 'ausentismo',
  x_3cdcbdf0: 'Festival cancelado',
  x_15dd9319: 'Fijar como feriado (doble paga)',
  x_2a2338ae: 'Gestión de asistencia',
  x_583cc547: 'empleados totales',
  x_1c6f494e: 'Ya registrado',
  x_a7da9234: 'tienda',
  x_93849f29: 'asistencia de hoy',
  x_87bd8d0d: 'calendario de vacaciones',
  x_3ccfeac0: 'Registro de punzonado',
  x_464f3d4e: 'papel',
  x_b4f0388f: 'ir a trabajar',
  x_96ed60cd: 'salir del trabajo',
  x_3fea7ca7: 'Estado',
  x_6bc72d59: 'No registrado',
  x_f5360872: 'Haga clic en la fecha para marcar/cancelar el feriado y trabajar durante el feriado se contará como 1,5 veces el salario (LOTTT)',
  x_8fb52fe0: 'Días festivos precargados',
  x_a7a9b5d0: 'nuevo',
  x_9087937f: 'Prellenar los días festivos legales de 2026',
  x_29a98994: 'vacaciones del mes',
  x_046c6233: 'Recientemente',
  x_249aba76: 'dia',
  x_4ff1e74e: 'Fecha',
  x_2b6bc0f2: 'Operación',
  x_19fcb9eb: 'tiempo',
  x_676e5982: 'operador',
  x_b3755e33: 'Sucursal Diaria',
  x_0c9d2b45: 'Método de pago',
  x_c633a333: 'esperado',
  x_06f26e9d: 'real',
  x_5fdfbade: 'diferencia',
  x_1f11f332: 'El PIN debe tener 4 o 6 dígitos',
  x_6a6dfeb1: 'Dos entradas son inconsistentes',
  x_7a6d647f: 'PIN guardado',
  x_6de920b4: 'Error al guardar',
  x_175377c0: 'Cambiar PIN',
  x_cbbd1f37: 'Establecer PIN',
  x_2a33020e: 'Guardando...',
  x_fd7c0215: 'Por favor confirme con PIN',
  x_b070fd2b: 'PIN de WhatsApp del jefe / PIN de comando de WhatsApp del jefe',
  x_66bff1f9: 'Se utiliza para confirmar cambios de precios, reembolsos, eliminaciones de pedidos y otras **operaciones peligrosas** a través de WhatsApp',
  x_44e60789: 'Ya configurado',
  x_fe2d26a2: 'no establecido',
  x_e81c6450: 'bloqueado',
  x_ed6c2836: 'Intentos fallidos:',
  x_1b87b102: 'Nuevo PIN (4 o 6 dígitos)',
  x_df21533b: 'Confirmar PIN',
  x_359986fb: 'Actualizar PIN',
  x_6b08b3ce: 'Guardar PIN',
  x_8513ad10: 'Como usar',
  x_32fa6a1b: '1. Envíe WhatsApp desde el número de jefe incluido en la lista blanca al número Meta vinculado a Sellox.',
  x_cb43e349: '2. Responder directamente a las consultas (ventas de hoy, inventario, crédito).',
  x_20f82d05: '3. Para modificaciones (cambio de precio/reembolso/ajuste de inventario/problema de cobro), se responderá "Confirmar con PIN".',
  x_8f4e84c9: '4. Solo respondes con un PIN de 4 dígitos, que es válido en 5 minutos. El sistema se ejecutará e informará.',
  x_1c3b9af4: 'Todas las operaciones se escriben en el registro de auditoría (audit_logs) y 5 PIN incorrectos se bloquean automáticamente durante 15 minutos.',
  x_61f6d70f: 'Efectivo',
  x_798d879e: 'Tarjeta',
  x_3ed4a686: 'Transferencia',
  x_3dd2ecf9: 'Crédito',
  x_b0559b3d: '✅ Vista previa generada',
  x_6a3a5ef0: 'Error en la vista previa',
  x_3bd0272f: 'Por favor, introduzca primero el número de teléfono móvil del socio.',
  x_9ca6a344: 'Envío fallido',
  x_ac52a991: '(sin nombre)',
  x_b93fce3d: '📆 1 de cada mes',
  x_f493a608: '📅 Todos los días 21:00',
  x_11e80f95: 'todos',
  x_ba1a3a35: 'Enviando...',
  x_07d0b32a: 'Enviar',
  x_2b5c1e95: '✅ Guardado',
  x_bec9ee92: 'Guardar',
  x_fe56e486: '🤝 AI envía cuentas al codirector',
  x_1c2e02ce: 'Aún no habilitado',
  x_2b05c552: 'Co-dueño:',
  x_e6f32bcc: 'Frecuencia:',
  x_7b03c3e6: 'Filtrar por (solo reportar estos):',
  x_2a0331b4: 'Último enviado:',
  x_6b4a51fc: 'Mensaje AI',
  x_4c117f20: 'Orden',
  x_28866da4: 'dólares totales',
  x_de742acb: 'Filtrar USD',
  x_3d9ffcbf: 'Co-dueño',
  x_c716dbd4: 'Activar',
  x_149265c0: 'Nombre co-dueño',
  x_0d0635b6: 'Su WhatsApp (incluido el código de país, formato 58XXXXXXXXXX)',
  x_ba2b6eee: 'Frecuencia',
  x_6d5a3b51: 'Enviado automáticamente a las 21:00',
  x_3253cde4: 'Emitido automáticamente el día 1',
  x_79218550: 'Informe solo estos métodos de pago (vacío = todos, ambos jefes ven los detalles de estos métodos)',
  x_a41cf705: 'Tono',
  x_b19cbde8: 'Enviar a mí también',
  x_55aa6366: 'Actualización exitosa',
  x_e2f2ba57: '✅ Habilitar',
  x_0031dd8b: '⛔ Desactivar',
  x_8ff8cf44: '🗑 Papelera de reciclaje',
  x_47508121: 'gorra$',
  x_7acbbda8: 'Retail',
  x_79c4a31e: 'Mayorista',
  x_f17d31b7: 'Clientes mayoristas (precio mayorista automático P2 + 0.5pt/$1)',
  x_4c998309: 'Imprimir Tarjeta QR',
  x_5fa802be: 'Operación fallida',
  x_2ffea779: 'Desactivar cliente',
  x_b2cdaef5: 'Volver a habilitar al cliente',
  x_5c56a889: 'desactivar',
  x_7854b52a: 'habilitar',
  x_e5323bab: 'Mover a la papelera de reciclaje (recuperable)',
  x_45f778d7: '✏️ Editar cliente',
  x_95e5011c: 'Ejemplo: 05-14',
  x_3df74976: 'credito',
  x_dd694c71: '🏭 Venta al por mayor',
  x_36cd3fdb: '🎂 Cumpleaños (MM-DD o AAAA-MM-DD)',
  x_e8228d38: '📱 WhatsApp (si es diferente al teléfono)',
  x_84a6c65b: '📨 Suscríbete a las notificaciones de WhatsApp (recibos electrónicos + deseos de cumpleaños + marketing)',
  x_766084e7: '🏭 Clientes mayoristas (puntos bajos)',
  x_6f76107e: '👤 Para uso propio del empleado (puntos bajos)',
  x_193fd90d: '🏭 Mayorista / 👤 Empleados → Según ratio de puntos mayoristas (0,5 pt/$1); sin marcar = minorista (1 pt/$1)',
  x_2e0d8c60: 'Error al exportar:',
  x_080e4cdb: '\\nUtilice el botón Imprimir para guardar como PDF.',
  x_617fe407: 'Please allow popups, then try again',
  x_8b05bd24: 'Print failed:',
  x_402193e1: '\\nUtilice el botón "Descargar PNG" para guardar e imprimir.',
  x_d2f8e650: 'Print',
  x_20b916e7: 'Close',
  x_1f1edd2f: 'Tema:',
  x_2c3a24c3: 'Gana puntos y disfruta de descuentos',
  x_9954e58a: 'Escanéame para consultar tu saldo de puntos',
  x_27210b8c: '🎯 ¿Cómo funciona?',
  x_70e4ea74: 'Abre la cámara de tu celular',
  x_f486f0e3: 'Escanea este QR',
  x_7baa65a2: 'Ingresa tu teléfono',
  x_b624f658: '¡Ve tus puntos!',
  x_dfdc6590: '💡 Sugerencias de uso',
  x_5df80e61: 'Descargar PNG → Imprímelo y pégalo en el **mostrador de caja/entrada de la tienda/pared de la tienda**',
  x_106fdc25: 'Envíe este enlace a clientes habituales y permítales guardarlo: consulte los puntos en cualquier momento',
  x_56f67f86: 'También puedes imprimirlo en un pequeño póster A4 y pegarlo en la pared.',
  x_5972e86f: 'Los clientes escanean el código QR e ingresan su **número de teléfono móvil** o **número de cliente** (como C123456) para verificar',
  x_049346a3: '🤖 Créditos de IA',
  x_fa6ec9d1: '💳 Alquiler mensual SaaS',
  x_90b1c915: '👑 Compra única',
  x_712596c1: '🛠 Cuota de mantenimiento anual',
  x_52e6abbe: 'Copiado',
  x_86516aa6: 'Moneda de pago',
  x_c1e2c9b2: '⚠️ Modo caja de arena',
  x_ed25395f: 'Modo de producción en vivo',
  x_4f0bae34: 'Ya recibido (USD)',
  x_aeb63c16: 'Facturas totales',
  x_fad5222c: 'Completado',
  x_072ece17: 'Esperando pago',
  x_28efb5bd: 'Crypto Income',
  x_694fc5ef: 'Actualizar',
  x_c459d386: 'By Type',
  x_21efd88b: 'Aún no hay datos',
  x_d071be88: 'Recent Invoices',
  x_4787d633: 'inquilino',
  x_226b0912: 'Tipo',
  x_f9b45f5c: 'Monto(USD)',
  x_def802c1: 'Recibido (USDT)',
  x_4572d0ec: 'Aún no hay factura',
  x_50de5a30: 'ya llego',
  x_74d3ba48: '= el estado es',
  x_1dea3af7: 'y',
  x_92a99777: 'facturas totales',
  x_bfa852da: '💡 Irá automáticamente a NowPayments entre 5 y 15 minutos después de que el cliente realice el pago → lo transferirá automáticamente a su billetera TRON',
  x_730aa550: '💡 Si quieres ver los detalles específicos de cada transacción, accede directamente a',
  x_351912e9: 'comprobar',
  x_8c25dee1: 'Naranja vibrante',
  x_3c683341: 'océano azul verde',
  x_a45a3ac7: 'verde fresco',
  x_46341dc6: 'Oro violeta elegante',
  x_e64084df: 'oro negro moderno',
  x_db29972a: 'Código QR de promoción de tienda online',
  x_32a67e3c: 'Genere hermosos carteles, imprímalos y publíquelos en las tiendas para atraer clientes para que escaneen el código QR y realicen pedidos.',
  x_e414473c: 'Imprimir',
  x_0657ba7c: 'Enlace de tienda en línea',
  x_6a9e5785: 'entrega puerta a puerta',
  x_0060e3d3: 'Haz un pedido en cualquier momento',
  x_f973aa04: 'Ofertas exclusivas',
  x_7864d864: 'llegar rapido',
  x_68d89d0b: 'Gama completa de productos',
  x_ee79ba4c: 'Pagos múltiples',
  x_72f59366: '¡No es necesario salir, los buenos productos se entregarán en su domicilio!',
  x_ccb69e71: '¡Descuento en el primer pedido para nuevos clientes + obtenga puntos al realizar un pedido!',
  x_dd35f3aa: 'QZ Tray es un servicio de impresión local gratuito. Después de la instalación, la página web puede enviar instrucciones de impresión directamente a la impresora.',
  x_227b88f4: 'No aparece el cuadro de diálogo de impresión',
  x_ee173ce8: 'Pasos:',
  x_e1eb333e: 'Haga clic para descargar:',
  x_ff7bbf67: 'Descargue Windows (.exe), instale',
  x_a3c49496: 'Haga clic en "Next" durante la instalacion',
  x_e0e27701: 'Aparecera el icono QZ en la bandeja del sistema',
  x_0671c916: 'Eliminar ventana de seguridad:',
  x_ea015cf2: 'Si aparece la ventana "Sitio web no confiable" cada vez que imprime la bandeja QZ, siga los pasos a continuación para instalar el certificado:',
  x_e43c62e9: 'Descargue el certificado:',
  x_d3f866d8: '2. Pon lo descargado',
  x_0457c44a: 'Copie el archivo a:',
  x_be76a70e: '3. Haga clic derecho en el icono QZ en la bandeja del sistema → Seleccionar',
  x_84b2bd4a: 'entrar',
  x_1094f3fa: 'Antecedentes de gestión → Configuración del sistema → Opciones de impresora',
  x_f643af46: ', complete el nombre de la impresora.',
  x_ce1cca4a: 'Impresora POS',
  x_1708461e: 'Se utiliza para imprimir recibos de ventas diarios (recibos falsos/recibos internos)',
  x_b627c3dc: 'Ejemplo:',
  x_1bd554fc: 'Impresora Fiscal',
  x_6f3305bc: 'Se utiliza para imprimir facturas de impuestos oficiales (genuinas/originales)',
  x_17f83847: 'Como encontrar el nombre?',
  x_69c9ff65: 'Configuración de Windows → Dispositivos → Impresoras y escáneres',
  x_b769e4ff: '¿Solo tienes una impresora? Simplemente complete los dos nombres de la misma manera.',
  x_49e382b0: 'Factura Fiscal',
  x_53299d30: 'Ingrese la cantidad',
  x_23ad596c: 'Imprimir en impresora de impuestos | El pedido aparece en el informe.',
  x_0597a697: 'Recibo Interno',
  x_748da81b: 'Imprimir en impresora POS | Orden oculta en el informe',
  x_43f28ccd: 'Solo Registrar',
  x_f523f020: 'No imprimir | Orden oculta en el informe',
  x_339fbb54: 'P: ¿Se muestra un botón gris "QZ" en la parte inferior del POS?',
  x_850263a4: 'R: La bandeja QZ no se está ejecutando. Compruebe si hay un icono QZ en la bandeja del sistema. De lo contrario, vuelva a abrir la bandeja QZ.',
  x_3c7cc6d8: 'P: ¿Aparece el cuadro de diálogo "Permitir/Bloquear"?',
  x_a008acbd: 'R: Marque "Recordar esta decisión" y haga clic en "Permitir", y ya no aparecerá.',
  x_5c8ae7a8: 'P: ¿No encuentras la impresora?',
  x_ed2b395c: 'R: Asegúrese de que el nombre de la impresora en la configuración sea exactamente el mismo que en Windows. Vaya a Configuración de Windows → Dispositivos → Impresoras para ver.',
  x_60ca8330: 'P: ¿Cómo configurar solo una impresora?',
  x_4042778b: 'R: Complete el mismo nombre tanto para la impresora POS como para la impresora de impuestos (por ejemplo, complete XP-80C).',
  x_d1b45389: 'P: ¿Puedo imprimir sin instalar la bandeja QZ?',
  x_0a468501: 'R: Sí, pero aparecerá un cuadro de diálogo del navegador cada vez que imprima. Con la bandeja QZ instalada, la impresión es completamente silenciosa.',
  x_231206dd: 'caja',
  x_f7edf5ac: 'piezas',
  x_d3bc58b6: 'tipo de cambio',
  x_93a17a92: '🧾 Recibo de pedido',
  x_79730766: '💰 Aviso de reclamación',
  x_3b380a1e: '🎂 Deseos de cumpleaños',
  x_4438a544: '📢 Anuncios promocionales',
  x_1a6b4e12: '⚠️ Alerta al jefe',
  x_88a1edb1: '💬 Personalizar',
  x_5e89ee46: 'Marked sent',
  x_02c1633a: 'Skipped',
  x_f2b4dbf5: 'No hay puntos de cliente ≥100, aún no hay VIP',
  x_490b3a34: 'Ningún cliente ha realizado pedidos en los últimos 30 días.',
  x_0ea30aad: 'Ningún cliente cumple años hoy',
  x_79eb3367: 'No hay cliente, o el cliente no ha rellenado el número de teléfono',
  x_bc21bd22: 'No hay clientes bajo la condición.',
  x_cc989ba6: 'Export failed',
  x_e73fb531: 'Outbox',
  x_1ce32b39: 'No pending messages',
  x_218e94e7: 'Los pedidos/crédito/cumpleaños aparecerán aquí automáticamente',
  x_a9550e64: '🚀 Cómo utilizar el CSV exportado:',
  x_e75ae49a: '1. Descargar',
  x_82190c17: 'APP oficial (gratuita, no requiere RIF)',
  x_976bdc5e: '2. Configuración → Herramientas →',
  x_c32cb069: 'Lista de difusión',
  x_4d238b59: '→ Nuevo',
  x_df804a38: '3. Importe CSV a través de Contactos de Google/iCloud (o agregue contactos manualmente)',
  x_df02ca90: '4. Envíe mensajes a la lista de transmisión: todos reciben un chat individual (no un chat grupal)',
  x_f4d94d4b: '⚠️ Una única lista de transmisión puede tener hasta 256 personas; si tienes muchos clientes, puedes exportarla varias veces en lotes',
  x_1603b069: 'lunes',
  x_b5a6a07e: 'martes',
  x_e60725e7: 'miércoles',
  x_170fc8e2: 'jueves',
  x_eb79cea6: 'viernes',
  x_24575130: 'sábado',
  x_562d7476: 'domingo',
  x_2e5d828a: 'Sin citas completadas este mes / No hay reservas completadas este mes',
  x_89a676e4: 'Cambia el % y se guarda automáticamente. Solo cuentan citas marcadas como completadas. / El porcentaje modificado se guarda automáticamente y solo se cuentan las reservas "completas"',
  x_685f370b: '📴 Sin conexión: la orden de entrega se ha guardado y se cargará automáticamente en línea.',
  x_d0c68f0b: '📴 Sin conexión: el recibo se ha registrado y se almacenará automáticamente en línea.',
  x_93c4b017: 'Orden de compra eliminada',
  x_41722aa3: 'La orden de compra ha sido archivada y oculta',
  x_dbc210d6: 'Por favor complete el código y el nombre',
  x_a889286a: 'La creación falló',
  x_535bef11: 'Las categorías han sido actualizadas.',
  x_930442e2: 'La actualización falló',
  x_44e7120c: 'Ocultar completado',
  x_9779a11a: 'Mostrar completado',
  x_1a750305: 'Todas las categorias',
  x_37c419ae: 'Adjuntar código de barras',
  x_f2996845: 'unidad',
  x_ea887bd0: 'Especificaciones',
  x_c5855564: 'fijación de precios',
  x_d0e857e9: 'Fórmula de tasa de beneficio',
  x_cb340191: 'beneficio',
  x_c6e41d42: 'precio FCL',
  x_d4229e8a: 'Reglamento de caja',
  x_51829073: 'inventario inicial',
  x_a45686c0: 'Alerta de stock',
  x_dce5379c: 'ocultar',
  x_2f4aaddd: 'Eliminar',
  x_ecf7ebb5: 'Sin categoría',
  x_8ec0438a: 'Historial de pagos',
  x_bce9f7d6: 'Agregue productos rápidamente (compras y almacenamiento)',
  x_625fb26b: 'Cancelar',
  x_730bfc36: 'pagado en su totalidad',
  x_8ec00711: '¡La orden de compra ha sido pagada en su totalidad!',
  x_9698ab8c: 'Por favor elija cómo procesar esta orden de compra:',
  x_83ef2b4d: 'Efectivo',
  x_90f94c19: 'Tarjeta',
  x_f1a5d025: 'Transfer',
  x_2fc44ed8: 'Crédito',
  x_4fa3a2eb: 'Se ha generado el código de referencia.',
  x_7f7de8a2: 'Error de compilación',
  x_10173e90: 'Código de referencia copiado',
  x_a95b0fa6: 'Enlace de registro copiado',
  x_fe32def4: 'activo',
  x_69b0f684: 'Desactivado',
  x_5947a2a4: 'Recompensas por recomendación',
  x_62ea3c2c: 'Recomendado cortésmente',
  x_838b386f: '1. Comparte el código de referencia',
  x_d6ade6c8: 'Comparta su código de referencia exclusivo con otros comerciantes',
  x_07cff2ae: '2. Registro de amigos',
  x_af47e408: 'Los amigos usan el código de referencia para registrarse y obtener una prueba de 44 días',
  x_6019e1c3: '3. Ambas partes ganan premios',
  x_a250368b: 'También obtienes una extensión gratuita de 30 días',
  x_c6c4ba10: 'Aún no tienes un código de referencia, haz clic para generarlo',
  x_83e0c4f0: 'Mi código de referencia',
  x_6e1519ad: 'Número de personas que han sido recomendadas',
  x_2964d77d: 'Número de días para recibir el bono',
  x_f3ce8bc2: 'Registros recomendados',
  x_23733df5: 'No hay registro de ventas en los últimos 30 días y no se puede calcular automáticamente.',
  x_0b1cc5f0: 'El cálculo falló',
  x_0d667672: 'Calculando...',
  x_0868b4ed: 'Establecer automáticamente el inventario mínimo',
  x_88b16782: 'Reparación fallida',
  x_e596edd9: 'Aplicando...',
  x_5921137f: 'Resultados calculados automáticamente (basados en los últimos 30 días de ventas + 7 días de stock de seguridad)',
  x_b409f53c: 'Inventario y comparación',
  x_e7c0908c: 'efectivo',
  x_c31eabb4: 'tarjeta magnética',
  x_acaf665f: 'transferir',
  x_2432b575: 'Observaciones',
  x_cd1cff20: 'Ventas totales (brutas)',
  x_6b587c75: '¿Conciliar este cambio (recalcular el total de la biblioteca de pedidos)?',
  x_a8336884: '¿Se obliga a que las clases terminen al mismo tiempo?',
  x_f0407e01: '✅ Reconciliado',
  x_769a6bb0: '🔧Conciliar (desde la base de datos de pedidos)',
  x_d342fac8: 'Reimprimir el informe',
  x_a6240224: 'Detalles del desempeño de los empleados',
  x_a235c0c8: 'Agrupación de clientes RFM + envío grupal en un clic de WhatsApp',
  x_0cd126ef: 'WhatsApp Web no está conectado. Vaya a “📱 WhatsApp se conecta automáticamente” para escanear el QR antes de transmitir.',
  x_1e664d6e: 'Haga clic en Grupo para seleccionar rápidamente todos los clientes del grupo → Complete previamente la copia promocional con un solo clic',
  x_c7b27363: 'mensajes grupales de whatsapp',
  x_792f9eb2: '✨Generación de redacción publicitaria con IA (GPT-5.2)',
  x_1aa19423: 'Escriba automáticamente 3 textos de WhatsApp según su industria + segmento seleccionado + comportamiento de compra del cliente',
  x_e4234194: 'Opcional: Promoción Día de la Madre / Novedades / Especiales de fin de semana...',
  x_4dfe7036: 'generar',
  x_48853792: 'Datos vistos por la IA',
  x_baea39ef: 'consumo per cápita',
  x_de4db8d2: 'Visitas per cápita',
  x_b6838383: 'alquilar',
  x_0ee0c81c: 'Agua y electricidad',
  x_be11fc04: 'salario',
  x_1f4beff9: 'Consumibles',
  x_324712a3: 'Reparación',
  x_0f3a252a: 'transporte',
  x_638e3280: 'impuestos',
  x_0d98c747: 'Otros',
  x_d594b77a: 'Por favor ingrese la cantidad',
  x_3fdaeadf: 'Agregado exitosamente',
  x_0719d4e5: '¿Estás seguro de eliminar?',
  x_3fef31de: 'gestión de gastos',
  x_e5d6c826: 'nuevos gastos',
  x_07d77a1b: 'gastos totales',
  x_3d2a964f: 'Número de bolígrafos',
  x_6b63c89c: 'Gastos de cada tienda',
  x_3bdd08ad: 'Descripción',
  x_f9ac4b2a: 'operador',
  x_86c5708d: 'Seleccionar tienda',
  x_16a097d2: 'Facturas de agua, facturas de luz, gastos de logística, etc.',
  x_de5f6c72: 'equivalente',
  x_1e49734c: 'Recibo real',
  x_1993ed26: 'Resumen',
  x_78d078e8: 'gastos',
  x_80170f62: 'beneficio neto',
  x_e9caa1e9: '¿Escanee inmediatamente a todos los inquilinos en busca de desviaciones de productos, existencias versus inventario, cantidad y las corrija automáticamente? \\n\\n¿Auditar la derivación de inventario y autoreparar?',
  x_3859c850: 'Desviación cero del inventario: todo se alinea ✓',
  x_e6c2d5d3: 'Escaneando...',
  x_8f7072ac: 'auditoría de inventario',
  x_66411a09: 'Mensaje de prueba',
  x_6e4f4b33: 'Por favor introduce el número de teléfono móvil',
  x_12020cd0: '✅ Habilitado: los clientes recibirán automáticamente un recibo de WhatsApp después de realizar un pedido',
  x_ad859563: '⏸ El recibo automático está desactivado',
  x_1668b5ee: '⏸ Se ha desactivado la reclamación automática',
  x_f562ea82: 'Seleccione primero la tienda predeterminada',
  x_9f276dd7: '✅ Habilitado: cuando los clientes envían capturas de pantalla de pago a su WhatsApp, el pedido se reconocerá y comparará automáticamente.',
  x_08f2f5b8: '⏸ La cancelación automática está desactivada',
  x_207fff73: '¿Estás seguro de que quieres cerrar sesión en WhatsApp? Después de cerrar sesión, debe escanear el código QR para conectarse nuevamente.',
  x_a58b3a30: 'Cerré la sesión, esperando un nuevo código QR...',
  x_3d7c933b: 'Error al cerrar sesión',
  x_c5ea9c6a: 'Conectado',
  x_9fde5e83: 'Esperando escaneo',
  x_61536d6b: 'Certificación en proceso...',
  x_7f3a55b2: 'No conectado',
  x_4c7bf874: 'Conflicto (iniciar sesión desde otro dispositivo)',
  x_fbecd9e3: 'excepción de servicio',
  x_e12b354d: 'ENCENDIDO',
  x_3b6ed28d: 'Cerrar APAGADO',
  x_be5fbbe3: 'guardar',
  x_7657f76c: 'tu numero',
  x_65026c6a: 'Estado de conexión:',
  x_9db7a84f: 'Ya encendido',
  x_d4909dab: 'recibido automáticamente',
  x_5d855937: 'Vencido',
  x_0d041ace: 'Caduca en 3 días',
  x_0e4b660d: 'El intervalo mínimo entre dos recordatorios para el mismo cliente:',
  x_30b38123: 'Enviado a tu número de WhatsApp',
  x_6134f524: 'coincidencia automática',
  x_f3a2348c: 'Los invitados no necesitan abrir la página web ni escanear el código QR, como si enviaran un mensaje en WeChat.',
  x_12e45b5a: 'Tienda de propiedad predeterminada:',
  x_f26bedc7: '(sin tienda)',
  x_abfc9ba9: 'Cerrar primero antes de cambiar de tienda.',
  x_c363b9ec: 'Escanea el código QR para conectarte a tu WhatsApp',
  x_dfaf8682: 'Abre WhatsApp en tu teléfono',
  x_3fafc6fe: 'Menú →',
  x_4a4c2cf7: 'Dispositivos vinculados',
  x_a7ad104b: 'dispositivo de enlace',
  x_e0290bd7: 'Escanea el código QR a continuación con tu cámara',
  x_6d81d254: 'Espere de 5 a 10 segundos hasta que aparezca "Conectado".',
  x_0d280386: 'Esperando a que se genere el código QR...',
  x_008fe1ba: 'Generalmente toma entre 10 y 20 segundos',
  x_b8a25309: 'Conectado exitosamente ✅',
  x_b71dbebc: '📤 Envío de prueba',
  x_565ea0b6: 'Número de destinatario (formato E.164)',
  x_b87b7756: 'Contenido del mensaje',
  x_eb0bd897: '💡 Consejos de uso',
  x_0fb5c8cf: 'Esta conexión es',
  x_01e161e9: 'gratis',
  x_22d65176: ', no consume crédito de Twilio',
  x_d01f9a4f: 'Enviar un mensaje a cualquier cliente',
  x_52c58309: 'No es necesario unirse',
  x_332247f3: ', al igual que el envío grupal de WeChat',
  x_83320746: 'No es necesario que mantengas WhatsApp abierto en tu teléfono, VPS te mantiene conectado automáticamente',
  x_fcf8348a: 'Si dice "conflicto", estás usando WhatsApp Web en otro lugar; simplemente cierra sesión en el otro dispositivo',
  x_0f4dfafd: 'En caso de cerrar sesión, simplemente regrese a esta página y escanee el código nuevamente (1 minuto)',
  x_f27d2855: '👉Cortar hacia arriba',
  x_167fc20b: '"🎂Marketing de festivales/cumpleaños"',
  x_525ce8d5: 'Etiquetas, puede enviar mensajes grupales de vacaciones/cumpleaños a WhatsApp con un solo clic, la IA escribe automáticamente una copia',
  x_4fe8cddc: 'Establecer tiendas ilimitadas',
  x_7b9796b4: 'El diagnóstico falló:',
  x_c1e4fc86: 'Reparación completada',
  x_24c6a887: 'Reparación fallida:',
  x_105c8a51: 'Exportación exitosa',
  x_dd51ab50: 'Exportación fallida',
  x_80070ef8: 'Sin límite de tiendas',
  x_104faff3: 'Límite de tienda',
  x_7fa365e7: 'Diagnóstico/Reparación',
  x_9344b89b: 'Exportar copia de seguridad',
  x_0719aa2b: 'restablecer contraseña',
  x_bdd21b3d: 'Cambiar ID',
  x_9171e387: 'Cantidad personalizada (dejar en blanco = sin límite)',
  x_a94b953e: '→ Cree mesas automáticamente, habilite la emisión de boletos de cocina, etiquetas de escenario de servicio y una tarifa de servicio del 10%',
  x_1b89e094: '→ Abrir el número de recogida de comidas, emisión de tickets de cocina y pedidos de autoservicio',
  x_5d960ff3: '→ Habilite variantes de tamaño × color, etiquetas de temporada, reducción automática de precios al por mayor y al por menor',
  x_3fc4b6fb: '→ Habilitar la gestión del número de lote y la fecha de vencimiento',
  x_db15472a: '→ Iniciar ventas a granel/pesaje y cajas completas',
  x_609adbd2: '→ Comercio minorista general (sin funciones específicas de la industria)',
  x_72d55e89: 'Ingrese una nueva contraseña',
  x_fbc026c9: 'salud',
  x_fe3d61c1: 'con advertencia',
  x_ab9512ba: 'Hay un problema grave',
  x_e2e27a87: 'serio',
  x_900c70fa: 'advertencia',
  x_8f3d0f51: '¿Está seguro de que desea borrar todos los pedidos? ¡Esta acción es irreversible!',
  x_b97b6c51: 'Establece el número máximo de tiendas que este comerciante puede abrir según el paquete (precio correspondiente: 1 tienda $50 / 2 tiendas $80 / 3 tiendas $110 / 5 tiendas $160 / 8 tiendas $230). Dejar en blanco = sin límite.',
  x_8441b348: 'Sin límite',
  x_6258bb14: '— Inicializar automáticamente la clasificación + funciones de la industria',
  x_9e0124e8: 'General Retail',
  x_8bc59f0c: '🍽️ Restaurante (mesa + mampara de cocina + cargo por servicio)',
  x_2306dfd6: '🍔 Fast food / Comida rápida (número de pedido + pantalla de cocina)',
  x_03d614a2: '👕 Ropa / Tienda de ropa (talla × color + temporada + mayoreo)',
  x_9357f511: '💊 Farmacia/Farmacia (número de lote + gestión de caducidad)',
  x_ef343e19: '🥕 Supermercado/Supermercado (granel + pesaje)',
  x_e44ccd80: 'Panadería',
  x_1464330c: 'Ferretería',
  x_08460537: '📱 Electrónica / Electrónica (número de serie)',
  x_eebcf410: '💄Belleza/Belleza (cita)',
  x_89d569a1: 'Restablecer contraseña de comerciante',
  x_0644dad5: 'Ingrese su nombre de usuario y nueva contraseña. Si el usuario no existe, el sistema lo creará automáticamente.',
  x_bf7da0bf: 'nueva contraseña',
  x_80cfc33c: 'Confirmar reinicio',
  x_316a4683: 'Tienda de diagnóstico y reparación.',
  x_44d50e5a: 'Diagnosticando...',
  x_a519dc2a: 'Problemas encontrados',
  x_95ab9037: 'operación de reparación',
  x_bab268d5: 'proveedor',
  x_e54ee345: '¡Atrasado!',
  x_edae78fd: 'Loan',
  x_c3704da5: 'Goods Credit',
  x_ebe86a1f: 'Repayment',
  x_03531769: 'Salary Deduction',
  x_756048fc: 'Declaración del empleado',
  x_4cf24aba: 'Cantidad',
  x_5a4fcfe2: 'Monto actual adeudado',
  x_90ea8d11: 'Crédito de empleado',
  x_5a611987: 'Tienda no asignada',
  x_ad83f8e5: 'monto total adeudado',
  x_bd3616ee: 'Recibo + QR',
  x_2dbf283b: 'Estado de cuenta',
  x_bbdd42a0: 'asentado',
  x_ea340b7c: 'pedir dinero prestado',
  x_3f01df5b: 'bienes a crédito',
  x_620610c0: 'ha sido devuelto',
  x_8577b01a: 'Retiro de depósito',
  x_44ba3fed: 'No se pudo extraer',
  x_7b1df363: 'Actualmente no hay registro de deudas de empleados.',
  x_4c95bf44: 'reembolso',
  x_79ef16e5: 'deducciones de nómina',
  x_006deeed: 'Crédito POS',
  x_d2f88894: 'Adquisiciones',
  x_e6119529: 'Recibo de Pago + QR',
  x_ef9ec7c0: 'Contact Support',
  x_acf0664a: 'Error al eliminar',
  x_ec25deba: 'Error al borrar',
  x_a2339865: 'Ya el almacén principal.',
  x_5154ae17: 'Copia fallida',
  x_d6fecfb2: 'Por favor introduce una cantidad válida',
  x_956ef5ad: 'Aprobado / Aprobado',
  x_786c8fe1: 'Rechazado / Rechazado',
  x_7e237e94: 'costo',
  x_4eb4b061: 'Copiar desde el repositorio principal',
  x_b6eea70f: 'Failed to load tiers',
  x_81bbad14: 'Costo no establecido',
  x_901a44b7: 'No establecido',
  x_55fadf3b: 'costo unitario',
  x_7e0457bb: 'Settings saved',
  x_c330679b: 'El umbral es demasiado alto y la prueba no se activa (el umbral actual',
  x_82b783f0: 'ignorado',
  x_d06adee8: 'Advertencia de fluctuación del tipo de cambio',
  x_46d3ff51: 'Alert Settings',
  x_5659fd6c: 'Enable FX alerts',
  x_839db71f: '— se activa cuando se excede este porcentaje',
  x_3a62401d: 'Recomendado 5% (las fluctuaciones diarias regulares del BCV son del 1 al 3%, exceder el 5% es anormal)',
  x_4ab817d3: '—Con código de país, sin +',
  x_eae0f4d8: 'Número configurado automáticamente con PIN de Boss cuando está vacío',
  x_0468089c: 'Alert History',
  x_317dbe0f: 'No alerts yet',
  x_c4677828: 'Time',
  x_8bd0b918: 'Source',
  x_609a902e: 'viejo → nuevo',
  x_34d0195a: 'cambiar',
  x_41dfb0bf: 'Razón',
  x_6ef780bf: 'dañado',
  x_584cd195: 'Caducado',
  x_a6a652d7: 'uso personal',
  x_42e0c46b: 'muestra',
  x_fe299b11: 'Informe de clasificación/análisis de tipo de cambio',
  x_1e355e1f: 'mercado negro',
  x_800dfdd9: 'hoy',
  x_72520580: 'esta semana',
  x_0ec94a37: 'este mes',
  x_c5d35890: 'el mes pasado',
  x_6da06b0c: 'Todas las tiendas',
  x_bee912d7: 'Consulta',
  x_72d76618: 'Tipo de cambio:',
  x_4cbae8f6: 'ventas totales',
  x_9719978c: 'costo de los bienes',
  x_bae6c9ba: 'ganancia bruta',
  x_7bfa923d: 'gastos diarios',
  x_cea67413: 'Daños/pérdidas reportadas',
  x_29225555: 'Ganancias cambiarias',
  x_33fa2d30: 'Cuentas por cobrar de empleados',
  x_4fbe97e5: 'Para ser retirado',
  x_fbb493d0: 'Número de pedidos',
  x_eee785b1: 'Obtenga productos al tipo de cambio del gobierno',
  x_9ae44464: 'ventas',
  x_f5acfdc9: 'Bienes del mercado negro',
  x_bc41ea8b: 'Estadísticas por categoría',
  x_bfec3534: 'Modelo de precios',
  x_27a504ee: 'Ventas ($)',
  x_2d4ec760: 'Ventas(Bs)',
  x_eae13adc: 'Costo ($)',
  x_e052f520: 'Beneficio ($)',
  x_7a3da957: 'margen de beneficio',
  x_e4f48bf4: 'numero de piezas',
  x_dda07873: 'Detalles de gastos',
  x_030808e9: 'Detalles del informe de daños/pérdidas',
  x_65cccb1c: 'Detalles de ingresos de intercambio',
  x_ac502247: 'Comprar USD en efectivo',
  x_2feedc17: 'Pase la tarjeta para obtener dinero en efectivo',
  x_0d91478b: 'Estadísticas por día',
  x_d6ddd835: 'Seguimiento de lotes/lotes (FIFO)',
  x_e06e4a15: 'Agregar nuevo lote',
  x_a6eefa41: 'Recuperar la trazabilidad',
  x_f7414a41: 'Preparando',
  x_a2d94b67: 'Listo',
  x_362f791f: 'Error',
  x_a7cf3c19: 'Nuevas',
  x_641fb174: 'Comenzar',
  x_6062f967: 'Listo',
  x_c7664439: 'Listas',
  x_d9d86061: 'Rollback',
  x_4f5b356a: 'Kitchen Display',
  x_f05d50fe: 'Sin órdenes',
  x_ebedad8a: 'Esperando órdenes del POS...',
  x_8f9d8f83: 'Cuenta/Correo electrónico (PayPal/Wise/Zelle)',
  x_6ee9e469: 'Dirección de billetera (USDT/BTC/ETH)',
  x_6a069dc9: 'Revolut)',
  x_436d77df: 'Binance Pay)',
  x_03c32ab3: 'Número de cuenta bancaria (transferencia bancaria)',
  x_f8dfedcd: 'salvado',
  x_a9ca9fd6: '+58 424-8476761 (中文/Español/English)',
  x_274c1e1b: 'TU_USDT_TRC20_AQUI (marcador de posición)',
  x_ed7823b1: '+ agregar',
  x_ac92f4c5: 'Nombre (por ejemplo, Wise / Zelle / Binance Pay)',
  x_76254a13: 'Cuenta/dirección/enlace (como your-wise@email.com)',
  x_61860e54: 'Instrucciones de pago a clientes (opcional)',
  x_908a649e: 'Ejemplo: después del pago, tome una captura de pantalla y envíela al servicio de atención al cliente de WhatsApp. Activaremos su cuenta Sellox y le enviaremos sus credenciales de inicio de sesión en 30 minutos.',
  x_921915b6: 'Guardar todas las configuraciones',
  x_fb4ca1cf: 'Cargando…',
  x_f19e59a5: '🌍 Configuración de pagos internacionales (cobro transfronterizo)',
  x_4290f0a0: 'Configure el método de pago para clientes extranjeros (Sudáfrica/Brasil/Colombia y otros 7 países) para pagar $199/$499/$999. La información se mostrará en la ventana emergente "Comprar" en la página de inicio.',
  x_8009051e: 'Habilitar pagos internacionales',
  x_e90bdf1a: 'Después del cierre, el botón Comprar en la página de inicio solo muestra WhatsApp de servicio al cliente.',
  x_17fb55f0: 'Número de WhatsApp (con código de país, sin +)',
  x_45ffbd9d: 'Ejemplo: 5804248476761 (Venezuela)',
  x_f3864065: 'Mostrar etiqueta (opcional)',
  x_d04bbc0e: 'correo electrónico de PayPal',
  x_0fed3f6b: 'Enlace paypal.me (recomendado: pago con un clic para clientes)',
  x_0b36d1a2: 'TRC20 (Tron): tarifa de gestión ≈ $1, recomendado ⭐',
  x_67ebc935: 'ERC20 (Ethereum): tarifa de gestión de 5 a 20 dólares',
  x_51e8a79c: 'BEP20 (Binance Smart Chain): tarifa <$1',
  x_e71d5f47: 'Aún no agregado. Haga clic en "+ Agregar" en la esquina superior derecha para agregar cualquier método de pago (Wise/Revolut/Zelle/Binance Pay/Pix/Western Union, etc.)',
  x_0380d11f: '💰 Precio del paquete (USD)',
  x_dcf9f3db: 'Compra única en USD',
  x_92d28a70: '📝 Instrucciones de pago a clientes (opcional)',
  x_37ef8c61: 'registro de paypal',
  x_a094a4a9: '(La cuenta personal puede cobrar el pago)',
  x_9b3c8bf1: 'paypal.me creado',
  x_d149282b: 'Billetera USDT TRC20 (recomendado)',
  x_b9f4d9f0: 'Wise (remesas transfronterizas)',
  x_42c062bf: '🛒 Tienda ordinaria',
  x_b0c7322a: 'Comercio minorista en general como tiendas de abarrotes, ferreterías, tiendas de conveniencia, papelerías, tiendas de cosméticos, etc. No existen categorías preestablecidas, crea las tuyas propias según tus necesidades.',
  x_e69533ce: '✓ Doble moneda (USD + Bs)',
  x_5c26623b: '✓Múltiples tiendas',
  x_348c3c42: '✓ Publicación de tienda online',
  x_c971b497: '✓ Apto para el 90% de los negocios ordinarios',
  x_d5ebb7de: '🍽️ Restaurante',
  x_c85301d4: 'Restaurantes de té, comida rápida, barbacoas, cafeterías, bares, etc. Crea categorías de menú, ubicación de mesas y pedidos de cocina con un solo clic.',
  x_74efa0b8: '✓ 7 categorías de menú creadas automáticamente',
  x_03fb8ea8: '✓ 10 mesas disponibles inmediatamente',
  x_01cdb4fc: '✓ Realizar pedidos automáticamente en la cocina',
  x_05474198: '✓ Tarifa de servicio 10%',
  x_6229e580: '👕 Tienda de ropa',
  x_66682a68: 'Ropa, zapatos y sombreros, ropa infantil, complementos. Cada prenda puede tener talla (S/M/L/XL) × color (rojo/azul/negro) y múltiples variaciones en stock.',
  x_57dd3ef7: '✓ 8 categorías de ropa',
  x_2b54dfae: '✓ Tamaño + Variaciones de color',
  x_7d9f9b66: '✓ Etiquetas de temporada',
  x_72c05d38: '✓ Doble precio al por mayor y al por menor',
  x_f9003331: 'Ya en esta industria',
  x_acd5cb84: 'falló',
  x_66342ccc: '✓ Industria actual',
  x_3f86ef3c: 'Aplicar esta plantilla',
  x_e2662ca4: 'Servicio',
  x_8da5aff6: '✅ Guardado: el pago en POS funcionará de inmediato',
  x_cea028d0: 'Plantilla de industria',
  x_cd790081: 'Defina su tipo de tienda con un solo clic: categorías, tablas y variaciones, todo a la vez',
  x_a22b06e7: 'Consejos:',
  x_605629af: 'tienda ordinaria',
  x_686dbf3b: 'Cargo por servicio/propina (Servicio)',
  x_3b858549: 'Tarifa de servicio habilitada de forma predeterminada',
  x_2420b778: 'Porcentaje de tarifa de servicio (%)',
  x_f0d6cce2: 'El nombre que aparece en el recibo.',
  x_0bfa1205: '🛵 Repartidores',
  x_00a0e92f: '⚙️ Configuración de tarifas',
  x_6af35899: '📦 Pedidos de delivery',
  x_696bc73f: '✅ Aprobado, el repartidor ya puede aceptar pedidos',
  x_28687aeb: '¿Seguro que quieres rechazar a este repartidor? No podrá aceptar pedidos.',
  x_81233d75: 'Rechazado',
  x_3bddf714: '¿Suspender a este repartidor? No podrá aceptar nuevos pedidos.',
  x_a2d930fd: 'suspendido',
  x_30a59161: '✅ Restaurado y puede aceptar pedidos.',
  x_a431ba4e: 'Buscar por nombre/teléfono',
  x_75eb29d6: '🛵 Motocicleta',
  x_f534abbc: '🚲 Bicicleta',
  x_b590db5d: '🚗 Carro',
  x_56d6a939: '🚶 A pie',
  x_5c2ee4b5: '📍 Obteniendo ubicación...',
  x_88a5387f: '✅ La ubicación actual se ha obtenido como coordenadas de la tienda.',
  x_1b925959: 'No se puede obtener la ubicación, introdúzcala manualmente',
  x_77322d90: '✅ Configuración guardada',
  x_6620698d: 'Agarrar grupo de pedidos',
  x_68905cf3: 'en línea',
  x_cb2806df: '⏳ Pedidos pendientes',
  x_fc6e17a5: '🛵 Aceptado',
  x_107d8896: '📦 Recogido',
  x_e0ae219c: '🚀 Entregando',
  x_16661b98: '✓ Entregado',
  x_9d77d772: 'Gestión de repartidores',
  x_bce11e3f: 'Repartidores · Aprobar repartidores / configurar tarifas / monitorear pedidos',
  x_c612876e: 'Aún no hay repartidores registrados',
  x_a37a9be7: 'Comparte este enlace:',
  x_25e4e975: 'con tus repartidores para que se registren con el código de la tienda',
  x_809476e2: 'Comparte con tus repartidores:',
  x_6cab0af7: 'Tasa de entrega',
  x_14289a36: 'Tarifa inicial (USD)',
  x_7de56a40: 'Incremento de precio por kilómetro (USD)',
  x_b25f1d80: 'Distancia de entrega más lejana (km)',
  x_73bb91d6: 'Ubicación de la tienda (utilizada para calcular la distancia)',
  x_039e0dfc: 'Latitud Lat',
  x_05e720b2: 'Longitud Lng',
  x_3fd0fc33: 'Dirección de la tienda (visible para los repartidores)',
  x_fa8ee2c3: 'Auto-asignación',
  x_28b2a26f: 'Se asigna automáticamente al repartidor en línea más cercano',
  x_f2418716: 'Distancia × 50 - Número de pedidos × 30',
  x_58714e73: 'Aún no hay pedidos',
  x_86ce4ab5: 'Repartidor:',
  x_9f911a7c: 'Sin repartidor aún',
  x_188bff11: '🔴 Caducado',
  x_6314a940: '🟠Dentro de 7 días',
  x_fc95d888: '🟡Dentro de 30 días',
  x_3aae3aea: '🆓 Pruébalo',
  x_d7bfdc78: '🟢 Salud',
  x_d94c64e8: '👑 La compra es permanente',
  x_4a5421bb: '❔ Sin fecha de caducidad',
  x_32137a91: 'La generación de IA falló',
  x_3b5acbf9: 'El mensaje no puede estar vacío',
  x_1a70e8dc: 'Bandeja de salida unida + Abrir WhatsApp',
  x_4d5ccd01: 'Caducado',
  x_d3cf0210: 'Caduca en 7 días',
  x_56ee9094: 'Caduca en 30 días',
  x_cda88e69: 'compra permanente',
  x_1a5e9603: '😊 Amistoso',
  x_489fd45e: '⏰ urgente',
  x_c6863be8: '💎Compra de actualización',
  x_0e223ebb: 'No completado',
  x_05e9dc7b: 'Enviar WhatsApp',
  x_de815854: 'Panel de suscripción/renovación de inquilinos',
  x_ecb48dd6: '🤖 Recordatorio inteligente de IA',
  x_ee3f5585: 'país',
  x_927babb3: 'Días restantes',
  x_fd5561f7: 'pago final',
  x_a522f3ba: 'Actualmente no hay inquilinos en esta categoría.',
  x_46ca8fe7: 'sin telefono',
  x_59cf15fe: 'Plantilla',
  x_0f0c4077: '😊 Reescribir (amigable)',
  x_849ced1d: '⏰ Reescribir (urgente)',
  x_28e51c71: '💎 Reescribir (actualizar)',
  x_6b2b61c1: 'Al hacer clic en "Enviar WhatsApp", se unirá automáticamente a la Bandeja de salida y se abrirá la web/aplicación de WhatsApp al mismo tiempo. Sólo necesitas hacer clic en ➤ Flecha Enviar.',
  x_8fe83636: 'Por favor ingrese el número de teléfono de recepción',
  x_b8c17683: 'Meta está bloqueada y se ha agregado a la cola wa.me.',
  x_8384ee76: 'Sent via Meta API',
  x_e98c5780: 'Configuration',
  x_e1c652bc: 'Envío de prueba',
  x_8b608503: '¿Cuál es la ganancia hoy?',
  x_780a3ce3: 'Copiado de la página de configuración de Meta WhatsApp',
  x_dfc26b0a: 'Si necesita actualizar, pegue el nuevo token',
  x_14ae8f5b: 'Generado a partir del usuario del metasistema',
  x_4323be72: 'Guardar configuración',
  x_1b709fcc: 'Recibir llamadas +584...',
  x_ff6d830a: 'Enviar mensaje de prueba',
  x_1c00c645: '💡 Tarda entre 15 y 20 minutos. Configúrelo una vez y nunca más tendrá que preocuparse por eso.',
  x_5a3044a7: 'Todos los pasos son gratuitos a menos que los mensajes comerciales de WhatsApp excedan el límite gratuito de Meta.',
  x_d9917a0f: 'Paso 1 / Paso 1: Crear una cuenta de metadesarrollador',
  x_18305c0e: 'Abierto:',
  x_f9056348: 'Inicia sesión con tu cuenta de Facebook/WhatsApp',
  x_7d427d3d: 'Haga clic en la esquina superior derecha',
  x_9c11804f: 'Empezar/comenzar',
  x_a3c972b7: '→ Sigue las instrucciones para completar el registro (gratis)',
  x_63d5e90b: 'Paso 2 / Paso 2: Crear una cuenta comercial',
  x_be604f8b: 'punto',
  x_86165c96: 'Create Business',
  x_34bc86ed: '→ Complete el nombre de la tienda, su nombre y dirección de correo electrónico',
  x_ff5d264e: 'Paso 3 / Paso 3: Crear la aplicación WhatsApp Business',
  x_b140dd92: 'volver a',
  x_abb2b8f6: 'Crear aplicación / Crear aplicación',
  x_e90efab1: 'Opción de caso de uso',
  x_7d394eff: 'Otro / otro',
  x_9c2b1541: '→ Selección de tipo',
  x_eaa0a8e3: 'Negocio/Negocio',
  x_36a6d4b9: 'Vincular a la cuenta comercial creada en el paso anterior → Crear',
  x_de9dda75: 'Ingrese al Panel de aplicaciones → Buscar en el menú de la izquierda',
  x_2ac93ee6: '→ punto',
  x_700677b3: 'Instalar/configurar',
  x_ca3908a1: 'Paso 4 / Paso 4: Obtener ID de número de teléfono + token temporal',
  x_2fcc28b3: 'Ingresa a WhatsApp → haz clic a la izquierda',
  x_b1d07643: 'API Setup',
  x_593a1499: 'En la parte superior de la página verás',
  x_542bd2bd: '(comenzando con `EAA...`) → Copiar',
  x_0c4c68c7: 'Verás en el medio',
  x_2868963d: 'Número de teléfono ID/número de teléfono',
  x_1ff9d199: '(una cadena de números) → copiar',
  x_9a3f0a43: '⚠️ El token temporal solo dura 24 horas y se utilizará como token permanente para el usuario del sistema más adelante (consulte el siguiente paso).',
  x_1743a4bd: 'Paso 5 / Paso 5: Token Permanente (recomendado)',
  x_d7098f50: 'abierto',
  x_5b1bc0f8: 'Agregar / agregar',
  x_04bb0f86: '→ Nombre "Sellox Bot" → Selección de personaje',
  x_7635736a: 'Ingrese el usuario del sistema → haga clic',
  x_6effb00e: 'Agregar activos / Agregar activos',
  x_0c143e9a: '☑ Aplicaciones → Aplicación Hook →',
  x_d0a5ba88: '☑ Cuentas de WhatsApp → Gancho WABA →',
  x_609f8cf0: 'Generar nuevo token / Generar nuevo token',
  x_373a96ca: '→ Seleccionar aplicación →',
  x_be153369: 'Generar →',
  x_d600945c: 'Copiar ahora',
  x_e9b20985: '(No puedes verlo si cierras la ventana)',
  x_eeb6320c: 'Paso 6 / Paso 6: Configurar Webhook (para que Meta pueda enviarnos mensajes)',
  x_9ce48b57: 'Configuration"',
  x_99539f07: 'Página de metaconfiguración',
  x_4d572586: 'Editar / editar',
  x_bdc858dc: 'Pega los dos valores de arriba',
  x_fae01bc0: 'Verificar y guardar / Verificar y guardar',
  x_7701988b: '→ Aparece un check verde ✅',
  x_c348bfce: 'Campos de webhook a continuación →',
  x_bc2153d1: '→ Suscríbete',
  x_ab20cc42: 'y',
  x_8f2b0cd1: 'Paso 7 / Paso 7: Complete el backend de Sellox (esta es la página a continuación)',
  x_5ce0ecbc: 'abajo',
  x_95805797: '② Tus credenciales de WhatsApp Business',
  x_87bff178: 'Token de acceso permanente (o token temporal)',
  x_c4d93fb8: 'Número de teléfono (opcional)',
  x_c8c135f6: 'Lista blanca de teléfonos móviles de Boss (formato +584xxxxxxxxxx)',
  x_142f5856: 'gancho',
  x_97c38974: 'Paso 8 / Paso 8: Prueba',
  x_eb2ec6d7: 'Después de guardar, aparecerá lo siguiente',
  x_f94ea898: '"Envío de prueba"',
  x_d87f215d: 'tarjeta',
  x_742be581: 'Ingrese el número de teléfono móvil de su jefe e intente enviar un mensaje.',
  x_4ee03501: 'Después de recibirlo, responda "¿Cuál es la ganancia hoy?" en WhatsApp → La IA responderá con datos reales 🎉',
  x_7d5267db: '⚠️ Límite de número de prueba',
  x_7509351d: 'Los números de prueba metagratuitos (+1 555 662 4521) solo se pueden emitir a un máximo de 5 destinatarios verificados manualmente. Para enviárselo a cualquier persona, debe agregar su número comercial en Meta (la verificación comercial tardará algunos días).',
  x_20c5cf28: '💬¿Tienes algún problema?',
  x_fd4d3093: 'Comuníquese con el administrador de la plataforma para que lo ayude a configurarla o haga clic en el asistente de IA en la esquina inferior derecha para solicitar pasos específicos.',
  x_3f58e45d: '① Configuración de Meta Webhook (rellene el panel de Meta App)',
  x_d025f0d5: 'Campos de suscripción:',
  x_01f35594: 'Número de teléfono (E.164)',
  x_60eae7be: '(guardado, no mostrado)',
  x_372c24bf: 'Lista blanca de teléfonos móviles de Boss (separados por comas de medio ancho, múltiples)',
  x_bb28c476: 'Solo con números de teléfonos móviles en la lista blanca, la IA responderá a los datos comerciales (beneficios, inventario, deuda, etc.)',
  x_01b59ca9: '③ Comportamiento de la IA',
  x_e6a08432: 'modo IA',
  x_639ebc3f: 'Sólo el jefe - sólo la lista blanca puede chatear, los demás no responderán',
  x_31d7946b: 'Solo clientes: los clientes verifican los productos, pero el jefe aún puede solicitar datos',
  x_4ea5a5ee: 'Ambos: los clientes verifican los productos, los jefes verifican los datos',
  x_20339501: 'Envíe automáticamente un recibo electrónico al WhatsApp del cliente después de cada pago.',
  x_f679838d: 'El perfil del cliente tiene marcada "📨 Suscribirse a notificaciones de WhatsApp"',
  x_f4cfb985: 'Es decir, cada cliente puede elegir individualmente si desea recibir',
  x_185c0503: 'Por favor seleccione un cliente',
  x_dd2124ee: 'Por favor agregue producto',
  x_9923d1e2: 'Pedido abierto con éxito',
  x_21263321: 'Facturación mayorista',
  x_d166bb06: 'Sede',
  x_abfecaae: 'agregar cliente',
  x_c6403f20: 'Cuota',
  x_ec3fb565: 'Seleccionar cliente',
  x_b042c052: 'Buscar producto (nombre/código de barras)...',
  x_57c89bca: 'Buscar artículos y agregarlos al pedido',
  x_fedff361: 'Resumen del pedido',
  x_0367ebd1: 'Observaciones...',
  x_e7814437: 'Confirmar facturación',
  x_0706515e: 'Agregue clientes rápidamente',
  x_18401477: 'Límite de crédito ($)',
  x_a48948bf: 'Todas las tiendas',
  x_be3565c4: 'Coincidencia del número de referencia',
  x_a0e50b0e: 'coincidencia de pedidos',
  x_c95d6f32: 'igualación de cantidad',
  x_1622dc9b: 'desconocido',
  x_ed0ad119: 'Informe de conciliación diario',
  x_8e600fc0: 'emparejado',
  x_8567bca1: 'No hay verificación coincidente',
  x_728bf491: 'Ventas inigualables',
  x_1e8dc255: 'Número de pedido',
  x_ca2944f0: 'cantidad de IA',
  x_093c45aa: 'monto de ventas',
  x_5c4caeaf: 'Número de referencia',
  x_f3d55d6b: 'remitente',
  x_f14b4f28: 'banco',
  x_d47a0207: 'Conciliación automática diaria',
  x_6ea41b97: 'Registro de verificación de IA versus ventas de pagos electrónicos: verificación de coincidencia automática',
  x_dd09a5da: 'Número total de verificaciones de IA',
  x_193911c6: 'No se encontró ningún pedido de venta correspondiente en estos registros de verificación de AI. Puede ser que el cliente lo haya subido pero el cajero no lo haya confirmado.',
  x_396a3453: 'No se encontró ninguna verificación de IA correspondiente para estas ventas de pago electrónico. Es posible que el cliente no haya subido capturas de pantalla de pago.',
  x_d4c1ecd7: '¡Todos coinciden! Todos los pagos electrónicos del día han sido verificados.',
  x_82e96463: 'El inventario debe ser un número ≥ 0',
  x_6e5907ee: '🔄 Actualizar',
  x_1db180af: 'Buscar producto / color / talla / SKU',
  x_105b1395: 'Existencias ≤5',
  x_b12876c8: 'Agotado',
  x_ad9238d4: 'Sin productos con tallas',
  x_36094e1c: 'Sin coincidencias',
  x_afcc3e34: '💾 Guardar',
  x_5c94144d: 'SKU de variante total',
  x_0e076143: 'Producto',
  x_f1daf080: 'Tamaño',
  x_6b36c6f7: 'Color',
  x_dd56adce: '¿Está seguro de que desea crear/asociar automáticamente perfiles de clientes para todos los empleados? \\nDe esta manera pueden acumular puntos al hacer crédito o gastar.',
  x_f10dfc69: 'Registra automáticamente a todos los empleados como \'clientes\' (is_staff=true) para que puedan acumular puntos al realizar crédito o consumo.',
  x_f33656e1: 'tarjeta de identificación',
  x_881a9bd5: 'Número de identificación (Cédula)',
  x_69b8571e: 'Salario ($)',
  x_b5ca1dd9: 'ciclo de pago',
  x_09b03b6d: 'semanal',
  x_9104c0c5: 'cada dos semanas',
  x_aa3d57c0: 'mensual',
  x_72b3c2be: 'Lista blanca de IP (dejar en blanco = sin restricciones)',
  x_ba15d1d2: 'Ejemplo: 190.205.1.100, 200.44.32.50',
  x_9cf8e8f2: 'Separe varias IP con comas. Están exentos de esta restricción los administradores y directivos.',
  x_e6d7c138: 'Tiempo de inicio de sesión permitido (dejar en blanco = sin límite)',
  x_d18b4c06: 'Hora de Venezuela (UTC-4). Ejemplo: 07:00 ~ 22:00',
  x_3eb2b5e8: 'No puede ser inferior al precio de coste.',
  x_6bde6f81: 'El precio después del descuento no puede ser inferior al precio de coste.',
  x_a6f3ec47: 'Servicio al cliente de IA de tienda online',
  x_e7454268: 'Jefe AI contando',
  x_10f8a322: 'mensaje de WhatsApp',
  x_bb364b6d: 'WhatsApp Voz',
  x_6af959ee: 'Tome fotografías y guárdelas en un lugar de almacenamiento.',
  x_e50663b2: 'Recargar',
  x_34ce201c: 'regalar',
  x_85f42dcd: 'consumo',
  x_51d2fc74: '¿Cancelar el pedido actual? Puedes recargar nuevamente después de la cancelación. \\n¿Cancelar esta orden?',
  x_f3955e88: 'Orden cancelada',
  x_2b8fa5ac: 'Already paid',
  x_98308839: 'Créditos AI agregados ✓',
  x_655c5610: 'No payment address',
  x_326e34ed: 'Se ha generado la información de pago / Información de pago lista: escanee el código QR para pagar',
  x_efad9fe0: 'No se pudo crear la factura',
  x_46ccee5b: 'Copiado',
  x_2e3006a9: 'Dirección copiada',
  x_9790e47c: 'Créditos AI',
  x_ae190ef1: 'Saldo actual',
  x_8af6c290: 'Recarga acumulada',
  x_5c9bc81a: 'Consumo acumulado',
  x_34dccb6b: 'Costo por función',
  x_7efdc4e4: 'Historial',
  x_b9db8476: 'Aún no hay registro',
  x_833cba67: 'Pagando USDT TRC-20',
  x_1833a9ec: '💰 Monto de pago / Monto (USDT-TRC20) ⚠️ Entrada manual',
  x_9d3931f8: 'Dirección (TRON TRC-20)',
  x_900ee05e: 'Proceso de escaneo',
  x_30d4a272: '(Cualquier billetera USDT funcionará):',
  x_bf863bf8: '1. Haga clic en "Enviar" en Binance/OKX/Trust Wallet → seleccione USDT → Red',
  x_4c6c1bd8: '2. Escanea este código QR → la dirección se completará automáticamente',
  x_550c9aef: 'Monto ingresado manualmente',
  x_46703262: '✓ Ya recibido',
  x_f4e8f238: 'Old pending order',
  x_3d75129d: 'créditos',
  x_3f60cc81: 'Comprar con USDT',
  x_e6b9334f: 'Welcome follow-up',
  x_4f3f45b3: '¡Hola {nombre}! Gracias por registrarte para tu prueba de Sellox. Yo soy el fundador. Si tienes alguna pregunta, por favor pregúntame directamente. Te quedan {días} días en tu prueba, esta es la dirección de inicio de sesión:\\nhttps://backup.sellox.shop',
  x_1b556750: 'Expiring reminder',
  x_b8e14961: 'Hola, {nombre}, te quedan {días} días en tu prueba de Sellox. Para continuar usándolo, elija un paquete:\\n• Estándar $29/mes (5 personas en 1 tienda)\\n• Pro $49/mes (15 personas en 3 tiendas + AI)\\n\\nEnlace de renovación: https://backup.sellox.shop/saas/checkout',
  x_0cc0a930: 'Invite demo',
  x_8787d76d: 'Hola {nombre}, ¿te gustaría que te hiciera una demostración remota de 15 minutos? Podemos importar sus productos juntos y permitirle comenzar a pagar con POS en 1 hora.',
  x_9639c829: 'Sin número de teléfono',
  x_558b5ced: 'WhatsApp está abierto y se registra el seguimiento',
  x_cdcef6e3: 'WhatsApp está abierto',
  x_e984172c: 'teléfono copiado',
  x_5255b7ec: 'Total',
  x_30aeeb9b: 'Active',
  x_a337d612: 'Expiring',
  x_f7656c12: 'Expired',
  x_2ba7855c: 'Pending',
  x_80d9ba9e: 'Buscar Comerciante / Contacto / Teléfono / ID...',
  x_c41ac297: 'Expira pronto',
  x_9246fe88: 'a pagar',
  x_f2992715: 'Haga clic para copiar',
  x_fb4174dd: 'Trial Signups',
  x_4740f413: 'All countries',
  x_f10c9104: 'No hay resultados coincidentes',
  x_5bf2e3d5: 'Tenant',
  x_52409da5: 'Persona de contacto',
  x_5a93d3f7: 'telefono',
  x_56526d93: 'Registrado en',
  x_43b510ed: 'restante',
  x_b0d7b92a: 'Templates',
  x_56cfacad: 'Contenido del mensaje (editable)',
  x_a66e77ec: 'Tienda única',
  x_6feaed50: '1 tienda',
  x_792d962f: '3 cajeros',
  x_f2e24124: 'Sin tienda online',
  x_8a77db1e: '🎁 Los nuevos inquilinos no necesitan mantenimiento durante el primer año',
  x_9a61b1d7: '1 tienda principal + 2 sucursales',
  x_4463f4a6: '12 cajeros',
  x_dab7b561: 'Tienda online',
  x_a0eac492: 'Empresa · 1+10 · Recomendado',
  x_fe8cdaef: '1 tienda principal + 10 sucursales',
  x_63c7540a: 'Cajeros ilimitados',
  x_1e7614cb: '✅ Tienda online + delivery + reporte multitienda',
  x_b934c4e3: 'Cancelar esta orden?',
  x_d16fd88d: 'Cancelled',
  x_2276b3e8: '¡Activación exitosa!',
  x_92a13409: 'No se puede generar la dirección de pago',
  x_33486076: 'Se ha generado el código de pago/escanee el código o copie la dirección para pagar',
  x_1c017415: 'Se ha generado el código de pago',
  x_d988ff0f: 'Dirección copiada',
  x_65dd9ef1: 'esperando',
  x_fafc7219: 'Activación de Plan · servicio anual',
  x_e2841a14: 'Amount',
  x_d41c514e: 'Network',
  x_93ba918d: 'Sólo red TRON',
  x_13b5c750: 'Estado:',
  x_b21b5ec9: 'Cancelar pedido',
  x_228a7d81: '⭐ Recomendado',
  x_d65904be: 'Incluye 1er año de servicio · luego tarifa anual',
  x_39e6803b: 'compra de USDT',
  x_b36b9c5e: '/año',
  x_16bcce59: 'Incluye: Servidor · Actualizaciones automáticas · Servicio al cliente · Copia de seguridad de datos · Actualizaciones mensuales de PWA',
  x_338e96c9: '🎁 El primer año para nuevos inquilinos es gratis con la compra · La renovación comienza a partir del segundo año',
  x_2962f3d5: 'paquete de compra',
  x_d1fdc613: 'Hay un límite superior en el número de tiendas.',
  x_9823244e: '. Si necesita agregar una tienda, comuníquese directamente con el servicio de atención al cliente de WhatsApp para obtener una cotización. No se actualizará automáticamente en el sistema.',
  x_29aca265: 'Solo red USDT TRC-20. Cualquier otra moneda o cadena se perderá permanentemente.',
  x_8428cdf2: 'Activación automática entre 5 y 15 minutos después del pago. Si tienes alguna duda, WhatsApp de atención al cliente:',
  x_1f1c7645: 'Los grupos opcionales requieren al menos 2 opciones.',
  x_5b530127: 'Por favor complete la información completa',
  x_a3033ebf: '(Copiar)',
  x_79d3abe9: 'Copiar',
  x_ea15ae2b: 'Opciones',
  x_839a578d: 'Cree combinaciones de paquetes para aumentar el precio unitario por cliente',
  x_c901f681: 'Nombre del paquete',
  x_cc6c35a3: 'codificación',
  x_cc949910: 'Artículos fijos',
  x_abba9357: '🔍 Ingrese el nombre a buscar, menú desplegable de filtro automático...',
  x_2cad29d6: 'Aún no hay productos fijos',
  x_9a982d0f: 'Accesorios opcionales',
  x_2e363fc9: 'Agregar grupo opcional',
  x_8243c74a: 'Actualmente no hay grupos opcionales (los clientes pueden elegir uno de cada grupo)',
  x_c6db8605: 'Precios',
  x_75c8703e: 'Precio del paquete',
  x_8690ee2e: 'guardar',
  x_c12c079a: 'Nombre del grupo (por ejemplo, selección de bebidas)',
  x_d2ea9e05: 'Opciones predeterminadas',
  x_ae648cba: 'Agregue al menos 2 opciones, los clientes pueden elegir una de ellas al comprar el paquete',
  x_348f1b33: 'Por favor seleccione una imagen primero',
  x_4dc3f98d: 'OCR falló',
  x_17710b35: 'No hay filas para importar',
  x_9190cc22: 'Nombre del proveedor',
  x_1fd1d5c5: 'Nombre del producto',
  x_39f76a9b: 'código de barras',
  x_5f99f6a8: 'precio de venta',
  x_1981be5f: 'Tome una orden de compra y la IA la identificará automáticamente → Alinear los productos → Actualizar inventario + precio de venta recomendado',
  x_bfd77887: '① Subir fotos de órdenes de compra',
  x_5324ed82: 'Haga clic para tomar una foto o seleccionar una imagen',
  x_346a0f2f: 'Admite JPG/PNG, máximo 15 MB',
  x_da7e7127: 'Reconocimiento de IA en progreso, alrededor de 5 a 10 segundos...',
  x_4eb51d8f: 'Empezar a identificar',
  x_3f2f5467: '② Verifique los resultados del reconocimiento',
  x_a24b9d90: 'Ya tengo proveedor (opcional)',
  x_7b8bc49d: '-- use el nombre de arriba --',
  x_9452920c: 'Almacén entrante',
  x_dcffc8fa: 'Número de pedido:',
  x_7501567a: 'Fecha:',
  x_dbcbbf20: 'Totales:',
  x_01be458f: '③ Cada fila de productos: seleccione acción',
  x_d32fc7ef: 'No se reconoce ninguna línea de productos',
  x_c58187fe: 'reconocimiento OCR',
  x_e514d3ef: 'Cantidad:',
  x_3bf6cfdd: '× precio unitario',
  x_c500cfab: 'acción',
  x_f504986f: 'partido',
  x_26bb8418: 'Nuevo',
  x_92636e8c: 'saltar',
  x_ba30d5cc: '-- Clasificación --',
  x_6a9e619b: 'Confirmar almacenamiento',
  x_1d46b01c: '✅ Almacenamiento completado',
  x_bb3502bb: 'Número de orden de compra:',
  x_4a049640: 'Artículos en stock:',
  x_29645b50: 'artículo',
  x_art_pl: 'artículos',
  x_d909d882: 'Importe total:',
  x_c28d24cc: 'Por favor seleccione un banco',
  x_f821a75d: 'Por favor ingrese el número de cuenta',
  x_5d813f65: 'Por favor ingrese el número de teléfono',
  x_d467588f: 'Ya agregado, recuerda hacer clic en Guardar',
  x_e742ab60: 'Ejemplo: 0199 Mi Banco Personal',
  x_8d1a5254: 'Por favor ingrese el nombre del banco',
  x_c3441b0e: 'El banco ya existe',
  x_1796b0b6: 'Cuentas de Recepción',
  x_2fae4dfd: 'El número de cuenta bancaria del beneficiario que se ve cuando el cliente realiza un pedido. Se pueden agregar múltiplos (Transferencia + Pago Móvil).',
  x_4edfb958: 'Aún no existe una cuenta de cobro. Añade el primero a continuación.',
  x_9c3929ba: 'Cuenta:',
  x_343c39bd: 'Teléfono:',
  x_468507f3: 'Titular de la tarjeta:',
  x_a315035f: 'Agregar cuenta',
  x_b7887785: 'Tipo',
  x_c75632b1: 'Banco',
  x_d9d63df2: 'Cuenta',
  x_ccfc0579: 'Titular',
  x_b87b58ea: 'Teléfono',
  x_f1e36d48: '+ Agregar cuenta de pago',
  x_3a24d652: 'Bancos en Tienda Online',
  x_9bdee3a3: 'El banco seleccionado por el cliente al realizar el pedido. Desmarque cualquiera = mostrar todo (predeterminado). Se pueden agregar bancos personalizados.',
  x_3036d714: 'Agregar banco',
  x_de8733ca: 'Todos',
  x_7c589a7b: 'Ninguno',
  x_4d915d93: 'Suscripción extendida ✓',
  x_9d6a7ced: 'No se puede crear la factura',
  x_4e16c811: 'meses',
  x_5beef376: 'mes',
  x_91d63f7f: 'Renovar Suscripción',
  x_bc8a11d1: 'Tenant:',
  x_9b9a6730: 'Plan:',
  x_5f06418b: 'Esperando confirmación de USDT…',
  x_516de1ba: '· Estado:',
  x_1bcf2f98: 'Ahorra 2 meses',
  x_e27e83d3: 'Renovación del USDT',
  x_77de9017: 'Wallet: Solo USDT de la red TRON, enviando otras monedas no podrán llegar.',
  x_ef6a3fe2: 'Una vez completado el pago, la página volverá automáticamente aquí y mostrará "La suscripción ha sido renovada". Si no salta automáticamente, puede regresar manualmente y hacer clic en "Actualizar".',
  x_da8f9e35: 'Cajas/caja',
  x_77862e71: 'Error de sincronización, verifique la red y vuelva a intentarlo',
  x_ad41fef2: 'La sincronización BCV falló',
  x_12d0d88a: 'Error de sincronización paralela',
  x_b4b5434b: 'BCV = funcionario/informe | Binance = dólar estadounidense efectivo/cambio | mercado negro = precio de venta',
  x_536911f7: 'Sin internet / no internet — espere a que vuelva la conexión',
  x_b2fbbabf: 'Nada que sincronizar / No hay elementos para sincronizar',
  x_aece3f5d: '¿Descartar este cambio? No se podrá recuperar / ¿Está seguro de que desea abandonar esta operación? No se puede recuperar',
  x_912a4250: 'Eliminado / Eliminado',
  x_cb4d2044: 'Sin elementos fallidos / No hay misión fallida',
  x_10b526fb: 'El turno ha finalizado: el pedido de ventas realmente se ha guardado; esta es una solicitud de recuento duplicado y se puede descartar de forma segura',
  x_5f01f33d: 'La orden pendiente ya no existe; es posible que se haya liquidado o eliminado, por lo que puede descartarla de forma segura.',
  x_d10bff45: 'Stock insuficiente',
  x_57e7ae15: 'Inventario insuficiente en el almacén de origen',
  x_8496514a: 'El almacén de origen no tiene inventario suficiente: ¡no se ha creado la orden de transferencia! Reduzca la cantidad y vuelva a realizar un pedido, o reponga el stock primero. Esta orden estancada se puede descartar',
  x_4eb6919a: 'Autoridad de crédito',
  x_fee56ee3: 'El cliente no ha abierto el permiso de crédito; abra primero enable_credit en "Gestión de clientes" o descarte el pedido y rehágalo con efectivo o transferencia.',
  x_b5bda5aa: 'Solicitud duplicada: el servidor la ha procesado y puede descartarse de forma segura',
  x_f17d4674: 'La red es normal.',
  x_01f3782e: 'Red desconectada',
  x_8b9a1e80: '— sincronizando automáticamente / Sincronizando automáticamente',
  x_9e50fc79: '🔄 Sincronizar ahora / Sync Now',
  x_1a62aebf: 'Descartar / darse por vencido',
  x_bcb61127: 'Nada pendiente / No hay artículos para subir',
  x_78e8a2f9: '✅ La cuenta ha sido publicada',
  x_ccc63b24: '🔧 Reparación de cuenta de crédito sin dueño',
  x_97ce76db: 'El cajero hizo clic en "Crédito" pero no seleccionó a un cliente/empleado; haga clic en "Crédito" a la derecha para transferir el crédito a la persona correcta.',
  x_2a4cb867: '✅ No se encontraron cuentas de crédito sin propietario, todas las cuentas de crédito se han vinculado correctamente a las cuentas de clientes/empleados',
  x_b7a67cb8: 'Buscar número de pedido/artículo/cajero...',
  x_faa34bbd: 'No hay ninguna cuenta de crédito sin dueño coincidente',
  x_87633dad: 'Deuda pendiente',
  x_bdc278a2: 'Paga la factura a...',
  x_d84f39b4: '👤 Empleados',
  x_796638a3: '🧑‍🤝‍🧑 Clientes',
  x_69632a49: 'Buscar empleados...',
  x_4b93385f: 'Buscar clientes...',
  x_ce2242ff: 'Está estrictamente prohibido mezclar los ingresos reales en dólares estadounidenses y la conversión en moneda local en un solo total; la naturaleza y el riesgo de cobertura de los dos son diferentes.',
  x_0b0fad08: 'Análisis de ventas de paquetes.',
  x_b061a19e: 'Número de pedidos de paquetes',
  x_761c7bd5: 'Participación del total de pedidos',
  x_e0674456: 'Ingresos por paquetes',
  x_8bdec340: 'Número de paquetes activos',
  x_a789726b: 'Precio medio del menú fijo',
  x_221340da: 'Ranking de ventas de paquetes',
  x_794b4643: 'Aún no hay datos de venta de paquetes',
  x_da518fe1: 'Después de crear un paquete, los datos de ventas se mostrarán aquí.',
  x_398265e4: 'Distribución de venta de paquetes.',
  x_956aaaf0: 'Tendencias de venta de paquetes',
  x_9c4738fa: 'Orden del paquete',
  x_c2ee20c6: 'Estadísticas de selección de accesorios',
  x_d7bbccf6: 'Detalles de venta de paquetes',
  x_46cd403a: '💵 Recibos en USD · Recibos en USD',
  x_9a2602b9: 'flujo de caja real',
  x_b5091ee6: '💰 Conversión de moneda local · VES → Instantánea de USD',
  x_3989b42a: 'Bloquear precio en $ para el día',
  x_840a3569: '(referencia)',
  x_d22c8252: 'Muestra/Prueba',
  x_2ba8df79: 'Pérdida/sobreventa',
  x_1a6387e4: 'Registro de daños exitoso',
  x_8f2328a2: 'Gestión de informes de pérdidas',
  x_20d8ea7f: 'Crear un nuevo informe de pérdidas',
  x_6e2c4471: 'Registro de informe de pérdidas',
  x_1a9a9b5c: 'Cantidad de pérdidas reportadas',
  x_6c3b96c6: 'cantidad de pérdida',
  x_2e51c1e9: 'todas las razones',
  x_7074d50c: 'pérdida',
  x_531401ac: 'Reemplazar',
  x_c270fc6f: 'almacén',
  x_cb29982e: 'Almacén predeterminado',
  x_748662a5: 'Razón para informar la pérdida',
  x_da086f20: 'Instrucciones complementarias (opcional)',
  x_6966f4a1: 'pérdida esperada',
  x_3303f395: 'Confirmar informe de pérdida',
  x_607e7a4f: 'Ver',
  x_30eb1c49: 'hay esta semana',
  x_0c6ff5f3: 'Cumpleaños de un cliente: haga clic para ver el centro de marketing',
  x_35bd0636: 'Mantenga al menos un artículo',
  x_dadc0335: 'Modificación de pedido',
  x_5badb3ba: 'La modificación falló',
  x_1229b861: 'Ocultar pedidos no legítimos activados',
  x_dc78ab4d: 'Cerrado para ocultar pedidos no originales - Mostrar todo',
  x_a2290676: 'Ocultar pedidos no legítimos: activado',
  x_3d0512c9: 'Ocultar pedidos no legítimos: desactivado',
  x_027d489f: 'Pedido medio de cliente',
  x_77678b5c: 'Todas las tiendas',
  x_565955cb: 'Todos los cajeros',
  x_bfdaebfd: 'cajero',
  x_41ce131a: 'mezclar',
  x_966038af: 'Devuelto',
  x_7623803b: 'Marcado completado',
  x_1512dcd4: 'Editar orden',
  x_9567eef9: 'efectivo efectivo',
  x_838effc3: 'Desliza Punto',
  x_32005a19: 'Transferir Transferir',
  x_30bee6f5: 'Pago mixto',
  x_5939657d: 'pago dividido',
  x_1e9b1d5d: 'Efectivo$',
  x_26954cc9: 'Bs en efectivo',
  x_26922a58: 'recibido',
  x_c993e001: 'cambiar',
  x_4091e27c: 'Descuento',
  x_c8b8ba24: 'pago real',
  x_c5575b3f: 'Guardar cambios',
  x_7a8a35ec: 'Todos los métodos de pago',
  x_25557e0c: 'Tarjeta',
  x_9f6bb100: 'Mixto',
  x_04330953: 'Crédito',
  x_974470ef: 'Pago:',
  x_da4abd3e: 'precio unitario',
  x_0bf60b32: 'Cantidad',
  x_f599fcd3: 'Subtotal',
  x_669e3a20: 'Configuración guardada',
  x_9e144231: '¿Enviar los deseos de cumpleaños de hoy ahora?',
  x_6193e011: 'mensaje demasiado corto',
  x_0ef8caa0: 'Por favor seleccione una hora de envío programada',
  x_50525e3d: 'La hora no puede ser anterior a la actual.',
  x_a5a64f69: '${blastForm.campaign_name || \'Festival\'}',
  x_4dc5ca8d: 'La programación falló',
  x_370f2e2c: '¿Cancelar esta tarea programada?',
  x_482e8539: 'Cancelación fallida',
  x_5ae7b19b: '¡Hoy!',
  x_71325692: 'Ejemplo: Día de la Madre 2026',
  x_2fb90b05: 'Procesando...',
  x_2ae98dbc: '⏰ Programado',
  x_846a6e3b: 'Enviar a misa inmediatamente',
  x_917f9004: '🎂 Cumpleaños/Vacaciones WhatsApp Auto Marketing',
  x_2e7a63e4: 'Enviado automáticamente a clientes con cumpleaños a las 9:00 AM (VE) todos los días',
  x_81b7205c: 'Cada cliente se deduplica automáticamente una vez al año.',
  x_8f6280a1: 'Prefijo de cupón',
  x_429d5967: 'Porcentaje de descuento (%)',
  x_f81c3d04: 'Días válidos',
  x_d3276905: 'Ninguno todavía. Primero complete la fecha de nacimiento (MM-DD) en la información del cliente.',
  x_8483ed13: 'cumpleaños',
  x_3ec2bba0: 'distancia',
  x_02daf71f: 'Suscríbete',
  x_7001dd63: 'Cancelar suscripción',
  x_3e744a9b: 'Suscribirse',
  x_1fd094a7: '📅 Selección rápida de vacaciones (ordenar por fecha, hacer clic para seleccionar)',
  x_919bf6ba: 'Seleccione una plantilla de bendición → complete automáticamente el siguiente formulario (se puede editar)',
  x_83f2b3fe: 'No hay una plantilla predeterminada para este día festivo, ingrésela manualmente',
  x_53eab0ee: 'Nombre del evento (usado para eliminar duplicados, el mismo nombre solo se enviará una vez en el día)',
  x_baa7d2f5: '⏰ Envío programado (opcional)',
  x_a69942de: 'Seleccione fecha y hora de envío (en su zona horaria local)',
  x_afea4271: '✨El sistema lo enviará automáticamente a la hora que especifiques. Por ejemplo, si se configura una semana antes del Día de la Madre, se enviará automáticamente a las 9 a. m. del 10 de mayo.',
  x_04ab3e0f: 'Después de activarlo, puede especificar una hora en el futuro para que se envíe automáticamente (por ejemplo, las 09:00 del Día de la Madre).',
  x_f9c3ed43: 'Aún no hay registro de envío',
  x_db8a4b9a: 'Completar todo',
  x_4177fcbd: 'Bienvenido',
  x_b6076a05: 'Error al iniciar sesión',
  x_459db148: 'Ej: codigo-tienda',
  x_d89bbf9f: 'Se requiere código de tienda/teléfono móvil/contraseña/nombre',
  x_817f3912: '✅ ¡Registro exitoso! Podrás aceptar pedidos cuando el dueño te apruebe',
  x_1c56d8c5: 'Registro fallido',
  x_c5864848: 'Código *',
  x_a3006784: 'Teléfono *',
  x_0b7dd959: 'Contraseña *',
  x_552fd502: 'Mínimo 4 caracteres',
  x_914a33ec: 'Nombre *',
  x_3f1613aa: 'Placa',
  x_e33cbc27: '🎉 ¡Pedido tomado! Ve a la tienda a recoger la mercancía',
  x_ecb6d7f9: 'No se pudo tomar el pedido',
  x_5cc14c3c: 'Aceptado',
  x_c92aaa37: 'Error de confirmación',
  x_74cc7a41: 'Pasado al siguiente repartidor',
  x_52690cab: '🚀 Iniciar entrega',
  x_1d6ecc64: '✅ Entregado, el costo de envío ha sido acreditado en la cuenta',
  x_e319cca8: '¿Tomar una foto del comprobante de entrega?\\n(Puedes omitirla y cancelarla directamente)',
  x_ead2daed: 'Póngase en contacto con el propietario para obtener más detalles.',
  x_757bc40a: 'Después de pasar la revisión, el pedido disponible se mostrará aquí.',
  x_a830777b: 'No se puede aceptar el pedido',
  x_b720a69a: 'En revisión',
  x_4a9428f9: '✓ Certificado',
  x_c9d929e0: '✗ Rechazado',
  x_1ef6f1db: 'Pendiente',
  x_10f8cbf4: 'Aceptado · ir a recoger',
  x_f8a40394: 'Recogido',
  x_d409c4ea: 'Distancia desconocida',
  x_e91aeee2: 'Órdenes completadas',
  x_9af2659b: 'Ingresos acumulados',
  x_f061db1c: 'Vehículo',
  x_108db12e: 'Calificación',
  x_ad77bf1d: 'Sellox Repartidor',
  x_dec20a6b: 'Código de tienda',
  x_8e362599: 'Teléfono',
  x_a6eabe9b: 'Contraseña',
  x_58caca00: 'Registro de repartidor',
  x_1c3a8565: 'Tipo vehículo *',
  x_8db8ee8e: 'Moto',
  x_201504a8: 'Bicicleta',
  x_cc31ee5d: 'Carro',
  x_fbba6044: 'A pie',
  x_6c78bebb: 'Esperando aprobación',
  x_4a798e43: 'La cuenta ha sido desactivada',
  x_d6991a83: 'Completado ✓',
  x_9890f97b: 'Asistente de configuración de impresión',
  x_cff3211b: 'Configuración completa de impresión silenciosa en 3 pasos, imprimiendo sin ventanas emergentes',
  x_26590e3f: 'Paso 1: configurar la impresora predeterminada',
  x_8fb52e11: 'Abra Configuración de Windows → Bluetooth y dispositivos → Impresoras y escáneres',
  x_86219510: 'Desactive "Permitir que Windows administre la impresora predeterminada"',
  x_d82f67dd: 'Haga clic en su impresora térmica (como la XP-80C)',
  x_476e0586: 'Haga clic en "Establecer como predeterminado"',
  x_b26839a0: 'Paso 2: copia el comando de inicio',
  x_89eff51a: 'Haga clic en el botón de abajo para copiar el comando',
  x_e63a8355: 'Paso 3: crea un acceso directo en el escritorio',
  x_4a7e4b2f: 'Sigue estos pasos',
  x_39dca51d: 'Haga clic derecho en un espacio vacío en el escritorio → Nuevo → Acceso directo',
  x_f89fc87a: 'Pega el comando que acabas de copiar en el cuadro "Dónde"',
  x_8f932a07: 'Haga clic en Siguiente y escriba Sellox POS como nombre',
  x_631effbe: 'Haga clic en Listo. En el futuro, haga doble clic en el icono para abrir el sistema de caja.',
  x_e45ed499: 'Copie el comando de inicio de Edge',
  x_a28aa67f: '¡Copiado!',
  x_e541bfc7: 'Copiar comando de Chrome',
  x_eedf4bbd: 'Consejo: Si imprime en OneNote o PDF, verifique si la impresora predeterminada está configurada correctamente en el paso 1.',
  x_797d0e09: 'Una vez completada la configuración, haga doble clic en el icono "Sellox POS" en el escritorio y la impresión se enviará automáticamente a la impresora sin que aparezca ningún cuadro de diálogo.',
  x_f394cfe1: 'Cuenta Mayorista / Cuenta Mayorista',
  x_95e3ad97: 'Cliente/cliente',
  x_a702e3be: 'Puntos / Puntos',
  x_b29b209c: 'Crédito/crédito',
  x_0170732a: 'Resumen de Deuda / Panorama de las deudas pendientes',
  x_39ee196f: 'Pedidos Mayoristas / Pedidos Mayoristas',
  x_4ccb2222: 'Compras recientes / compras recientes',
  x_5f2a9420: 'código de escaneo',
  x_ecd041a0: 'Redirigiendo / Redirigiendo…',
  x_9a8ed80b: 'Pago recibido / pago exitoso',
  x_e7268001: 'Error al subir / Error al subir',
  x_b37d1896: 'Comprimiendo... / Comprimir imágenes...',
  x_bd703be1: 'Procesando... / Procesando...',
  x_67c3bc10: 'El bono ha sido enviado.',
  x_96d7970c: 'Pago confirmado',
  x_0cb0251b: 'Pago rechazado',
  x_ea4ccc53: 'Vale enviado al cajero',
  x_8a6643a7: 'Referencia / número de referencia',
  x_88e9e55d: 'Monto/cantidad',
  x_230397c0: 'Fecha/Fecha',
  x_e10ba955: 'remitente / nombre',
  x_e222bb0c: 'Teléfono / teléfono móvil',
  x_248a9885: 'Cédula/DNI',
  x_e4f17ebf: 'banco / banco',
  x_31bde601: 'Tipo / Tipo',
  x_2faded9f: 'Sube una captura de pantalla de tu comprobante de pago',
  x_ff5f2a1f: 'Por favor espere / Por favor espere...',
  x_ee8d09d1: 'Haga clic para tomar una foto o seleccione una imagen para cargar',
  x_e893f6b1: 'Datos identificados / Resultados de reconocimiento de IA',
  x_c7c7b829: '✓ Cuenta receptora correcta / La cuenta receptora es correcta',
  x_aa855a32: '⚠️ Cuenta NO coincide — revisar / La cuenta receptora no coincide',
  x_2f1745ef: 'Subir otro comprobante / Subir otro',
  x_1b056098: 'El cajero puede ver este resultado en tiempo real.',
  x_7eef492b: 'Ingresa tu teléfono o código',
  x_rider_push_banner: 'Activa avisos de pedidos en segundo plano (suena con pantalla bloqueada)',
  x_rider_push_btn: 'Activar',
  x_rider_push_on: '¡Avisos en segundo plano activados!',
  x_rider_push_denied: 'Notificaciones bloqueadas — actívalas en ajustes del teléfono',
  x_rider_push_fail: 'Error al activar, intente de nuevo',
  x_rider_new_order: '¡Nuevo pedido!',
  x_5b4d6f56: 'No encontrado',
  x_ba825d88: 'Falta tienda',
  x_163d4734: 'Nombre muy corto',
  x_d8d5dbd4: 'Teléfono inválido',
  x_61d1e909: 'Error en el registro',
  x_9e478700: '🎁 Club de puntos',
  x_4f4ed4a8: 'Tienda',
  x_e223e6f8: '📱 Teléfono o Código',
  x_400ea289: '📋 Reglas',
  x_f4ae4ba2: '1 minuto',
  x_e41c8f96: 'Recibe felicitaciones y promociones por WhatsApp',
  x_472eeea6: 'Hola',
  x_e0ad1b59: 'puntos',
  x_b6d516c1: 'Reglas',
  x_3207b63d: 'Pena de ausencia',
  x_366edeab: 'deducción salarial',
  x_1eb00e63: 'Empresa le debe / La empresa le debe a sus empleados',
  x_ecd32f47: 'Saldo pendiente / pendiente de pago',
  x_a93dac50: 'Saldo / Equilibrio',
  x_e37433ef: 'A retirar en caja / se puede recoger en caja',
  x_c72b5c9e: 'Horario Semanal / Horario de turnos esta semana',
  x_2c7d6de7: 'Movimientos recientes / registros recientes',
  x_4536f3e5: 'es / chino',
  x_98961d8e: '⏰ Enlace caducado / enlace caducado',
  x_13cd19da: '📸 Imagen original / original',
  x_855e9d6c: '✨ Mejorada con IA / AI versión embellecida',
  x_8cd3793f: 'div>',
  x_9f2178d0: 'div>',
  x_261541dd: '⏳ Esperando que un repartidor tome el pedido.',
  x_b886ab95: '🛵 El repartidor aceptó el pedido y va hacia la tienda.',
  x_a2d70627: '📦 El repartidor recogió el pedido.',
  x_168a78b9: '🚀 El repartidor está en camino',
  x_c5febde0: '✅ Entregado',
  x_4babc22d: '❌ Cancelado',
  x_f07cecdb: 'No se puede obtener el estado del pedido',
  x_69deca2b: 'Orden no encontrada',
  x_638959b3: 'Tienda',
  x_9b16789f: '🏪 Tienda',
  x_341cb93c: '📍tú',
  x_3934104b: 'Repartidor',
  x_b1862ef3: 'Monto del pedido',
  x_1138a92b: 'tarifa de entrega',
  x_2541ca48: 'Actualizar ahora',
  x_153942db: 'Nos vemos la próxima vez',
  x_78f2095f: 'nueva versión encontrada',
  x_9b601b8e: 'Versión actual',
  x_9ee20a30: 'última versión',
  x_49009569: '📝 Actualizar contenido',
  x_4a07f0c8: 'La suscripción ha caducado',
  x_db45a2da: 'Su suscripción a Sellox ha caducado. Para evitar afectar el negocio, renueve lo antes posible.',
  x_5eeb04af: 'La suscripción está a punto de caducar',
  x_8dd2a3dc: 'El juicio termina pronto',
  x_01059b1d: 'La prueba gratuita ha finalizado',
  x_26a5e5a8: 'Renueve para desbloquear todas las funciones y continuar administrando su negocio.',
  x_0ea5b9f4: 'El pago anual es de solo $500 (Ahorre $100 · Obtenga 2 meses gratis) · El pago mensual es de $50',
  x_39bb592b: 'Renovar ahora (WhatsApp)',
  x_dc017114: 'recordatorio más tarde',
  x_7693a3c0: 'Hola, me gustaría renovar mi suscripción a Sellox. Comerciante:',
  x_4a6ea4ec: 'No más avisos dentro de 7 días',
  x_feea9211: 'Descargar código QR',
  x_04c8c8a8: '📱 Se lanzó la aplicación móvil Sellox',
  x_faf8c169: 'Escanea el código QR con cámara · Impresión Bluetooth · Consulta tus ventas en cualquier momento - haz clic aquí para escanear el código QR para descargar',
  x_053877ee: 'Escanee el código QR para descargar la aplicación móvil de Sellox',
  x_d73e6673: '📱Escanear con la cámara del teléfono móvil o WeChat',
  x_9f9d3632: 'teléfono móvil',
  x_5c980c4f: 'cámara',
  x_a7185263: 'o',
  x_767c7df9: 'Escanear en WeChat',
  x_d17430c7: 'Alinear el código QR',
  x_15067f6d: 'Haga clic para aparecer',
  x_17dbbc8e: 'Enlace de descarga',
  x_69350bb6: '→ APK comienza a descargarse',
  x_86e36e8c: 'Después de la instalación, habrá un ícono adicional de Sellox: inicie sesión directamente',
  x_6d876a09: 'Ver página completa',
  x_a75406c6: 'Hola superadministrador 👑\\nPuedes pedirme que haga lo siguiente:\\n• "Recargar 500 puntos a Andy"\\n• "Observar el total de inquilinos y el uso de IA de la plataforma"\\n• "Los 10 inquilinos con el mayor saldo de IA"\\n• "Información detallada de Andy"',
  x_720f0600: 'El servicio de IA no está disponible',
  x_d21e1fb6: 'Descripción general de la plataforma',
  x_dc45b9fc: 'Listar todos los inquilinos',
  x_1c101627: '10 saldos principales',
  x_922f1ff2: 'Recarga andy con 500 puntos',
  x_40e77bcc: 'dime que hacer...',
  x_ee98d830: 'Control de nivel de plataforma · GPT-5.2',
  x_dbd5f6e5: 'Pick a variant',
  x_9cc890a7: 'Cancelar',
  x_b4a55bb3: 'Permita las ventanas emergentes / Please enable pop-ups',
  x_45546304: 'Enviar a WhatsApp (~$0,01)',
  x_3835157d: 'Envío dual con un clic: imprima papel QR + cuadro emergente de WhatsApp',
  x_e0caf262: 'Reconciliación rápida',
  x_fccab93a: 'por cobrar',
  x_6e2a13a0: 'Requiere confirmación del gerente para finalizar el turno',
  x_4349b878: 'El gerente confirma',
  x_49dfdd8b: 'Gerente confirmado',
  x_04070c1f: 'Cantidad de conteo real',
  x_57680d2c: 'Efectivo por cobrar',
  x_4acec17e: 'Observaciones (si hay alguna diferencia, explique los motivos)',
  x_5f411223: 'Regresar',
  x_1e576858: 'Pedido offline sincronizado / Transmisión de orden suplementaria offline',
  x_b15d9127: 'Cerrar',
  x_240ce88f: 'El gerente debe escanear el código QR o ingresar la contraseña para confirmar el cambio de turno.',
  x_26201f40: 'Verificación PagoMóvil:',
  x_eec5e9de: '💡 El sistema "Cuentas por Cobrar" se ha completado por defecto. Simplemente modifique la fila que no coincida con el recuento real (normalmente sólo la fila de efectivo).',
  x_77f4b22c: 'Caja inicial:',
  x_cf80dc01: '(Agregado a "efectivo por cobrar")',
  x_3b2cc96c: 'Es normal si la diferencia proviene de comisiones bancarias, propinas o cambio. Si los números no coinciden, verifique si cometió un error tipográfico o se perdió algo.',
  x_81ab69b9: 'Cambiar mesas / compartir mesas / forzar cierre de mesa',
  x_555dcd4d: 'Sin mesas',
  x_7188b57a: 'Primero vaya a Administrador → Plantilla de industria → Restaurante para crear una tabla automáticamente, o → Administración de tablas para agregar una tabla manualmente',
  x_21f69613: 'Tabla: Abrir un nuevo pedido. punto',
  x_b19d83e5: 'Cambiar mesa',
  x_6f52c7c0: 'mesa compartida',
  x_cecf0ca3: 'Forzar el cierre de la mesa',
  x_2435f5bd: 'Comentarios del producto',
  x_0fa5956e: 'Introduzca notas...',
  x_da36e122: 'sin azucar',
  x_d8a56361: 'shaobing',
  x_358cbe41: 'picante',
  x_81f4307e: 'sin cebollas',
  x_7e1d3c25: 'Para llevar',
  x_bc8d758c: 'urgente',
  x_11db356c: 'Introduzca notas de pedido...',
  x_4403fca0: 'Borrar',
  x_2b6c52ae: 'No hay nuevos pedidos',
  x_8131eb5e: 'El sonido está desactivado · Haga clic para activar',
  x_7d1a9279: 'El sonido está activado · Haga clic para apagar',
  x_e2392cc3: 'Aún no hay pedidos de mesa',
  x_60ce5286: 'Producto recetado:',
  x_2c475e48: 'Primero debe registrar al cliente (nombre + número de teléfono) antes de poder realizar el pago.',
  x_8e5fdd7c: '⚠️Artículos inmediatos/caducados:',
  x_c15301ed: 'Expira hoy',
  x_abfc8ce7: 'Abrir Turno',
  x_9f22fdc1: 'Caja inicial',
  x_561e47de: '¿Cuánto efectivo hay en el cajón ahora? Solía ​​hacer cambios. El sistema deducirá automáticamente este monto para conciliación al final del turno.',
  x_b250b8da: 'Omitir',
  x_e2f5ed34: 'Abrir',
  x_d43f28df: 'Etiquetas de Precio',
  x_cb08c979: 'Buscar...',
  x_6ff3aa66: 'Precio',
  x_b7704c27: 'Tamaño',
  x_eb10f492: 'Térmica de 80 mm (1 foto por pedido)',
  x_bc3c00b4: 'A4 (cuadrícula de 3 columnas, ahorro de papel)',
  x_3f5cee0a: 'Recargo Cashea %',
  x_248bf378: 'Sin resultados',
  x_8821f767: 'Buscar nombre o tel',
  x_aed44ac1: 'Firma del Cliente *',
  x_1c5dca75: 'Monto total / total',
  x_a306d0a4: 'Cliente *',
  x_b21d8bb4: 'Sin resultados',
  x_15e8601c: 'Efectivo USD',
  x_6aad3987: 'Bs en efectivo',
  x_edf32545: 'Ref. Bancaria',
  x_a31b8b65: 'Ingrese el número de referencia de la transferencia del cliente y el sistema verificará automáticamente si el banco ha recibido el pago.',
  x_868e4ac3: 'Plazo (días)',
  x_9da7a7b8: 'contrato de credito',
  x_6c6d1878: 'yo mismo',
  x_0f76a0c9: 'Confirmar recepción de la mercancía descrita, valor total.',
  x_7221fd2a: ', Chengruozai',
  x_d959b5d4: 'liquidar el saldo',
  x_96553cea: '. Los comerciantes con pagos atrasados ​​tienen derecho a emprender acciones legales.',
  x_e2b5c6cc: 'Nombre del producto',
  x_b10acb59: 'tomar orden',
  x_a5e0e12d: 'UN FAVOR DEL EMPLEADO / La empresa le debe a sus empleados',
  x_17ea5dd2: '📱 Estado de cuenta digital / factura electrónica',
  x_4e743c6d: 'Saldo real/saldo actual',
  x_4ae414d7: 'Préstamos y abonos / Préstamos y reembolsos',
  x_c7d9aa03: 'Mercancía a crédito / credit record',
  x_8815c25b: 'Salarios pagados / Historial de Salarios',
  x_6cb22de0: '✅ Empresa le debe / La empresa debe depósitos a los empleados',
  x_66ea4390: '📱 Escanea para ver tu estado de cuenta digital / Escanea el código QR para ver la factura electrónica',
  x_443de421: 'Reportar perdida',
  x_bb54122e: 'Reimprimir recibo',
  x_50c099f4: 'Registro de pérdida',
  x_a1ed3194: 'Buscar nombre o código del producto...',
  x_7959f6f5: 'clientes mayoristas',
  x_e2e1c3c9: 'Buscar miembros (nombre/teléfono móvil)',
  x_0c9545b4: 'Nombre del cliente *',
  x_8098e2b4: 'Número de teléfono móvil',
  x_6ecea67c: 'Número de identificación Cédula',
  x_67f6a89e: 'Observaciones (opcional)',
  x_df3c5cbe: 'USB está conectado',
  x_d685a4d5: 'Conecte la impresora USB',
  x_bfff47cd: 'La balanza electrónica está conectada.',
  x_2864a729: 'Conectar balanza electrónica',
  x_912cc1e7: 'lista de verificación',
  x_4b8e471b: 'Apartas',
  x_05cee7de: 'Imprimir etiquetas de precio',
  x_6441bd25: 'Refrescante...',
  x_498519d1: 'Actualizar datos',
  x_066ae8d7: 'detrás del escenario',
  x_b9431793: 'Cambiar usuario',
  x_c3992269: 'Salir',
  x_f98a4911: 'Early Cash Drop',
  x_953a783e: 'Modo sin conexión: los pedidos se pueden realizar normalmente y los pedidos se sincronizarán automáticamente una vez que se restablezca la red.',
  x_4080c16f: 'Sin conexión y sin datos almacenados en caché: conéctese primero a Internet para cargar datos',
  x_8bcfc934: 'Los datos almacenados en caché tienen más de 24 horas, es posible que se hayan actualizado los precios y el stock. Se actualizará automáticamente después de que se restablezca la red.',
  x_a75ed77e: 'Si los datos almacenados en caché superan 1 hora, se recomienda conectarse a Internet para actualizar.',
  x_333142e1: 'Escriba para buscar / Ingrese para buscar más...',
  x_7ffacc1a: '🎂 Cumpleaños Cumpleaños',
  x_787b5677: 'género',
  x_6a0ee6bd: 'Utilice el modo de impresión quiosco de Chrome para imprimir silenciosamente en la impresora predeterminada (XP-80C) sin necesidad de configuración adicional',
  x_8dc32ae4: 'Efectivo',
  x_14add33c: 'Tarjeta',
  x_a474b44e: 'Transfer',
  x_80263dad: 'Mixto',
  x_7f3933e2: 'Credito',
  x_86aa4552: 'Consulta de pedido/reimpresión de factura',
  x_36bcb2a1: 'Buscar número de pedido...',
  x_0cc05f42: 'de',
  x_d716f1e8: 'llegar',
  x_83958d46: ' pedidos',
  x_85ab5250: 'Sin orden',
  x_9109ea1e: 'agregar pago',
  x_16a3cf1d: 'Cambiar pago',
  x_d8b294d0: 'imprimir factura',
  x_15a6696e: 'billete pequeño de 80 mm',
  x_62d36990: 'añadir al carrito',
  x_e90b99bd: 'Early Drop',
  x_6cbe5ffa: 'USD (Dólar estadounidense)',
  x_7559edad: 'Enter amount',
  x_06508433: 'Manager PIN required',
  x_731c658b: 'Void this drop?',
  x_dcc961ae: 'anulado',
  x_267fa274: 'Seleccionar administrador',
  x_3700ec74: '4-8 dígitos',
  x_e20efdec: 'Ejemplo: el cajón está demasiado lleno',
  x_e39ec276: 'Confirm Drop',
  x_563e10ba: 'Void',
  x_43c80a9b: 'Entregue con anticipación la gran cantidad de efectivo que hay en el cajón al gerente. El sistema lo deducirá automáticamente al final del turno y simplemente contará el efectivo restante.',
  x_2ed7e4e2: 'Currency',
  x_ae59a48e: 'Manager',
  x_a87ce55a: 'Manager PIN',
  x_3a14c9f8: 'Notas / Notas (opcional)',
  x_b72845a8: 'Aún no hay registro de entrada',
  x_db16fe15: '✅ Completo',
  x_de040917: '⚠️ Confiscado',
  x_56673f3a: 'Error',
  x_f15ea525: 'Buscar número de pedido/cliente/número de teléfono',
  x_712939e0: 'La cantidad debe ser mayor que 0',
  x_e1308cbe: '✅ Pago recibido exitosamente',
  x_1d5381c2: 'Cancelado, el inventario se ha revertido',
  x_a29d3fab: 'Motivo',
  x_92b67f7b: 'Devolución del depósito al cliente',
  x_4c2db86d: 'El depósito va al comerciante.',
  x_0aa2fd58: 'Activas',
  x_80e42329: 'Completadas',
  x_f3f6aad1: 'Canceladas',
  x_9f5fa600: 'Forfeit',
  x_7cf73f3d: 'Todas',
  x_4865eb9a: 'no aparte',
  x_76898534: 'equilibrio',
  x_d941a5be: '⚠️ Caducado',
  x_3a291eca: 'Cobrar',
  x_0959981b: '✅ Borrado',
  x_353048bb: 'Se puede enviar a los clientes.',
  x_e91d829e: 'La cancelación de pedidos requiere permisos de administrador',
  x_e8606af7: 'Confirmar cancelación',
  x_d2dbc37e: 'no cancelar',
  x_de1ec1b5: 'Dividir entre / dividir en partes iguales',
  x_32cd3100: 'Error al cambiar la tabla',
  x_26e78ec2: 'No se pudo unir a la mesa',
  x_ae1573f2: 'Liberación fallida',
  x_be163dfd: 'Cambiar mesa',
  x_010a57e3: 'Transferir la cuenta de esta mesa a otra mesa vacía',
  x_f4b63ba2: 'Combinar cuentas',
  x_57c68729: 'Fusionar las cuentas de otra tabla con esta tabla',
  x_dee2caa5: 'Liberar mesa',
  x_145ac83c: 'Sin liquidación, solo se liberan los asientos de la mesa (escenario de conciliación manual)',
  x_5a43d675: 'Selecciona mesa libre:',
  x_88f3038b: 'WhatsApp será enviado a',
  x_b787eaf7: 'El número es demasiado corto, al menos 8 dígitos',
  x_1a5e2d7a: 'one-click)',
  x_a62f3804: 'USDT (TRC20) · Tron · Tarifa de gestión ≈$1 ⭐',
  x_e9868cc5: 'Copiado ✓',
  x_48eb1f6c: 'Fastest)',
  x_50a13126: 'Tap to chat with pre-filled message',
  x_067ff847: 'Payment Methods',
  x_57c296c9: 'Payment instructions',
  x_422c8df2: 'facturación',
  x_96575b5a: 'singular',
  x_2ab9e7e1: 'Efectivo sin receta',
  x_9627644f: 'Regresar',
  x_598fb8ab: 'Método de pago',
  x_5d5de3a9: '¿Qué se vendió?',
  x_9902bd0f: 'Buscar nombre del producto...',
  x_729c413f: 'bienes',
  x_f965fea3: 'veces',
  x_b68919a3: 'turno',
  x_6f862984: 'Dinero para empezar una clase.',
  x_3788667e: 'recibos en efectivo',
  x_8fbe97e2: 'quitar',
  x_769b69c5: 'debería ahora',
  x_27e303bd: 'No hay clases abiertas (no hay datos de efectivo en el mostrador)',
  x_3e586351: 'No hay registro del día.',
  x_244b0c8f: 'orden original',
  x_ea9fedcb: 'ingreso bruto',
  x_211d2fdf: 'Cámara no disponible:',
  x_2637e51a: 'Error al iniciar cámara',
  x_2cbd6249: 'Código no está en bases públicas — fill manualmente',
  x_3016cebc: 'Búsqueda falló',
  x_2a3e7f5c: 'manuales',
  x_092a15aa: 'Ingrese el código (EAN-13, UPC...)',
  x_9ebf3950: 'Usar y crear',
  x_82cafd5c: 'Continuar con código',
  x_c0079539: 'Buscando...',
  x_eba9d01c: 'Código no encontrado',
  x_913fcd49: 'Sin cambios',
  x_9216d1be: 'Tallas',
  x_bbbbab6e: 'Colores',
  x_f297d54c: 'Paso 2: Ingresar inventario por línea → Guardar',
  x_2f88548e: 'Tamaño\\Color',
  x_3e616117: 'Ingresa tu teléfono / Por favor introduce tu número de móvil registrado',
  x_925ff2fa: 'Ingresa el código / Por favor ingresa el código de verificación',
  x_798b1cb7: 'Contraseña mínimo 6 caracteres / La contraseña debe tener al menos 6 caracteres',
  x_8052ef2a: 'Las contraseñas no coinciden / Dos contraseñas son inconsistentes',
  x_8049f1c7: 'Enviar codigo / Enviar código de verificación',
  x_9d936c0f: 'Restablecer / Restablecer Contraseña',
  x_a850638e: 'Se enviará un código de verificación al WhatsApp registrado de la tienda.',
  x_6c546734: 'Teléfono registrado / Registrar número de móvil',
  x_b3382444: 'Código / código de verificación',
  x_a25bd352: 'Nueva contraseña / Nueva contraseña',
  x_134cc560: 'Repetir la contraseña / perder de nuevo',
  x_72138076: '¡Contraseña restablecida! / Restablecer contraseña',
  x_35973a26: 'Tienda / ID de tienda:',
  x_0c58a4d9: 'Usuario / Nombre de usuario:',
  x_871b1e0c: 'Nueva versión lista',
  x_77dbaf27: 'Actualizando...',
  x_edf4de14: 'official)',
  x_c9dc4ffd: 'Compatibilidad con el sistema heredado Firefox ESR',
  x_39400df4: '🌍 Mapa global de inquilinos',
  x_ef8318a7: '💰 Descripción general de pagos criptográficos',
  x_09636666: '🔔 Recordatorio de renovación (IA)',
  x_542ce2f8: 'Trial Signups',
  x_408009cf: 'Intl Pay',
  x_5910639f: '📦 Número de lote/lote (FIFO)',
  x_b1381d19: '🎯 Agrupación RFM + envío masivo',
  x_559dca3c: '🏆 Detalles del desempeño de los empleados',
  x_6e1ce46a: 'manual de la impresora',
  x_03a9825e: '¡Hola jefe! Soy tu asistente comercial de IA. Puedes preguntarme "¿A cuánto asciende la ganancia hoy?", "El producto más vendido", "Inventario insuficiente", "Quién me debe dinero", etc.',
  x_b26b0699: 'El servicio de IA no está disponible temporalmente',
  x_0a0092b7: 'Los 5 productos con mayor recaudación',
  x_b23a6752: '¿Qué acciones están agotadas?',
  x_19a63387: '¿Quién me debe más dinero?',
  x_9445221f: 'Asistente de negocios de IA',
  x_a6f1ba27: 'Haz una pregunta...',
  x_20448d20: 'GPT-5.2 · Consultar datos en tiempo real',
  x_943201f9: 'subir/subir',
  x_caecf5b4: 'caer / caer',
  x_f345932a: 'Dismiss',
  x_1c4d65a8: 'FX Alert',
  x_2a9db7a6: '✓ Cuenta de jefe de WhatsApp empujada',
  x_b2a5c20e: '⚪ WhatsApp no está activado (configure el número del jefe en la configuración de FX)',
  x_4f100f54: 'Hola Sellox! Estoy interesado en tu POS.',
  x_0cbf83cc: 'Contáctenos',
  x_e9e8054f: 'correo',
  x_73325cad: 'lleno',
  x_41f5f6ef: 'menos',
  x_8be34d50: 'comprar',
  x_040f3943: 'enviar',
  x_9aacc1c5: 'oferta especial',
  x_3fcde29c: 'No se pudo cargar el comprobante de pago:',
  x_bf7669aa: '. Intente utilizar una captura de pantalla más clara.',
  x_b4c3bd30: 'Sin imagen',
  x_3cf48c32: 'imágenes existentes (se pueden reemplazar) / Con imagen',
  x_f653eca8: 'La cámara no está disponible (',
  x_90b6a7dd: '), volver al álbum de fotos',
  x_52983340: 'Tiendas · Empleados ilimitados',
  x_a40aedb7: '✅ Enviado',
  x_791333be: 'WhatsApp',
  x_3083efed: 'Asegúrese de que el cliente',
  x_97bbb919: '"¿Mover a la papelera de reciclaje?" \\nLas cuentas y el historial no se perderán y se pueden restaurar en cualquier momento.',
  x_8d6e3b74: 'Movido a la basura',
  x_b70e8e43: 'Restaurado',
  x_3580b741: 'Reactivado',
  x_4a561e6f: 'caracteres (la firma ha sido probada y aprobada)',
  x_f30d10af: 'caja x',
  x_cdf08038: 'asegúrese de',
  x_a24c6f3f: '¿Marcar todas las publicaciones como publicadas?',
  x_5c51c3b8: 'Exportado',
  x_c0a515b2: 'clientes / Exportados',
  x_2d4c5dcc: 'Creado',
  x_6c0b9fed: 'Inventario mínimo de artículos.',
  x_ddfcb2be: 'Fijo',
  x_b1418bb8: 'Inventario negativo de bienes.',
  x_fe4c8813: '\\n...También',
  x_930882bb: 'un',
  x_8cfef109: 'compartir',
  x_896a955f: 'Artículos sin precio de coste:\\n\\n',
  x_6b73316d: '\\n\\n¿Confirmar para eliminar todo? ¡Esta operación es irreversible!',
  x_5cc23262: 'Eliminado',
  x_db0a9f72: 'bienes sin precio de costo',
  x_a2aaa24e: 'Aplicarlos todos (',
  x_fc4d75f6: 'descubrir',
  x_1e2b2923: 'productos a la deriva, total',
  x_e86ee821: 'unidad. ¿Reparar inmediatamente?',
  x_992bce69: 'productos (',
  x_e2f9c4d8: 'unidad)',
  x_e213f3ac: '✅ ¡Enviado! identificación:',
  x_30fae0dd: '✅ Habilitado: recordatorio automático a las 9:30 a. m. todos los días (mismo cliente',
  x_ed0dbd12: 'No se repite a los pocos días)',
  x_04501e0e: '✅ Guardado: número mínimo de mismos clientes',
  x_99c19d88: 'El genio te lo recordará de nuevo.',
  x_11c0bdd6: 'Dar "',
  x_04b02a3b: '》Establecer nuevo ID de inicio de sesión\\nActual:',
  x_951c3597: '\\n(4-20 dígitos, letras/números/guiones/subrayados)',
  x_ec9f4837: 'Confirmar',
  x_eb7706ac: 'Cambiar a',
  x_61bbc1d1: '?\\n⚠️ Todos los empleados de este comerciante deben iniciar sesión nuevamente con nuevos ID y el enlace de la tienda en línea también se convertirá en /shop/',
  x_f0bb4cec: 'El límite de la tienda se ha establecido en',
  x_a6cdd2a0: 'casa',
  x_4a368d87: 'Confirmar eliminación',
  x_f8789f6e: '¿Registros de inventario?',
  x_4d8a497e: 'Aceptar para borrar',
  x_52f6f1b8: 'de todo el inventario? ¡Esta operación es irreversible!',
  x_61682ed3: 'Confirmar nuevamente: borrar',
  x_9a5e3bc8: '¿Todos los registros de inventario?',
  x_3683077f: 'Borrado',
  x_4deb231b: 'registros de inventario',
  x_d5d53fcf: 'Asegúrese de copiar todo el inventario del almacén principal a',
  x_1b3f235d: 'Ya desde',
  x_06363f80: 'llegan los artículos',
  x_dd78ca49: '✅ ¡Recarga exitosa! +',
  x_19e9aae9: 'Se ha activado la advertencia de prueba:',
  x_adfefb8e: 'Cambiar a "',
  x_0258b3da: '”? \\nLas categorías correspondientes se crearán automáticamente (las existentes no se repetirán). Puedes volver a cambiar en cualquier momento.',
  x_6341a6f1: 'mesa',
  x_2cf87b31: '✅ Cambiado - Nuevo',
  x_2cd6fde3: 'categorias',
  x_f64a9820: '· Completado',
  x_8983c664: 'riesgo de ingresos',
  x_b8f4e941: 'Informe de conciliación',
  x_822ac472: 'Emparejado (',
  x_268173c2: 'No hay validación coincidente (',
  x_172d9095: 'Ventas inigualables (',
  x_d03e7311: '✅ Procesado: Nuevo',
  x_11e6be8e: '· Asociación',
  x_b06b30ab: '·Asociado',
  x_1b16b10a: '· Falta el número de teléfono móvil',
  x_26b59f52: 'pagar',
  x_fddfa6c6: 'Reconocimiento de IA completado:',
  x_6def8122: 'Ya en stock:',
  x_2ef72bb3: 'Artículo/orden de compra',
  x_97695dd1: 'hace s',
  x_be72b0b9: 'subidas correctamente / Uploaded',
  x_b0ef9048: 'descartar',
  x_24406e3e: '¿La operación fue rechazada por el servidor?\\n\\n',
  x_8d893e60: '⚠️ Estas operaciones no tienen efecto en el servidor. Confirme si necesita volver a operar antes de descartarlo)',
  x_61cef91b: 'eliminados / cleared',
  x_9fb4dafd: 'bolígrafo',
  x_5526ee20: 'Cuenta de crédito sin dueño, total',
  x_13743a01: 'Determinar inmediatamente hasta hoy.',
  x_1eca306b: '¿Enviar bendiciones por WhatsApp a un cumpleañero?',
  x_939d7902: '…etc.',
  x_2b689f7b: 'Modificado',
  x_0a66a2c4: 'Vista previa: disponible hoy',
  x_27e4f2f4: 'cumpleaños del cliente',
  x_bff5e1f3: 'Enviado:',
  x_8e141b21: '· Fracaso:',
  x_2517df74: '· Saltar:',
  x_9127c4b7: 'Vista previa: será enviada a',
  x_e61704c3: 'clientes (excluyendo',
  x_e1967cf6: 'planeado en',
  x_ed33b3f4: 'enviartr(',
  x_00c0b64d: ')? ¿Confirmar?',
  x_05235460: 'Programado:',
  x_bab46d2e: 'enviará tr(',
  x_6912b561: ') mensaje, confirmación?',
  x_f43d612e: 'Envío por lotes completado:',
  x_8891f2c6: 'Éxito ·',
  x_c3342602: 'Fracaso ·',
  x_17fbc240: 'reina del cielo',
  x_d5b805a6: 'diva ·',
  x_3b8c1c81: 'Plantilla completa:',
  x_e46f5031: '% / Subiendo',
  x_1f06712c: 'rechazadas — revisar / Rechazado, necesita ser procesado',
  x_35b7c240: 'Tu suscripción también tiene',
  x_aa277e9b: 'Cuando expire el período, renueve a tiempo para evitar la interrupción del uso.',
  x_7dc5867e: 'Queda la prueba gratuita',
  x_1d74fc6c: 'Días. Renueva para seguir usando todas las funciones.',
  x_613c2e78: '⚠️ Descubre',
  x_81764eb3: 'Hay una gran diferencia entre los artículos, verifique antes de cerrar la clase.',
  x_86103e41: '⚠ Descubre',
  x_473bed24: 'pequeñas diferencias',
  x_3aa832e9: 'Ordene a través de la tienda en línea #',
  x_1cda5086: 'Orden de mesa pendiente',
  x_1b95ed0e: 'depósito',
  x_641e1071: '≥ mínimo',
  x_1c73433c: 'más bajo',
  x_1ecba8c2: '🏷️ Crear Aparta (firmado)',
  x_793d5c95: '🏷️ Crear Aparta',
  x_4ffc9e7c: '✅ Ya en la bolsa',
  x_ced2e82c: '⬆️ Subir',
  x_2180077a: 'Soltero / Subir',
  x_b6f69d33: 'Soltero para pasar · pecado rojo',
  x_0e6f5c6c: 'cuentas fusionadas en',
  x_d8817d65: '🤝 Fusión completada ·',
  x_dce1d1f6: 'Artículo ·',
  x_09e8990d: 'Confirmar cierre forzado',
  x_7e05053e: '? Esta orden pendiente no se liquidará automáticamente. / ¿Liberar la mesa sin cobrar?',
  x_7f673278: 'liberado',
  x_050ed17c: '✅ Encontrado / Encontrado:',
  x_3bdece77: '✅ Generar',
  x_7a656cfc: 'variantes',
  x_271f3942: 'inventario de línea',
  x_c53f6031: 'Aceptar · Fallar',
  x_2d5aef4f: 'OK',
  x_b491196a: 'Fallo de la interfaz de usuario:',
  x_296304f1: 'hoy',
  x_d8886c56: 'Cumpleaños de clientes: envíe deseos grupales con un clic',
  x_e292789d: 'Estado / Estado',
  x_6165a875: 'Bloqueado a:',
  x_ba1267f0: 'Última actualización/Última actualización:',
  x_65d9f49b: 'Mensaje a enviar (',
  x_764665c3: 'todos (',
  x_028a9628: 'Crear "',
  x_a0f73e03: 'Modificar clasificación —',
  x_fa5bee02: '⚠️ Excluido:',
  x_dce0ab9f: '— No se emitirán puntos por pedidos realizados con estos métodos de pago.',
  x_27651c15: 'venta de 30 días',
  x_1b3ba792: 'Stock mínimo:',
  x_04d8e11a: '(Actualmente:',
  x_efa4cb5c: 'personas/promedio diario',
  x_6f7909ea: 'Enviar automáticamente recibos de WhatsApp',
  x_0141c048: 'Reclamación automática (debido a WhatsApp)',
  x_041a7a49: 'Días: después de que se haya instado al cliente, incluso si aún no ha pagado, todavía tiene que esperar.',
  x_72f50f4b: '🤖 WhatsApp garantiza pagos automáticamente',
  x_4c0d90b0: 'Actualmente wa-web está ocupado por otros inquilinos (',
  x_5250451c: 'Sellox ya está disponible a través de tu WhatsApp (',
  x_24d49a39: 'Solo se envía una vez al día',
  x_97f6b93d: ') — Un servidor solo puede ser habilitado por un inquilino al mismo tiempo',
  x_4d4bb206: ') Enviar mensajes automáticamente a cualquier cliente.',
  x_6dcb77fd: 'Límite de tienda',
  x_2fd10482: 'Inventarios pendientes de aprobación / Inventario pendiente de aprobación (',
  x_49f610ec: 'No hay precio de coste establecido para este producto.',
  x_22261f15: 'Guardar configuración / Guardar',
  x_b45c0413: 'Enviar alerta de prueba / Enviar prueba',
  x_4d2afcd3: 'Completado (últimas 2h)',
  x_e0385134: 'Por producir ·',
  x_d7104c13: 'En producción ·',
  x_c02e8b6b: '💡 Se mostrará el botón Comprar en la página de inicio: Servicio al cliente de WhatsApp',
  x_889e1514: '· Otros',
  x_6f2e8e74: 'Industria actual:',
  x_26f914e7: 'Hora establecida:',
  x_9657acc8: '💡 Ejemplo: El cliente pide $20 → Agrega $ automáticamente',
  x_dc0ccfb0: 'Tarifa de servicio → Total $',
  x_6690b55c: '⏳ Revisión pendiente (',
  x_a6b994c5: '✓ Certificado (',
  x_0a4b9139: 'Desactivados (',
  x_c7c68337: 'Envía este enlace a los repartidores que quieras reclutar →',
  x_bb5bb60d: 'Guardar configuración',
  x_81cf7805: 'Lista de inquilinos (',
  x_a2b4e1d9: 'Borrador de recordatorio de renovación de IA',
  x_b6733812: '· País',
  x_e852c9a4: 'tienda',
  x_a2cf4af4: '· Teléfono',
  x_4b2603c3: 'Nombre de la aplicación Complete un nombre aleatorio (por ejemplo:',
  x_bccb0533: 'Resumen de turno (',
  x_80a13d4d: 'Transferencia:',
  x_f576986b: 'Iniciar reconciliación',
  x_ad131c12: 'Bolígrafo$',
  x_54213898: 'detalles (',
  x_4209a9ba: '1 pipa = $',
  x_7a2c820b: '(Copia el de arriba',
  x_184b4831: '4. Confirmar el envío → 1-2 minutos de créditos AI automáticamente +',
  x_8b2a4731: 'Orden:',
  x_0b463505: 'USD · La función AI se suspenderá cuando el saldo sea insuficiente · Contacte al administrador de la plataforma para recargar',
  x_be11172d: 'comerciantes de prueba',
  x_8ae8f95e: 'La tarifa anual es válida hasta:',
  x_d3d43df8: 'Esperando que llegue el USDT',
  x_30c0ee04: 'Tarifa de renovación anual USDT $',
  x_1a810c50: 'Versión de la tienda',
  x_f8f63ea1: '(Vendido por $',
  x_ea6914b3: '/Ingresar$',
  x_8f3599b6: 'confianza',
  x_02456a77: 'Código de barras:',
  x_b4fdcd01: 'Actualizar precio de coste (original',
  x_a3f28012: 'Precio de venta sugerido (+',
  x_8375f775: 'Caja ×',
  x_2c0e9a33: 'Encolado / Únete al equipo:',
  x_b8bfc6ea: 'Cambios pendientes de subir / Items to be uploaded',
  x_f15ef0a0: 'Bolígrafo·El cliente paga en dólares americanos',
  x_fadfbb89: 'Pluma · ≈',
  x_8e52492c: 'Enviar con un clic',
  x_777ba9db: 'artículos',
  x_60c22af0: 'Plantilla de mensaje (admite variables',
  x_2aabd245: 'Vista previa de resultados:',
  x_32e0b823: 'Cumpleaños en los próximos 30 días (',
  x_4e1abb5c: 'Contenido del mensaje (admite',
  x_122c804a: 'Plan para ser enviado (',
  x_d0176d3e: 'Enviar registros (casi 50 artículos · total',
  x_f2b7c51d: 'Listo para ir',
  x_fb9b45b1: '· Cupones',
  x_8e9b7f87: 'fiesta',
  x_4ca669c7: 'Enviado ·',
  x_7100dc7a: 'Saltar ·',
  x_ff8318c2: '⚡ ASIGNADO A TI',
  x_f1f28de8: 'Iniciar sesión',
  x_ed2d1a22: 'Enviar registro',
  x_618ab9b1: ' s para confirmar',
  x_49074539: 'Salario semanal estimado: $',
  x_9013fa6e: 'Orden #',
  x_1b3e5894: 'repartidor',
  x_d7d4b3fc: 'Enviando',
  x_875225ef: '— Selecciona especificación / Selecciona talla y color',
  x_8dcf5483: '📤 Enviado al gerente / Entregas anticipadas (',
  x_69a49f6a: '📩 Pedidos nuevos de la tienda online (',
  x_532e7e2f: 'Artículo · #',
  x_f38a0357: 'Los clientes de medicamentos recetados se han registrado:',
  x_2105a088: 'Caduca después de días',
  x_f77c9383: 'Más...',
  x_56f0d339: 'Fecha de caducidad ≈',
  x_4727e7e1: 'dólares estadounidenses',
  x_4b8b23a7: 'dentro de unos días',
  x_100bd194: 'artículos ·',
  x_56ec6c2c: '% Depósito Mínimo = $',
  x_338f8935: 'Inventario:',
  x_dd8e89b9: 'Más productos... Ingrese palabras clave para buscar',
  x_698818eb: 'Para sincronizar:',
  x_2751b59b: 'Monto / Monto (',
  x_423485d6: '📜 Este vuelo ha sido embolsado (',
  x_9fb8b1b7: '🏷️ Aparta / Gestión de Retención —',
  x_f9659c1d: 'yo $',
  x_e7feb554: '💯 Cobrar saldo $',
  x_d127a089: 'Seleccione la tabla que se fusionará (la cuenta de esta tabla se fusionará en',
  x_d0846a09: '✓ en',
  x_1e68d525: 'Consulta/Buscar',
  x_d7b1fd5f: 'encontrado',
  x_5f6ef156: 'Generar combinación / Generar',
  x_29953c6f: 'ser salvo',
  x_50918dbc: 'variaciones ·',
  x_fc461ac5: 'guardar inventario (',
  x_e468fa4f: '⚠️ Tu navegador está desactualizado —',
  x_9ba1a642: '(umbral',
  x_f876a49c: '% · Se recomienda consultar el precio de venta del producto)',
  x_795eaf50: '🖨️ Imprimir',
  x_8059771f: 'Sin imagen',
  x_cec3f014: 'Reemplazar',
  x_532c8856: 'Tomar foto',
  x_207eb32c: 'Desde galería',
  x_2425155d: '💡 Coloque el producto sobre una superficie brillante, el frente será el más claro',
  x_9cf1afed: 'Enfocando, manténgase estable durante ~1 segundo',
  x_77abc2a1: '👇 Elige cuál conservar',
  x_2d86ed95: 'Usar original',
  x_82fc4841: 'Iniciando cámara...',
  x_8df3213a: 'Usar la versión AI',
  x_781f0d75: 'Retake',
  x_dd740dc5: 'Los dos copropietarios reciben las cuentas por igual. AI envía automáticamente informes de ventas detallados a los dos jefes a través de WhatsApp de forma diaria o mensual.',
  x_2eb1e982: '📅Diario',
  x_d5ac2190: '📆Mensual Mensual',
  x_b5c8b0a2: 'Profesional',
  x_3706b4d0: 'Amigable',
  x_e366ccf1: 'ajustes',
  x_0a9c8842: 'Preview',
  x_c7db6d4f: 'Reactivar',
  rider_reset_pw: 'Restablecer contraseña',
  rider_navigate_btn: 'Navegar',
  rider_navigate_addr: 'Por dirección',
  rider_forgot_hint: '¿Olvidaste tu contraseña? Pídele al dueño de la tienda que la restablezca en Repartidores',
  x_5fb1fd09: 'QR Poster',
  x_aba55e6b: 'Enlace de escaneo:',
  x_6f7fff38: 'Descargar PNG',
  x_bc96a998: 'Configuration',
  x_4fc91b55: 'Escanea y compra fácilmente',
  x_c154a693: 'Manual de Impresoras',
  x_6b78e860: 'Instalar QZ Tray',
  x_75688f20: 'Configurar Impresoras',
  x_12ee3d19: 'Flujo de Impresion',
  x_90167330: 'Preguntas Frecuentes',
  x_433baf5e: 'Descargar',
  x_27db0784: 'Descargar Certificado',
  x_5482983f: '🔥 Activo durante 30 días',
  x_01b2a86b: '🎂 El cumpleaños de hoy',
  x_6810ae91: '📱 Exportar lista de clientes CSV → Importar',
  x_59556b40: 'Mark All Sent',
  x_1535fcfa: 'enviar',
  x_b1731af3: 'Export CSV para WhatsApp Business',
  x_58f4fc4b: 'APLICACIÓN → Crear lista de transmisión (256 personas a la vez) → Promoción masiva/cumpleaños',
  x_28cfe557: 'Reservado por ahora',
  x_23532881: 'nueva mercancia',
  x_ed3046c5: 'Crear y agregar a la orden de compra',
  x_71e9bba3: 'Eliminar (eliminar permanentemente)',
  x_846e5470: 'Oculto (registros de retención de archivos)',
  x_a9818765: 'Métodos sin puntos',
  x_e1d9e1d6: 'Biopago.',
  x_00155faf: 'Generar mi código de referencia',
  x_040f51a6: 'copiar código',
  x_879058ce: 'Copiar enlace',
  x_db07affa: 'Restablecimiento del inventario negativo a cero',
  x_8f9b2023: 'Eliminar artículos sin precio de coste',
  x_07c8a48c: 'Conexión de autoservicio de WhatsApp (envío gratuito/ilimitado)',
  x_ed2be317: 'Escanee el código QR una vez para montar permanentemente su cuenta de WhatsApp en el sistema Sellox. Envíe mensajes automáticos a todos los clientes/empleados sin unirse.',
  x_8277b145: 'Después de encenderlo, si el cliente tiene un número de teléfono móvil + se ha suscrito a las notificaciones de WhatsApp durante el pago,',
  x_301c285f: 'Los cajeros ya no necesitan hacer clic manualmente en wa.me.',
  x_4fa7c9cc: 'Evite acosar a la misma persona todos los días.',
  x_fdbb8738: '⚙️Rango 1-60 días. Recomendación: 3 días para grupos reducidos de clientes, 7 días para clientes normales, 14-30 días para clientes grandes.',
  x_bbe42801: '🔒 Cada captura de pantalla deducirá 1 vale de IA de forma independiente; el envío repetido de la misma imagen en un plazo de 5 minutos se ignorará automáticamente.',
  x_9eba1d0b: 'El código QR se actualiza automáticamente cada 25 segundos; no te preocupes por no poder escanearlo.',
  x_a3ac5646: 'Montado:',
  x_5319c74b: 'será en 30 segundos',
  x_78623eae: 'todos los dias',
  x_b036b784: 'mismo cliente',
  x_2ee44035: '💡 Por ejemplo, supongamos',
  x_ef49a64e: 'El cliente tomó una captura de pantalla de la transferencia.',
  x_676ea371: 'También responderá automáticamente al cliente "✅ Pago confirmado / pedido confirmado".',
  x_69893eef: '💡 En este caso, cuando no se puede encontrar el pedido coincidente exacto después del reconocimiento de IA, el comprobante se registrará en la lista de "Verificación de pago" de la tienda para que el empleado lo procese manualmente.',
  x_1b037636: 'Conexión',
  x_771d235b: '🎂Marketing de festivales/cumpleaños',
  x_75c856b1: 'Cerrar sesión',
  x_2abe9e2c: 'Enlace de recibo electrónico —',
  x_2b9efa91: 'Actualmente cerrado: el efecto entrará en vigor inmediatamente después de activarse',
  x_acabef73: 'Escanee automáticamente todos los registros de crédito - Dar',
  x_e30c7cd7: 'de los clientes envían recordatorios por WhatsApp.',
  x_5a445658: ', no te molestará repetidamente. También disponible en',
  x_95de8c70: '"Reclamación manual con un solo clic en la página.',
  x_8ee2848b: ', AI identifica automáticamente el número/importe de referencia,',
  x_53eb1951: 'Pedidos pendientes en las últimas 48 horas y marcados como pagados,',
  x_01276a67: 'Industria',
  x_60624b98: 'Limpiar el inventario huérfano',
  x_1c74acdb: 'Registros de inventario completos',
  x_01702b13: 'Borrar todos los pedidos (peligrosos)',
  x_fcc3d39a: 'Reparación automática',
  x_be0ade04: 'Índice de reconstrucción',
  x_fd76118e: 'Exportar copia de seguridad de datos',
  x_aac9e1d1: 'AI Credits Top-up',
  x_a8fc5824: 'Establezca el precio de coste en la gestión de productos y vuelva a comprobarlo.',
  x_67c6118c: 'BCV',
  x_a2084b07: 'Threshold',
  x_66bfebe7: 'Boss Phone',
  x_c0d5d68f: 'ignorar',
  x_e38cac91: 'Reabrir',
  x_842010db: 'F11',
  x_a24983d8: '📞WhatsApp de Atención al Cliente (requerido)',
  x_48912e07: '🪙 USDT (moneda estable, aceptada globalmente)',
  x_1d7f3562: '🧩 Otros métodos de pago (Wise/Zelle/Binance Pay...)',
  x_bad080e4: '📍 Después de cambiar a la tienda de ropa, puedes completar las variantes de talla/color en la página de edición del producto.',
  x_7f9f889d: 'Cuando está activado, el cajero del POS del restaurante **automáticamente** agregará una tarifa de servicio del X% después del subtotal al momento de pagar.',
  x_9dad4122: 'El cajero puede cancelar una sola transacción. El recibo del cliente también mostrará esta línea.',
  x_47bd55cf: 'Si ya tiene categorías de productos, se recomienda utilizar "',
  x_7b6d74a4: '📍 Después de cambiar al restaurante, aparecerá "🍽️ Gestión de mesa" en el menú de la izquierda.',
  x_78841a5c: 'Cambiar de industria** solo agrega categorías** y no eliminará sus productos/categorías existentes.',
  x_6c525ddf: '”Y luego use solo las funciones que necesita (como mesas de restaurante).',
  x_8d63ef38: 'Suspender',
  x_e7c3bc5c: 'El repartidor ingresa el código de la tienda al registrarse: ',
  x_7037508b: '💡 Reglas de clasificación:',
  x_23c1f399: 'Aprobar',
  x_7173f809: 'Rechazar',
  x_a5978c43: '(o su ID de inquilino), verá "revisión pendiente" en esta página y él podrá aceptar el pedido después de aprobarlo.',
  x_70f983d4: 'Usar ubicación actual (haga clic aquí en la tienda)',
  x_13e8fee8: '· Cuanto más cerca + más libre, se da prioridad ·',
  x_929fc89b: 'Estilo de mensaje de IA:',
  x_144db44b: 'recordatorio de IA',
  x_9d6f026a: '📖 ¿Primera vez que lo usas? Haga clic aquí para ver el tutorial de configuración completo',
  x_7bd0aecf: 'Costo: ~$0.01/artículo (Meta Cloud API, ventana de servicio de más de 24 horas)',
  x_9fe61acb: 'Después del cierre, el empleado aún puede hacer clic manualmente en el botón [WhatsApp] para enviar en la ventana emergente "Pedido completado".',
  x_1dcf3bf4: 'Copie los siguientes dos valores en la página Webhook de Meta (menú de la izquierda',
  x_a4e7978d: 'Condiciones: ① El jefe comprueba este interruptor ② WhatsApp ha sido configurado y habilitado ③ El cliente ha creado un perfil + tiene un número de teléfono móvil ④',
  x_defd4e63: '→ Verifique tres permisos:',
  x_31aadde4: 'Rellena la tarjeta:',
  x_922a7731: 'respuesta automática',
  x_85849d21: 'Recibo automático',
  x_83413c5e: '— Simplemente compruébalo cuando vayas a Gestión de clientes/Crear un nuevo cliente.',
  x_88b8d068: 'Imprimir informe',
  x_88ae41b0: 'Inventario por talla & color',
  x_1af9ab5b: '🔗 Conecte archivos de clientes con un clic',
  x_0563df42: 'Recargar con USDT (TRC-20)',
  x_6ae048ae: 'Cancel',
  x_6503c16e: 'Admite USDT TRC-20 (tarifa de manejo muy baja) · Acreditado automáticamente en la cuenta aproximadamente 1-2 minutos después del pago · Sin KYC',
  x_3eb35747: 'Estado:',
  x_90ef892d: 'Copy Address',
  x_4f8d48ef: 'estado de actualización',
  x_5b9fc057: 'Página de pago alternativa',
  x_c4ab90ae: 'seguimiento whatsap',
  x_f1d9634a: 'abrir WhatsApp',
  x_81930d76: 'Compra activada:',
  x_69774c73: 'Copiar dirección',
  x_84f49b2a: 'Annual Maintenance',
  x_1ecf95c4: 'Foto de Factura',
  x_075b05f1: 'Actualizar precio de venta →',
  x_1d447944: 'tomar un pedido',
  x_ae765162: 'Elige tu plan · USDT TRC-20',
  x_b610fd7a: 'Suscripción Actual',
  x_04a54e6d: '✅ Todo sincronizado',
  x_f9885395: 'tareas rechazadas por el servidor',
  x_4606c263: '— ⚠️ ¡Estas operaciones no surtieron efecto! Consulte los motivos a continuación: es necesario corregirlo, volver a operarlo y descartarlo después de confirmar que es inútil.',
  x_2395acb4: '🗑️ Descartar todas las fallidas',
  x_8dd7df98: 'Cualquier modificación que realice sin conexión (agregar productos, crédito, inventario, etc.) aparecerá automáticamente aquí y se cargará automáticamente cuando se restablezca la red.',
  x_a1ef1534: 'valor en dólares',
  x_70f80ce3: '🎂 Disponible hoy',
  x_5248ea19: '¡Un cumpleañero!',
  x_49bc061f: 'Cliente:',
  x_e6c8ab7b: 'usa esta plantilla',
  x_115028a6: 'Deseos de cumpleaños automáticos',
  x_ae8e4235: 'Vista previa hoy',
  x_bb4c3061: 'Enviar ahora hoy',
  x_f45f7f98: 'Envío masivo de días festivos/promoción',
  x_8e4d1d3b: 'Vista previa del número de personas',
  x_acac71c9: '¿No tienes cuenta? Regístrate',
  x_b7074575: '← Volver a iniciar sesión',
  x_7f8fb4ff: '⚠️ Después del registro, debes esperar a que el propietario de la tienda lo apruebe en segundo plano antes de poder comenzar a recibir pedidos. Tenga paciencia y espere unos 30 minutos.',
  x_1c88cdf2: 'Su registro ha sido recibido. Una vez que el propietario de la tienda apruebe el pedido, podrá verlo y recibirlo. Generalmente de 5 a 30 minutos, tenga paciencia.',
  x_f0d22726: '📋 Disponibles',
  x_3d0cf184: '🛵 Entregando',
  x_24eee8a8: '👤 Mis pedidos',
  x_79646591: 'No hay pedidos nuevos en este momento, espere y actualice nuevamente.',
  x_7957b16f: 'Aceptar',
  x_2f3b0a05: 'Pasar',
  x_350d4758: 'Tomar pedido',
  x_edc9f0b4: 'Sin pedidos aún',
  x_6cb26531: '📦 Ya recogí el pedido',
  x_26407f6e: 'Iniciar entrega',
  x_285135ae: '✅ Entregado, pago completado',
  x_3f53cc4a: 'Después del registro, el propietario de la tienda debe aprobarlo antes de poder aceptar pedidos.',
  x_4a566f8e: 'Navegar con Google Maps',
  x_e33fe8b5: 'Cerrar sesión',
  x_52dc2f55: 'Iniciar sesión',
  x_d839dff6: 'AI verificando...',
  x_70654539: 'Aún no eres miembro. Regístrate gratis en 1 minuto',
  x_ae1f9579: 'y empieza a acumular puntos en tu próxima compra 🎁',
  x_295a203d: 'Registro gratis',
  x_3e869d4a: 'Sin horario esta semana',
  x_c7a3ad5d: 'Cuenta al día',
  x_fa9a9ed5: '¿Olvidaste tu contraseña?',
  x_5dac1074: 'Coloca el producto sobre fondo claro · Mejor tomado sobre un fondo brillante',
  x_b2d24a53: '👇 Elige qué versión usar',
  x_ab4a66f9: 'Usar original',
  x_cd32a3bc: 'Tomar foto',
  x_d978ee93: 'Usar mejorada ✨',
  x_ad7db97f: 'Tomar otra',
  x_757bfeeb: 'Seguimiento',
  x_b01f7e91: 'Buscando el repartidor más cercano... Normalmente 1-3 minutos',
  x_f2dec5f3: 'Actualiza cada 5 seg',
  x_c1558ab2: 'Comprobante',
  x_b426bb47: '⚠️ Esta versión debe estar actualizada para seguir usándola',
  x_f26ef914: 'Descargar',
  x_4ddef578: 'Descarga directa',
  x_2905f1e3: 'Agregar',
  x_fa8d0ac2: 'Reset',
  x_cf5fddcb: '💡 puntos',
  x_4bf93975: '⋮ Pulsa prolongadamente o el pequeño icono en la esquina superior derecha:',
  x_1f15f435: 'Mesa: Transfiere el pedido de esta mesa al carrito de compras.',
  x_d432ce48: 'Mostrar $USD',
  x_910a7387: 'Mostrar Bs.',
  x_fdf6f7f6: 'nombre para mostrar',
  x_37c233bc: 'Especificaciones de la pantalla',
  x_b8da42c6: 'Código',
  x_eaeef91b: 'etiquetas',
  x_288f0c40: 'Borrar',
  x_e429696c: 'Imprimir',
  x_61a0eed9: '🏷️ Crear Aparta',
  x_bcc9eb9f: 'ℹ️ Deduzca el inventario inmediatamente después de la creación y WhatsApp enviará recibos automáticamente a los clientes',
  x_13b83977: 'Firma del Cliente',
  x_2fe011c2: 'Acuerdo de Crédito',
  x_7c82e213: 'El cliente ha leído y acepta los términos',
  x_ba00b607: 'Anticipo',
  x_4d28eb40: '🔄 Actualizar',
  x_28a2f60d: '📨 Permitir notificaciones de WhatsApp (recibos + deseos de cumpleaños)',
  x_5698e78f: 'Early Cash Drop',
  x_c052324e: 'Caducidad:',
  x_e56c9982: 'Confirmar pago',
  x_386c1cb4: 'Cancelar pedido (restaurar inventario)',
  x_e6a96594: '💡 Este es un "recibo separado" para los clientes: el pago real se liquidará según el precio total.',
  x_eb695f9f: 'Todo subido',
  x_ba769ad1: '← Volver',
  x_50d1e443: '⏳Se está abriendo el pago online. Por favor pase arriba',
  x_9747fec8: 'Después del pago, envíe la captura de pantalla al servicio de atención al cliente de WhatsApp → Active su cuenta Sellox en 30 minutos ✅',
  x_d6e0b32d: 'Póngase en contacto con el servicio de atención al cliente para completar la compra y activar la cuenta en 30 minutos.',
  x_2070ff11: 'Escanear código de barras',
  x_a9cebdd2: 'Apunte el código de barras a la cámara',
  x_0e626263: '💡 Escanee el código de barras con una pistola de códigos de barras USB → el cuadro de entrada se completará automáticamente + ingrese automáticamente',
  x_b779b5fc: 'Simplemente complete el nombre + precio manualmente. Al hacer clic en "Usar este código de barras", se completarán previamente los campos del código de barras y la IA puede ayudarlo a generar imágenes de productos.',
  x_1ee3ff57: 'Cámara',
  x_5f78052a: 'Entrada manual/pistola de código de barras',
  x_c600be33: 'Variantes Talla × Color',
  x_0c240da9: '⚠️ La generación sobrescribirá las variantes existentes (el tamaño/color se migrará automáticamente si los datos del inventario permanecen sin cambios)',
  x_443da31a: 'Paso 1: Ingrese el tamaño y el color (use comas',
  x_e0baad05: 'separados), haga clic en "Generar" para crear la combinación',
  x_fc14f592: 'Recuperar contraseña',
  x_2a86dd91: '← Cambiar número',
  x_49f38495: 'Iniciar sesión',
  x_ffcd6690: 'Es posible que algunas funciones (como el pago sin conexión, la instalación de PWA, el escáner de códigos QR, etc.) no funcionen. Se recomienda actualizar a los siguientes navegadores:',
  x_a415f6c2: 'UI Error',
  x_d470d3d3: 'La pantalla falló. ¡La venta PUEDE NO estar registrada! Pulse «Cerrar», revise en «Últimas ventas» si existe la orden y, si no, vuelva a cobrar.',
  x_8d2f4bdd: 'Dismiss',
  x_5428abef: 'Reload',
  x_f1a0be3e: 'Ver historial/establecer umbrales',
  x_fix_shop_confirm: 'Pulse el botón "Confirmar pedido" abajo',
  x_fix_bosspin_3: '3. Acciones de modificación (precio/anulación/inventario/cobro) responderán "Se requiere PIN del jefe".',
  x_fix_profit_warn: ', el cálculo de ganancia no es preciso (se muestra "?").',
  x_fix_intlpay_empty: 'Aún no agregado. Pulse "Agregar" arriba a la derecha para añadir cualquier método (Wise/Revolut/Zelle/Binance Pay/Pix/Western Union, etc.)',
  x_fix_rider_flow: 'Nuevo pedido → el sistema elige al repartidor libre más cercano → 60 s para confirmar → si no acepta pasa al siguiente → solo si todos rechazan vuelve a "asignación manual"',
  x_fix_rider_gps: 'El repartidor necesita latido GPS en los últimos 5 minutos para contar como "en línea"',
  x_fix_super_outbox: 'Al pulsar "Enviar" se agrega al Outbox y se abre WhatsApp Web/App; solo debe pulsar la flecha ➤.',
  x_fix_pin_lock: '5 intentos fallidos = bloqueo de 15 min',
  x_fix_none: '—',
  x_fix_agotado_tip: '• Si el sistema muestra "AGOTADO" pero hay existencia física → vaya a ',
  x_fix_days_remind: 'días antes de recordar de nuevo.',
  x_fix_rider_fee_example: '💡 Ej.: base $1.0 + $0.3/km, distancia 5 km → envío $1 + $0.3×5 =',
  x_fix_all: 'Todos',
  x_fix_wa_reply_tip: 'Al recibirlo, responda "reporte" en WhatsApp → la IA contestará con datos reales 🎉',
  x_fix_usdt_note: 'Acepta USDT TRC-20 (comisión mínima) · La suscripción se extiende automáticamente al confirmar · 1 mes = 30 días · Sin KYC',
  x_fix_apk_download: 'Al pulsar "Descargar" se abrirá el navegador para bajar el nuevo APK',
  x_fix_shift_prefill: '💡 Ya se rellenó el "monto esperado" del sistema. Solo modifique la línea que no coincida con el conteo real (normalmente solo efectivo).',
  x_fix_added_expected: '(agregado al "monto esperado")',
  x_fix_usb_scanner_tip: '💡 El escáner USB también usa modo "teclado"',
  x_m0: '',
  x_m1: 'Enero',
  x_m2: 'Febrero',
  x_m3: 'Marzo',
  x_m4: 'Abril',
  x_m5: 'Mayo',
  x_m6: 'Junio',
  x_m7: 'Julio',
  x_m8: 'Agosto',
  x_m9: 'Septiembre',
  x_m10: 'Octubre',
  x_m11: 'Noviembre',
  x_m12: 'Diciembre',
  x_fix_all_stores: 'Todas las tiendas',
  next: 'siguiente',
  priceEdited: 'Precio cambiado',
  noProducts: 'Producto no encontrado',
  spec: 'Especificaciones',
  cedula: 'Número de identificación Cédula',
  goToAdmin: 'Ir al Panel Admin',
  switchAccount: 'Cambiar de cuenta',
  refresh: 'Actualizar',
  addPayment: 'agregar pago',
  editPayment: 'Cambiar pago',
  transfers: 'Transferir y recibir mercancías.',
  submitting: 'Enviando...',
  marginPercent: 'margen de beneficio',
  autoCalcPrice: 'El sistema calcula automáticamente el precio.',
  taxRate: 'tasa impositiva',
  pendingTransfers: 'Orden de transferencia de mercancías a recibir',
  noTransfers: 'No hay ninguna orden de transferencia por recibir',
  saved: 'salvado',
  scheduleTemplates: 'Plantilla de turno',
  new: '+ Nuevo',
  weeklySalaryEstimate: 'estimación de salario semanal',
  morningShift: 'mañana',
  afternoonShift: 'tarde',
  off: 'hugo',
  clickToToggle: 'Haga clic en la cuadrícula para recorrerla',
  noPermission: 'Sin permiso',
  invalidPrice: 'Por favor introduce un precio válido',
  noNewKitchenItems: '✅ El pedido ha sido realizado (no hay platos nuevos, no impresos)',
  addCustomerSuccess: 'Cliente agregado exitosamente',
  quickPriceTooltip: 'Venta rápida: introduzca directamente el precio (cigarrillos/bolsas/productos a granel)',
  quickSell: 'Venta Rápida',
  quickSellHint: 'Productos sin códigos de barras: cigarrillos/bolsas/mercancías a granel, etc., ingrese el precio directamente para agregar al carrito de compras',
  priceInCurrency: 'Precio',
  itemNameOptional: 'nombre (opcional)',
  itemNamePlaceholder: 'Por ejemplo: Cigarrillo/Cigarro/Bolsa',
  barcodeNotFound: 'El código de barras no coincide con el producto.',
  creating: 'Creando...',
  reprintReport: 'Reimprimir el informe',
  customers: 'Cliente',
  equivalent: 'equivalente',
  summary: 'Resumen',
  orderDetails: 'Detalles del producto',
  deleteProductWarning: 'Nota: ¡Eliminar productos afectará a todas las sucursales!',
  confirmResequence: '¿Está seguro de que desea recodificar todos los productos ordenados por nombre? (01, 02, 03...)',
  labelPaperSize: 'papel de etiqueta',
  salary: 'Salario ($)',
  x_fix_iva_enabled: 'IVA habilitado',
  x_fix_iva_included: 'IVA incluido en precio',
  x_fix_igtf_label: 'IGTF 3% — pagos en divisas (USD)',
  x_fix_min_salary_note: 'Salario mínimo vigente según Gaceta Oficial. Se usa en el Recibo de Pago mensual (LOTTT Art. 106).',
  x_fix_404: 'Página no encontrada',
  x_fix_404_home: '← Volver al inicio',
  einv_menu: 'Factura Electrónica',
  einv_title: 'Factura Electrónica (SENIAT)',
  einv_subtitle: 'Preparación para la facturación digital — perfil fiscal, IVA y exportación',
  einv_tab_profile: 'Perfil Fiscal',
  einv_tab_invoices: 'Facturas',
  einv_tab_health: 'Diagnóstico',
  einv_tab_export: 'Exportar',
  einv_rif: 'RIF',
  einv_razon: 'Razón Social',
  einv_address: 'Dirección Fiscal',
  einv_phone: 'Teléfono',
  einv_taxpayer: 'Tipo de Contribuyente',
  einv_taxpayer_ordinario: 'Ordinario',
  einv_taxpayer_especial: 'Contribuyente Especial',
  einv_apply_iva: 'Cobrar IVA al pagar (precio sin IVA)',
  einv_apply_iva_hint: 'Al activar: el POS suma el IVA (16%/8% según cada producto) al total en el momento del cobro.',
  einv_saved: 'Perfil fiscal guardado',
  einv_not_enabled_title: 'Módulo en fase piloto',
  einv_not_enabled_desc: 'La facturación electrónica está en preparación. Contacte a Sellox para activar el piloto en su comercio.',
  einv_run_health: 'Ejecutar diagnóstico',
  einv_profile_missing: 'Datos del perfil faltantes',
  einv_orders_total: 'Facturas en el período',
  einv_orders_ready: 'Listas para e-factura',
  einv_missing_rif: 'Sin RIF/C.I. de cliente',
  einv_missing_fiscal: 'Sin número fiscal',
  einv_products_no_tax: 'Productos sin alícuota IVA',
  einv_ready_pct: 'Preparación',
  einv_invoice_no: 'Factura',
  einv_control_no: 'Nº Control',
  einv_date: 'Fecha',
  einv_customer: 'Cliente',
  einv_customer_rif: 'RIF/C.I.',
  einv_total: 'Total',
  einv_iva_col: 'IVA',
  einv_status_ready: 'Completa',
  einv_status_incomplete: 'Incompleta',
  einv_pos_rif: 'RIF / C.I. para factura (opcional)',
  einv_load: 'Cargar',
  einv_export_hint: 'Exporta las facturas del período en formato listo para SENIAT (XML / CSV / JSON).',
  einv_none: 'Sin facturas en el período',
  einv_ok_all: 'Todo listo — datos del perfil completos',
  wa_connect_mine: 'Conectar mi propio WhatsApp',
  wa_connect_started: 'Iniciando sesión — el código QR aparecerá en unos segundos…',
  wa_channel_title: 'Canal de envío',
  wa_channel_platform_title: 'Número de la plataforma Sellox (recomendado para tiendas nuevas)',
  wa_channel_platform_desc: 'Sin escanear QR — recibos y avisos salen del número oficial de Sellox con nota "no responder"',
  wa_channel_own_title: 'Tu propio número (escanear QR abajo)',
  wa_channel_own_desc: 'Los clientes ven TU número y pueden responderte (vendedor IA disponible)',
  wa_channel_meta_title: 'API oficial de Meta (nunca bloqueado)',
  wa_channel_meta_desc: 'Conecta tu propia cuenta de Meta Business — guía paso a paso incluida',
  wa_channel_configure: 'Configurar →',
  wa_channel_on: '✅ Canal plataforma activado',
  wa_channel_off: '✅ Usando tu propio número',
  wa_relay_usage_month: '📊 Este mes: {n} mensajes enviados',
  qs_assigned: 'Asignado',
  qs_paid: 'Pagado',
  qs_due: 'Total',
  qs_hint: '💡 Escriba el monto en cada método, 2+ cajas = pago dividido',
  qs_missing: 'Falta',
  qs_change: 'Vuelto',
  wa_not_connected: 'No conectado (escanee para vincular su número)',
  wa_platform_fallback: 'Los mensajes salen ahora por el número de la plataforma Sellox. Conecte su propio número para que sus clientes vean el WhatsApp de su tienda.',
  wa_own_number_hint: 'Cada comercio puede vincular su propio número de WhatsApp — escanee una vez y queda montado.',
  sx_cost: 'Costo',
  sx_taxable_base: 'Base Imponible (Gravado)',
  sx_exempt: 'Exento (Sin IVA)',
  sx_iva: 'IVA',
  sx_total: 'TOTAL',
  sx_gravado_sales: 'Ventas Gravadas',
  sx_exento_sales: 'Ventas Exentas',
  sx_iva_due: 'IVA a pagar (16%)',
  sx_tax_card_title: 'IVA / Resumen fiscal',
  sx_pkg_title: 'Paquetes de Sesiones',
  sx_pkg_new: 'Nuevo paquete',
  sx_pkg_defs: 'Definición de paquetes',
  sx_pkg_sold: 'Paquetes vendidos',
  sx_pkg_sell: 'Vender a cliente',
  sx_pkg_redeem: 'Canjear 1 sesión',
  sx_pkg_left: 'Quedan',
  sx_pkg_times: 'sesiones',
  sx_pkg_name_hint: 'Nombre (ej: Corte x10)',
  sx_pkg_sessions: 'Sesiones',
  sx_pkg_price: 'Precio $',
  sx_pkg_days: 'Días válidos',
  sx_pkg_customer: 'Cliente',
  sx_pkg_paymethod: 'Método de pago',
  sx_pkg_confirm: 'Confirmar venta',
  sx_pkg_none: 'Sin paquetes aún',
  sx_pkg_sold_none: 'Sin paquetes vendidos',
  sx_menu_packages: 'Paquetes de sesiones',
  sx_note_no_spicy: 'Sin picante',
  sx_note_no_sauce: 'Sin salsa',
  sx_note_egg: 'Con huevo',
  sx_note_well_done: 'Bien cocido',
  sx_note_less_salt: 'Poca sal',
  sx_note_no_cheese: 'Sin queso',
  sx_usd_toggle: '💵 Cobro en USD ($)',
  sx_cashier_price_switch: '🔓 Cajero puede cambiar precio (P1/P2/Caja)',
  sx_usd_off_info: 'El POS ocultará el modo USD; solo se cobrará en Bs (la tasa BCV sigue visible como referencia)',
  sx_cashea_pct: 'Recargo Cashea %',
  sx_cashea_pct_hint: 'Se agrega este % al total cuando el cliente paga con Cashea (0 = sin recargo)',
  sx_variant_pick: 'Selecciona opción (talla/color/sabor)',
  sx_recargo: 'recargo',
  sx_customer: 'Cliente',
  sx_subtotal: 'Subtotal (sin IVA)',
  sx_discount: 'Descuento',
  sx_promo: 'Promoción',
  sx_promo_incl: 'ya incluida en el precio',
  sx_cost_usd: 'Costo $',
  sx_cost_bs: 'Costo Bs',
  sx_profit: 'Ganancia',
  sx_sales_summary: 'Resumen de Ventas',
  sx_loading_orders: 'Cargando órdenes, por favor espere…',
  sx_loss_alert: 'A pérdida',
  sx_stale_alert: 'Precio vencido',
  sx_loss_hint: 'Precio neto (sin IVA) menor al costo',
  sx_stale_hint: 'Bs con tasa vieja o sin actualizar +30 días',
  sx_net_price: 'Neto sin IVA',
  sx_loss_each: 'Pérdida c/u',
  sx_current_bs: 'Bs actual',
  sx_expected_bs: 'Bs esperado',
  sx_days_no_update: 'Días sin actualizar',
  sx_reason_rate: 'tasa vieja',
  sx_reason_old: 'sin actualizar',
  sx_production_date: 'Fecha de producción',
  sx_expiry_alert: 'Por vencer',
  sx_expiry_hint: 'Vence en 30 días o ya vencido',
  sx_days_left: 'Restan',
  sx_expired: 'Vencido',
  sx_batch_expiry: 'Vencimiento del lote',
  sx_export_products: 'Exportar Excel',
  sx_payment_breakdown: 'Desglose de Pagos',
  sx_orders_count: 'N° de órdenes',
  sx_items_count: 'Artículos',
  sx_total_bs: 'Total Bs',
  sx_cash_usd: 'Efectivo $',
  sx_cash_bs: 'Efectivo Bs',
  sx_avg_ticket: 'Ticket promedio',
  sx_gravado: 'Gravado',
  sx_exento_short: 'Exento',
  sx_subtotal_short: 'Subtotal',
  sx_tax_total: 'Total IVA',
  sx_pay_total: 'Total a pagar',
  sx_printer_default: 'Impresora predeterminada',
  sx_fiscal_machine: 'Máquina Fiscal',
  sx_fiscal_already: '🧾 Esta orden ya fue fiscalizada — no se puede duplicar',
  sx_fiscal_done: 'Fiscalizada',
  sx_fiscal_desktop_only: 'Máquina fiscal solo disponible en la app de escritorio (COM)',
  sx_pretax: 'Base',
  sx_customer_display: 'Pantalla del cliente',
  sx_ws_mode: 'Modo Mayorista (B2B)',
  sx_ws_mode_desc: 'Al activarlo: los visitantes de la tienda online NO ven precios; el cliente debe registrarse y ser aprobado por usted (interruptor "Mayorista" en Clientes). Pedidos por docena/bulto.',
  sx_ws_locked: 'Precio solo para mayoristas registrados',
  sx_ws_apply: 'Solicitar cuenta mayorista',
  sx_ws_pending: 'Su cuenta mayorista está en revisión. Podrá ver precios cuando sea aprobada.',
  sx_ws_pending_badge: 'Solicitud pendiente',
  sx_ws_moq: 'Pedido mínimo',
  sx_ws_moq_hint: 'MOQ por defecto (docena); si el producto tiene cantidad por bulto se usa esa',
  wsx_zone: 'Zona Mayorista',
  wsx_go_retail: 'Ir a tienda detal',
  wsx_go_mayor: 'Entrada mayorista',
  wsx_closed_retail_title: 'Solo ventas al mayor',
  wsx_closed_retail_sub: 'La tienda detal está cerrada. Entre a la zona mayorista.',
  wsx_closed_mayor_title: 'Venta al mayor no disponible',
  wsx_closed_mayor_sub: 'Esta tienda aún no acepta pedidos al mayor. Visite la tienda detal.',
  wsx_tier_ge: '≥{n} pzs',
  wsx_mix_hint: '✨ Surtido: combine estilos y complete {n} pzs en total para precio mayorista',
  wsx_mix_need: 'Faltan {n} pzs para el mínimo surtido',
  wsx_mix_ok: 'Mínimo surtido alcanzado',
  wsx_mix_progress: 'Progreso surtido',
  wsx_vip_badge: 'Precio VIP -{n}%',
  wsx_moq_multi: 'Mínimo {n} pzs, en múltiplos de {n}',
  wsx_moq_min: 'Mínimo {n} pzs',
  wsx_settings_title: 'Tienda Mayorista Online (B2B)',
  wsx_tab_orders: 'Pedidos',
  wsx_tab_salesmen: 'Vendedores',
  wsx_tab_settings: 'Ajustes',
  wsx_terms_title: 'Plazos de crédito & descuento (pedidos mayoristas online)',
  wsx_terms_hint: 'El cliente elige plazo al pedir. % positivo = descuento, negativo = recargo (ej: 15 días -3%)',
  wsx_terms_days: 'días',
  wsx_terms_pct: '% desc.',
  wsx_terms_add: 'Agregar plazo',
  wsx_retail_toggle: 'Tienda detal',
  wsx_ws_toggle: 'Tienda mayorista (/mayor)',
  wsx_copy_link: 'Copiar enlace',
  wsx_link_copied: 'Enlace copiado',
  wsx_default_moq: 'MOQ por defecto (pzs)',
  wsx_retail_ws_qty: 'Cant. al mayor tienda retail (global)',
  wsx_retail_ws_qty_hint: '0 = desactivado; la cantidad del producto tiene prioridad',
  sx_boss_confirm: '✔ Confirmar',
  sx_boss_confirm_ask: '¿Confirmar que este pago fue verificado? Pasará a la sección verde',
  wsx_mix_enable: 'Permitir surtido (combinar estilos)',
  wsx_mix_min: 'Mínimo total surtido (pzs)',
  wsx_vip_pct: 'Descuento extra VIP %',
  wsx_ai_desc: 'El cliente pregunta por WhatsApp "¿Tienes Harina PAN? ¿Cuánto cuesta?" — la IA consulta el stock, cotiza, registra la intención de compra y responde (en español). Cada respuesta consume 1 crédito IA.',
  wsx_ai_setup: 'Primero conecte el WhatsApp de su tienda escaneando el QR (tarjeta verde arriba). Cuando el cliente confirma el pedido, la IA crea un pedido en espera — en caja presione F10 para cobrarlo.',
  wsx_ai_store: 'Tienda del pedido (dónde se guardan los pedidos que toma la IA)',
  wsx_ai_store_auto: 'Automático (primera tienda)',
  wsx_ai_extra: 'Información extra de la tienda (horario / delivery / formas de pago — la IA la usará al responder)',
  wsx_ai_kb: 'Base de conocimiento de la IA (preguntas frecuentes / políticas / devoluciones / qué NO decir — la IA la seguirá al pie de la letra)',
  wsx_ai_kb_ph: 'Ej:\nP: ¿Hacen delivery? R: Gratis en Caracas desde $20; otras zonas según distancia.\nP: ¿Fían? R: Solo a clientes conocidos con aprobación del dueño.\nNo prometer fechas de llegada; no dar descuentos; no mencionar a la competencia.',
  wsx_ai_lead_phone: 'Número para avisos de socios / proveedores',
  wsx_ai_lead_hint: 'Si escriben sobre alianza, integración, API o son proveedores, la IA deja de vender y reenvía el mensaje a este número (vacío = número de avisos de pedidos)',
  wsx_ai_save: 'Guardar info',
  wsx_ai_chats_view: 'Ver conversaciones IA',
  wsx_ai_chats_hide: 'Ocultar conversaciones',
  wsx_ai_chats_none: 'Sin conversaciones IA todavía',
  wsx_ai_msgs: 'msjs',
  wsx_ai_on: 'Activado',
  wsx_ai_enable: 'Activar',
  wsx_cr_l1: 'Todos los días a las 9:30 AM se escanean los créditos y se envía recordatorio por WhatsApp a los clientes vencidos o por vencer en 3 días.',
  wsx_cr_int_pre: 'Un mismo cliente recibe máximo 1 recordatorio cada ',
  wsx_cr_int_post: ' días, sin molestias repetidas. También puede cobrar manualmente en la página /admin/credits.',
  dlv_enforce_max: 'Bloquear pedidos fuera de rango',
  dlv_enforce_max_hint: 'Al activarlo, los clientes más allá de la distancia máxima no pueden ordenar (requiere compartir ubicación)',
  dlv_map_hint: '🗺️ Mapa de cobertura — haga clic en el mapa para fijar la ubicación de la tienda',
  dlv_map_legend_max: 'Rango máximo de entrega',
  dlv_map_legend_free: 'Envío gratis',
  sh_week_hint: 'Horario por día (p. ej. domingo medio día o cerrado); los días sin ajuste usan el horario de arriba',
  sh_mode_default: 'Horario normal',
  sh_mode_custom: 'Personalizado',
  sh_mode_closed: 'Cerrado',
  sh_day_mon: 'Lunes', sh_day_tue: 'Martes', sh_day_wed: 'Miércoles', sh_day_thu: 'Jueves', sh_day_fri: 'Viernes', sh_day_sat: 'Sábado', sh_day_sun: 'Domingo',
  pl_mode_p1: 'P1 (Detal)', pl_mode_p2: 'P2 (Al Mayor)', pl_mode_p3: 'P3 (Mayor)',
  pl_mode_p1p2: 'P1 + P2', pl_mode_cashea: 'P1 + Cashea', pl_mode_box: 'P1 + Caja', pl_mode_p1p2box: 'P1 + P2 + Caja', pl_mode_p1p3: 'P1 + P3', pl_mode_all: 'Los 3 precios',
  pl_instock: 'Con stock', pl_all: 'Todos', pl_clear: 'Limpiar',
  wsx_save_ok: 'Configuración mayorista guardada',
  wsx_tiers_btn: 'Precios escalonados',
  wsx_tiers_title: 'Precios mayoristas escalonados',
  wsx_tiers_sub: 'Ej: ≥12 pzs $5.00, ≥48 pzs $4.50, ≥144 pzs $4.00. Vacío = usa precio P2. El primer nivel define el mínimo del producto.',
  wsx_tier_qty: 'Cantidad ≥',
  wsx_tier_price: 'Precio $',
  wsx_tiers_saved: 'Precios escalonados guardados',
  wsx_tier_manage: 'Configurar precios escalonados',
  wsx_search_product: 'Buscar producto para precios escalonados...',
  wsx_catalog_btn: 'Catálogo PDF',
  wsx_catalog_with: 'Con precios (clientes aprobados)',
  wsx_catalog_without: 'Sin precios (para captar clientes)',
  wsx_catalog_note: 'Regístrese como mayorista para ver precios y ordenar',
  wsx_vip_toggle_on: 'Cliente ascendido a VIP mayorista',
  wsx_vip_toggle_off: 'VIP desactivado',
  wsx_guide_title: '📖 ¿Cómo usar la tienda mayorista? Ver tutorial',
  wsx_guide_1: '1️⃣ Active el interruptor "Tienda mayorista" y comparta el enlace (/mayor) en sus grupos de WhatsApp. Detal y mayor comparten productos e inventario; cada entrada se puede activar/desactivar.',
  wsx_guide_2: '2️⃣ Por defecto "Sin aprobación": el cliente se registra (nombre + teléfono) y ya puede ver precios y ordenar — ideal para clientes fiados habituales. Si quiere controlar quién ve precios, desactívelo y apruebe manualmente en Clientes.',
  wsx_guide_3: '3️⃣ Configure precios escalonados: más cantidad = menor precio (ej: 12 pzs $5 / 48 pzs $4.5 / 144 pzs $4). Sin escalones se usa el precio P2.',
  wsx_guide_4: '4️⃣ Mínimos: con escalones, el primer nivel es el mínimo; sin escalones aplica la cantidad por bulto o el MOQ por defecto, en múltiplos (12, 24, 36…).',
  wsx_guide_5: '5️⃣ Surtido para clientes pequeños: al activarlo pueden combinar estilos y completar el total mínimo (ej: 36 pzs) sin mínimo por estilo.',
  wsx_guide_6: '6️⃣ Clientes VIP: actívelos en Clientes y reciben un % extra de descuento sobre el precio mayorista.',
  wsx_guide_7: '7️⃣ Genere el catálogo PDF: versión "sin precios" para captar clientes en grupos, versión "con precios" para clientes aprobados.',
  wsx_guide_8: '8️⃣ Los pedidos entran a "Pedidos Online"; puede imprimir factura A4 mayorista. Clientes con crédito pueden ordenar fiado con recordatorio automático por WhatsApp.',
  wsx_hot_title: 'Más vendidos al mayor',
  wsx_hot_sold: '{n} pzs en 7 días',
  wsx_auto_approve: 'Sin aprobación (registro = ver precios y ordenar)',
  wsx_pedido_nopay: 'Pedido sin pago (mayor)',
  wsx_pedido_nopay_hint: 'El cliente envía el pedido sin pagar ni reservar stock; imprima el A5 para picking, el stock se descuenta al confirmar y el detalle llega al WhatsApp del cliente',
  wsx_salesman: 'WhatsApp del vendedor (pedidos al mayor se envían automático)',
  wsx_wa_target: 'Número o ID de grupo WhatsApp',
  wsx_send_with: 'Enviar catálogo con precios',
  wsx_send_without: 'Enviar catálogo sin precios',
  wsx_sent_ok: 'Enviado por WhatsApp',
  wsx_send_fail: 'Error al enviar — verifique la conexión de WhatsApp',
  wsx_size_mix: 'Surtido de tallas (ej: S*4 M*4 L*4)',
  wsx_statement: 'Estado de cuenta',
  wsx_only_left: '¡Solo quedan {n}!',
  wsx_load_groups: 'Cargar grupos de WhatsApp',
  wsx_pick_group: 'Elegir grupo',
  wsx_groups_fail: 'Error — verifique que WhatsApp esté conectado',
  wsx_salesman_multi: 'WhatsApp de vendedores (varios, separados por coma)',
  wsx_sm_title: 'Vendedores & Comisiones',
  wsx_settle_pdf: 'PDF liquidación',
  wsx_settle_send: 'Enviar liquidación (WhatsApp)',
  wsx_settle_sent: 'Liquidación enviada ✓',
  wsx_sm_enable: 'Activar comisiones',
  wsx_sm_add: 'Agregar vendedor',
  wsx_sm_name: 'Nombre',
  wsx_sm_pct: 'Comisión %',
  wsx_sm_link: 'Enlace personal',
  wsx_sm_customers: 'Clientes',
  wsx_sm_orders: 'Pedidos',
  wsx_sm_sales: 'Ventas $',
  wsx_sm_collected: 'Cobrado $',
  wsx_sm_comm_sales: 'Comisión (ventas)',
  wsx_sm_comm_coll: 'Comisión (cobrado)',
  wsx_sm_none: 'Sin asignar',
  wsx_sm_unassigned: 'Pedidos sin vendedor',
  wsx_sm_saved: 'Guardado',
  wsx_sm_hint: '💡 Comparta el enlace personal de cada vendedor: los clientes que se registren por su enlace quedan a su nombre (también puede asignarlos manualmente en Clientes). Los pedidos de sus clientes se le envían solo a él.',
  wsx_wechat_copy: 'WeChat / otras apps:',
  wsx_copy_with: 'Copiar texto con precios',
  wsx_copy_without: 'Copiar texto sin precios',
  wsx_copied: 'Texto copiado — péguelo en el grupo y envíe',
  wsx_color_theme: 'Color de la tienda online',
  wsx_color_hint: 'Elija y guarde — el color de la tienda detal y mayorista cambia al instante',
  x_nosalary_prompt: '⚠️ Este empleado no tiene salario configurado, no se puede calcular el descuento automáticamente.\nIngrese el monto a descontar ($USD). Cancelar = no registrar deuda:',
  x_nosalary_skipped: 'No se registró deuda. Consejo: configure el salario del empleado en «Empleados» para calcular el descuento por falta automáticamente',
  x_free_label: 'GRATIS',
  x_credits_unit: 'créditos',
  ci_btn: 'Lista de empaque',
  ci_title: 'Importar lista de empaque (contenedor de China)',
  ci_upload_hint: 'Suba la lista de empaque del proveedor (Excel .xlsx o .csv). La plantilla estándar se importa directo; formatos irregulares los reconoce la IA columna por columna.',
  ci_choose_file: 'Elegir archivo',
  ci_analyzing: 'Analizando...',
  ci_download_template: 'Descargar plantilla',
  ci_ai_note: 'Respaldo IA: cualquier formato del proveedor sirve — el sistema reconoce las columnas (código/nombre/cajas/unid. por caja/costo RMB) y puede corregirlas antes de importar.',
  ci_ai_used: '✨ La IA mapeó las columnas — revise y confirme',
  ci_ai_mapped: 'Mapeado por IA',
  ci_analyze_fail: 'Error al analizar el archivo',
  ci_total_rows: 'Filas de datos',
  ci_mapping_hint: 'Puede cambiar el campo de cada columna arriba',
  ci_f_ignore: '— Ignorar —',
  ci_f_code: 'Código',
  ci_f_name: 'Nombre',
  ci_f_barcode: 'Código de barras',
  ci_f_cartons: 'Cajas',
  ci_f_per_box: 'Unid./caja',
  ci_f_qty: 'Cantidad total',
  ci_f_cost_rmb: 'Costo RMB',
  ci_f_cost_usd: 'Costo USD',
  ci_f_retail_usd: 'Precio detal USD',
  ci_f_wholesale_usd: 'Precio mayor USD',
  ci_f_t1_qty: 'Nivel1 mín.',
  ci_f_t1_price: 'Nivel1 precio$',
  ci_f_t2_qty: 'Nivel2 mín.',
  ci_f_t2_price: 'Nivel2 precio$',
  ci_f_t3_qty: 'Nivel3 mín.',
  ci_f_t3_price: 'Nivel3 precio$',
  ci_f_category: 'Categoría',
  ci_f_spec: 'Especificación/color',
  ci_rmb_rate: 'Tasa RMB→USD',
  ci_live_rate: 'Tasa en vivo aplicada',
  rmb_card_title: 'Tasa RMB (yuan chino, en vivo)',
  rmb_auto_note: 'USD→CNY en vivo automático, convertido a Bs con BCV/Binance (actualiza cada 6h)',
  rmb_refresh: 'Actualizar',
  rmb_unavailable: 'Tasa RMB no disponible por ahora',
  rmb_example: 'Ejemplo',
  ci_shipping: 'Flete total USD (prorrateado al costo)',
  ci_warehouse: 'Almacén destino',
  ci_wh_default: 'Almacén por defecto',
  ci_dup_mode: 'Códigos existentes',
  ci_mode_add: 'Sumar stock + actualizar precios',
  ci_mode_skip: 'Omitir',
  ci_commit: 'Confirmar importación',
  ci_back: 'Subir de nuevo',
  ci_commit_fail: 'Error al importar',
  ci_result_created: 'Productos creados',
  ci_result_updated: 'Stock sumado',
  ci_result_skipped: 'Omitidos',
  ci_result_failed: 'Fallidos',
  ci_result_units: 'Unidades ingresadas',
  ci_ship_per_unit: 'Flete por unidad',
  ci_po_created: 'Orden de compra recibida generada (ver costo del contenedor en Compras)',
  bi_offer: 'Agregue fotos a este lote y venda en la tienda online ya',
  bi_create_link: 'Generar enlace para fotos (móvil)',
  bi_link_copied: 'Enlace copiado — ábralo en el teléfono para tomar fotos',
  bi_copy: 'Copiar enlace',
  bi_wa_text: '📸 Enlace para fotos de mercancía nueva (abrir en el móvil, IA fondo blanco):',
  bi_hint: 'Abra el enlace en el teléfono y fotografíe producto por producto; la IA pone fondo blanco. Original gratis, versión IA cobra créditos por foto. Válido 7 días.',
  bi_title: 'Fotos del lote nuevo',
  bi_done_count: 'con foto',
  bi_take_photo: 'Tomar foto / elegir',
  bi_processing: 'IA procesando...',
  bi_use_this: 'Usar esta',
  bi_ai_failed: 'IA falló — use la original',
  bi_retake: 'Repetir foto',
  bi_cancel: 'Volver a la lista',
  bi_style_whitebg: 'Fondo blanco',
  bi_style_poster: 'Póster e-commerce (IA con textos)',
  ci_done: 'Listo',
  pt_tier_title: 'Precios mayoristas por nivel (≥cant. → precio$, se guarda con el producto)',
  pt_tier_minqty: 'Cant.',
  pt_tier_price: 'Precio',
  pt_tier_hint: 'Ej.: ≥12 $2.80 / ≥60 $2.50 / ≥120 $2.20. Deje vacío para no usar niveles.',
  pt_tier_save_fail: 'Error guardando niveles — reintente en la página Mayorista',
  wsx_cp_title: 'Descuento inteligente por pronto pago',
  wsx_cp_slogan: 'Eslogan (se muestra en el estado de cuenta del cliente)',
  wsx_cp_slogan_ph: 'Ej.: ¡Pague en 30 días y reciba 3% de descuento!',
  wsx_cp_days: 'Plazo de crédito por defecto (días)',
  wsx_cp_tier_days: '≤ días',
  wsx_cp_tier_pct: 'Desc. %',
  wsx_pronto_hint_1: 'Deuda de',
  wsx_days: 'días',
  wsx_pronto_receive: 'pague ahora solo',
  wsx_pronto_save: 'ahorra',
  wsx_pronto_btn: 'Aplicar descuento pronto pago',
  pu_loading: 'Cargando...',
  pu_done_title: '¡Listo!',
  pu_saved_for: 'Foto guardada para',
  pu_close_tab: 'Ya puedes cerrar esta pestaña',
  pu_title: 'Subir foto del producto',
  pu_code: 'Código',
  wsx_banner: 'Banner de la tienda (imagen superior de la tienda online)',
  wsx_banner_upload: 'Subir imagen del banner',
  aisd_btn: 'Diseño AI',
  pos_ai_logo_btn: 'Crear logo con AI',
  pos_ai_logo_regen: 'Regenerar logo AI',
  aisd_title: 'Diseñador AI de tu tienda',
  aisd_kind_banner: 'Banner de tienda',
  aisd_kind_logo: 'Logo de tienda',
  aisd_style: 'Estilo',
  aisd_color_synced: 'Color de la tienda sincronizado con el banner',
  aisd_ref_hint: 'opcional',
  aisd_ref_upload: 'Sube un banner que te guste y la IA copiará su estilo',
  aisd_ref_active: 'Se imitará el estilo de la referencia (con tu nombre y contacto)',
  aisd_style_supermercado: '🛒 Súper Latino',
  aisd_style_modern: 'Moderno',
  aisd_style_anime: '🎌 Anime',
  aisd_style_tech: '⚡ Tecnológico',
  aisd_style_3d: '🧊 3D',
  aisd_style_warm: 'Cálido',
  aisd_style_luxury: 'Lujo',
  aisd_style_promo: 'Promoción',
  aisd_style_minimal: 'Minimalista',
  aisd_style_festive: 'Festivo',
  aisd_desc: 'Descripción extra (opcional)',
  aisd_desc_ph: 'Ej: vendo frutas y verduras, quiero estilo promocional rojo',
  aisd_generate: 'Generar',
  aisd_generating: 'Generando…',
  aisd_regen: 'Regenerar',
  aisd_apply: 'Aplicar a mi tienda',
  aisd_applied: '¡Aplicado a tu tienda!',
  aisd_cost: 'Costo',
  aisd_credits: 'créditos',
  aisd_balance: 'Saldo',
  aisd_no_credits: 'Créditos AI insuficientes — recargue en ✨Créditos AI',
  aisd_failed: 'Error al generar — créditos devueltos, intente de nuevo',
  aisd_wait_hint: 'Tarda 30-90 segundos, no cierre la ventana',
  shopslug_label: 'URL personalizada de tu tienda',
  shopslug_hint: '3-30 caracteres: letras minúsculas, números y guiones. El enlace anterior sigue funcionando.',
  shopslug_save: 'Guardar URL',
  shopslug_saved: '¡URL guardada!',
  shopslug_invalid: 'Nombre inválido o ya en uso',
  poster_btn: 'Póster AI',
  poster_title: 'Póster promocional AI',
  poster_select_hint: 'Marque 1-6 productos y la AI arma un póster promocional',
  poster_max6: 'Máximo 6 productos',
  poster_promo_label: 'Frase promocional (opcional)',
  poster_promo_ph: 'Ej: ¡Mega oferta de fin de semana! Solo 3 días',
  poster_sent: 'Póster enviado a WhatsApp:',
  poster_phone_ph: 'Teléfono (vacío = número del jefe)',
  poster_wa_hint: 'Llega a tu WhatsApp — reenvíalo a tus grupos de clientes',
  poster_download: 'Descargar imagen del póster',
  hb_toggle: 'Banner festivo automático',
  hb_hint: '5 días antes de Navidad, Black Friday, etc., la AI genera un banner festivo (16 créditos) y te lo manda por WhatsApp para aplicarlo con 1 clic',
  hb_enabled: 'Banner festivo automático activado',
  hb_disabled: 'Banner festivo automático desactivado',
  gb_title: '🔥 Compra Grupal',
  payqr_upload: '📷 Subir QR de cobro',
  pk_menu: '📦 Despacho',
  vd_menu: '🧳 Vendedores',
  vendedor: 'Vendedor',
  pd_gallery_label: 'Más imágenes (ficha en la tienda)',
  pd_gallery_hint: 'El cliente las ve al tocar el producto en la tienda online',
  pd_desc_label: 'Descripción (se muestra en la ficha del producto)',
  tid_contact_admin: 'El ID de comercio lo gestiona la plataforma — contacte a soporte Sellox para cambiarlo',
  payqr_change: '📷 Cambiar QR',
  aiverify_label: '🤖 IA lee capturas de pago automáticamente',
  aiverify_hint: 'Al desactivar, los comprobantes van a revisión manual (sin gastar créditos IA): el cliente pone la referencia + sube captura, usted confirma',
  sdc_btn: '🎉 Tarjeta promo',
  sdc_download: '📥 Descargar imagen',
  sdc_share: 'Compartir por WhatsApp',
  sdc_hint: 'Descarga la imagen y publícala en tu estado de WhatsApp o envíala a tus clientes',
  gb_intro: 'Estilo Pinduoduo: fija un precio grupal + tamaño del grupo. El cliente inicia un grupo, lo comparte por WhatsApp, y al completarse se crean los pedidos automáticamente. Expira en 24h.',
  gb_enabled: 'Activado',
  gb_disabled: 'Desactivado (clic para activar)',
  gb_on: '¡Compra grupal activada!',
  gb_off: 'Compra grupal desactivada',
  gb_add_product: 'Agregar producto grupal',
  gb_search_ph: 'Buscar producto por nombre/código',
  gb_price: 'Precio grupal',
  gb_size: 'Personas',
  gb_saved: '¡Producto grupal guardado!',
  gb_configured: 'Productos con compra grupal',
  gb_none: 'Sin productos aún — busca arriba para agregar',
  gb_groups: 'Grupos',
  gb_no_groups: 'Aún no hay grupos iniciados',
  gb_st_completed: 'Completado',
  gb_st_open: 'En curso',
  gb_st_expired: 'Expirado',

  wsx_banner_removed: 'Banner eliminado',
  sx_fiscal_copy_ok: 'Copia impresa (la factura fiscal ya fue emitida; la copia no tiene valor fiscal)',
  sx_last_cost: 'Última compra',
  sx_ocr_menu: 'Escanear factura (AI)',
  sx_cost_up: 'Subió vs última compra',
  sx_cheaper_sup: 'Proveedor más barato',
  sx_shrink_menu: 'Mermas y Pérdidas',
  sx_shrink_title: 'Reporte de Mermas y Pérdidas',
  sx_shrink_sub: 'Diferencias de conteo + mermas declaradas — pérdidas invisibles en números claros',
  sx_shrink_stk_loss: 'Faltante (conteo)',
  sx_shrink_declared: 'Mermas declaradas',
  sx_shrink_gain: 'Sobrante (conteo)',
  sx_shrink_total: 'Pérdida total',
  sx_shrink_top: 'Top productos con pérdida (por valor)',
  sx_shrink_times: 'Veces',
  sx_shrink_qty: 'Cant. faltante',
  sx_shrink_value: 'Pérdida $',
  sx_shrink_no_data: 'Sin pérdidas registradas en este período 🎉',
  sx_shrink_wh: 'Almacén',
  sx_shrink_events: 'Detalle de eventos',
  sx_shrink_source_stk: 'Conteo',
  sx_shrink_source_loss: 'Merma',
  sx_resq_title: '⚠️ Reordenar códigos — acción peligrosa',
  sx_resq_body: 'Esto cambiará TODOS los códigos de productos a 01, 02, 03… por orden de nombre. ¡Los códigos actuales serán reemplazados! (El sistema guarda un respaldo automático de los códigos)',
  sx_resq_type_hint: 'Para continuar, escribe abajo',
  sx_resq_go: 'Reordenar ahora',
  sx_exit_system: 'Salir del sistema',
  sx_ocr2_cur_q: '¿En qué moneda están los precios de esta factura?',
  sx_ocr2_usd: 'Dólares USD',
  sx_ocr2_bs: 'Bolívares Bs',
  sx_ocr2_rate: 'Tasa (Bs ÷ tasa = $)',
  sx_ocr2_rate_hint: 'Los precios en Bs se dividen por la tasa para guardar en USD (prioridad: tu tasa, luego la tasa impresa en la factura)',
  sx_ocr2_usd_hint: 'Si la factura tiene columnas $ y Bs, la IA lee SOLO la columna $; el precio por bulto/caja se divide entre las unidades automáticamente',
  sx_ocr2_rate_req: 'Ingresa la tasa primero',
  sx_ocr2_src_user: 'tasa manual',
  sx_ocr2_src_invoice: 'tasa de la factura',
  sx_ocr2_src_system: 'tasa del sistema',
  sx_ocr2_box_conv: 'Conversión bulto',
  sx_ocr2_units: 'und',
  sx_ocr2_pick: '🔍 Buscar y elegir producto…',
  sx_ocr2_no_pick: 'marcado como coincidencia pero sin producto elegido',
  pm_wait_bank: '⏳ Esperando aviso del banco (puede tardar 1-2 min)…',
  overpay_label: 'Cobrado de más',
  overpay_return_by: 'Devolver por',
  overpay_cash: '💵 Efectivo',
  overpay_transfer: '🏦 Transferencia',
  overpay_cash_hint: 'Se descuenta del efectivo de la caja',
  overpay_transfer_hint: 'No afecta el efectivo de la caja',
  aisd_ref_banner: '🖼️ Banner de referencia',
  aisd_style_gold3d: 'Oro 3D',
  aisd_style_mascota: 'Mascota 3D',
  aisd_style_emblema: 'Emblema',
  aisd_style_neon: 'Neón',
  pay_where_transfer: '📍 Dónde se muestra: checkout de la tienda online → cuenta que ve el cliente al elegir "Transferencia" (cuenta única antigua; recomendamos la lista "Cuentas de Recepción" abajo, permite varias)',
  pay_where_pm: '📍 Dónde se muestra: checkout de la tienda online → datos que ve el cliente al elegir "Pago Móvil" (cuenta única antigua; recomendamos la lista "Cuentas de Recepción" abajo)',
  pay_where_wa: '📍 Dónde se muestra: checkout de la tienda online → el cliente puede pedir por WhatsApp a este número',
  pay_where_cashea: '📍 Dónde se muestra: checkout de la tienda online → opción de cuotas Cashea',
  pm_edit_auth_action: 'Modificar el pago requiere autorización del gerente (escanear QR o contraseña)',
  dlv_charge_customer: 'Cliente paga el envío',
  dlv_charge_customer_hint: 'Al activarlo, la tienda online cobra el envío automáticamente (tarifa base + $/km × distancia)',
  dlv_free_over: 'Envío GRATIS a partir de (US$)',
  dlv_free_over_hint: 'Si el subtotal del pedido llega a este monto, el envío es gratis; 0 = desactivado',
  dlv_free_km: 'Envío GRATIS dentro de (km)',
  dlv_free_km_hint: 'Si el cliente está a esta distancia o menos de la tienda, el envío es gratis; 0 = desactivado (requiere ubicación del cliente)',
  dlv_banner_toggle: 'Mostrar banner de envío gratis en la tienda',
  dlv_banner_hint: 'Muestra un banner "Envío GRATIS desde $X" arriba de los productos para incentivar la compra',
  oe_edit_auth_action: 'Modificar el pedido requiere autorización del gerente (escanear QR o contraseña)',
  oe_edit_note: 'Editar el pedido ajusta el stock y queda auditado',
  x_4ea2dc0c: 'En Safari toque «Compartir» → «Añadir a pantalla de inicio»',
  x_b3f1742d: 'Menú del navegador ⋮ → «Añadir a pantalla de inicio / Instalar app»',
  x_c6b0ecc1: 'PROFORMA',
  x_b43540a2: 'Documento de referencia — no fiscal. Sujeto a confirmación de inventario.',
  x_d2a5f47d: 'Fuera de horario, no aceptamos pedidos. Horario',
  x_79da6318: 'Error al crear el pedido',
  x_a7387278: 'Mis pedidos',
  x_0134ef91: 'Instalar en el teléfono',
  x_e655a410: 'Instalar',
  x_9f68a807: 'Puntos',
  x_c6a7617b: 'Precio mayorista desde 12 unidades',
  x_db3c3f79: '¡Envío gratis en tu primer pedido!',
  x_92254b8d: 'Oferta en grupo',
  x_1cb0067b: '✨ Nuevo',
  x_262a5f78: '💥 Oferta',
  x_9789ea3d: 'Agotado',
  x_7c114133: 'Mayorista',
  x_fe0e8bf7: 'Registrarse',
  x_c5f36f1e: 'Tipo de registro',
  x_a634b186: 'Mayorista',
  x_33809226: 'Cliente minorista',
  x_1b21e28e: 'Nombre del negocio',
  x_abbe4bb4: 'Fecha de nacimiento',
  x_fccc2b4a: 'Enero',
  x_c1d13f1d: 'Febrero',
  x_c4767bc3: 'Marzo',
  x_3eaf4b30: 'Abril',
  x_0545f138: 'Mayo',
  x_f2422a6e: 'Junio',
  x_464bab7f: 'Julio',
  x_81017142: 'Agosto',
  x_4b592d5e: 'Septiembre',
  x_f544c399: 'Octubre',
  x_57c44755: 'Noviembre',
  x_c0615eb3: 'Diciembre',
  x_e42b99d5: 'Mes',
  x_465260fe: 'Año',
  x_a65be661: 'Teléfono o cédula',
  x_ab735ef3: 'Clientes registrados en tienda pueden entrar con teléfono o cédula',
  x_5f57ab2b: 'Seleccione la fecha de nacimiento completa',
  x_18d9ac63: '¡Bienvenido de nuevo!',
  x_c94c6645: '¡Registro exitoso!',
  x_c91539c5: '¡Ya eres cliente de la tienda! Crea una contraseña para tu primer acceso online; tus puntos e historial se conservan',
  x_bc490ac9: '¿No tienes cuenta? Regístrate',
  x_89438cb2: 'Mis puntos',
  x_70c5388d: 'Crédito pendiente',
  x_99b7dc82: 'Plazo',
  x_f7013966: '-- Seleccione banco --',
  x_b00a4f4e: 'Envío gratis',
  x_abd7f31c: 'Zona de entrega limitada, comparta su ubicación arriba',
  x_df4e7845: 'Compra en grupo',
  x_e77dadaf: 'Personas por grupo',
  x_96b165fe: 'Este grupo ya terminó — puedes abrir uno nuevo',
  x_a49dc062: 'Seleccione método de pago',
  x_0d6fd032: 'Ingrese la referencia de pago (mín. 4 dígitos)',
  x_0025409e: '🎉 ¡Grupo completo! Pedido creado',
  x_934a013a: 'Ocurrió un error, intente de nuevo',
  x_918d2e43: 'Grupos en curso — ¡únete!',
  x_cece7904: 'clientes',
  x_4d99b1b3: 'Unirse →',
  x_7be5df87: '🚀 Crear mi grupo',
  x_02c280bb: 'Tu nombre',
  x_a0b92ea7: 'Tu teléfono (WhatsApp)',
  x_630a2d4f: '💳 Pagar ahora para asegurar tu cupo',
  x_e3648a5b: '📲 Escanear con la app del banco',
  x_bc7dbf60: 'Referencia de pago *',
  x_78fbb3b8: 'La tienda verificará tu pago. Si el grupo no se completa en 24h, se reembolsa.',
  x_fbf44f79: '💬 Al completarse el grupo, coordina el pago por WhatsApp con la tienda.',
  x_661f0360: '✅ Unirme al grupo',
  x_a392ec03: '🚀 Crear grupo',
  x_9c401b86: 'Comparte el enlace — al completarse, el pedido se confirma automático. Válido 24h.',
  x_1d7b443a: 'Compartir por WhatsApp',
  x_4b7d6310: 'Enlace copiado',
  x_02b52fdf: '¡Grupo completo!',
  x_375ec885: 'OK',
  x_0b4f1582: 'SENIAT - Centro de Control Fiscal',
  x_a2a6e3a5: 'Gestión fiscal · Reportes Z/X · Exportar · Auditoría',
  x_466ef11d: 'Reporte X',
  x_aecc6c50: 'Reporte Z (cierre)',
  x_52f43ce8: 'Contadores',
  x_685de23a: 'Exportar SENIAT',
  x_a722bf43: 'Registro de auditoría',
  x_18f25f32: 'Verificar numeración',
  x_917b67ce: 'Generar reporte X',
  x_3fca2d1d: 'Generar reporte Z (cierre)',
  x_4d020ba3: 'Generando...',
  x_2a9ce745: 'Reporte Z = cierre fiscal del día, se genera una sola vez al cerrar.',
  x_6ca3821a: '⚠️ Está en el navegador: la impresora fiscal solo funciona desde la app de escritorio',
  x_4823e2b3: '📅 Reimprimir copia Z por fecha — memoria fiscal',
  x_1b1964c7: 'Reimprime en la impresora fiscal la copia legal del Z guardado de una fecha. No genera un Z nuevo ni modifica datos — válido para SENIAT y contabilidad.',
  x_d3955f6a: 'Imprimir en máquina fiscal',
  x_0ef2525d: '⚠️ Solo desde la app de escritorio (requiere impresora fiscal)',
  x_a8be906b: 'Aún no se ha generado ningún reporte Z',
  x_ade95bda: 'Ventas de hoy',
  x_f4f5a946: 'transacciones',
  x_ee1689c9: 'IVA cobrado',
  x_52f7f49a: 'Ventas exentas',
  x_f2a378e9: 'Anuladas',
  x_983f27e7: 'Ventas netas',
  x_d3c85a4d: 'Nº factura',
  x_d3a4a490: 'Nº control',
  x_6cced836: 'Detalle IVA',
  x_b294fbbf: 'Base imponible',
  x_2bb46698: 'Sin contadores todavía. Se crean con la primera venta facturada.',
  x_f74759c0: 'Contador de Nº de control',
  x_353cab9e: 'Contador de Nº de factura',
  x_4c9bb426: 'Prefijo',
  x_ca8f0b14: 'Número actual',
  x_f2c71b78: 'Exportar datos fiscales (SENIAT)',
  x_b44c0f33: 'Fecha inicio',
  x_1d468be9: 'Fecha fin',
  x_55405ea6: 'Exportar',
  x_aa03f534: 'CSV: separado por «;», compatible Excel/SENIAT. Campos: fecha, factura, control, RIF, base, IVA%, IVA, exento, total, método, moneda',
  x_7a5bbc5b: 'TXT: texto plano separado por |, para integrar con SENIAT',
  x_725b5a3e: 'JSON: formato estructurado para integraciones API',
  x_1fd02a90: 'Usuario',
  x_79c05840: 'Sin registros de auditoría',
  x_5839aebb: 'Los datos de auditoría se conservan 10 años según SENIAT (SNAT/2024/000121).',
  x_43c011c1: 'Verificar numeración',
  x_0410cb00: 'Verificando...',
  x_bc5b83bc: 'Sin fechas = revisar todo. Autoverificación interna, no depende de SENIAT.',
  x_7974ad56: '✅ Numeración completa',
  x_8dc2b6cc: '⚠️ Problemas encontrados',
  x_19616fb8: 'facturas · rango',
  x_9a136985: 'Saltos (números faltantes)',
  x_a656f3be: 'Números duplicados',
  x_c258e133: 'Fuera de orden cronológico',
  x_5da53c3a: 'Registro offline / anuladas',
  x_af5eba6e: 'Detalle de saltos (números de control faltantes)',
  x_d8066277: 'Números de control duplicados',
  x_351f1da9: 'Facturación fuera de orden cronológico',
  x_8ce24893: '¿Generar reporte Z? Cierra el día fiscal, solo una vez al día. ¿Confirmar?',
  x_87d27264: '⚠️ Solo disponible en la app de escritorio',
  x_66823aa3: 'Asignado a',
  x_89a92538: 'Publicado, los riders pueden tomarlo',
  x_d02627fe: '✅ Ajustes de notificación guardados',
  x_6af47376: '✅ Pedido modificado',
  x_d3cb9a21: '✅ Facturación completada',
  x_cdbe0c92: '¿Cancelar este pedido? Se libera el stock y se cancela la entrega',
  x_32ff009c: '✅ Pedido cancelado',
  x_a769cdc2: '¿Eliminar definitivamente este pedido? Libera el stock reservado, no se puede deshacer',
  x_2716e6a7: '¿Eliminar definitivamente este registro? No se puede deshacer',
  x_cbb7bf56: '🗑 Eliminado definitivamente',
  x_00e41368: 'Ingrese la cantidad a devolver',
  x_96c48fd4: '✅ Cambio completado, cobrar al cliente',
  x_7ef40e73: '✅ Devolución exitosa, stock actualizado',
  x_44c198c1: 'Reembolso',
  x_f36ecce3: 'Notificación de nuevos pedidos',
  x_359ff4db: 'Número WhatsApp para avisos de pedidos (vacío = no enviar)',
  x_b7656e18: 'Tono',
  x_0d9c291a: 'Suave',
  x_1fdac4c2: 'Fuerte',
  x_95b9408f: 'Anunciar monto por voz',
  x_f4a35245: 'Probar',
  x_f62dea70: 'Qué cuentas reciben la alarma (ninguna = todas)',
  x_2026e292: 'La PC suena y anuncia por voz el monto del pedido nuevo (según idioma del sistema)',
  x_2dad819e: 'Reembolsado total',
  x_f67d89db: 'Reembolso parcial',
  x_bc3583b5: 'Facturar',
  x_4efd6a13: 'Enviar a rider',
  x_cbfc5ba6: 'Sin stock puede cambiar cantidad, 0 elimina el producto',
  x_855fb7e2: 'Total confirmado',
  x_d613b1b4: 'Al confirmar: descuenta stock + crédito al cliente (según plazo) + comisión al vendedor',
  x_b59c07ff: '✅ Confirmar facturación',
  x_897dbdee: 'Modificar pedido',
  x_7650487a: 'Dirección',
  x_d2dd7e1c: 'Sin stock puede cambiar cantidad, 0 elimina el producto',
  x_d99e3dbb: 'Nuevo total (sin envío)',
  x_926c613a: '⚠️ Pedido ya pagado, ajuste la diferencia con el cliente',
  x_84693468: '💾 Guardar cambios',
  x_b163cb6a: 'Devolución de pedido',
  x_a9275c2e: 'Por defecto devuelve todo; ajuste cantidades para devolución parcial (0 = no devolver)',
  x_2f656a74: 'Devuelto',
  x_4178e0b6: 'Método de reembolso',
  x_976f94a1: 'Motivo (opcional)',
  x_fd3108f0: 'Ej: producto dañado',
  x_cf55227f: 'Cambio (opcional) — por otro producto, diferencia automática',
  x_33bda28d: 'Buscar producto de cambio...',
  x_9854a54a: 'Monto devolución',
  x_51811a84: 'Monto cambio',
  x_2718ce26: 'Devolver al cliente',
  x_d1903e50: 'Cliente debe pagar',
  x_1830fefb: 'Al confirmar: entra stock devuelto + sale cambio + registro de reembolso (en reportes) + aviso WhatsApp al cliente',
  x_54945fc4: '✅ Confirmar cambio/devolución',
  x_6be8ae78: '✅ Confirmar devolución',
  x_1817ed2a: 'Asignar a rider',
  x_dc2c3193: 'No hay riders verificados. Deben registrarse en sellox.shop/rider y usted aprobarlos.',
  x_727df9ee: 'Publicar para que tomen (sin asignar)',
  x_c29ce6fd: 'Efectivo $',
  x_58ef5787: 'Borrador limpiado',
  x_129fe574: 'Nº factura proveedor:',
  x_2959bd81: '✅ Borrador automático diario activado (7:00)',
  x_e6a85d28: 'Borrador automático desactivado',
  x_a2a843ad: 'No hay productos populares por reponer',
  x_513d596e: '✅ Borrador confirmado como compra oficial',
  x_0c456ca5: '¿Eliminar este borrador?',
  x_9b19d9c6: '⚠️ Seleccione un almacén primero',
  x_20b73ca7: '💾 Compra guardada offline, se sube al volver la red',
  x_1922f043: '💾 Recepción guardada offline, se sube al volver la red',
  x_31d1f953: '📋 Producto copiado, solo cambie nombre y código de barras',
  x_673942b6: 'Código de barras ya existe',
  x_47e03fd1: 'Código ya está en uso',
  x_b0007365: 'Sin proveedor',
  x_e24ce335: 'Auto borrador: ON',
  x_9cfd9afd: 'Auto borrador: OFF',
  x_31416882: 'Generar borrador ahora',
  x_719fb446: 'Buscar proveedor o vendedor...',
  x_4091474b: '📝 Borrador',
  x_d7291e52: 'Moneda del documento',
  x_2ced248f: 'Copiar como nuevo (solo cambia nombre y código)',
  x_e21626f3: '🗑 Limpiar borrador',
  x_64457c62: 'Clic para cambiar departamento/categoría',
  x_00ca7c29: 'Sin categoría · clic para asignar',
  x_df6d0757: 'un/caja',
  x_64d9ef93: 'Margen',
  x_9e4dbf03: 'Monto Bs',
  x_77449ea5: 'Tasa (Bs/$)',
  x_5e496273: 'Ingrese Bs y se convierte a USD con la tasa del día (editable)',
  x_be85dc34: 'Referencia / Nº operación',
  x_0edbdf53: 'Referencia de transferencia, confirmación Zelle…',
  x_8f8b954f: 'Ej: efectivo al vendedor Juan, abono parcial…',
  x_f8580966: 'Comprobante de pago (captura/recibo)',
  x_be6f0f22: 'Foto / subir comprobante',
  x_aa24f2e1: 'Imagen muy grande (máx 8MB)',
  x_94171ce2: 'Comprobante',
  x_3e440694: 'Este código ya está en uso',
  x_be607248: 'Este código de barras ya existe',
  x_515c0b7e: '¿Cambiar almacén de todo el documento? El stock recibido se mueve al nuevo almacén',
  x_15816bc7: '¿Cambiar el almacén de este documento?',
  x_0e344978: 'Bancos y Caja',
  x_5bb78d8a: 'Transferir entre cuentas',
  x_228d2bab: 'Nueva cuenta',
  x_3b186bad: 'Sin cuentas. Cree cuentas bancarias/cajas y los cobros entran automáticamente.',
  x_6095e59c: 'Movimientos',
  x_348e534e: 'Nº doc / nota',
  x_09e1d043: 'Sin movimientos',
  x_6f484666: 'Editar cuenta',
  x_f3f18020: 'Nombre (ej. BNC principal / Caja USD)',
  x_f430b947: 'Banco (opcional)',
  x_4d72cab9: 'Últimos 4 dígitos (opcional)',
  x_de35ac7b: 'Saldo inicial',
  x_1f0fca13: 'Métodos de pago vinculados (los cobros entran aquí)',
  x_68e9a989: 'Nota (opcional)',
  x_3e25b5d4: 'Cuenta origen',
  x_e83fca1c: 'Cuenta destino',
  x_33ed7cfa: 'Monto a enviar',
  x_30f229d9: 'Monto recibido',
  x_26050b04: 'Confirmar transferencia',
  x_9e268a5d: 'Ingrese el nombre',
  x_db8ac4f2: 'Monto inválido',
  x_4ab08f52: 'Registrado',
  x_51e7ba4a: 'Transferencia registrada',
  x_3524c978: 'Exportar estado de cuenta',
  x_be123473: 'Exportar estado de cuenta (Excel/PDF)',
  x_81909158: 'Mes',
  x_37cb3781: 'Resumen',
  x_32f2f705: 'Resumen de fondos',
  x_026d5880: 'Inicial',
  x_361ffa7f: 'Entradas',
  x_37cc0a9a: 'Salidas',
  x_b39409ce: 'Neto',
  x_d6080990: 'Final',
  x_79ceb63f: 'Caja de la tienda',
  x_936cf2c9: 'Aprobaciones',
  x_5a97be8a: 'Aprobación de montos grandes',
  x_6fded8ab: 'Activar aprobación (retiros/transferencias/pagos a proveedor sobre el umbral piden PIN)',
  x_a54fc320: 'Umbral USD $ (0 = sin límite)',
  x_807af4c1: 'Umbral Bs (0 = sin límite)',
  x_c0e9bd0c: 'Nuevo PIN de 6 dígitos (vacío = no cambiar)',
  x_47217200: 'PIN actual (para cambiar ajustes)',
  x_9ccb14f1: 'Ajustes de aprobación guardados',
  x_d9d6d5ba: '🔐 Requiere aprobación del jefe',
  x_be9d2bc1: 'Monto sobre el umbral, ingrese el PIN de 6 dígitos',
  x_0e1667c5: 'PIN de 6 dígitos',
  x_9cc24820: 'PIN incorrecto',
  x_b8e32288: 'PIN bloqueado, intente en 15 minutos',
  x_7116e7ec: 'Cuenta',
  x_e3dea388: 'Sin datos en este período',
  x_767d5ae4: 'Turno sin cerrar recuperado automáticamente',
  x_b231f6b0: 'Se recuperó el turno de hoy sin cerrar, continúe',
  x_d5ff526d: 'Tiene un turno anterior sin cerrar, ciérrelo antes de abrir otro',
  x_42d9293a: '30 días',
  x_94903830: '60 días',
  x_dc491dae: '90 días',
  x_cba8c4ef: 'Permita las ventanas emergentes',
  x_6f2838fe: 'Ingrese el precio',
  x_32a79f1b: 'Productos sin movimiento',
  x_ed320806: 'Más vendidos',
  x_9e3d9f77: 'Productos con stock',
  x_862dacd0: 'Costo estancado sin ventas',
  x_70ac9021: 'Costo total de inventario',
  x_966a2e61: 'Meses de stock',
  x_460e109d: 'Costo estancado',
  x_993a1358: 'Última venta',
  x_7098d682: 'Liquidar',
  x_d81bb206: 'Nunca',
  x_0dc5dc88: 'Grupo',
  x_28183523: '💥 Poner precio de liquidación',
  x_baed7f26: '🔥 Liquidar por compra en grupo',
  x_f9c82b80: 'Oferta activada (etiqueta OFERTA online + precio POS sincronizado)',
  x_6edc3851: 'Imprimir etiquetas de oferta',
  x_23a605c4: 'Precio oferta (USD) — por defecto -15%',
  x_3576efc7: 'Precio de grupo (USD)',
  x_ec798f44: 'Personas para completar (2-5)',
  x_3907665a: 'Duración de la oferta (vuelve al precio normal al vencer)',
  x_d716067e: '7 días',
  x_d9926871: '15 días',
  x_853f8cf7: '30 días',
  x_544cb8d3: 'Cambia el precio 1 y pone etiqueta OFERTA en la tienda online',
  x_6ff9fab3: 'Activa compra en grupo para este producto (requiere interruptor general activado)',
  x_15af542a: '🔒 La información fiscal la administra el proveedor del sistema. Cambios de nombre/dirección: contacte a su proveedor (servicio con costo).',
  x_6e0df37b: '🧾 Numeración de facturas',
  x_12923f27: '✅ Numeración consecutiva activa',
  x_9aa9020f: '⬜ Desactivada (clic para activar)',
  x_99a06c43: 'Prefijo',
  x_453340fc: 'Dígitos',
  x_f45ac04c: 'Próximo Nº',
  x_02f02875: 'Al activar, cada pedido online con pago confirmado recibe un número de factura consecutivo, visible en la factura electrónica y el ticket.',
  x_eea9deb9: 'Logo de la tienda (para impresión o avatar de WhatsApp)',
  x_8c57e455: 'Subir logo',
  x_456885ba: 'Descargar logo',
  x_967d445b: '🕐 Horario de pedidos online',
  x_8a0bbf6e: 'Hora de Venezuela; fuera de este horario no se aceptan pedidos online; el POS no se ve afectado',
  x_2086719a: 'Volver a Precio 1 tras cada escaneo (P2/Caja aplica solo al próximo producto)',
  x_b9f9fade: 'Moneda en ticket',
  x_d30839fd: 'Solo Bolívares',
  x_99f08c08: 'Solo Dólares',
  x_75bffa13: 'Bs + $',
  x_09d4c026: '🧑‍💼 Panel de Gerente',
  x_41ebcf52: 'Las funciones apagadas no aparecen al gerente de tienda (el jefe no se limita)',
  x_a2e95088: 'Resumen del día',
  x_1ae34829: 'Inventario y productos',
  x_eb479750: 'Inventariar',
  x_e7926cff: 'Gastos',
  x_75e361e0: 'Ganancia cambiaria',
  x_1a7665ae: 'Efectivo en caja',
  x_9a127288: 'Cuentas de empleados',
  x_d7a96cba: 'Horario',
  x_9ac5ab89: 'Créditos',
  x_c1f80f9b: 'Agregar producto',
  x_0735fcbc: 'Traslados',
  x_2ff230cf: '📊 Análisis de visitantes',
  x_677d39e2: 'Quién visita su tienda online, qué mira y si compra',
  x_49ea343c: 'En línea ahora',
  x_36331e50: 'Visitantes hoy',
  x_63568477: 'Vistas hoy',
  x_f2a70aa0: 'Pedidos hoy',
  x_43798078: 'Tendencia de visitantes',
  x_c527743c: 'Conversión a pedido',
  x_852da3f7: 'Visitantes',
  x_88bc4d7a: 'Vistas',
  x_dd2a2f3b: '🔥 Productos populares (añadidos al carrito)',
  x_f2581824: 'Sin datos aún — se registran cuando los clientes agregan al carrito',
  x_4f15720f: 'Dispositivos',
  x_e855972e: 'PC',
  x_c77c44eb: 'Sin visitantes aún — comparta el enlace de su tienda',
  x_c864ee0a: '14 días',
  x_fdfd62e8: 'Registros hoy',
  x_bd83f3a1: '🛒 Embudo de compra',
  x_3c5c43e5: 'Al carrito',
  x_423da4b1: 'Pedidos',
  x_6e3a0666: 'veces al carrito',
  x_72df3158: '📝 Clientes nuevos',
  x_1818467a: 'Sin registros nuevos en este período',
  x_61dd3548: '👀 Visitantes recientes',
  x_44761c5f: 'Visitante anónimo',
  x_ff6e1828: 'Sin registros de visitas',
  x_e9ac9962: 'vistas',
  x_381fb5ef: '🔔 Alerta de pico de visitas',
  x_3836004f: 'Aviso por WhatsApp cuando hay muchos en línea, aproveche para promociones',
  x_468a206b: 'En línea ≥',
  x_60051ff7: 'Número de aviso (vacío = usar el de pedidos)',
  x_0c18a538: 'Mínimo 60 minutos entre avisos para no saturar',
  x_add9c8bf: '⚖️ Laboral LOTTT',
  x_a09fe96e: '🧾 Fiscal SENIAT',
  x_e9f30aae: '🏢 Mercantil',
  x_3dcf62b4: 'Pregunte lo que sea, por ejemplo:',
  x_50a1215a: '¿Cuánto se paga al despedir a un empleado con 3 años?',
  x_c9e9a906: '¿Cómo se calculan las horas extra?',
  x_eb3853bc: '"¿Cuánto pagar al despedir a un empleado de 3 años?" · "¿Cuánto es el cestaticket actual?"',
  x_b08d2eca: '⚖️ La IA está consultando la ley…',
  x_323d361d: 'Escriba su consulta…',
  x_74221fd8: 'Limpiar conversación',
  x_2aad6aeb: 'Seleccione un empleado',
  x_842bd876: 'Empleado',
  x_f48c1e0f: 'Desde',
  x_0a50a227: 'Hasta',
  x_60197011: 'IA calculando…',
  x_9945bf6c: 'Nómina mensual con IA',
  x_98a98282: 'La IA lee los datos reales del empleado (salario, asistencia, préstamos) y genera la nómina conforme a la LOTTT.',
  x_010a3d9c: '⚖️ La IA está verificando la LOTTT y calculando… (20-40 s)',
  x_b7014d64: 'Ley laboral LOTTT · fiscal SENIAT · mercantil — la IA cita artículos y genera nóminas conformes',
  x_1a1d2d4e: 'Saldo de créditos AI',
  x_88426c86: 'Pregunta 1 crédito · Nómina 3 créditos',
  x_10d691fd: '💰 Nómina AI',
  x_c228ed55: '⏳ Pendiente de subir',
  x_95a03b22: '✅ Duplicada - probablemente ya cobrada, verifique y elimine',
  x_b60c2cbc: '❌ Sin stock - NO registrada, reponga y facture de nuevo',
  x_9ed2da59: '❌ Rechazada por el servidor - NO registrada',
  x_9c8b638d: 'Nada que sincronizar',
  x_59c10673: 'Cola de sincronización',
  x_963d2f9c: 'Todo sincronizado, sin operaciones pendientes',
  x_422e18f2: 'Eliminada',
  x_6b1192c7: 'Eliminar',
};

Object.assign(es, {
  refCommNav: '💵 Comisiones de Referidos',
  refCommTitle: 'Comisiones de Referidos',
  refCommDesc: 'Cuando un comercio referido hace su primer pago, quien lo refirió gana una comisión en efectivo (única vez)',
  refCommEnabled: 'Activar comisiones en efectivo',
  refCommRate: 'Porcentaje de comisión (%)',
  refCommSave: 'Guardar',
  refCommSettingsSaved: 'Configuración de comisiones guardada',
  refCommPendingTotal: 'Comisiones por pagar',
  refCommPaidTotal: 'Comisiones pagadas',
  refCommPendingCount: 'pendientes',
  refCommRecords: 'Registros de comisiones',
  refCommReferrer: 'Quien refirió',
  refCommReferred: 'Nuevo comercio',
  refCommAmountPaid: 'Pago del cliente',
  refCommAmount: 'Comisión',
  refCommStatus: 'Estado',
  refCommPending: 'Por pagar',
  refCommPaid: 'Pagada',
  refCommCancelled: 'Anulada',
  refCommMarkPaid: 'Marcar pagada',
  refCommPayMethod: 'Método de pago',
  refCommPayRef: 'Referencia / nota',
  refCommConfirmPay: 'Confirmar pago',
  refCommCancelRec: 'Anular',
  refCommManualAdd: 'Agregar comisión manual',
  refCommSelectTenant: 'Seleccionar comercio referido',
  refCommNoEligible: 'No hay comercios elegibles (deben registrarse con código de referido y no tener comisión previa)',
  refCommNoRecords: 'Sin registros de comisiones',
  refCommDate: 'Fecha',
  refCommClose: 'Cerrar',
  refCommMyEarnings: 'Mis Comisiones en Efectivo',
  refCommPendingBalance: 'Por cobrar',
  refCommReceived: 'Recibido',
  refCommEarnRule: 'Cuando un nuevo cliente se registra con tu código y hace su primer pago, ganas el {rate}% de ese pago en efectivo',
  refCommPayoutNote: '💰 La plataforma te paga por Pago Móvil / Zelle / Binance',
  refCommCreatedToast: 'Comisión registrada',
  renewAmountPaid: 'Monto recibido (USD)',
  renewAmountPaidHint: 'Opcional · para registro de pago y comisión de referido',
  renewReferredHint: 'Este comercio se registró con código de referido — el primer pago generará una comisión',
  refPosterBtn: 'Afiche',
  refPosterTitle: 'Afiche para Compartir',
  refPosterDownload: 'Descargar afiche',
  refPosterDownloaded: '¡Afiche descargado — compártelo por WhatsApp!',
  refPosterHint: 'Descarga la imagen o toca WhatsApp para compartir tu enlace de referido',
  refProgramNav: '🎁 Recomienda y Gana · Plataforma Sellox',
  refHow2Desc: 'Tu amigo se registra de prueba con tu código (aún sin comisión)',
  refHow3Title: 'Paga = tú ganas',
  refHow3Desc: 'Solo cuando él pague de verdad, ganas el {rate}% de su pago en efectivo',
  refStatUses: 'Comercios referidos',
  refStatEarned: 'Comisiones acumuladas',
  duTitle: 'Pago Directo USDT (Binance)',
  duZeroFee: 'Sin comisiones',
  duDesc: 'Envía USDT (TRC20) directo a la dirección de la plataforma, pega el TxID y se activa al instante. Para transferencias internas de Binance usa revisión por captura.',
  duBuyLifetime: 'Activar plan (incluye 1er año de servicio; luego tarifa anual)',
  duMaintenance: 'Renovar mantenimiento anual',
  duMaintenance12m: 'Mantenimiento anual · 12 meses',
  duExpiry: 'Vence',
  duCredits: 'Recargar créditos AI',
  duStep1: 'Paso 1: Envía este monto exacto a la dirección (solo red TRC20)',
  duStep2: 'Paso 2: Pega el hash de transacción (TxID) — verificado en cadena y activado al instante',
  duTxidPlaceholder: 'Pega el hash de 64 caracteres…',
  duVerifyBtn: 'Verificar y Activar',
  duPasteTxid: 'Pega el TxID por favor',
  duNetworkWarn: '¡Usa solo la red TRC20 (TRON) — red equivocada = fondos perdidos!',
  duBinanceInternal: '¿Transferencia interna de Binance (sin TxID)?',
  duUploadScreenshot: 'Subir captura para revisión',
  duMyOrders: 'Mis órdenes de pago',
  duStPending: 'Pendiente',
  duStReview: 'En revisión',
  duStConfirmed: 'Activado',
  duStRejected: 'Rechazado',
  duNav: '💰 Pagos USDT Directos',
  duAdminTitle: 'Órdenes de Pago USDT Directo',
  duAll: 'Todos',
  duTenant: 'Comercio',
  duUseCase: 'Propósito',
  duApprove: 'Aprobar',
  duRejectNote: 'Motivo de rechazo (opcional)',
  duScreenshot: 'Captura de pago',
  duYearFee: 'servicio 1er año',
  mainSupplier: 'Proveedor principal (reabastecimiento agrupa pedidos por él)',
  noSupplier: '— Sin asignar —',
  priceCompare: 'Comparación de proveedores (historial de compras, más barato primero)',
  posRejTitle: 'PEDIDO RECHAZADO',
  posRejLine1: '¡Este pedido NO se guardó! No aparecerá en el sistema',
  posRejLine2: '¡NO entregues el vuelto ni la mercancía todavía!',
  posRejLine3: 'El carrito sigue ahí: corrige el problema y cobra de nuevo',
  posSaveFailTitle: '¡NO SE PUDO GUARDAR!',
  posSaveFailLine1: 'El servidor no responde y este equipo tampoco pudo guardar el pedido',
  posSaveFailLine2: 'Toma foto o anota el número y monto de arriba, avisa al jefe',
  posSaveFailLine3: '¡NO cierres esta página! Cuando vuelva el internet, cobra de nuevo',
  posShiftWarnTitle: 'Turno sin conexión',
  posShiftWarnLine1: 'El turno quedó guardado en este equipo, puedes seguir vendiendo',
  posShiftWarnLine2: 'Si el internet no vuelve, avísale al jefe',
  supBasicInfo: 'Información básica',
  supExtraInfo: 'Información adicional',
  supCategory: 'Categoría',
  supAddCategory: 'Agregar categoría',
  supTaxId: 'RIF / NIT',
  supCurrency: 'Moneda de pago',
  supTerms: 'Plazo de pago (días)',
  supEmail: 'Correo electrónico',
  supPostal: 'Código postal',
  supBankName: 'Banco',
  supBankAccount: 'Cuenta bancaria',
  supCarrier: 'Transportista predeterminado',
  supCountry: 'País',
  supState: 'Estado',
  supCity: 'Ciudad',
  supNotes: 'Notas',
  supAutoGen: 'Se genera automático si queda vacío',
  supDupName: '⚠️ Este proveedor ya existe',
  supDupCode: '⚠️ Este código ya está en uso',
  supSearch: 'Buscar proveedor por nombre/código…',
  supNoMatch: 'Sin proveedores que coincidan',
  posAlertSoundTitle: 'Sonido de alerta POS',
  posAlertSoundHint: 'Suena cuando aparece la alerta roja (clic para probar)',
  soundBuzzer: 'Zumbador (defecto)',
  soundBeep: 'Bip',
  soundChime: 'Campanilla',
  posSaleSoundTitle: 'Sonido de venta completada',
  posSaleSoundHint: 'Suena al terminar cada cobro (clic para probar)',
  saleSoundDing: 'Din-don',
  saleSoundCash: 'Caja registradora',
  saleSoundOk: 'Doble OK',
  pmVoiceTitle: 'Voz al verificar Pago Móvil / Transferencia',
  pmVoiceHint: 'Anuncia el resultado al verificar la referencia en caja: confirmado / con observación / no encontrado',
  pmVoiceShort: 'Solo «Pago Móvil confirmado»',
  pmVoiceAmount: '«Confirmado» + monto en Bs',
  soundSiren: 'Sirena',
  soundOff: 'Silencio',
  invLedger: 'Movimientos de stock',
  ledgerSale: 'Venta',
  ledgerReturn: 'Devolución',
  ledgerPurchase: 'Compra',
  ledgerAdjust: 'Ajuste',
  ledgerLoss: 'Pérdida',
  ledgerTransfer: 'Traslado',
  ledgerCreate: 'Producto creado',
  ledgerDelete: 'Producto eliminado',
  ledgerAllProducts: 'Todos los productos (altas/bajas/ajustes)',
  ledgerNoData: 'Sin movimientos en el período',
  ledgerCurStock: 'Stock actual',
  posNoLastOrder: 'Aún no hay recibo para reimprimir (haz una venta primero)',
  posOk: 'ENTENDIDO',
  verNewWeb: '🆕 Nueva versión',
  verClickReload: 'toca para actualizar',
  cat_pdf_btn: 'Catálogo PDF',
  cat_pdf_title: 'Exportar catálogo PDF por categoría',
  cat_pdf_hint: 'Catálogo horizontal con fotos grandes, ideal para grupos de WhatsApp. Los precios son los mismos de la tienda mayorista.',
  cat_pdf_select_all: 'Todas',
  cat_pdf_clear: 'Ninguna',
  cat_pdf_hide_inactive: 'Ocultar productos inactivos',
  cat_pdf_hide_oos: 'Ocultar productos sin stock',
  cat_pdf_show_prices: 'Mostrar precios',
  cat_pdf_generate: 'Generar PDF',
  cat_pdf_generating: 'Generando… (10–30 s si hay muchas fotos)',
  cat_pdf_done: 'PDF generado',
  cat_pdf_empty: 'Las categorías seleccionadas no tienen productos',
  cat_pdf_pick: 'Seleccione al menos una categoría',
  cat_pdf_color: 'Color del catálogo',
  cat_pdf_color_custom: 'Color personalizado',
  wsx_sm_qr: 'QR de la tienda',
  wsx_sm_qr_hint: 'El cliente escanea y entra a la tienda mayorista; sus pedidos quedan a nombre de este vendedor. Guarde la imagen y envíela por WhatsApp.',
  bulto: 'Bulto',
  bultoBoxes: 'Cajas por bulto',
  bultoPrice: 'Precio por bulto',
  bultoHint: 'Bulto = empaque grande con varias cajas. 0 = sin bulto.',
  bultos: 'bultos',
  wsx_moq_mode: 'Compra mínima',
  wsx_moq_mode_box: 'Por caja completa (múltiplos de caja)',
  wsx_moq_mode_unit: 'Por unidad (desde 1, con botón +1 caja)',
  wsx_moq_mode_hint: 'Si su unidad mínima ya es un paquete/caja, elija «Por unidad».',
  cat_pdf_products: 'productos',
  cat_pdf_uncat: 'sin categoría (no salen en el PDF)',
  cat_pdf_uncat_hint: 'Asígneles categoría en Productos para que aparezcan',
  x_svc_staff_pick: '¿Quién lo hizo?…',
  x_svc_not_found: 'no se encontró el servicio, agrégalo manualmente',
  x_beauty_center: 'Centro de belleza',
  x_appt_pay_pos: 'Cobrar en caja',
  x_appt_paid: 'Cobrada',
  x_appt_online: 'Reserva online',
  x_appt_pick_service: 'Elige el servicio…',
  x_appt_pick_staff: 'Elige profesional…',
  x_cust_beauty: 'Ficha de belleza',
  x_pkg_service: 'Servicio que cubre (en caja solo paga ese servicio)',
  x_pkg_service_any: 'Cualquier servicio',
  x_save_btn: 'Guardar',
});

export default es;